function copyText(e) {
  $("#myInput").val(e);
  var t = document.getElementById("myInput");
  t.select(),
    t.setSelectionRange(0, 99999),
    document.execCommand("copy"),
    alert("Copied!");
}
!(function () {
  var e =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof self
        ? self
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : {},
    t = {},
    i = {},
    n = e.parcelRequire3852;
  null == n &&
    (((n = function (e) {
      if (e in t) return t[e].exports;
      if (e in i) {
        var n = i[e];
        delete i[e];
        var s = { id: e, exports: {} };
        return (t[e] = s), n.call(s.exports, s, s.exports), s.exports;
      }
      var a = new Error("Cannot find module '" + e + "'");
      throw ((a.code = "MODULE_NOT_FOUND"), a);
    }).register = function (e, t) {
      i[e] = t;
    }),
    (e.parcelRequire3852 = n)),
    n.register("gCGxJ", function (e, t) {
      var i, n;
      (n = (function (e, t, i) {
        "use strict";
        var n, s;
        if (
          ((function () {
            var t,
              i = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                fastLoadedClass: "ls-is-cached",
                iframeLoadMode: 0,
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: 0.8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 0,
                throttleDelay: 125,
              };
            for (t in ((s = e.lazySizesConfig || e.lazysizesConfig || {}), i))
              t in s || (s[t] = i[t]);
          })(),
          !t || !t.getElementsByClassName)
        )
          return { init: function () {}, cfg: s, noSupport: !0 };
        var a,
          r,
          o,
          l,
          c,
          u,
          d,
          h,
          p,
          f,
          v,
          m,
          g,
          y,
          b,
          w,
          S,
          x,
          C,
          k,
          E,
          T,
          _,
          M,
          L,
          P,
          I,
          D,
          A,
          z,
          O,
          B,
          N,
          q,
          $,
          H,
          F,
          V,
          R,
          j,
          X,
          G,
          W,
          Y,
          U = t.documentElement,
          K = e.HTMLPictureElement,
          Q = "addEventListener",
          Z = "getAttribute",
          J = e[Q].bind(e),
          ee = e.setTimeout,
          te = e.requestAnimationFrame || ee,
          ie = e.requestIdleCallback,
          ne = /^picture$/i,
          se = ["load", "error", "lazyincluded", "_lazyloaded"],
          ae = {},
          re = Array.prototype.forEach,
          oe = function (e, t) {
            return (
              ae[t] || (ae[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
              ae[t].test(e[Z]("class") || "") && ae[t]
            );
          },
          le = function (e, t) {
            oe(e, t) ||
              e.setAttribute("class", (e[Z]("class") || "").trim() + " " + t);
          },
          ce = function (e, t) {
            var i;
            (i = oe(e, t)) &&
              e.setAttribute("class", (e[Z]("class") || "").replace(i, " "));
          },
          ue = function (e, t, i) {
            var n = i ? Q : "removeEventListener";
            i && ue(e, t),
              se.forEach(function (i) {
                e[n](i, t);
              });
          },
          de = function (e, i, s, a, r) {
            var o = t.createEvent("Event");
            return (
              s || (s = {}),
              (s.instance = n),
              o.initEvent(i, !a, !r),
              (o.detail = s),
              e.dispatchEvent(o),
              o
            );
          },
          he = function (t, i) {
            var n;
            !K && (n = e.picturefill || s.pf)
              ? (i &&
                  i.src &&
                  !t[Z]("srcset") &&
                  t.setAttribute("srcset", i.src),
                n({ reevaluate: !0, elements: [t] }))
              : i && i.src && (t.src = i.src);
          },
          pe = function (e, t) {
            return (getComputedStyle(e, null) || {})[t];
          },
          fe = function (e, t, i) {
            for (
              i = i || e.offsetWidth;
              i < s.minSize && t && !e._lazysizesWidth;

            )
              (i = t.offsetWidth), (t = t.parentNode);
            return i;
          },
          ve =
            ((X = []),
            (G = j = []),
            (W = function () {
              var e = G;
              for (G = j.length ? X : j, V = !0, R = !1; e.length; )
                e.shift()();
              V = !1;
            }),
            (Y = function (e, i) {
              V && !i
                ? e.apply(this, arguments)
                : (G.push(e), R || ((R = !0), (t.hidden ? ee : te)(W)));
            }),
            (Y._lsFlush = W),
            Y),
          me = function (e, t) {
            return t
              ? function () {
                  ve(e);
                }
              : function () {
                  var t = this,
                    i = arguments;
                  ve(function () {
                    e.apply(t, i);
                  });
                };
          },
          ge = function (e) {
            var t,
              n,
              s = function () {
                (t = null), e();
              },
              a = function () {
                var e = i.now() - n;
                e < 99 ? ee(a, 99 - e) : (ie || s)(s);
              };
            return function () {
              (n = i.now()), t || (t = ee(a, 99));
            };
          },
          ye =
            ((S = /^img$/i),
            (x = /^iframe$/i),
            (C = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent)),
            0,
            (k = 0),
            (E = 0),
            (T = -1),
            (_ = function (e) {
              E--, (!e || E < 0 || !e.target) && (E = 0);
            }),
            (M = function (e) {
              return (
                null == w && (w = "hidden" == pe(t.body, "visibility")),
                w ||
                  !(
                    "hidden" == pe(e.parentNode, "visibility") &&
                    "hidden" == pe(e, "visibility")
                  )
              );
            }),
            (L = function (e, i) {
              var n,
                s = e,
                a = M(e);
              for (
                m -= i, b += i, g -= i, y += i;
                a && (s = s.offsetParent) && s != t.body && s != U;

              )
                (a = (pe(s, "opacity") || 1) > 0) &&
                  "visible" != pe(s, "overflow") &&
                  ((n = s.getBoundingClientRect()),
                  (a =
                    y > n.left &&
                    g < n.right &&
                    b > n.top - 1 &&
                    m < n.bottom + 1));
              return a;
            }),
            (I = (function (e) {
              var t,
                n = 0,
                a = s.throttleDelay,
                r = s.ricTimeout,
                o = function () {
                  (t = !1), (n = i.now()), e();
                },
                l =
                  ie && r > 49
                    ? function () {
                        ie(o, { timeout: r }),
                          r !== s.ricTimeout && (r = s.ricTimeout);
                      }
                    : me(function () {
                        ee(o);
                      }, !0);
              return function (e) {
                var s;
                (e = !0 === e) && (r = 33),
                  t ||
                    ((t = !0),
                    (s = a - (i.now() - n)) < 0 && (s = 0),
                    e || s < 9 ? l() : ee(l, s));
              };
            })(
              (P = function () {
                var e,
                  i,
                  a,
                  r,
                  o,
                  l,
                  d,
                  p,
                  S,
                  x,
                  _,
                  P,
                  I = n.elements;
                if ((h = s.loadMode) && E < 8 && (e = I.length)) {
                  for (i = 0, T++; i < e; i++)
                    if (I[i] && !I[i]._lazyRace)
                      if (!C || (n.prematureUnveil && n.prematureUnveil(I[i])))
                        q(I[i]);
                      else if (
                        (((p = I[i][Z]("data-expand")) && (l = 1 * p)) ||
                          (l = k),
                        x ||
                          ((x =
                            !s.expand || s.expand < 1
                              ? U.clientHeight > 500 && U.clientWidth > 500
                                ? 500
                                : 370
                              : s.expand),
                          (n._defEx = x),
                          (_ = x * s.expFactor),
                          (P = s.hFac),
                          (w = null),
                          k < _ && E < 1 && T > 2 && h > 2 && !t.hidden
                            ? ((k = _), (T = 0))
                            : (k = h > 1 && T > 1 && E < 6 ? x : 0)),
                        S !== l &&
                          ((f = innerWidth + l * P),
                          (v = innerHeight + l),
                          (d = -1 * l),
                          (S = l)),
                        (a = I[i].getBoundingClientRect()),
                        (b = a.bottom) >= d &&
                          (m = a.top) <= v &&
                          (y = a.right) >= d * P &&
                          (g = a.left) <= f &&
                          (b || y || g || m) &&
                          (s.loadHidden || M(I[i])) &&
                          ((u && E < 3 && !p && (h < 3 || T < 4)) ||
                            L(I[i], l)))
                      ) {
                        if ((q(I[i]), (o = !0), E > 9)) break;
                      } else
                        !o &&
                          u &&
                          !r &&
                          E < 4 &&
                          T < 4 &&
                          h > 2 &&
                          (c[0] || s.preloadAfterLoad) &&
                          (c[0] ||
                            (!p &&
                              (b ||
                                y ||
                                g ||
                                m ||
                                "auto" != I[i][Z](s.sizesAttr)))) &&
                          (r = c[0] || I[i]);
                  r && !o && q(r);
                }
              })
            )),
            (A = me(
              (D = function (e) {
                var t = e.target;
                t._lazyCache
                  ? delete t._lazyCache
                  : (_(e),
                    le(t, s.loadedClass),
                    ce(t, s.loadingClass),
                    ue(t, z),
                    de(t, "lazyloaded"));
              })
            )),
            (z = function (e) {
              A({ target: e.target });
            }),
            (O = function (e, t) {
              var i = e.getAttribute("data-load-mode") || s.iframeLoadMode;
              0 == i
                ? e.contentWindow.location.replace(t)
                : 1 == i && (e.src = t);
            }),
            (B = function (e) {
              var t,
                i = e[Z](s.srcsetAttr);
              (t = s.customMedia[e[Z]("data-media") || e[Z]("media")]) &&
                e.setAttribute("media", t),
                i && e.setAttribute("srcset", i);
            }),
            (N = me(function (e, t, i, n, a) {
              var r, o, l, c, u, h;
              (u = de(e, "lazybeforeunveil", t)).defaultPrevented ||
                (n &&
                  (i ? le(e, s.autosizesClass) : e.setAttribute("sizes", n)),
                (o = e[Z](s.srcsetAttr)),
                (r = e[Z](s.srcAttr)),
                a && (c = (l = e.parentNode) && ne.test(l.nodeName || "")),
                (h = t.firesLoad || ("src" in e && (o || r || c))),
                (u = { target: e }),
                le(e, s.loadingClass),
                h && (clearTimeout(d), (d = ee(_, 2500)), ue(e, z, !0)),
                c && re.call(l.getElementsByTagName("source"), B),
                o
                  ? e.setAttribute("srcset", o)
                  : r && !c && (x.test(e.nodeName) ? O(e, r) : (e.src = r)),
                a && (o || c) && he(e, { src: r })),
                e._lazyRace && delete e._lazyRace,
                ce(e, s.lazyClass),
                ve(function () {
                  var t = e.complete && e.naturalWidth > 1;
                  (h && !t) ||
                    (t && le(e, s.fastLoadedClass),
                    D(u),
                    (e._lazyCache = !0),
                    ee(function () {
                      "_lazyCache" in e && delete e._lazyCache;
                    }, 9)),
                    "lazy" == e.loading && E--;
                }, !0);
            })),
            (q = function (e) {
              if (!e._lazyRace) {
                var t,
                  i = S.test(e.nodeName),
                  n = i && (e[Z](s.sizesAttr) || e[Z]("sizes")),
                  a = "auto" == n;
                ((!a && u) ||
                  !i ||
                  (!e[Z]("src") && !e.srcset) ||
                  e.complete ||
                  oe(e, s.errorClass) ||
                  !oe(e, s.lazyClass)) &&
                  ((t = de(e, "lazyunveilread").detail),
                  a && be.updateElem(e, !0, e.offsetWidth),
                  (e._lazyRace = !0),
                  E++,
                  N(e, t, a, n, i));
              }
            }),
            ($ = ge(function () {
              (s.loadMode = 3), I();
            })),
            (F = function () {
              u ||
                (i.now() - p < 999
                  ? ee(F, 999)
                  : ((u = !0), (s.loadMode = 3), I(), J("scroll", H, !0)));
            }),
            {
              _: function () {
                (p = i.now()),
                  (n.elements = t.getElementsByClassName(s.lazyClass)),
                  (c = t.getElementsByClassName(
                    s.lazyClass + " " + s.preloadClass
                  )),
                  J("scroll", I, !0),
                  J("resize", I, !0),
                  J("pageshow", function (e) {
                    if (e.persisted) {
                      var i = t.querySelectorAll("." + s.loadingClass);
                      i.length &&
                        i.forEach &&
                        te(function () {
                          i.forEach(function (e) {
                            e.complete && q(e);
                          });
                        });
                    }
                  }),
                  e.MutationObserver
                    ? new MutationObserver(I).observe(U, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0,
                      })
                    : (U[Q]("DOMNodeInserted", I, !0),
                      U[Q]("DOMAttrModified", I, !0),
                      setInterval(I, 999)),
                  J("hashchange", I, !0),
                  [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend",
                  ].forEach(function (e) {
                    t[Q](e, I, !0);
                  }),
                  /d$|^c/.test(t.readyState)
                    ? F()
                    : (J("load", F), t[Q]("DOMContentLoaded", I), ee(F, 2e4)),
                  n.elements.length ? (P(), ve._lsFlush()) : I();
              },
              checkElems: I,
              unveil: q,
              _aLSL: (H = function () {
                3 == s.loadMode && (s.loadMode = 2), $();
              }),
            }),
          be =
            ((r = me(function (e, t, i, n) {
              var s, a, r;
              if (
                ((e._lazysizesWidth = n),
                (n += "px"),
                e.setAttribute("sizes", n),
                ne.test(t.nodeName || ""))
              )
                for (
                  a = 0, r = (s = t.getElementsByTagName("source")).length;
                  a < r;
                  a++
                )
                  s[a].setAttribute("sizes", n);
              i.detail.dataAttr || he(e, i.detail);
            })),
            (o = function (e, t, i) {
              var n,
                s = e.parentNode;
              s &&
                ((i = fe(e, s, i)),
                (n = de(e, "lazybeforesizes", { width: i, dataAttr: !!t }))
                  .defaultPrevented ||
                  ((i = n.detail.width) &&
                    i !== e._lazysizesWidth &&
                    r(e, s, n, i)));
            }),
            {
              _: function () {
                (a = t.getElementsByClassName(s.autosizesClass)),
                  J("resize", l);
              },
              checkElems: (l = ge(function () {
                var e,
                  t = a.length;
                if (t) for (e = 0; e < t; e++) o(a[e]);
              })),
              updateElem: o,
            }),
          we = function () {
            !we.i && t.getElementsByClassName && ((we.i = !0), be._(), ye._());
          };
        return (
          ee(function () {
            s.init && we();
          }),
          (n = {
            cfg: s,
            autoSizer: be,
            loader: ye,
            init: we,
            uP: he,
            aC: le,
            rC: ce,
            hC: oe,
            fire: de,
            gW: fe,
            rAF: ve,
          })
        );
      })((i = "undefined" != typeof window ? window : {}), i.document, Date)),
        (i.lazySizes = n),
        e.exports && (e.exports = n);
    }),
    n("gCGxJ");
  var s = {};
  function a(e, t) {
    for (var i in t) {
      var n = t[i];
      e.addEventListener(i, n.listener || n, n.options || void 0);
    }
  }
  !(function (e, t) {
    if (e) {
      var i = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
      };
      (t = t.bind(null, e, e.document)),
        s
          ? t(n("gCGxJ"))
          : "function" == typeof define && define.amd
          ? define(["lazysizes"], t)
          : e.lazySizes
          ? i()
          : e.addEventListener("lazyunveilread", i, !0);
    }
  })("undefined" != typeof window ? window : 0, function (e, t, i) {
    "use strict";
    if (e.addEventListener) {
      var n = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
        s = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
        a = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
        r = /^picture$/i,
        o = i.cfg,
        l = {
          getParent: function (t, i) {
            var n = t,
              s = t.parentNode;
            return (
              (i && "prev" != i) ||
                !s ||
                !r.test(s.nodeName || "") ||
                (s = s.parentNode),
              "self" != i &&
                (n =
                  "prev" == i
                    ? t.previousElementSibling
                    : (i &&
                        (s.closest || e.jQuery) &&
                        (s.closest ? s.closest(i) : jQuery(s).closest(i)[0])) ||
                      s),
              n
            );
          },
          getFit: function (e) {
            var t,
              i,
              n = getComputedStyle(e, null) || {},
              r = n.content || n.fontFamily,
              o = {
                fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit"),
              };
            return (
              !o.fit && r && (t = r.match(s)) && (o.fit = t[1]),
              o.fit
                ? (!(i =
                    e._lazysizesParentContainer ||
                    e.getAttribute("data-parent-container")) &&
                    r &&
                    (t = r.match(a)) &&
                    (i = t[1]),
                  (o.parent = l.getParent(e, i)))
                : (o.fit = n.objectFit),
              o
            );
          },
          getImageRatio: function (t) {
            var i,
              s,
              a,
              l,
              c,
              u,
              d,
              h = t.parentNode,
              p =
                h && r.test(h.nodeName || "")
                  ? h.querySelectorAll("source, img")
                  : [t];
            for (i = 0; i < p.length; i++)
              if (
                ((s =
                  (t = p[i]).getAttribute(o.srcsetAttr) ||
                  t.getAttribute("srcset") ||
                  t.getAttribute("data-pfsrcset") ||
                  t.getAttribute("data-risrcset") ||
                  ""),
                (a = t._lsMedia || t.getAttribute("media")),
                (a = o.customMedia[t.getAttribute("data-media") || a] || a),
                s && (!a || ((e.matchMedia && matchMedia(a)) || {}).matches))
              ) {
                (l = parseFloat(t.getAttribute("data-aspectratio"))) ||
                  ((c = s.match(n))
                    ? "w" == c[2]
                      ? ((u = c[1]), (d = c[3]))
                      : ((u = c[3]), (d = c[1]))
                    : ((u = t.getAttribute("width")),
                      (d = t.getAttribute("height"))),
                  (l = u / d));
                break;
              }
            return l;
          },
          calculateSize: function (e, t) {
            var i,
              n,
              s,
              a = this.getFit(e),
              r = a.fit,
              o = a.parent;
            return "width" == r ||
              (("contain" == r || "cover" == r) && (n = this.getImageRatio(e)))
              ? (o ? (t = o.clientWidth) : (o = e),
                (s = t),
                "width" == r
                  ? (s = t)
                  : (i = t / o.clientHeight) &&
                    (("cover" == r && i < n) || ("contain" == r && i > n)) &&
                    (s = t * (n / i)),
                s)
              : t;
          },
        };
      (i.parentFit = l),
        t.addEventListener("lazybeforesizes", function (e) {
          if (!e.defaultPrevented && e.detail.instance == i) {
            var t = e.target;
            e.detail.width = l.calculateSize(t, e.detail.width);
          }
        });
    }
  });
  var r =
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype,
    o = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent),
    l = ["src", "poster"];
  function c(e, t) {
    var i = !0,
      n = !1,
      s = void 0;
    try {
      for (
        var a, r = l[Symbol.iterator]();
        !(i = (a = r.next()).done);
        i = !0
      ) {
        var o = a.value;
        o in e.dataset &&
          (e.setAttribute(o, e.dataset[o]),
          e.classList.contains(t) && e.classList.remove(t));
      }
    } catch (e) {
      (n = !0), (s = e);
    } finally {
      try {
        i || null == r.return || r.return();
      } finally {
        if (n) throw s;
      }
    }
  }
  function u(e, t, i, n) {
    if ("VIDEO" == e.nodeName) {
      var s = Array.from(e.querySelectorAll("source")),
        a = !0,
        r = !1,
        o = void 0;
      try {
        for (
          var l, u = s[Symbol.iterator]();
          !(a = (l = u.next()).done);
          a = !0
        )
          c(l.value, t);
      } catch (e) {
        (r = !0), (o = e);
      } finally {
        try {
          a || null == u.return || u.return();
        } finally {
          if (r) throw o;
        }
      }
      e.load();
    }
    c(e, t);
    var d = e.classList;
    d.contains(i) && (d.remove(i), d.add(n));
  }
  function d(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function h(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      (n.enumerable = n.enumerable || !1),
        (n.configurable = !0),
        "value" in n && (n.writable = !0),
        Object.defineProperty(e, n.key, n);
    }
  }
  function p(e, t, i) {
    return t && h(e.prototype, t), i && h(e, i), e;
  }
  function f(e, t, i) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = i),
      e
    );
  }
  function v(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {},
        n = Object.keys(i);
      "function" == typeof Object.getOwnPropertySymbols &&
        (n = n.concat(
          Object.getOwnPropertySymbols(i).filter(function (e) {
            return Object.getOwnPropertyDescriptor(i, e).enumerable;
          })
        )),
        n.forEach(function (t) {
          f(e, t, i[t]);
        });
    }
    return e;
  }
  function m(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var i = 0, n = new Array(t); i < t; i++) n[i] = e[i];
    return n;
  }
  function g(e) {
    if (
      ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
      null != e["@@iterator"]
    )
      return Array.from(e);
  }
  function y(e, t) {
    if (e) {
      if ("string" == typeof e) return m(e, t);
      var i = Object.prototype.toString.call(e).slice(8, -1);
      return (
        "Object" === i && e.constructor && (i = e.constructor.name),
        "Map" === i || "Set" === i
          ? Array.from(i)
          : "Arguments" === i ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
          ? m(e, t)
          : void 0
      );
    }
  }
  function b(e) {
    return (
      (function (e) {
        if (Array.isArray(e)) return m(e);
      })(e) ||
      g(e) ||
      y(e) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      })()
    );
  }
  var w = (function () {
      "use strict";
      function e(t) {
        d(this, e), (this._notification = t);
      }
      return (
        p(e, [
          {
            key: "show",
            value: function (e, t) {
              this._notification.show(e, t);
            },
          },
        ]),
        e
      );
    })(),
    S = new ((function () {
      "use strict";
      function e() {
        var t = this;
        d(this, e),
          f(this, "_handleWindowScroll", function () {
            t._timeoutScrollId &&
              (clearTimeout(t._timeoutScrollId), (t.isScrolling = !0)),
              (t._timeoutScrollId = setTimeout(function () {
                t.isScrolling = !1;
              }, 300));
          });
        var i = document.querySelector("#GlobalNotification");
        i && (this.notification = new w(i)),
          (this.isScrolling = !1),
          (this.overlaySelector = "#BodyOverlay"),
          window.addEventListener("wheel", this._handleWindowScroll),
          (this.overlayCalls = []);
      }
      return (
        p(e, [
          {
            key: "showOverlay",
            value: function (e, t) {
              var i = document.querySelector(this.overlaySelector);
              i &&
                ((this.overlayCalls = b(this.overlayCalls).concat([
                  { key: e, styles: t },
                ])),
                this.setBodyOverlayStyles(
                  v(
                    {},
                    { zIndex: 3, backgroundColor: "var(--gsc-black-color-50)" },
                    t
                  )
                ),
                i.setAttribute("visible", ""),
                this.setScrollLock());
            },
          },
          {
            key: "hideOverlay",
            value: function (e) {
              var t = document.querySelector(this.overlaySelector);
              if (t && t.hasAttribute("visible")) {
                this.overlayCalls = this.overlayCalls.filter(function (t) {
                  return t.key !== e;
                });
                var i = this.overlayCalls[this.overlayCalls.length - 1];
                i
                  ? this.setBodyOverlayStyles(i.styles)
                  : (t.removeAttribute("visible"),
                    t.setAttribute("style", ""),
                    this.unsetScrollLock());
              }
            },
          },
          {
            key: "setScrollLock",
            value: function () {
              (document.body.style.top = "-".concat(
                window.scrollY ||
                  Math.abs(parseInt(document.body.style.top || "0")),
                "px"
              )),
                document.body.setAttribute("scroll-y-off", "");
            },
          },
          {
            key: "unsetScrollLock",
            value: function () {
              var e = document.body.style.top;
              document.body.removeAttribute("scroll-y-off"),
                (document.body.style.top = ""),
                window.scrollTo(0, -1 * parseInt(e || "0"));
            },
          },
          {
            key: "setBodyOverlayStyles",
            value: function (e) {
              var t = document.querySelector(this.overlaySelector);
              t &&
                e &&
                Object.keys(e).forEach(function (i) {
                  t.style[i] = e[i];
                });
            },
          },
        ]),
        e
      );
    })())();
  function x(e) {
    if (void 0 === e)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return e;
  }
  function C(e, t) {
    return (
      (C =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        }),
      C(e, t)
    );
  }
  function k(e, t) {
    return C(e, t);
  }
  function E(e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function");
    (e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      t && k(e, t);
  }
  function T(e) {
    return (
      (T = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }),
      T(e)
    );
  }
  function _(e) {
    return T(e);
  }
  function M(e, t) {
    return !t ||
      ("object" !==
        (function (e) {
          return e && e.constructor === Symbol ? "symbol" : typeof e;
        })(t) &&
        "function" != typeof t)
      ? x(e)
      : t;
  }
  function L(e) {
    var t = (function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    })();
    return function () {
      var i,
        n = _(e);
      if (t) {
        var s = _(this).constructor;
        i = Reflect.construct(n, arguments, s);
      } else i = n.apply(this, arguments);
      return M(this, i);
    };
  }
  function P(e, t, i) {
    return (
      (P = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Date.prototype.toString.call(
              Reflect.construct(Date, [], function () {})
            ),
            !0
          );
        } catch (e) {
          return !1;
        }
      })()
        ? Reflect.construct
        : function (e, t, i) {
            var n = [null];
            n.push.apply(n, t);
            var s = new (Function.bind.apply(e, n))();
            return i && k(s, i.prototype), s;
          }),
      P.apply(null, arguments)
    );
  }
  function I(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (
      (I = function (e) {
        if (
          null === e ||
          ((i = e), -1 === Function.toString.call(i).indexOf("[native code]"))
        )
          return e;
        var i;
        if ("function" != typeof e)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, n);
        }
        function n() {
          return (function (e, t, i) {
            return P.apply(null, arguments);
          })(e, arguments, _(this).constructor);
        }
        return (
          (n.prototype = Object.create(e.prototype, {
            constructor: {
              value: n,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
          k(n, e)
        );
      }),
      I(e)
    );
  }
  function D(e) {
    return I(e);
  }
  var A = {
      SECTION_LOAD: "shopify:section:load",
      SECTION_UNLOAD: "shopify:section:unload",
      SECTION_SELECT: "shopify:section:select",
      SECTION_DESELECT: "shopify:section:deselect",
      SECTION_REORDER: "shopify:section:reorder",
      BLOCK_SELECT: "shopify:block:select",
      BLOCK_DESELECT: "shopify:block:deselect",
    },
    z = "ArrowLeft",
    O = "ArrowRight",
    B = 37,
    N = 39,
    q = "Enter",
    $ = 13,
    H = "Escape",
    F = 27,
    V = function (e) {
      return new Promise(function (t, i) {
        setTimeout(t, e);
      });
    },
    R = function (e, t, i, n) {
      i && e && t && e["".concat(n, "EventListener")](t, i);
    },
    j = function (e, t, i) {
      R(e, t, i, "add");
    },
    X = function (e, t, i) {
      R(e, t, i, "remove");
    },
    G = new IntersectionObserver(function (e, t) {
      e.forEach(function (e) {
        var t = e.isIntersecting,
          i = e.target.closest('[aria-hidden="true"], .hidden');
        e.target.toggleAttribute("data-is-in-viewport", t && !i);
      });
    }),
    W = function () {
      return ["button", "[href]", "[data-focus-trap-target]", "a", "[tabindex]"]
        .map(function (e) {
          return "".concat(
            e,
            ':not([tabindex="-1"]):not([data-color-swatches-hidden-count]:empty)'
          );
        })
        .join(",");
    },
    Y = function (e) {
      var t = document.createElement("div");
      return (
        t.classList.add("hidden"),
        document.body.appendChild(t),
        t.appendChild(e),
        t
      );
    },
    U = function (e) {
      e.remove();
    },
    K = function (e) {
      return e === $ || e === q;
    },
    Q = function (e) {
      return e === N || e === O;
    },
    Z = function (e) {
      return e === B || e === z;
    },
    J = (function () {
      "use strict";
      function e() {
        d(this, e), (this._listeners = {});
      }
      return (
        p(e, [
          {
            key: "subscribe",
            value: function (e, t) {
              this._listeners[e] || (this._listeners[e] = []),
                j(document, A[e], t),
                this._listeners[e].push(t);
            },
          },
          {
            key: "unsubscribe",
            value: function (e, t) {
              this._listeners[e] &&
                (X(document, A[e], t),
                (this._listeners[e] = this._listeners[e].filter(function (e) {
                  return e !== t;
                })));
            },
          },
          {
            key: "destroy",
            value: function () {
              var e = this;
              Object.keys(this._listeners).forEach(function (t) {
                e._listeners[t].forEach(function (i) {
                  e.unsubscribe(t, i);
                });
              }),
                (this._listeners = {});
            },
          },
        ]),
        e
      );
    })(),
    ee = window.Shopify,
    te = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this))._editor = new J()),
          (e._isEditorMode = ee.designMode),
          (e._listeners = {}),
          e
        );
      }
      return (
        p(i, [
          {
            key: "subscribe",
            value: function (e, t) {
              this._listeners[e] || (this._listeners[e] = []),
                this._listeners[e].push(t);
            },
          },
          {
            key: "unsubscribe",
            value: function (e, t) {
              this._listeners[e] &&
                (this._listeners[e] = this._listeners[e].filter(function (e) {
                  return e !== t;
                }));
            },
          },
          {
            key: "emit",
            value: function (e, t) {
              this._listeners[e] &&
                this._listeners[e].forEach(function (e) {
                  return e(t);
                });
            },
          },
        ]),
        i
      );
    })(D(HTMLElement)),
    ie = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleClick", function (t) {
            var i = t.target;
            if (i.hasAttribute("data-login-form-button")) {
              var n = i.dataset.loginFormId || "";
              e.setFormVisibleById(n), e.updateFocus();
            }
          }),
          (e.forms = b(e.querySelectorAll("[data-login-form]"))),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateFocus(),
                this.addEventListener("click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleClick);
            },
          },
          {
            key: "setFormVisibleById",
            value: function (e) {
              this.forms.forEach(function (t) {
                var i = t.getAttribute("data-login-form") === e;
                t.classList.toggle("hidden", !i);
              });
            },
          },
          {
            key: "updateFocus",
            value: function () {
              this.forms.forEach(function (e) {
                var t = e.classList.contains("hidden"),
                  i = e.querySelector('[type="email"]');
                !t && i && i.focus();
              });
            },
          },
        ]),
        i
      );
    })(te),
    ne = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleWindowScroll", function () {
            e.updateButtonVisible();
          }),
          f(x(e), "_handleButtonClick", function () {
            e.scrollToTop();
          }),
          (e.button = e.querySelector("[data-back-to-top-button]")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.button &&
                this.button.addEventListener("click", this._handleButtonClick),
                window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "updateButtonVisible",
            value: function () {
              if (this.button) {
                var e = window.scrollY > window.innerHeight;
                this.button.toggleAttribute("visible", e);
              }
            },
          },
          {
            key: "scrollToTop",
            value: function () {
              window.scrollTo({ top: 0, behavior: "smooth" });
            },
          },
        ]),
        i
      );
    })(D(HTMLElement)),
    se = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleWindowScroll", function () {
            var t = document.querySelector(
              ".shopify-section.shopify-section-header"
            );
            if (t && e.button) {
              var i =
                t.getBoundingClientRect().bottom + e.button.offsetHeight < 0;
              e.button.toggleAttribute("visible", i);
            }
          }),
          (e.button = e.querySelector("[data-cart-sticky-button]")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
        ]),
        i
      );
    })(D(HTMLElement)),
    ae = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleBlur", function (t) {
            if (e.input) {
              var i = t.target.value || "0";
              (e.input.value = i),
                e._updateButtonsDisabled(),
                (e._prevValue = i);
            }
          }),
          f(x(e), "_handleKeydown", function (t) {
            e.input &&
              K(t.key || t.keyCode) &&
              (t.preventDefault(), e.input.blur());
          }),
          f(x(e), "_handleInput", function (t) {
            if (e.input) {
              var i = t.target.value;
              (e.input.value = e._isMoreThanStock ? e._stockValue : i),
                e._updateButtonsDisabled(),
                (e._prevValue = i);
            }
          }),
          (e.inputSelector = "[data-quantity-input]"),
          (e.input = e.querySelector(e.inputSelector)),
          (e._prevValue = e._value),
          (e._stockValue = e.dataset.stock || "0"),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._updateButtonsDisabled(),
                j(this.input, "keypress", this._handleKeydown),
                j(this.input, "input", this._handleInput),
                j(this.input, "blur", this._handleBlur);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this.input, "keypress", this._handleKeydown),
                X(this.input, "input", this._handleInput),
                X(this.input, "blur", this._handleBlur);
            },
          },
          {
            key: "inputChange",
            value: function (e) {
              this.input &&
                ("minus" === e ? this.input.stepDown() : this.input.stepUp(),
                +this._prevValue != +this._value &&
                  this.input.dispatchEvent(
                    new Event("change", { bubbles: !0 })
                  ),
                this._updateButtonsDisabled());
            },
          },
          {
            key: "_updateButtonsDisabled",
            value: function () {
              this._updateButtonDisabled("minus", this._isLessThanMin),
                this._updateButtonDisabled("plus", this._isMoreThanStock);
            },
          },
          {
            key: "setDisable",
            value: function (e) {
              this._updateButtonDisabled("minus", e),
                this._updateButtonDisabled("plus", e);
            },
          },
          {
            key: "_updateButtonDisabled",
            value: function (e, t) {
              var i = this.querySelector(
                'quantity-btn[data-action="'.concat(e, '"]')
              );
              i && i.toggleAttribute("disabled", t);
            },
          },
          {
            key: "_value",
            get: function () {
              return this.input ? this.input.value : "0";
            },
          },
          {
            key: "_isLessThanMin",
            get: function () {
              return !!this.input && +this._value <= +this.input.min;
            },
          },
          {
            key: "_isMoreThanStock",
            get: function () {
              return +this._value >= +this._stockValue;
            },
          },
        ]),
        i
      );
    })(te),
    re = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleButtonClick", function (t) {
            t.preventDefault(), e.update();
          }),
          f(x(e), "_handleKeyDown", function (t) {
            var i = K(t.key || t.keyCode),
              n = t.target;
            i &&
              !n.hasAttribute("disabled") &&
              (t.preventDefault(), e.update());
          }),
          (e._quantity = e.closest("quantity-component")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("click", this._handleButtonClick),
                this.addEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleButtonClick),
                this.removeEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.dataset.action;
              this._quantity &&
                e &&
                (this._quantity.inputChange(e),
                "minus" === e && this._setDisabled());
            },
          },
          {
            key: "_setDisabled",
            value: function () {
              if (this._quantity && this._quantity.input) {
                var e = "1" === this._quantity.input.value;
                this.toggleAttribute("disabled", e);
              }
            },
          },
        ]),
        i
      );
    })(te),
    oe = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleClick", function (t) {
            t.preventDefault();
            var i = t.target;
            i.hasAttribute("data-localization-item") &&
              e.input &&
              e.form &&
              i.dataset.value &&
              ((e.input.value = i.dataset.value), e.form.submit());
          }),
          (e.inputSelector = "[data-localization-input]"),
          (e.formSelector = "form"),
          (e.input = e.querySelector(e.inputSelector)),
          (e.form = e.querySelector(e.formSelector)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "click", this._handleClick);
            },
          },
        ]),
        i
      );
    })(te),
    le = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleCloseButtonClick", function () {
            e.hide();
          }),
          (e._closeBtnSelector = "[data-notification-close-button]"),
          (e._alertSelector = "[data-notification-alert]"),
          (e._alertTextSelector = "[data-notification-alert-text]"),
          (e._closeBtn = e.querySelector(e._closeBtnSelector)),
          (e._alert = e.querySelector(e._alertSelector)),
          (e._alertText = e.querySelector(e._alertTextSelector)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._closeBtn &&
                this._closeBtn.addEventListener(
                  "click",
                  this._handleCloseButtonClick
                );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._closeBtn &&
                this._closeBtn.removeEventListener(
                  "click",
                  this._handleCloseButtonClick
                );
            },
          },
          {
            key: "show",
            value: function (e, t) {
              var i = this;
              this._setAlert(e, t || "warning"),
                this.showTimeoutId && clearTimeout(this.showTimeoutId),
                this._setVisible(!0),
                (this.showTimeoutId = setTimeout(function () {
                  i._setVisible(!1);
                }, 3e3));
            },
          },
          {
            key: "hide",
            value: function () {
              this._setVisible(!1);
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.toggleAttribute("open", e);
            },
          },
          {
            key: "_setAlert",
            value: function (e, t) {
              this._alert &&
                this._alertText &&
                (this._alert.setAttribute("alert-type", t),
                (this._alertText.innerHTML = e));
            },
          },
        ]),
        i
      );
    })(te);
  function ce(e, t) {
    return (
      (t = null != t ? t : {}),
      Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
        : (function (e, t) {
            var i = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(e);
              i.push.apply(i, n);
            }
            return i;
          })(Object(t)).forEach(function (i) {
            Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
          }),
      e
    );
  }
  var ue = (function () {
      "use strict";
      function e(t) {
        d(this, e), (this.element = t);
      }
      return (
        p(e, [
          {
            key: "update",
            value: function (e) {
              var t = e === this.element.getAttribute("data-id");
              this.element.classList.toggle("selected", t);
            },
          },
        ]),
        e
      );
    })(),
    de = function (e) {
      e && e.classList.remove("hidden");
    },
    he = function (e) {
      e && e.classList.add("hidden");
    },
    pe = function (e, t) {
      return getComputedStyle(e)[t];
    },
    fe = function (e) {
      return e.content.cloneNode(!0);
    },
    ve = function (e) {
      return e.content.firstElementChild.cloneNode(!0);
    },
    me = function (e, t) {
      e && e.classList.toggle("forward-transition", t);
    },
    ge = function (e) {
      return new DOMParser().parseFromString(e, "text/html");
    },
    ye = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleTabNameClick", function (t) {
            t.preventDefault();
            var i = t.target;
            i.dataset.id && e.selectTab(i.dataset.id);
          }),
          f(x(e), "_handleKeyDown", function (t) {
            var i = t.target;
            i.dataset.id &&
              K(t.key || t.keyCode) &&
              (t.preventDefault(), e.selectTab(i.dataset.id));
          }),
          (e.containerSelector = "[data-tabs-container]"),
          (e.templateSelector = "[data-tabs-elements-template]"),
          (e.tabSelector = "tab-component"),
          (e.tabNameSelector = "[data-tabs-name]"),
          (e.container = e.querySelector(e.containerSelector)),
          (e.template = e.querySelector(e.templateSelector)),
          (e.templateContent = fe(e.template)),
          (e.tabNames = b(e.querySelectorAll(e.tabNameSelector))),
          (e.tabMap = e.generateTabMap()),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this.tabNames.forEach(function (t) {
                t.addEventListener("keydown", e._handleKeyDown),
                  t.addEventListener("click", e._handleTabNameClick);
              });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.tabNames.forEach(function (t) {
                t.removeEventListener("keydown", e._handleKeyDown),
                  t.removeEventListener("click", e._handleTabNameClick);
              });
            },
          },
          {
            key: "generateTabMap",
            value: function () {
              return [this.querySelector(this.tabSelector)]
                .concat(
                  b(this.templateContent.querySelectorAll(this.tabSelector))
                )
                .reduce(function (e, t) {
                  var i = t.dataset.id;
                  return i ? ce(v({}, e), f({}, i, t)) : e;
                }, {});
            },
          },
          {
            key: "selectTab",
            value: function (e) {
              this._updateNameById(e),
                this._setTabById(e),
                this.emit("selectTab", e);
            },
          },
          {
            key: "_unmountTab",
            value: function (e) {
              e.remove();
            },
          },
          {
            key: "_mountTab",
            value: function (e) {
              this.container && this.container.appendChild(e);
            },
          },
          {
            key: "_updateNameById",
            value: function (e) {
              this.tabNames.forEach(function (t) {
                new ue(t).update(e);
              });
            },
          },
          {
            key: "_setTabById",
            value: function (e) {
              var t = this.tabMap[e],
                i = this.tabMap[this.dataset.selectedTabId];
              i &&
                t &&
                (this.showNextTab(t), i !== t && this.hideCurrentTab(i));
            },
          },
          {
            key: "showNextTab",
            value: function (e) {
              var t = e.getAttribute("data-id");
              t &&
                (this._mountTab(e), e.show(), (this.dataset.selectedTabId = t));
            },
          },
          {
            key: "hideCurrentTab",
            value: function (e) {
              var t = this;
              e.hide().then(function () {
                t._unmountTab(e);
              });
            },
          },
        ]),
        i
      );
    })(te),
    be = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "collapse", function () {
            e._hideItems(), he(e._collapseBtn), de(e._expandBtn);
          }),
          f(x(e), "expand", function () {
            e._initialHeight || e._setInitialHeight(),
              e._showItems(),
              e._tryHideExpandBtn(),
              de(e._collapseBtn),
              e._setMaxHeight();
          }),
          (e.itemSelector = "[data-list-item]"),
          (e.expandBtnSelector = 'list-btn[data-trigger="expand"]'),
          (e.collapseBtnSelector = 'list-btn[data-trigger="collapse"]'),
          (e.visibleItemSelector = "".concat(e.itemSelector, ":not(.hidden)")),
          (e.hiddenItemSelector = "".concat(e.itemSelector, ".hidden")),
          (e._expandBtn = e.querySelector(e.expandBtnSelector)),
          (e._collapseBtn = e.querySelector(e.collapseBtnSelector)),
          (e.styles = getComputedStyle(x(e))),
          e
        );
      }
      return (
        p(i, [
          {
            key: "_setInitialHeight",
            value: function () {
              (this._initialHeight = this.offsetHeight),
                (this.style.maxHeight = "".concat(this._initialHeight, "px"));
            },
          },
          {
            key: "_setMaxHeight",
            value: function () {
              (this._maxHeight = this.scrollHeight),
                (this.style.maxHeight = "".concat(this._maxHeight, "px"));
            },
          },
          {
            key: "_hideItems",
            value: function () {
              var e = this,
                t = this.querySelectorAll(this.visibleItemSelector);
              (this.style.maxHeight = "".concat(this._initialHeight, "px")),
                setTimeout(function () {
                  t.forEach(function (t, i) {
                    i + 1 >
                      +(e.dataset.initialCount ? +e.dataset.initialCount : 0) &&
                      he(t);
                  });
                }, this._transitionDuration);
            },
          },
          {
            key: "_showItems",
            value: function () {
              var e = this;
              this.querySelectorAll(this.hiddenItemSelector).forEach(function (
                t,
                i
              ) {
                i + 1 < +(e.dataset.showCount ? e.dataset.showCount : 0) &&
                  de(t);
              }),
                (this.style.maxHeight = "".concat(this._maxHeight, "px"));
            },
          },
          {
            key: "_tryHideExpandBtn",
            value: function () {
              0 === this.querySelectorAll(this.hiddenItemSelector).length &&
                he(this._expandBtn);
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        i
      );
    })(te),
    we = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.update();
            }
          ),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e.update());
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.closest("list-component");
              e &&
                ("collapse" === this.dataset.trigger
                  ? e.collapse()
                  : e.expand(),
                this.emit("click", e));
            },
          },
        ]),
        i
      );
    })(te),
    Se = we;
  function xe(e, t, i, n, s, a, r) {
    try {
      var o = e[a](r),
        l = o.value;
    } catch (e) {
      return void i(e);
    }
    o.done ? t(l) : Promise.resolve(l).then(n, s);
  }
  function Ce(e) {
    return function () {
      var t = this,
        i = arguments;
      return new Promise(function (n, s) {
        var a = e.apply(t, i);
        function r(e) {
          xe(a, n, s, r, o, "next", e);
        }
        function o(e) {
          xe(a, n, s, r, o, "throw", e);
        }
        r(void 0);
      });
    };
  }
  function ke(e, t) {
    if (null == e) return {};
    var i,
      n,
      s = (function (e, t) {
        if (null == e) return {};
        var i,
          n,
          s = {},
          a = Object.keys(e);
        for (n = 0; n < a.length; n++)
          (i = a[n]), t.indexOf(i) >= 0 || (s[i] = e[i]);
        return s;
      })(e, t);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (n = 0; n < a.length; n++)
        (i = a[n]),
          t.indexOf(i) >= 0 ||
            (Object.prototype.propertyIsEnumerable.call(e, i) && (s[i] = e[i]));
    }
    return s;
  }
  function Ee(e, t) {
    var i,
      n,
      s,
      a,
      r = function (e) {
        return function (t) {
          return o([e, t]);
        };
      },
      o = function (r) {
        if (i) throw new TypeError("Generator is already executing.");
        for (; a && ((a = 0), r[0] && (l = 0)), l; )
          try {
            if (
              ((i = 1),
              n &&
                (s =
                  2 & r[0]
                    ? n.return
                    : r[0]
                    ? n.throw || ((s = n.return) && s.call(n), 0)
                    : n.next) &&
                !(s = s.call(n, r[1])).done)
            )
              return s;
            switch (((n = 0), s && (r = [2 & r[0], s.value]), r[0])) {
              case 0:
              case 1:
                s = r;
                break;
              case 4:
                return l.label++, { value: r[1], done: !1 };
              case 5:
                l.label++, (n = r[1]), (r = [0]);
                continue;
              case 7:
                (r = l.ops.pop()), l.trys.pop();
                continue;
              default:
                if (
                  !(
                    (s = (s = l.trys).length > 0 && s[s.length - 1]) ||
                    (6 !== r[0] && 2 !== r[0])
                  )
                ) {
                  l = 0;
                  continue;
                }
                if (3 === r[0] && (!s || (r[1] > s[0] && r[1] < s[3]))) {
                  l.label = r[1];
                  break;
                }
                if (6 === r[0] && l.label < s[1]) {
                  (l.label = s[1]), (s = r);
                  break;
                }
                if (s && l.label < s[2]) {
                  (l.label = s[2]), l.ops.push(r);
                  break;
                }
                s[2] && l.ops.pop(), l.trys.pop();
                continue;
            }
            r = t.call(e, l);
          } catch (e) {
            (r = [6, e]), (n = 0);
          } finally {
            i = s = 0;
          }
        if (5 & r[0]) throw r[1];
        return { value: r[0] ? r[1] : void 0, done: !0 };
      },
      l = {
        label: 0,
        sent: function () {
          if (1 & s[0]) throw s[1];
          return s[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (a = { next: r(0), throw: r(1), return: r(2) }),
      "function" == typeof Symbol &&
        (a[Symbol.iterator] = function () {
          return this;
        }),
      a
    );
  }
  function Te(e) {
    return e.split("-")[1];
  }
  function _e(e) {
    return "y" === e ? "height" : "width";
  }
  function Me(e) {
    return e.split("-")[0];
  }
  function Le(e) {
    return ["top", "bottom"].includes(Me(e)) ? "x" : "y";
  }
  function Pe(e, t, i) {
    var n,
      s = e.reference,
      a = e.floating,
      r = s.x + s.width / 2 - a.width / 2,
      o = s.y + s.height / 2 - a.height / 2,
      l = Le(t),
      c = _e(l),
      u = s[c] / 2 - a[c] / 2,
      d = "x" === l;
    switch (Me(t)) {
      case "top":
        n = { x: r, y: s.y - a.height };
        break;
      case "bottom":
        n = { x: r, y: s.y + s.height };
        break;
      case "right":
        n = { x: s.x + s.width, y: o };
        break;
      case "left":
        n = { x: s.x - a.width, y: o };
        break;
      default:
        n = { x: s.x, y: s.y };
    }
    switch (Te(t)) {
      case "start":
        n[l] -= u * (i && d ? -1 : 1);
        break;
      case "end":
        n[l] += u * (i && d ? -1 : 1);
    }
    return n;
  }
  Object.create, Object.create;
  var Ie,
    De =
      ((Ie = Ce(function (e, t, i) {
        var n,
          s,
          a,
          r,
          o,
          l,
          c,
          u,
          d,
          h,
          p,
          m,
          g,
          y,
          b,
          w,
          S,
          x,
          C,
          k,
          E,
          T,
          _,
          M,
          L,
          P;
        return Ee(this, function (I) {
          switch (I.label) {
            case 0:
              return (
                (n = i.placement),
                (s = void 0 === n ? "bottom" : n),
                (a = i.strategy),
                (r = void 0 === a ? "absolute" : a),
                (o = i.middleware),
                (l = void 0 === o ? [] : o),
                (c = i.platform),
                (u = l.filter(Boolean)),
                [4, null == c.isRTL ? void 0 : c.isRTL(t)]
              );
            case 1:
              return (
                (d = I.sent()),
                [
                  4,
                  c.getElementRects({ reference: e, floating: t, strategy: r }),
                ]
              );
            case 2:
              (h = I.sent()),
                (p = Pe(h, s, d)),
                (m = p.x),
                (g = p.y),
                (y = s),
                (b = {}),
                (w = 0),
                (S = 0),
                (I.label = 3);
            case 3:
              return S < u.length
                ? ((x = u[S]),
                  (C = x.name),
                  [
                    4,
                    (0, x.fn)({
                      x: m,
                      y: g,
                      initialPlacement: s,
                      placement: y,
                      strategy: r,
                      middlewareData: b,
                      rects: h,
                      platform: c,
                      elements: { reference: e, floating: t },
                    }),
                  ])
                : [3, 11];
            case 4:
              return (
                (k = I.sent()),
                (E = k.x),
                (T = k.y),
                (_ = k.data),
                (M = k.reset),
                (m = null != E ? E : m),
                (g = null != T ? T : g),
                (b = ce(v({}, b), f({}, C, v({}, b[C], _)))),
                M && w <= 50
                  ? (w++,
                    "object" != typeof M
                      ? [3, 9]
                      : (M.placement && (y = M.placement),
                        M.rects
                          ? !0 !== M.rects
                            ? [3, 6]
                            : [
                                4,
                                c.getElementRects({
                                  reference: e,
                                  floating: t,
                                  strategy: r,
                                }),
                              ]
                          : [3, 8]))
                  : [3, 10]
              );
            case 5:
              return (L = I.sent()), [3, 7];
            case 6:
              (L = M.rects), (I.label = 7);
            case 7:
              (h = L), (I.label = 8);
            case 8:
              (P = Pe(h, y, d)), (m = P.x), (g = P.y), (I.label = 9);
            case 9:
              return (S = -1), [3, 10];
            case 10:
              return S++, [3, 3];
            case 11:
              return [
                2,
                { x: m, y: g, placement: y, strategy: r, middlewareData: b },
              ];
          }
        });
      })),
      function (e, t, i) {
        return Ie.apply(this, arguments);
      });
  function Ae(e) {
    return "number" != typeof e
      ? (function (e) {
          return v({ top: 0, right: 0, bottom: 0, left: 0 }, e);
        })(e)
      : { top: e, right: e, bottom: e, left: e };
  }
  function ze(e) {
    return ce(v({}, e), {
      top: e.y,
      left: e.x,
      right: e.x + e.width,
      bottom: e.y + e.height,
    });
  }
  function Oe(e, t) {
    return Be.apply(this, arguments);
  }
  function Be() {
    return (Be = Ce(function (e, t) {
      var i,
        n,
        s,
        a,
        r,
        o,
        l,
        c,
        u,
        d,
        h,
        p,
        f,
        m,
        g,
        y,
        b,
        w,
        S,
        x,
        C,
        k,
        E,
        T,
        _,
        M,
        L,
        P,
        I,
        D;
      return Ee(this, function (A) {
        switch (A.label) {
          case 0:
            return (
              void 0 === t && (t = {}),
              (n = e.x),
              (s = e.y),
              (a = e.platform),
              (r = e.rects),
              (o = e.elements),
              (l = e.strategy),
              (c = t.boundary),
              (u = void 0 === c ? "clippingAncestors" : c),
              (d = t.rootBoundary),
              (h = void 0 === d ? "viewport" : d),
              (p = t.elementContext),
              (f = void 0 === p ? "floating" : p),
              (m = t.altBoundary),
              (g = void 0 !== m && m),
              (y = t.padding),
              (b = Ae(void 0 === y ? 0 : y)),
              (w = "floating" === f ? "reference" : "floating"),
              (S = o[g ? w : f]),
              (C = a.getClippingRect),
              (k = {}),
              [4, null == a.isElement ? void 0 : a.isElement(S)]
            );
          case 1:
            return null == (i = A.sent()) || i ? ((E = S), [3, 5]) : [3, 2];
          case 2:
            return (T = S.contextElement)
              ? [3, 4]
              : [
                  4,
                  null == a.getDocumentElement
                    ? void 0
                    : a.getDocumentElement(o.floating),
                ];
          case 3:
            (T = A.sent()), (A.label = 4);
          case 4:
            (E = T), (A.label = 5);
          case 5:
            return [
              4,
              C.apply(a, [
                ((k.element = E),
                (k.boundary = u),
                (k.rootBoundary = h),
                (k.strategy = l),
                k),
              ]),
            ];
          case 6:
            return (
              (x = ze.apply(void 0, [A.sent()])),
              (_ =
                "floating" === f
                  ? ce(v({}, r.floating), { x: n, y: s })
                  : r.reference),
              [
                4,
                null == a.getOffsetParent
                  ? void 0
                  : a.getOffsetParent(o.floating),
              ]
            );
          case 7:
            return (
              (M = A.sent()), [4, null == a.isElement ? void 0 : a.isElement(M)]
            );
          case 8:
            return A.sent()
              ? [4, null == a.getScale ? void 0 : a.getScale(M)]
              : [3, 10];
          case 9:
            return (P = A.sent() || { x: 1, y: 1 }), [3, 11];
          case 10:
            (P = { x: 1, y: 1 }), (A.label = 11);
          case 11:
            return (
              (L = P),
              a.convertOffsetParentRelativeRectToViewportRelativeRect
                ? [
                    4,
                    a.convertOffsetParentRelativeRectToViewportRelativeRect({
                      rect: _,
                      offsetParent: M,
                      strategy: l,
                    }),
                  ]
                : [3, 13]
            );
          case 12:
            return (D = A.sent()), [3, 14];
          case 13:
            (D = _), (A.label = 14);
          case 14:
            return (
              (I = ze.apply(void 0, [D])),
              [
                2,
                {
                  top: (x.top - I.top + b.top) / L.y,
                  bottom: (I.bottom - x.bottom + b.bottom) / L.y,
                  left: (x.left - I.left + b.left) / L.x,
                  right: (I.right - x.right + b.right) / L.x,
                },
              ]
            );
        }
      });
    })).apply(this, arguments);
  }
  var Ne = Math.min,
    qe = Math.max;
  function $e(e, t, i) {
    return qe(e, Ne(t, i));
  }
  var He = function (e) {
      return {
        name: "arrow",
        options: e,
        fn: function (t) {
          return Ce(function () {
            var i,
              n,
              s,
              a,
              r,
              o,
              l,
              c,
              u,
              d,
              h,
              p,
              v,
              m,
              g,
              y,
              b,
              w,
              S,
              x,
              C,
              k,
              E,
              T,
              _,
              M,
              L,
              P,
              I,
              D,
              A,
              z,
              O;
            return Ee(this, function (B) {
              switch (B.label) {
                case 0:
                  return (
                    (n = (i = e || {}).element),
                    (s = i.padding),
                    (a = void 0 === s ? 0 : s),
                    (r = t.x),
                    (o = t.y),
                    (l = t.placement),
                    (c = t.rects),
                    (u = t.platform),
                    (d = t.elements),
                    null == n
                      ? [2, {}]
                      : ((h = Ae(a)),
                        (p = { x: r, y: o }),
                        (v = Le(l)),
                        (m = _e(v)),
                        [4, u.getDimensions(n)])
                  );
                case 1:
                  return (
                    (g = B.sent()),
                    (b = (y = "y" === v) ? "top" : "left"),
                    (w = y ? "bottom" : "right"),
                    (S = y ? "clientHeight" : "clientWidth"),
                    (x =
                      c.reference[m] + c.reference[v] - p[v] - c.floating[m]),
                    (C = p[v] - c.reference[v]),
                    [
                      4,
                      null == u.getOffsetParent ? void 0 : u.getOffsetParent(n),
                    ]
                  );
                case 2:
                  return (
                    (k = B.sent()),
                    (E = k ? k[S] : 0),
                    (T = !E)
                      ? [3, 4]
                      : [4, null == u.isElement ? void 0 : u.isElement(k)]
                  );
                case 3:
                  (T = !B.sent()), (B.label = 4);
                case 4:
                  return (
                    T && (E = d.floating[S] || c.floating[m]),
                    (_ = x / 2 - C / 2),
                    (M = h[b]),
                    (L = E - g[m] - h[w]),
                    (P = E / 2 - g[m] / 2 + _),
                    (I = $e(M, P, L)),
                    (D =
                      null != Te(l) &&
                      P != I &&
                      c.reference[m] / 2 - (P < M ? h[b] : h[w]) - g[m] / 2 <
                        0),
                    (A = D ? (P < M ? M - P : L - P) : 0),
                    [
                      2,
                      ((O = {}),
                      f(O, v, p[v] - A),
                      f(
                        O,
                        "data",
                        ((z = {}), f(z, v, I), f(z, "centerOffset", P - I), z)
                      ),
                      O),
                    ]
                  );
              }
            });
          })();
        },
      };
    },
    Fe = { left: "right", right: "left", bottom: "top", top: "bottom" };
  function Ve(e) {
    return e.replace(/left|right|bottom|top/g, function (e) {
      return Fe[e];
    });
  }
  var Re = { start: "end", end: "start" };
  function je(e) {
    return e.replace(/start|end/g, function (e) {
      return Re[e];
    });
  }
  var Xe = function (e) {
    return (
      void 0 === e && (e = {}),
      {
        name: "flip",
        options: e,
        fn: function (t) {
          return Ce(function () {
            var i,
              n,
              s,
              a,
              r,
              o,
              l,
              c,
              u,
              d,
              h,
              p,
              f,
              v,
              m,
              g,
              y,
              w,
              S,
              x,
              C,
              k,
              E,
              T,
              _,
              M,
              L,
              P,
              I,
              D,
              A,
              z,
              O,
              B,
              N,
              q,
              $,
              H;
            return Ee(this, function (F) {
              switch (F.label) {
                case 0:
                  return (
                    (s = t.placement),
                    (a = t.middlewareData),
                    (r = t.rects),
                    (o = t.initialPlacement),
                    (l = t.platform),
                    (c = t.elements),
                    (u = e.mainAxis),
                    (d = void 0 === u || u),
                    (h = e.crossAxis),
                    (p = void 0 === h || h),
                    (f = e.fallbackPlacements),
                    (v = e.fallbackStrategy),
                    (m = void 0 === v ? "bestFit" : v),
                    (g = e.fallbackAxisSideDirection),
                    (y = void 0 === g ? "none" : g),
                    (w = e.flipAlignment),
                    (S = void 0 === w || w),
                    (x = ke(e, [
                      "mainAxis",
                      "crossAxis",
                      "fallbackPlacements",
                      "fallbackStrategy",
                      "fallbackAxisSideDirection",
                      "flipAlignment",
                    ])),
                    (C = Me(s)),
                    (k = Me(o) === o),
                    [4, null == l.isRTL ? void 0 : l.isRTL(c.floating)]
                  );
                case 1:
                  return (
                    (E = F.sent()),
                    (T =
                      f ||
                      (k || !S
                        ? [Ve(o)]
                        : (function (e) {
                            var t = Ve(e);
                            return [je(e), t, je(t)];
                          })(o))),
                    f ||
                      "none" === y ||
                      (i = T).push.apply(
                        i,
                        b(
                          (function (e, t, i, n) {
                            var s = Te(e),
                              a = (function (e, t, i) {
                                var n = ["left", "right"],
                                  s = ["right", "left"];
                                switch (e) {
                                  case "top":
                                  case "bottom":
                                    return i ? (t ? s : n) : t ? n : s;
                                  case "left":
                                  case "right":
                                    return t
                                      ? ["top", "bottom"]
                                      : ["bottom", "top"];
                                  default:
                                    return [];
                                }
                              })(Me(e), "start" === i, n);
                            return (
                              s &&
                                ((a = a.map(function (e) {
                                  return e + "-" + s;
                                })),
                                t && (a = a.concat(a.map(je)))),
                              a
                            );
                          })(o, S, y, E)
                        )
                      ),
                    (_ = [o].concat(b(T))),
                    [4, Oe(t, x)]
                  );
                case 2:
                  if (
                    ((M = F.sent()),
                    (L = []),
                    (P = (null == (n = a.flip) ? void 0 : n.overflows) || []),
                    d && L.push(M[C]),
                    p &&
                      ((I = (function (e, t, i) {
                        void 0 === i && (i = !1);
                        var n = Te(e),
                          s = Le(e),
                          a = _e(s),
                          r =
                            "x" === s
                              ? n === (i ? "end" : "start")
                                ? "right"
                                : "left"
                              : "start" === n
                              ? "bottom"
                              : "top";
                        return (
                          t.reference[a] > t.floating[a] && (r = Ve(r)),
                          { main: r, cross: Ve(r) }
                        );
                      })(s, r, E)),
                      (D = I.main),
                      (A = I.cross),
                      L.push(M[D], M[A])),
                    (P = b(P).concat([{ placement: s, overflows: L }])),
                    !L.every(function (e) {
                      return e <= 0;
                    }))
                  ) {
                    if (
                      ((B =
                        ((null == (z = a.flip) ? void 0 : z.index) || 0) + 1),
                      (N = _[B]))
                    )
                      return [
                        2,
                        {
                          data: { index: B, overflows: P },
                          reset: { placement: N },
                        },
                      ];
                    if (
                      !(q =
                        null ==
                        (O = P.filter(function (e) {
                          return e.overflows[0] <= 0;
                        }).sort(function (e, t) {
                          return e.overflows[1] - t.overflows[1];
                        })[0])
                          ? void 0
                          : O.placement)
                    )
                      switch (m) {
                        case "bestFit":
                          (H =
                            null ==
                            ($ = P.map(function (e) {
                              return [
                                e.placement,
                                e.overflows
                                  .filter(function (e) {
                                    return e > 0;
                                  })
                                  .reduce(function (e, t) {
                                    return e + t;
                                  }, 0),
                              ];
                            }).sort(function (e, t) {
                              return e[1] - t[1];
                            })[0])
                              ? void 0
                              : $[0]),
                            H && (q = H);
                          break;
                        case "initialPlacement":
                          q = o;
                      }
                    if (s !== q) return [2, { reset: { placement: q } }];
                  }
                  return [2, {}];
              }
            });
          })();
        },
      }
    );
  };
  function Ge(e, t) {
    return We.apply(this, arguments);
  }
  function We() {
    return (
      (We = Ce(function (e, t) {
        var i, n, s, a, r, o, l, c, u, d, h, p, f, m;
        return Ee(this, function (g) {
          switch (g.label) {
            case 0:
              return (
                (i = e.placement),
                (n = e.platform),
                (s = e.elements),
                [4, null == n.isRTL ? void 0 : n.isRTL(s.floating)]
              );
            case 1:
              return (
                (a = g.sent()),
                (r = Me(i)),
                (o = Te(i)),
                (l = "x" === Le(i)),
                (c = ["left", "top"].includes(r) ? -1 : 1),
                (u = a && l ? -1 : 1),
                (d = "function" == typeof t ? t(e) : t),
                (h =
                  "number" == typeof d
                    ? { mainAxis: d, crossAxis: 0, alignmentAxis: null }
                    : v({ mainAxis: 0, crossAxis: 0, alignmentAxis: null }, d)),
                (p = h.mainAxis),
                (f = h.crossAxis),
                (m = h.alignmentAxis),
                o && "number" == typeof m && (f = "end" === o ? -1 * m : m),
                [2, l ? { x: f * u, y: p * c } : { x: p * c, y: f * u }]
              );
          }
        });
      })),
      We.apply(this, arguments)
    );
  }
  var Ye = function (e) {
    return (
      void 0 === e && (e = 0),
      {
        name: "offset",
        options: e,
        fn: function (t) {
          return Ce(function () {
            var i, n, s;
            return Ee(this, function (a) {
              switch (a.label) {
                case 0:
                  return (i = t.x), (n = t.y), [4, Ge(t, e)];
                case 1:
                  return (
                    (s = a.sent()), [2, { x: i + s.x, y: n + s.y, data: s }]
                  );
              }
            });
          })();
        },
      }
    );
  };
  var Ue,
    Ke = function (e) {
      return (
        void 0 === e && (e = {}),
        {
          name: "shift",
          options: e,
          fn: function (t) {
            return Ce(function () {
              var i,
                n,
                s,
                a,
                r,
                o,
                l,
                c,
                u,
                d,
                h,
                p,
                m,
                g,
                y,
                b,
                w,
                S,
                x,
                C,
                k,
                E,
                T,
                _;
              return Ee(this, function (M) {
                switch (M.label) {
                  case 0:
                    return (
                      (i = t.x),
                      (n = t.y),
                      (s = t.placement),
                      (a = e.mainAxis),
                      (r = void 0 === a || a),
                      (o = e.crossAxis),
                      (l = void 0 !== o && o),
                      (c = e.limiter),
                      (u =
                        void 0 === c
                          ? {
                              fn: function (e) {
                                return { x: e.x, y: e.y };
                              },
                            }
                          : c),
                      (d = ke(e, ["mainAxis", "crossAxis", "limiter"])),
                      (h = { x: i, y: n }),
                      [4, Oe(t, d)]
                    );
                  case 1:
                    return (
                      (p = M.sent()),
                      (m = Le(Me(s))),
                      (g = (function (e) {
                        return "x" === e ? "y" : "x";
                      })(m)),
                      (y = h[m]),
                      (b = h[g]),
                      r &&
                        ((w = "y" === m ? "bottom" : "right"),
                        (S = y + p["y" === m ? "top" : "left"]),
                        (x = y - p[w]),
                        (y = $e(S, y, x))),
                      l &&
                        ((C = "y" === g ? "bottom" : "right"),
                        (k = b + p["y" === g ? "top" : "left"]),
                        (E = b - p[C]),
                        (b = $e(k, b, E))),
                      (_ = u.fn(
                        ce(v({}, t), (f((T = {}), m, y), f(T, g, b), T))
                      )),
                      [2, ce(v({}, _), { data: { x: _.x - i, y: _.y - n } })]
                    );
                }
              });
            })();
          },
        }
      );
    };
  function Qe(e) {
    var t;
    return (null == (t = e.ownerDocument) ? void 0 : t.defaultView) || window;
  }
  function Ze(e) {
    return Qe(e).getComputedStyle(e);
  }
  function Je(e) {
    return e instanceof Qe(e).Node;
  }
  function et(e) {
    return Je(e) ? (e.nodeName || "").toLowerCase() : "";
  }
  function tt() {
    if (Ue) return Ue;
    var e = navigator.userAgentData;
    return e && Array.isArray(e.brands)
      ? (Ue = e.brands
          .map(function (e) {
            return e.brand + "/" + e.version;
          })
          .join(" "))
      : navigator.userAgent;
  }
  function it(e) {
    return e instanceof Qe(e).HTMLElement;
  }
  function nt(e) {
    return e instanceof Qe(e).Element;
  }
  function st(e) {
    return (
      "undefined" != typeof ShadowRoot &&
      (e instanceof Qe(e).ShadowRoot || e instanceof ShadowRoot)
    );
  }
  function at(e) {
    var t = Ze(e),
      i = t.overflow,
      n = t.overflowX,
      s = t.overflowY,
      a = t.display;
    return (
      /auto|scroll|overlay|hidden|clip/.test(i + s + n) &&
      !["inline", "contents"].includes(a)
    );
  }
  function rt(e) {
    return ["table", "td", "th"].includes(et(e));
  }
  function ot(e) {
    var t = /firefox/i.test(tt()),
      i = Ze(e),
      n = i.backdropFilter || i.WebkitBackdropFilter;
    return (
      "none" !== i.transform ||
      "none" !== i.perspective ||
      (!!n && "none" !== n) ||
      (t && "filter" === i.willChange) ||
      (t && !!i.filter && "none" !== i.filter) ||
      ["transform", "perspective"].some(function (e) {
        return i.willChange.includes(e);
      }) ||
      ["paint", "layout", "strict", "content"].some(function (e) {
        var t = i.contain;
        return null != t && t.includes(e);
      })
    );
  }
  function lt() {
    return /^((?!chrome|android).)*safari/i.test(tt());
  }
  function ct(e) {
    return ["html", "body", "#document"].includes(et(e));
  }
  var ut = Math.min,
    dt = Math.max,
    ht = Math.round;
  function pt(e) {
    var t = Ze(e),
      i = parseFloat(t.width),
      n = parseFloat(t.height),
      s = it(e),
      a = s ? e.offsetWidth : i,
      r = s ? e.offsetHeight : n,
      o = ht(i) !== a || ht(n) !== r;
    return o && ((i = a), (n = r)), { width: i, height: n, fallback: o };
  }
  function ft(e) {
    return nt(e) ? e : e.contextElement;
  }
  var vt = { x: 1, y: 1 };
  function mt(e) {
    var t = ft(e);
    if (!it(t)) return vt;
    var i = t.getBoundingClientRect(),
      n = pt(t),
      s = n.width,
      a = n.height,
      r = n.fallback,
      o = (r ? ht(i.width) : i.width) / s,
      l = (r ? ht(i.height) : i.height) / a;
    return (
      (o && Number.isFinite(o)) || (o = 1),
      (l && Number.isFinite(l)) || (l = 1),
      { x: o, y: l }
    );
  }
  function gt(e, t, i, n) {
    var s, a;
    void 0 === t && (t = !1), void 0 === i && (i = !1);
    var r = e.getBoundingClientRect(),
      o = ft(e),
      l = vt;
    t && (n ? nt(n) && (l = mt(n)) : (l = mt(e)));
    var c = o ? Qe(o) : window,
      u = lt() && i,
      d =
        (r.left +
          ((u && (null == (s = c.visualViewport) ? void 0 : s.offsetLeft)) ||
            0)) /
        l.x,
      h =
        (r.top +
          ((u && (null == (a = c.visualViewport) ? void 0 : a.offsetTop)) ||
            0)) /
        l.y,
      p = r.width / l.x,
      f = r.height / l.y;
    if (o)
      for (
        var v = Qe(o), m = n && nt(n) ? Qe(n) : n, g = v.frameElement;
        g && n && m !== v;

      ) {
        var y = mt(g),
          b = g.getBoundingClientRect(),
          w = getComputedStyle(g);
        (b.x += (g.clientLeft + parseFloat(w.paddingLeft)) * y.x),
          (b.y += (g.clientTop + parseFloat(w.paddingTop)) * y.y),
          (d *= y.x),
          (h *= y.y),
          (p *= y.x),
          (f *= y.y),
          (d += b.x),
          (h += b.y),
          (g = Qe(g).frameElement);
      }
    return ze({ width: p, height: f, x: d, y: h });
  }
  function yt(e) {
    return ((Je(e) ? e.ownerDocument : e.document) || window.document)
      .documentElement;
  }
  function bt(e) {
    return nt(e)
      ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop }
      : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
  }
  function wt(e) {
    return gt(yt(e)).left + bt(e).scrollLeft;
  }
  function St(e) {
    if ("html" === et(e)) return e;
    var t = e.assignedSlot || e.parentNode || (st(e) && e.host) || yt(e);
    return st(t) ? t.host : t;
  }
  function xt(e) {
    var t = St(e);
    return ct(t) ? t.ownerDocument.body : it(t) && at(t) ? t : xt(t);
  }
  function Ct(e, t) {
    var i;
    void 0 === t && (t = []);
    var n = xt(e),
      s = n === (null == (i = e.ownerDocument) ? void 0 : i.body),
      a = Qe(n);
    return s
      ? t.concat(a, a.visualViewport || [], at(n) ? n : [])
      : t.concat(n, Ct(n));
  }
  function kt(e, t, i) {
    var n;
    if ("viewport" === t)
      n = (function (e, t) {
        var i = Qe(e),
          n = yt(e),
          s = i.visualViewport,
          a = n.clientWidth,
          r = n.clientHeight,
          o = 0,
          l = 0;
        if (s) {
          (a = s.width), (r = s.height);
          var c = lt();
          (!c || (c && "fixed" === t)) &&
            ((o = s.offsetLeft), (l = s.offsetTop));
        }
        return { width: a, height: r, x: o, y: l };
      })(e, i);
    else if ("document" === t)
      n = (function (e) {
        var t = yt(e),
          i = bt(e),
          n = e.ownerDocument.body,
          s = dt(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth),
          a = dt(
            t.scrollHeight,
            t.clientHeight,
            n.scrollHeight,
            n.clientHeight
          ),
          r = -i.scrollLeft + wt(e),
          o = -i.scrollTop;
        return (
          "rtl" === Ze(n).direction &&
            (r += dt(t.clientWidth, n.clientWidth) - s),
          { width: s, height: a, x: r, y: o }
        );
      })(yt(e));
    else if (nt(t))
      n = (function (e, t) {
        var i = gt(e, !0, "fixed" === t),
          n = i.top + e.clientTop,
          s = i.left + e.clientLeft,
          a = it(e) ? mt(e) : { x: 1, y: 1 };
        return {
          width: e.clientWidth * a.x,
          height: e.clientHeight * a.y,
          x: s * a.x,
          y: n * a.y,
        };
      })(t, i);
    else {
      var s = v({}, t);
      if (lt()) {
        var a,
          r,
          o = Qe(e);
        (s.x -= (null == (a = o.visualViewport) ? void 0 : a.offsetLeft) || 0),
          (s.y -= (null == (r = o.visualViewport) ? void 0 : r.offsetTop) || 0);
      }
      n = s;
    }
    return ze(n);
  }
  function Et(e, t) {
    var i = St(e);
    return (
      !(i === t || !nt(i) || ct(i)) && ("fixed" === Ze(i).position || Et(i, t))
    );
  }
  function Tt(e, t) {
    return it(e) && "fixed" !== Ze(e).position
      ? t
        ? t(e)
        : e.offsetParent
      : null;
  }
  function _t(e, t) {
    var i = Qe(e);
    if (!it(e)) return i;
    for (var n = Tt(e, t); n && rt(n) && "static" === Ze(n).position; )
      n = Tt(n, t);
    return n &&
      ("html" === et(n) ||
        ("body" === et(n) && "static" === Ze(n).position && !ot(n)))
      ? i
      : n ||
          (function (e) {
            for (var t = St(e); it(t) && !ct(t); ) {
              if (ot(t)) return t;
              t = St(t);
            }
            return null;
          })(e) ||
          i;
  }
  function Mt(e, t, i) {
    var n = it(t),
      s = yt(t),
      a = gt(e, !0, "fixed" === i, t),
      r = { scrollLeft: 0, scrollTop: 0 },
      o = { x: 0, y: 0 };
    if (n || (!n && "fixed" !== i))
      if ((("body" !== et(t) || at(s)) && (r = bt(t)), it(t))) {
        var l = gt(t, !0);
        (o.x = l.x + t.clientLeft), (o.y = l.y + t.clientTop);
      } else s && (o.x = wt(s));
    return {
      x: a.left + r.scrollLeft - o.x,
      y: a.top + r.scrollTop - o.y,
      width: a.width,
      height: a.height,
    };
  }
  var Lt = {
    getClippingRect: function (e) {
      var t = e.element,
        i = e.boundary,
        n = e.rootBoundary,
        s = e.strategy,
        a = b(
          "clippingAncestors" === i
            ? (function (e, t) {
                var i = t.get(e);
                if (i) return i;
                for (
                  var n = Ct(e).filter(function (e) {
                      return nt(e) && "body" !== et(e);
                    }),
                    s = null,
                    a = "fixed" === Ze(e).position,
                    r = a ? St(e) : e;
                  nt(r) && !ct(r);

                ) {
                  var o = Ze(r),
                    l = ot(r);
                  l || "fixed" !== o.position || (s = null),
                    (
                      a
                        ? !l && !s
                        : (!l &&
                            "static" === o.position &&
                            s &&
                            ["absolute", "fixed"].includes(s.position)) ||
                          (at(r) && !l && Et(e, r))
                    )
                      ? (n = n.filter(function (e) {
                          return e !== r;
                        }))
                      : (s = o),
                    (r = St(r));
                }
                return t.set(e, n), n;
              })(t, this._c)
            : [].concat(i)
        ).concat([n]),
        r = a[0],
        o = a.reduce(function (e, i) {
          var n = kt(t, i, s);
          return (
            (e.top = dt(n.top, e.top)),
            (e.right = ut(n.right, e.right)),
            (e.bottom = ut(n.bottom, e.bottom)),
            (e.left = dt(n.left, e.left)),
            e
          );
        }, kt(t, r, s));
      return {
        width: o.right - o.left,
        height: o.bottom - o.top,
        x: o.left,
        y: o.top,
      };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function (e) {
      var t = e.rect,
        i = e.offsetParent,
        n = e.strategy,
        s = it(i),
        a = yt(i);
      if (i === a) return t;
      var r = { scrollLeft: 0, scrollTop: 0 },
        o = { x: 1, y: 1 },
        l = { x: 0, y: 0 };
      if (
        (s || (!s && "fixed" !== n)) &&
        (("body" !== et(i) || at(a)) && (r = bt(i)), it(i))
      ) {
        var c = gt(i);
        (o = mt(i)), (l.x = c.x + i.clientLeft), (l.y = c.y + i.clientTop);
      }
      return {
        width: t.width * o.x,
        height: t.height * o.y,
        x: t.x * o.x - r.scrollLeft * o.x + l.x,
        y: t.y * o.y - r.scrollTop * o.y + l.y,
      };
    },
    isElement: nt,
    getDimensions: function (e) {
      return pt(e);
    },
    getOffsetParent: _t,
    getDocumentElement: yt,
    getScale: mt,
    getElementRects: function (e) {
      return Ce(function () {
        var t, i, n, s, a, r, o, l;
        return Ee(this, function (c) {
          switch (c.label) {
            case 0:
              return (
                (t = e.reference),
                (i = e.floating),
                (n = e.strategy),
                (s = this.getOffsetParent || _t),
                (a = this.getDimensions),
                (r = {}),
                (o = [t]),
                [4, s(i)]
              );
            case 1:
              return (
                (r.reference = Mt.apply(void 0, o.concat([c.sent(), n]))),
                (l = [{ x: 0, y: 0 }]),
                [4, a(i)]
              );
            case 2:
              return [
                2,
                ((r.floating = v.apply(void 0, l.concat([c.sent()]))), r),
              ];
          }
        });
      }).apply(this);
    },
    getClientRects: function (e) {
      return Array.from(e.getClientRects());
    },
    isRTL: function (e) {
      return "rtl" === Ze(e).direction;
    },
  };
  function Pt(e, t, i, n) {
    void 0 === n && (n = {});
    var s = n.ancestorScroll,
      a = void 0 === s || s,
      r = n.ancestorResize,
      o = void 0 === r || r,
      l = n.elementResize,
      c = void 0 === l || l,
      u = n.animationFrame,
      d = void 0 !== u && u,
      h =
        a || o
          ? b(
              nt(e) ? Ct(e) : e.contextElement ? Ct(e.contextElement) : []
            ).concat(b(Ct(t)))
          : [];
    h.forEach(function (e) {
      var t = !nt(e) && e.toString().includes("V");
      !a || (d && !t) || e.addEventListener("scroll", i, { passive: !0 }),
        o && e.addEventListener("resize", i);
    });
    var p,
      f = null;
    c &&
      ((f = new ResizeObserver(function () {
        i();
      })),
      nt(e) && !d && f.observe(e),
      nt(e) || !e.contextElement || d || f.observe(e.contextElement),
      f.observe(t));
    var v = d ? gt(e) : null;
    return (
      d &&
        (function t() {
          var n = gt(e);
          !v ||
            (n.x === v.x &&
              n.y === v.y &&
              n.width === v.width &&
              n.height === v.height) ||
            i(),
            (v = n),
            (p = requestAnimationFrame(t));
        })(),
      i(),
      function () {
        var e;
        h.forEach(function (e) {
          a && e.removeEventListener("scroll", i),
            o && e.removeEventListener("resize", i);
        }),
          null == (e = f) || e.disconnect(),
          (f = null),
          d && cancelAnimationFrame(p);
      }
    );
  }
  var It = function (e, t, i) {
      var n = new Map(),
        s = v({ platform: Lt }, i),
        a = ce(v({}, s.platform), { _c: n });
      return De(e, t, ce(v({}, s), { platform: a }));
    },
    Dt = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        d(this, i),
          f(x((e = t.call(this))), "_handleScroll", function () {
            "tooltip" === e._type &&
              (e.hide(), X(window, "wheel", e._handleScroll));
          }),
          f(x(e), "_handleBlockSelect", function (t) {
            e.dataset.sectionId === t.detail.sectionId &&
              (e.element.querySelector(
                '[block-id="'.concat(t.detail.blockId, '"]')
              ) && e._btn
                ? e._btn.trigger()
                : e.hide());
          }),
          f(x(e), "_handleBlockDeselect", function (t) {
            if (e.dataset.sectionId === t.detail.sectionId) {
              if (
                !e.element.querySelector(
                  '[block-id="'.concat(t.detail.blockId, '"]')
                )
              )
                return;
              e.hide();
            }
          }),
          f(x(e), "init", function () {
            var t =
              document.querySelector("#".concat(e.dataset.floatingElementId)) ||
              e._btn;
            t &&
              Pt(t, x(e), function () {
                It(t, e, e._getOptions()).then(function (t) {
                  e._updatePosition(t), e._arrow && e._updateArrow(t);
                });
              });
          }),
          f(x(e), "show", function () {
            ("tooltip" === e._type && S.isScrolling) ||
              (e._mount(),
              e.playVideos(),
              e._setVisible(!0),
              e.emit("show", {}),
              j(window, "wheel", e._handleScroll));
          }),
          f(x(e), "hide", function () {
            e._setVisible(!1),
              e.pauseVideos(),
              e._unmount(),
              e.emit("hide", {});
          }),
          (e._withOverlay = e.hasAttribute("data-with-overlay"));
        var n,
          s,
          a = e.querySelector("template");
        return (
          (e.element = ve(a)),
          (e._arrow = e.element.querySelector("[data-float-element-arrow]")),
          "fixed" === e._strategy &&
            ((n = x(e)),
            (s = document.getElementById("Portal")).appendChild(n),
            document.body.appendChild(s)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.init(),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._unmount(),
                this._isEditorMode && this._editor.destroy(),
                X(window, "wheel", this._handleScroll);
            },
          },
          {
            key: "_updatePosition",
            value: function (e) {
              var t = e.x,
                i = e.y;
              Object.assign(this.style, {
                left: "".concat(t, "px"),
                top: "".concat(i, "px"),
              });
            },
          },
          {
            key: "_getOptions",
            value: function () {
              return {
                placement: this._placement,
                middleware: this._getMiddleware(),
                strategy: this._strategy,
              };
            },
          },
          {
            key: "_getMiddleware",
            value: function () {
              var e = this.dataset.alignmentAxisOffset || 0,
                t = this.dataset.mainAxisOffset || 0,
                i = [Ye({ alignmentAxis: +e, mainAxis: +t }), Xe(), Ke()];
              return this._arrow && i.push(He({ element: this._arrow })), i;
            },
          },
          {
            key: "checkCursorOutside",
            value: function (e, t) {
              var i = +(this.dataset.mainAxisOffset || 0),
                n = this.getBoundingClientRect(),
                s = n.top - (t + i) > 2,
                a = t - n.bottom - i > 2,
                r = n.left - (e + i) > 2,
                o = e - n.right - i > 2;
              return s || a || r || o;
            },
          },
          {
            key: "_updateArrow",
            value: function (e) {
              var t = e.placement,
                i = e.middlewareData;
              if (this._arrow) {
                var n = i.arrow,
                  s = n.x,
                  a = n.y,
                  r = {
                    top: "bottom",
                    right: "left",
                    bottom: "top",
                    left: "right",
                  }[t.split("-")[0]];
                Object.assign(
                  this._arrow.style,
                  f(
                    {
                      left: null != s ? "".concat(s, "px") : "",
                      top: null != a ? "".concat(a, "px") : "",
                      right: "",
                      bottom: "",
                    },
                    r,
                    "-5px"
                  )
                );
              }
            },
          },
          {
            key: "_mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.isOpen && this._withOverlay && S.hideOverlay(this.id),
                this.element && this.element.remove();
            },
          },
          {
            key: "playVideos",
            value: function () {
              b(this.element.querySelectorAll("video")).forEach(function (e) {
                e.play();
              });
            },
          },
          {
            key: "pauseVideos",
            value: function () {
              b(this.element.querySelectorAll("video")).forEach(function (e) {
                e.pause();
              });
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              if (
                (this.setAttribute("aria-hidden", e ? "false" : "true"),
                this._btn && this._btn.setExpand(e),
                this._withOverlay)
              ) {
                var t = {
                  backdropFilter: this.hasAttribute("data-overlay-with-blur")
                    ? "blur(16.5px)"
                    : "none",
                };
                this.isOpen
                  ? S.showOverlay(this.id, t)
                  : S.hideOverlay(this.id);
              }
            },
          },
          {
            key: "_btn",
            get: function () {
              return document.querySelector(
                '[data-float-element-id="'
                  .concat(this.id, '"], [data-tooltip-id="')
                  .concat(this.id, '"]')
              );
            },
          },
          {
            key: "isOpen",
            get: function () {
              return "false" === this.getAttribute("aria-hidden");
            },
          },
          {
            key: "_strategy",
            get: function () {
              return this.dataset.strategy || "absolute";
            },
          },
          {
            key: "_type",
            get: function () {
              return this.dataset.type;
            },
          },
          {
            key: "_placement",
            get: function () {
              return this.dataset.placement || "bottom-end";
            },
          },
        ]),
        i
      );
    })(te),
    At = Dt;
  function zt(e, t) {
    return (
      (function (e) {
        if (Array.isArray(e)) return e;
      })(e) ||
      g(e) ||
      y(e, t) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      })()
    );
  }
  var Ot = "http://www.w3.org/2000/svg",
    Bt = function (e, t) {
      return !(!e || !t) && e.contains(t);
    },
    Nt = function (e) {
      e.current && (e.current.remove(), (e.current = null));
    },
    qt = function () {
      var e,
        t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        i = t.restMs,
        n = void 0 === i ? 0 : i,
        s = t.buffer,
        a = void 0 === s ? 0.5 : s,
        r = t.blockPointerEvents,
        o = void 0 === r || r,
        l = !1,
        c = !1;
      return function (t) {
        var i = t.x,
          s = t.y,
          r = t.placement,
          u = t.elements,
          d = t.onClose,
          h = t.polygonRef;
        return function (t) {
          var p,
            f = function () {
              Nt(h), clearTimeout(e), d();
            };
          if (
            (clearTimeout(e),
            u.domReference && u.floating && null != r && null != i && null != s)
          ) {
            var v,
              m = t.clientX,
              g = t.clientY,
              y = t.target,
              w = "mouseleave" === t.type,
              S = Bt(u.domReference, y),
              x = Bt(u.floating, y);
            if (w || !S) {
              if (
                (w || !(S || (l && Bt(h.current, y)))) &&
                !(
                  (w &&
                    ((v = t.relatedTarget),
                    v &&
                      v instanceof (document.defaultView || window).Element) &&
                    Bt(u.floating, t.relatedTarget)) ||
                  u.floating.querySelector('float-element[aria-hidden="false"]')
                )
              )
                if (
                  (x && (c = !0),
                  !x ||
                    w ||
                    "rect" ===
                      (null === (p = h.current) || void 0 === p
                        ? void 0
                        : p.dataset.type))
                ) {
                  var C = u.domReference.getBoundingClientRect(),
                    k = u.floating.getBoundingClientRect(),
                    E = r.split("-")[0],
                    T = i > k.right - k.width / 2,
                    _ = s > k.bottom - k.height / 2;
                  if (
                    ("top" === E && s >= C.bottom - 1) ||
                    ("bottom" === E && s <= C.top + 1) ||
                    ("left" === E && i >= C.right - 1) ||
                    ("right" === E && i <= C.left + 1)
                  )
                    return f();
                  var M = [];
                  switch (E) {
                    case "top":
                      (M = [
                        [k.left, C.top + 1],
                        [k.left, k.bottom - 1],
                        [k.right, k.bottom - 1],
                        [k.right, C.top + 1],
                      ]),
                        (l =
                          m >= k.left &&
                          m <= k.right &&
                          g >= k.top &&
                          g <= C.top + 1);
                      break;
                    case "bottom":
                      (M = [
                        [k.left, k.top + 1],
                        [k.left, C.bottom - 1],
                        [k.right, C.bottom - 1],
                        [k.right, k.top + 1],
                      ]),
                        (l =
                          m >= k.left &&
                          m <= k.right &&
                          g >= C.bottom - 1 &&
                          g <= k.bottom);
                      break;
                    case "left":
                      (M = [
                        [k.right - 1, k.bottom],
                        [k.right - 1, k.top],
                        [C.left + 1, k.top],
                        [C.left + 1, k.bottom],
                      ]),
                        (l =
                          m >= k.left &&
                          m <= C.left + 1 &&
                          g >= k.top &&
                          g <= k.bottom);
                      break;
                    case "right":
                      (M = [
                        [C.right - 1, k.bottom],
                        [C.right - 1, k.top],
                        [k.left + 1, k.top],
                        [k.left + 1, k.bottom],
                      ]),
                        (l =
                          m >= C.right - 1 &&
                          m <= k.right &&
                          g >= k.top &&
                          g <= k.bottom);
                  }
                  var L = l
                    ? M
                    : (function (e) {
                        var t = zt(e, 2),
                          i = t[0],
                          n = t[1],
                          s = k.width > C.width,
                          r = k.height > C.height;
                        switch (E) {
                          case "top":
                            var o = [
                                s ? i + a / 2 : T ? i + 4 * a : i - 4 * a,
                                n + a + 1,
                              ],
                              l = [
                                s ? i - a / 2 : T ? i + 4 * a : i - 4 * a,
                                n + a + 1,
                              ],
                              c = [
                                [k.left, T || s ? k.bottom - a : k.top],
                                [
                                  k.right,
                                  T ? (s ? k.bottom - a : k.top) : k.bottom - a,
                                ],
                              ];
                            return [o, l].concat(b(c));
                          case "bottom":
                            var u = [
                                s ? i + a / 2 : T ? i + 4 * a : i - 4 * a,
                                n - a,
                              ],
                              d = [
                                s ? i - a / 2 : T ? i + 4 * a : i - 4 * a,
                                n - a,
                              ],
                              h = [
                                [k.left, T || s ? k.top + a : k.bottom],
                                [
                                  k.right,
                                  T ? (s ? k.top + a : k.bottom) : k.top + a,
                                ],
                              ];
                            return [u, d].concat(b(h));
                          case "left":
                            var p = [
                                i + a + 1,
                                r ? n + a / 2 : _ ? n + 4 * a : n - 4 * a,
                              ],
                              f = [
                                i + a + 1,
                                r ? n - a / 2 : _ ? n + 4 * a : n - 4 * a,
                              ];
                            return b([
                              [_ || r ? k.right - a : k.left, k.top],
                              [
                                _ ? (r ? k.right - a : k.left) : k.right - a,
                                k.bottom,
                              ],
                            ]).concat([p, f]);
                          case "right":
                            var v = [
                                i - a,
                                r ? n + a / 2 : _ ? n + 4 * a : n - 4 * a,
                              ],
                              m = [
                                i - a,
                                r ? n - a / 2 : _ ? n + 4 * a : n - 4 * a,
                              ],
                              g = [
                                [_ || r ? k.left + a : k.right, k.top],
                                [
                                  _ ? (r ? k.left + a : k.right) : k.left + a,
                                  k.bottom,
                                ],
                              ];
                            return [v, m].concat(b(g));
                        }
                      })([i, s]);
                  !h.current &&
                    o &&
                    w &&
                    ((h.current = (function (e, t) {
                      var i,
                        n,
                        s = /apple/i.test(navigator.vendor),
                        a = document.defaultView || window,
                        r = document.createElementNS(Ot, "svg");
                      Object.assign(r.style, {
                        position: "fixed",
                        left: "".concat(
                          (s &&
                            (null === (i = a.visualViewport) || void 0 === i
                              ? void 0
                              : i.offsetLeft)) ||
                            0,
                          "px"
                        ),
                        top: "".concat(
                          (s &&
                            (null === (n = a.visualViewport) || void 0 === n
                              ? void 0
                              : n.offsetTop)) ||
                            0,
                          "px"
                        ),
                        width: "100%",
                        height: "100%",
                        pointerEvents: "none",
                        zIndex: 2147483647,
                      }),
                        r.setAttribute("data-type", t ? "rect" : "triangle");
                      var o = document.createElementNS(Ot, "polygon");
                      return (
                        o.setAttribute(
                          "points",
                          e
                            .map(function (e) {
                              var t = zt(e, 2),
                                i = t[0],
                                n = t[1];
                              return "".concat(i, ",").concat(n);
                            })
                            .join(" ")
                        ),
                        Object.assign(o.style, {
                          pointerEvents: "auto",
                          fill: "transparent",
                          opacity: 0,
                        }),
                        r.appendChild(o),
                        r
                      );
                    })(L, l)),
                    document.body.appendChild(h.current)),
                    l ||
                      ((function (e, t) {
                        for (
                          var i = zt(e, 2),
                            n = i[0],
                            s = i[1],
                            a = !1,
                            r = t.length,
                            o = 0,
                            l = r - 1;
                          o < r;
                          l = o++
                        ) {
                          var c = zt(t[o] || [0, 0], 2),
                            u = c[0],
                            d = c[1],
                            h = zt(t[l] || [0, 0], 2),
                            p = h[0],
                            f = h[1];
                          d >= s != f >= s &&
                            n <= ((p - u) * (s - d)) / (f - d) + u &&
                            (a = !a);
                        }
                        return a;
                      })([m, g], L)
                        ? n && !c && (e = setTimeout(d, n))
                        : f());
                } else Nt(h);
            } else Nt(h);
          }
        };
      };
    },
    $t = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleBlur", function () {
            e.blurElementTimeoutId = setTimeout(function () {
              e._floatElement && e._floatElement.hide();
            }, 0);
          }),
          f(x(e), "_handleFocus", function () {
            e._floatElement.show(), e.setTargetListeners("add");
          }),
          f(x(e), "_handleFirstTargetFocus", function () {
            clearTimeout(e.blurElementTimeoutId);
          }),
          f(x(e), "_handleTargetFocus", function () {
            clearTimeout(e.blurLastTargetTimeoutId);
          }),
          f(x(e), "_handleLastTargetBlur", function () {
            e.blurLastTargetTimeoutId = setTimeout(function () {
              e.setTargetListeners("remove"), e._floatElement.hide();
            }, 0);
          }),
          f(x(e), "_handleMouseEnter", function () {
            e.mouseenterTimeout = setTimeout(function () {
              e.trigger();
            }, 0);
          }),
          f(x(e), "_handleElementClick", function () {
            e.trigger();
          }),
          f(x(e), "_handleWindowClick", function (t) {
            var i = e._floatElement.checkCursorOutside(t.clientX, t.clientX),
              n = e._isTargetOutsideFloatElements(t.target);
            i &&
              n &&
              (X(window, "click", e._handleWindowClick),
              e._floatElement.hide());
          }),
          f(x(e), "_handleMouseLeave", function (t) {
            clearTimeout(e.mouseenterTimeout),
              e.safePolygonFn &&
                window.removeEventListener("mousemove", e._handleMouseMove),
              (e.safePolygonFn = qt()({
                x: t.clientX,
                y: t.clientY,
                placement: e._floatElement.dataset.placement,
                onClose: function () {
                  window.removeEventListener("mousemove", e._handleMouseMove),
                    e._floatElement && e._floatElement.hide(),
                    Nt(e.polygonRef);
                },
                elements: {
                  domReference: e.element,
                  floating: e._floatElement,
                },
                polygonRef: e.polygonRef,
              })),
              e.safePolygonFn(t),
              window.addEventListener("mousemove", e._handleMouseMove);
          }),
          f(x(e), "_handleMouseMove", function (t) {
            e.safePolygonFn(t);
          }),
          f(x(e), "trigger", function () {
            "click" === e._trigger
              ? (e._floatElement.isOpen
                  ? e._floatElement.hide()
                  : e._floatElement.show(),
                j(window, "click", e._handleWindowClick))
              : (e._floatElement.show(),
                j(e.element, "mouseleave", e._handleMouseLeave));
          }),
          (e._trigger = "click" === e.dataset.trigger ? "click" : "mouseenter"),
          (e.element = e.getElement()),
          (e.polygonRef = { current: null }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this.element, "focus", this._handleFocus),
                j(this.element, "blur", this._handleBlur),
                "click" === this.dataset.trigger
                  ? (j(window, "click", this._handleWindowClick),
                    j(this.element, "click", this._handleElementClick))
                  : (j(this.element, "mouseleave", this._handleMouseLeave),
                    j(this.element, "mouseenter", this._handleMouseEnter));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this.element, "focus", this._handleFocus),
                X(this.element, "blur", this._handleBlur),
                "click" === this.dataset.trigger
                  ? (X(window, "click", this._handleWindowClick),
                    X(this.element, "click", this._handleElementClick))
                  : (X(this.element, "mouseleave", this._handleMouseLeave),
                    X(this.element, "mouseenter", this._handleMouseEnter));
            },
          },
          {
            key: "setTargetListeners",
            value: function (e) {
              var t = this,
                i = this.getTargets(),
                n = i.targets,
                s = i.firstTarget,
                a = i.lastTarget,
                r = "add" === e ? j : X;
              r(s, "focus", this._handleFirstTargetFocus),
                n.forEach(function (e) {
                  r(e, "focus", t._handleTargetFocus);
                }),
                r(a, "blur", this._handleLastTargetBlur),
                r(window, "click", this._handleWindowClick);
            },
          },
          {
            key: "getElement",
            value: function () {
              var e = '[data-float-element-trigger="'.concat(
                this.dataset.floatElementId,
                '"]'
              );
              return this.querySelector(e) || this;
            },
          },
          {
            key: "getTargets",
            value: function () {
              var e = b(this._floatElement.element.querySelectorAll(W()));
              return {
                targets: e,
                firstTarget: e[0],
                lastTarget: e[e.length - 1],
              };
            },
          },
          {
            key: "_isTargetOutsideFloatElements",
            value: function (e) {
              var t = this._floatElement.contains(e),
                i = this.contains(e);
              return !t && !i;
            },
          },
          {
            key: "setExpand",
            value: function (e) {
              this.setAttribute("data-aria-expanded", e);
            },
          },
          {
            key: "_floatElement",
            get: function () {
              if (this.dataset.floatElementId)
                return document.getElementById(this.dataset.floatElementId);
            },
          },
          {
            key: "isOpen",
            get: function () {
              return this._floatElement.isOpen;
            },
          },
        ]),
        i
      );
    })(te),
    Ht = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleBlur", function () {
            var t = e.getTargets().targets;
            e.blurElementTimeoutId = setTimeout(function () {
              if (!t.includes(document.activeElement)) {
                if (!e._floatElement) return;
                e.setTargetListeners("remove"), e._floatElement.hide();
              }
            }, 0);
          }),
          f(x(e), "_handleDropdownShow", function () {
            j(window, "keydown", e._handleDropdownKeyDown);
          }),
          f(x(e), "_handleDropdownHide", function () {
            X(window, "keydown", e._handleDropdownKeyDown);
          }),
          f(x(e), "_handleKeyUp", function (t) {
            if (e._floatElement) {
              var i = t.key || t.keyCode;
              K(i) &&
                (e._floatElement.isOpen ||
                  (e._floatElement.show(), e.setTargetListeners("add")));
            }
          }),
          f(x(e), "_handleDropdownKeyDown", function (t) {
            if (e._floatElement) {
              var i = t.key || t.keyCode,
                n = i === H || i === F;
              e._floatElement.isOpen &&
                n &&
                (e.element.focus(),
                e.setTargetListeners("remove"),
                e._floatElement.hide());
            }
          }),
          f(x(e), "_handleFirstTargetFocus", function () {
            clearTimeout(e.blurElementTimeoutId);
          }),
          f(x(e), "_handleTargetFocus", function () {
            clearTimeout(e.blurLastTargetTimeoutId);
          }),
          f(x(e), "_handleLastTargetBlur", function () {
            e.blurLastTargetTimeoutId = setTimeout(function () {
              e._floatElement &&
                (e.setTargetListeners("remove"), e._floatElement.hide());
            }, 0);
          }),
          f(x(e), "_handleTrigger", function (t) {
            t.preventDefault(), e.trigger();
          }),
          f(x(e), "_handleUntrigger", function (t) {
            var i = t.clientX,
              n = t.clientY,
              s = t.target;
            if (e._floatElement) {
              var a = e._floatElement.checkCursorOutside(i, n),
                r = e._isTargetOutsideFloatElements(s);
              a &&
                r &&
                (e._floatElement.hide(),
                X(window, "click", e._handleUntrigger));
            }
          }),
          f(x(e), "trigger", function () {
            e._floatElement &&
              (e._floatElement.isOpen
                ? e._floatElement.hide()
                : e._floatElement.show(),
              j(window, "click", e._handleUntrigger));
          }),
          (e.element = e.getElement()),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._floatElement &&
                (customElements.upgrade(this._floatElement),
                this._floatElement.subscribe("show", this._handleDropdownShow),
                this._floatElement.subscribe("hide", this._handleDropdownHide)),
                j(this.element, "blur", this._handleBlur),
                j(this.element, "keyup", this._handleKeyUp),
                j(this.element, "mousedown", this._handleTrigger);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._floatElement &&
                (this._floatElement.unsubscribe(
                  "show",
                  this._handleDropdownShow
                ),
                this._floatElement.unsubscribe(
                  "hide",
                  this._handleDropdownHide
                )),
                X(this.element, "blur", this._handleBlur),
                X(this.element, "keyup", this._handleKeyUp),
                X(this.element, "mousedown", this._handleTrigger),
                X(window, "click", this._handleUntrigger);
            },
          },
          {
            key: "setTargetListeners",
            value: function (e) {
              var t = this,
                i = this.getTargets(),
                n = i.targets,
                s = i.firstTarget,
                a = i.lastTarget,
                r = "add" === e ? j : X;
              r(s, "focus", this._handleFirstTargetFocus),
                n.forEach(function (e) {
                  r(e, "focus", t._handleTargetFocus);
                }),
                r(a, "blur", this._handleLastTargetBlur),
                r(window, "click", this._handleUntrigger);
            },
          },
          {
            key: "getTargets",
            value: function () {
              if (this._floatElement) {
                var e = b(this._floatElement.element.querySelectorAll(W()));
                return {
                  targets: e,
                  firstTarget: e[0],
                  lastTarget: e[e.length - 1],
                };
              }
            },
          },
          {
            key: "_isTargetOutsideFloatElements",
            value: function (e) {
              if (this._floatElement) {
                var t = this._floatElement.contains(e),
                  i = this.contains(e);
                return !t && !i;
              }
            },
          },
          {
            key: "getElement",
            value: function () {
              var e = '[data-float-element-trigger="'.concat(
                this.dataset.floatElementId,
                '"]'
              );
              return this.querySelector(e) || this;
            },
          },
          {
            key: "setExpand",
            value: function (e) {
              this.setAttribute("data-aria-expanded", e);
            },
          },
          {
            key: "_floatElement",
            get: function () {
              return document.querySelector(
                "#".concat(this.dataset.floatElementId)
              );
            },
          },
        ]),
        i
      );
    })(te),
    Ft = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleMouseEnter",
            function () {
              e._floatElement && e._floatElement.show();
            }
          ),
          f(x(e), "_handleMouseLeave", function () {
            e._floatElement && e._floatElement.hide();
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "mouseenter", this._handleMouseEnter),
                j(this, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "mouseenter", this._handleMouseEnter),
                X(this, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "setExpand",
            value: function (e) {
              this.setAttribute("data-aria-expanded", e ? "true" : "false");
            },
          },
          {
            key: "_floatElement",
            get: function () {
              return this.dataset.floatElementId
                ? document.querySelector(
                    "#".concat(this.dataset.floatElementId)
                  )
                : null;
            },
          },
        ]),
        i
      );
    })(te),
    Vt = Ft,
    Rt = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleContentResize", function () {
            e.updateMaxHeight();
          }),
          f(x(e), "_handleBlockSelect", function (t) {
            var i = t.detail,
              n = i.sectionId,
              s = i.blockId,
              a = i.load,
              r = e.querySelector(e._contentWrapperSelector),
              o = e.dataset.sectionId === n,
              l = e.dataset.blockId === s;
            o &&
              l &&
              !e.isExpanded &&
              (me(r, a),
              me(x(e), a),
              e.show().then(function () {
                me(r, !1), me(x(e), !1);
              }));
          }),
          f(x(e), "_handleBlockDeselect", function (t) {
            var i = t.detail,
              n = i.sectionId,
              s = i.blockId;
            e.dataset.sectionId === n &&
              e.dataset.blockId === s &&
              e.isExpanded &&
              e.hide();
          }),
          (e._contentSelector = "[data-accordeon-content]"),
          (e._contentWrapperSelector = "[data-accordeon-content-wrapper]"),
          (e._content = e.querySelector(e._contentSelector)),
          (e._resizeObserver = new ResizeObserver(e._handleContentResize)),
          (e.styles = getComputedStyle(x(e))),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateMaxHeight(),
                this._content && this._resizeObserver.observe(this._content),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._resizeObserver.disconnect(),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "hide",
            value: function () {
              return this._setExpand(!1), V(this._transitionDuration);
            },
          },
          {
            key: "show",
            value: function () {
              return this._setExpand(!0), V(this._transitionDuration);
            },
          },
          {
            key: "toggle",
            value: function () {
              this._setExpand(!this.isExpanded);
            },
          },
          {
            key: "updateMaxHeight",
            value: function () {
              var e = this.closest("accordeon-component"),
                t = this.querySelector(this._contentSelector),
                i = this.querySelector(this._contentWrapperSelector);
              if (e && t && i) {
                var n = e.isExpanded ? t.offsetHeight : 0;
                i.style.maxHeight = "".concat(n, "px");
              }
            },
          },
          {
            key: "_setExpand",
            value: function (e) {
              if (window.location.href.includes("/products")) {
                document
                  .querySelectorAll("accordeon-component")
                  .forEach((el) => {
                    el.setAttribute("data-aria-expanded", "false");
                  }),
                  document
                    .querySelectorAll(
                      "accordeon-component [data-accordeon-content-wrapper]"
                    )
                    .forEach((el) => {
                      el.setAttribute("style", "max-height: 0px");
                    });
              }
              this.setAttribute("data-aria-expanded", e ? "true" : "false"),
                this.updateMaxHeight();
            },
          },
          {
            key: "isExpanded",
            get: function () {
              return "true" === this.getAttribute("data-aria-expanded");
            },
          },
          {
            key: "_contentWrapper",
            get: function () {
              return this.querySelector(this._contentWrapperSelector);
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        i
      );
    })(te),
    jt = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function (t) {
              t.preventDefault(), e.update();
            }
          ),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e.update());
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("click", this._handleButtonClick),
                this.addEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleButtonClick),
                this.removeEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.closest("accordeon-component");
              e && e.toggle();
            },
          },
        ]),
        i
      );
    })(te),
    Xt = jt,
    Gt = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleMouseEnter", function () {
            j(e._productCardInner, "mousemove", e._handleMouseMove);
          }),
          f(x(e), "_handleMouseLeave", function () {
            if (e._productCard) {
              var t = e._productCard.querySelector("[data-main-media]");
              t &&
                (e._selected && e._reset(),
                e._setImageVisible(t, !0),
                X(e._productCardInner, "mousemove", e._handleMouseMove));
            }
          }),
          f(x(e), "_handleMouseMove", function (t) {
            var i = e._getTabByCoords(t.clientX, t.clientY);
            if (e._productCard && i) {
              var n = e._productCard.querySelector("[data-main-media]"),
                s = e._productCard.querySelector(
                  '[data-id="'.concat(i.dataset.id, '"]')
                );
              if (!s || !n) return;
              e._selected && e._reset(),
                e._setTabSelect(i, !0),
                e._setImageVisible(s, !0),
                e._setImageVisible(n, !1),
                (e._selected = { tab: i, img: s });
            }
          }),
          (e._productCard = e.closest("product-card")),
          (e._productCardInner = e.closest(".product-card__inner")),
          (e._tabs = b(e.querySelectorAll("product-media-tab"))),
          (e._selected = null),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.update(),
                j(this._productCard, "mouseenter", this._handleMouseEnter),
                j(this._productCard, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._productCard, "mouseenter", this._handleMouseEnter),
                X(this._productCard, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "_getTabByCoords",
            value: function (e, t) {
              return this._tabs.find(function (i) {
                var n = i.getBoundingClientRect(),
                  s = t < n.y,
                  a = e - n.x < n.width;
                return s && a;
              });
            },
          },
          {
            key: "update",
            value: function () {
              this._tabs.forEach(function (e, t) {
                e.style.display = t + 1 > 5 ? "none" : "flex";
              });
            },
          },
          {
            key: "_setTabSelect",
            value: function (e, t) {
              e.classList.toggle("selected", t);
            },
          },
          {
            key: "_setImageVisible",
            value: function (e, t) {
              e.classList.toggle("product-card__img--visible", t);
            },
          },
          {
            key: "_reset",
            value: function () {
              this._selected &&
                (this._selected.img.classList.remove(
                  "product-card__img--visible"
                ),
                this._selected.tab.classList.remove("selected"),
                (this._selected = null));
            },
          },
        ]),
        i
      );
    })(te),
    Wt = (function () {
      "use strict";
      function e(t) {
        d(this, e), (this.element = t);
      }
      return (
        p(e, [
          {
            key: "update",
            value: function (e) {
              var t, i, n;
              this.element.innerText = e
                ? ((i = (t = e).slice(0, 1)),
                  (n = t.slice(1)),
                  i.toUpperCase() + n)
                : "";
            },
          },
        ]),
        e
      );
    })(),
    Yt = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "handleSwatchEnter", function (t) {
            if (e._productCard) {
              var i = t.target,
                n = i.dataset.variantId,
                s = e._productCard.querySelector(
                  '[data-variant-id="'.concat(n, '"]')
                ),
                a = i.dataset.color;
              s &&
                e.mainImage &&
                a &&
                (e.updateLabel(a),
                e._setImageVisible(s, !0),
                e._setImageVisible(e.mainImage, !1),
                (e.currentVisibleImage = s));
            }
          }),
          f(x(e), "handleSwatchLeave", function () {
            e.updateLabel(""),
              e.currentVisibleImage &&
                e._setImageVisible(e.currentVisibleImage, !1),
              e.mainImage && e._setImageVisible(e.mainImage, !0);
          }),
          (e.hiddenCountSelector = "[data-color-swatches-hidden-count]"),
          (e.hiddenCountLabelSelector =
            "[data-color-swatches-hidden-count-label]"),
          (e.labelSelector = "[data-color-swatches-label]"),
          (e.itemSelector = "[data-color-swatches-item]"),
          (e._hiddenCount = e.querySelector(e.hiddenCountSelector)),
          (e._hiddenCountLabel = e.querySelector(e.hiddenCountLabelSelector)),
          (e._label = e.querySelector(e.labelSelector)),
          (e._items = b(e.querySelectorAll(e.itemSelector))),
          (e._productCard = e.closest("product-card")),
          e._productCard &&
            (e.mainImage = e._productCard.querySelector("[data-main-media]")),
          e._label && (e._labelComponent = new Wt(e._label)),
          (e._hiddenCountLabelStyles = getComputedStyle(e._hiddenCountLabel)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              (this.hiddenCountLabelWidth = parseInt(
                this._hiddenCountLabelStyles.width
              )),
                this.update(),
                this._items.forEach(function (t) {
                  t.addEventListener("mouseenter", e.handleSwatchEnter),
                    t.addEventListener("mouseleave", e.handleSwatchLeave);
                });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this._items.forEach(function (t) {
                t.removeEventListener("mouseenter", e.handleSwatchEnter),
                  t.removeEventListener("mouseleave", e.handleSwatchLeave);
              });
            },
          },
          {
            key: "update",
            value: function () {
              this._setSwatchesOffset(),
                this._setSwatches(),
                this._updateCount();
            },
          },
          {
            key: "_setImageVisible",
            value: function (e, t) {
              e.classList.toggle("product-card__img--visible", t);
            },
          },
          {
            key: "_setSwatchesOffset",
            value: function () {
              var e = this;
              this._items.forEach(function (t) {
                e._setVisible(t, !0),
                  (t.dataset.x = "".concat(t.offsetLeft + t.offsetWidth));
              });
            },
          },
          {
            key: "_setSwatches",
            value: function () {
              var e = this;
              this._items.forEach(function (t) {
                var i =
                  +(t.dataset.x || 0) >
                  e.offsetWidth - e.hiddenCountLabelWidth - 12;
                t.toggleAttribute("visible", !i);
              }),
                this._items.forEach(function (t) {
                  var i = t.hasAttribute("visible");
                  e._setVisible(t, i);
                });
            },
          },
          {
            key: "_updateCount",
            value: function () {
              if (this._hiddenCount) {
                var e = this._items.filter(function (e) {
                    return !e.classList.contains("hide");
                  }),
                  t = +(this.dataset.count || 0) - e.length;
                t > 0
                  ? (de(this._hiddenCount),
                    (this._hiddenCountLabel.innerText = "+".concat(t)))
                  : (he(this._hiddenCount),
                    (this._hiddenCountLabel.innerText = ""));
              }
            },
          },
          {
            key: "updateLabel",
            value: function (e) {
              this._labelComponent && this._labelComponent.update(e);
            },
          },
          {
            key: "_setVisible",
            value: function (e, t) {
              e.classList.toggle("hide", !t);
            },
          },
        ]),
        i
      );
    })(te),
    Ut = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleKeydown", function (t) {
            var i = t.key || t.keyCode;
            (i === H || i === F) && e.hide();
          }),
          f(x(e), "_handleOutsideClick", function (t) {
            var i = document.getElementById("BodyOverlay"),
              n = parseFloat(pe(i, "zIndex")),
              s = parseFloat(e.styles.zIndex) - 1;
            t.target === i && n <= s && e.isOpen && e.hide();
          }),
          (e._template = e.querySelector("template")),
          (e.element = ve(e._template)),
          (e.styles = getComputedStyle(x(e))),
          e
        );
      }
      return (
        p(i, [
          {
            key: "show",
            value: function () {
              var e = this;
              this._mount(),
                this.focus(),
                setTimeout(function () {
                  e._setOpenState(!0);
                }, 0),
                (this.isOpen = !0);
            },
          },
          {
            key: "hide",
            value: function () {
              var e = this;
              return (
                this._setOpenState(!1),
                V(this._transitionDuration).then(function () {
                  e._unmount(), (e.isOpen = !1);
                })
              );
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.hide() : this.show();
            },
          },
          {
            key: "_mount",
            value: function () {
              this.element &&
                !this.contains(this.element) &&
                this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "_setOpenState",
            value: function (e) {
              var t = this,
                i = this.hasAttribute("data-overlay-important"),
                n = this.getAttribute("data-overlay-opacity") || 50,
                s = {
                  zIndex: i ? parseFloat(this.styles.zIndex) - 1 : 3,
                  backgroundColor: "var(--gsc-black-color-".concat(n, ")"),
                };
              e
                ? S.showOverlay(this.id, s)
                : V(this._transitionDuration).then(function () {
                    S.hideOverlay(t.id);
                  }),
                this._setVisible(e),
                this._setListeners(e ? "add" : "remove"),
                this.emit(e ? "show" : "hide", {});
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.toggleAttribute("open", e);
            },
          },
          {
            key: "_setListeners",
            value: function (e) {
              var t = this.hasAttribute("data-with-close-on-outside"),
                i = "".concat(e, "EventListener");
              t && window[i]("click", this._handleOutsideClick),
                window[i]("keydown", this._handleKeydown);
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return (
                1e3 * parseFloat(this.styles.transitionDuration) +
                1e3 * parseFloat(this.styles.transitionDelay)
              );
            },
          },
        ]),
        i
      );
    })(te);
  function Kt(e, t, i) {
    return (
      (Kt =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (e, t, i) {
              var n = (function (e, t) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(e, t) &&
                  null !== (e = _(e));

                );
                return e;
              })(e, t);
              if (n) {
                var s = Object.getOwnPropertyDescriptor(n, t);
                return s.get ? s.get.call(i || e) : s.value;
              }
            }),
      Kt(e, t, i)
    );
  }
  function Qt(e, t, i) {
    return Kt(e, t, i);
  }
  var Zt = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this)).passwordInput = e.querySelector(
            "[password-modal-input]"
          )),
          e
        );
      }
      return (
        p(i, [
          {
            key: "show",
            value: function () {
              Qt(_(i.prototype), "show", this).call(this),
                this.passwordInput && this.passwordInput.focus();
            },
          },
        ]),
        i
      );
    })(Ut),
    Jt = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "showProductFromParsedState",
            value: function (e, t) {
              var i = e.sections["cart-notification-popup-content"],
                n = ge(i);
              if (this.element) {
                var s = n.querySelector(
                    "#CartNotificationPopupItem-".concat(t)
                  ),
                  a = this.element.querySelector(
                    "[data-cart-notification-popup]"
                  );
                a && s && ((a.innerHTML = ""), a.appendChild(s)),
                  this._updateCartCountInHeader(e),
                  this.show();
              }
            },
          },
          {
            key: "_updateCartCountInHeader",
            value: function (e) {
              var t = e.sections["cart-count"],
                i = ge(t),
                n = document.getElementById("CartCount"),
                s = document.getElementById("StickyCartCount"),
                a = i.getElementById("CartCount");
              s && a && (s.innerHTML = a.innerHTML),
                n && a && (n.innerHTML = a.innerHTML);
            },
          },
        ]),
        i
      );
    })(Ut),
    ei = Jt,
    ti = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.showModal(), e.emit("click", {});
            }
          ),
          f(x(e), "_handleKeyDown", function (t) {
            if (K(t.key || t.keyCode) && e.dataset.modal) {
              t.preventDefault();
              var i = document.querySelector(e.dataset.modal);
              i && i.toggle();
            }
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "showModal",
            value: function () {
              if (this.dataset.modal) {
                var e = document.querySelector(this.dataset.modal);
                e && e.show();
              }
            },
          },
        ]),
        i
      );
    })(te),
    ii = ti,
    ni = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i.prototype), "connectedCallback", this).call(this),
                this.focus();
            },
          },
        ]),
        i
      );
    })(ii),
    si = ni,
    ai = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.hide();
            }
          ),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e.hide());
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "hide",
            value: function () {
              if (this.dataset.modal) {
                var e = document.querySelector(this.dataset.modal);
                e && e.hide();
              }
            },
          },
        ]),
        i
      );
    })(te),
    ri = ai,
    oi = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleButtonClick", function (e) {
            e.preventDefault();
          }),
          f(x(e), "handleButtonMouseDown", function (t) {
            t.preventDefault();
            var i = e.closest("carousel-component"),
              n = e.closest("carousel-dots");
            (e.isDraggingInCarousel = !(!i && !n)),
              e.isDraggingInCarousel
                ? (e.setMoveStartPoint(t.clientX, t.clientY),
                  (e.toggleAfterDraggingInCarousel = !0))
                : e.toggle();
          }),
          f(x(e), "handleButtonMouseMove", function (t) {
            if (e.isDraggingInCarousel) {
              var i = Math.abs(e.startPointX - t.clientX),
                n = Math.abs(e.startPointY - t.clientY);
              (i > 24 || n > 24) && (e.toggleAfterDraggingInCarousel = !1);
            }
          }),
          f(x(e), "handleButtonMouseUp", function () {
            e.isDraggingInCarousel &&
              (e.toggleAfterDraggingInCarousel && e.toggle(),
              (e.isDraggingInCarousel = !1),
              (e.toggleAfterDraggingInCarousel = !1),
              e.setMoveStartPoint(0, 0));
          }),
          f(x(e), "_handleButtonFocus", function () {
            e.button && e.button.addEventListener("keydown", e.handleKeyDown);
          }),
          f(x(e), "_handleButtonBlur", function () {
            e.button &&
              e.button.removeEventListener("keydown", e.handleKeyDown);
          }),
          f(x(e), "handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e.toggle());
          }),
          (e.buttonSelector = "[data-sidebar-button]"),
          (e.button = e.querySelector(e.buttonSelector)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.button &&
                (this.button.addEventListener("click", this._handleButtonClick),
                this.button.addEventListener("focus", this._handleButtonFocus),
                this.button.addEventListener("blur", this._handleButtonBlur),
                this.button.addEventListener(
                  "mousedown",
                  this.handleButtonMouseDown
                ),
                this.button.addEventListener(
                  "mousemove",
                  this.handleButtonMouseMove
                ),
                this.button.addEventListener(
                  "mouseup",
                  this.handleButtonMouseUp
                ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                (this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                this.button.removeEventListener(
                  "focus",
                  this._handleButtonFocus
                ),
                this.button.removeEventListener("blur", this._handleButtonBlur),
                this.button.removeEventListener(
                  "mousedown",
                  this.handleButtonMouseDown
                ),
                this.button.removeEventListener(
                  "mousemove",
                  this.handleButtonMouseMove
                ),
                this.button.removeEventListener(
                  "mouseup",
                  this.handleButtonMouseUp
                ));
            },
          },
          {
            key: "setMoveStartPoint",
            value: function (e, t) {
              (this.startPointX = e), (this.startPointY = t);
            },
          },
          {
            key: "toggle",
            value: function () {
              if (this.button) {
                var e = this.button.dataset.sidebarId || "",
                  t = document.querySelector("#".concat(e));
                t && (t.toggle(), this.update());
              }
            },
          },
          {
            key: "update",
            value: function () {
              if (this.button) {
                var e = this.button.dataset.sidebarId || "",
                  t = document.querySelector("#".concat(e));
                t &&
                  this.button.setAttribute(
                    "data-aria-expanded",
                    t.isOpen ? "true" : "false"
                  );
              }
            },
          },
        ]),
        i
      );
    })(te),
    li = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleSectionLoad", function () {
            e._isSection || e.withOpenOnInit || e.hide();
          }),
          f(x(e), "_handleSectionSelect", function (t) {
            var i = t.detail.sectionId;
            e._isSection && e.dataset.sectionId === i && e.open();
          }),
          f(x(e), "_handleSectionDeselect", function (t) {
            var i = t.detail.sectionId;
            e._isSection && e.dataset.sectionId === i && e.hide();
          }),
          f(x(e), "_handleOutsideClick", function (t) {
            var i = document.getElementById("BodyOverlay"),
              n = parseFloat(pe(i, "zIndex")),
              s = parseFloat(e.styles.zIndex) - 1;
            t.target === i && n <= s && e.isOpen && e.hide();
          }),
          f(x(e), "_handleTouchStart", function (t) {
            (e._touchStartX = t.targetTouches[0].clientX),
              (e._touchStartY = t.targetTouches[0].clientY);
          }),
          f(x(e), "_handleTouchMove", function (t) {
            (e._touchEndX = t.targetTouches[0].clientX),
              (e._touchEndY = t.targetTouches[0].clientY);
          }),
          f(x(e), "_handleTouchEnd", function (t) {
            var i = Math.abs(e._touchStartX - e._touchEndX),
              n = Math.abs(e._touchStartY - e._touchEndY);
            if (
              !(
                t.target.closest("[data-carousel-viewport]") ||
                0 === e._touchEndX ||
                n > 48
              )
            ) {
              var s =
                "right" === e.dataset.openDirection
                  ? e._touchStartX < e._touchEndX
                  : e._touchStartX > e._touchEndX;
              e.isOpen && i > 96 && s && e.hide(), e.cleanTouchPoints();
            }
          }),
          f(x(e), "_handleKeydown", function (t) {
            var i = t.key || t.keyCode;
            e.hasAttribute("data-with-close-on-escape") &&
              (i === H || i === F) &&
              e.hide();
          }),
          (e._template = e.querySelector("template")),
          (e.element = ve(e._template)),
          (e.buttonSelector = '[data-sidebar-button][data-sidebar-id="'.concat(
            e.id,
            '"]'
          )),
          (e.styles = getComputedStyle(x(e))),
          e.withOpenOnInit && e.open(),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("touchstart", this._handleTouchStart),
                this.addEventListener("touchmove", this._handleTouchMove),
                this.addEventListener("touchend", this._handleTouchEnd),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  ),
                  this._editor.subscribe(
                    "SECTION_SELECT",
                    this._handleSectionSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_DESELECT",
                    this._handleSectionDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("touchstart", this._handleTouchStart),
                this.removeEventListener("touchmove", this._handleTouchMove),
                this.removeEventListener("touchend", this._handleTouchEnd),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "cleanTouchPoints",
            value: function () {
              (this._touchStartX = 0),
                (this._touchEndX = 0),
                (this._touchStartY = 0),
                (this._touchEndY = 0);
            },
          },
          {
            key: "open",
            value: function () {
              var e = this;
              return (
                this.classList.contains("sidebar-cart") &&
                  document
                    .querySelector("#pop-club-quick-buy3")
                    ?.classList.add("hidden"),
                this.mount(),
                this.setAttribute("tabindex", "-1"),
                this.focus(),
                setTimeout(function () {
                  e._setOpenState(!0);
                }, 0),
                V(this._transitionDuration)
              );
            },
          },
          {
            key: "hide",
            value: function (e) {
              var t = this;
              if (
                (this.classList.contains("sidebar-cart") &&
                  document
                    .querySelector("#pop-club-quick-buy3")
                    ?.classList.remove("hidden"),
                this._setOpenState(!1),
                !e)
              )
                return V(this._transitionDuration).then(function () {
                  t.unmount();
                });
              this.unmount();
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.hide() : this.open();
            },
          },
          {
            key: "mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "updateTemplate",
            value: function (e) {
              this.element.remove(),
                (this.element = ve(e)),
                this.appendChild(this.element);
            },
          },
          {
            key: "_setOpenState",
            value: function (e) {
              var t = this,
                i = this.hasAttribute("data-with-overlay"),
                n = document.querySelectorAll(this.buttonSelector);
              if (
                (this._setVisible(e),
                this._setListeners(e ? "add" : "remove"),
                localStorage.setItem("sidebar-".concat(this.id), "".concat(e)),
                i)
              ) {
                var s = this.hasAttribute("data-overlay-important"),
                  a = this.hasAttribute("data-overlay-with-blur"),
                  r = +(this.getAttribute("data-overlay-opacity") || 50),
                  o = {
                    zIndex: s ? parseFloat(this.styles.zIndex) - 1 : 3,
                    backdropFilter: a ? "blur(16.5px)" : "none",
                    backgroundColor: "var(--gsc-black-color-".concat(r, ")"),
                  };
                e
                  ? S.showOverlay(this.id, o)
                  : V(this._transitionDuration).then(function () {
                      S.hideOverlay(t.id);
                    });
              }
              n.forEach(function (t) {
                t.setAttribute("data-aria-expanded", e ? "true" : "false");
              });
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.setAttribute("data-aria-expanded", e ? "true" : "false");
            },
          },
          {
            key: "_setListeners",
            value: function (e) {
              var t = this.hasAttribute("data-with-close-on-outside"),
                i = "".concat(e, "EventListener");
              t && window[i]("click", this._handleOutsideClick),
                window[i]("keydown", this._handleKeydown);
            },
          },
          {
            key: "_isSection",
            get: function () {
              return this.hasAttribute("data-sidebar-section");
            },
          },
          {
            key: "isOpen",
            get: function () {
              return "true" === this.getAttribute("data-aria-expanded");
            },
          },
          {
            key: "withOpenOnInit",
            get: function () {
              return this.hasAttribute("data-with-open-on-init");
            },
          },
          {
            key: "isOpenBeforeSectionChange",
            get: function () {
              return (
                "true" === localStorage.getItem("sidebar-".concat(this.id))
              );
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return (
                1e3 * parseFloat(this.styles.transitionDuration) +
                1e3 * parseFloat(this.styles.transitionDelay)
              );
            },
          },
        ]),
        i
      );
    })(te),
    ci = function () {
      return matchMedia("(max-width: 768px)").matches;
    },
    ui = function () {
      return matchMedia("(prefers-reduced-motion: reduce)").matches;
    },
    di = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleClick", function (t) {
            var i = t.target,
              n = ci(),
              s = i === e._searchInput,
              a = "A" === i.tagName,
              r = i.closest("[data-sidebar-search-query]");
            if (e._searchInput && r) {
              var o = new Event("input", { bubbles: !0 });
              (e._searchInput.value = "".concat(
                r.getAttribute("data-sidebar-search-query")
              )),
                e._searchInput.dispatchEvent(o),
                e._searchInput.focus();
            }
            n && s && (e.isInputFocused = !0),
              !s &&
                e.isInputFocused &&
                (a && t.preventDefault(), (e.isInputFocused = !1));
          }),
          f(x(e), "_handleInputFocus", function () {
            ci() && (e.isInputFocused = !0);
          }),
          f(x(e), "_handleSearchSidebarTouchEnd", function (t) {
            var i = t.target,
              n = Math.abs(e._touchStartX - e._touchEndX),
              s = Math.abs(e._touchStartY - e._touchEndY),
              a = n > 12 || s > 12,
              r = "A" === i.tagName;
            e.isInputFocused &&
              a &&
              e._searchInput &&
              (r && t.preventDefault(),
              e._searchInput.blur(),
              (e.isInputFocused = !1)),
              e.cleanTouchPoints();
          }),
          f(x(e), "_handleContentResultsResize", function () {
            e.updateViewport();
          }),
          f(x(e), "_handleContentScroll", function () {
            if (e.content) {
              var t = e.checkContentOverflow(),
                i = e.content.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t && i);
            }
          }),
          (e.searchInputSelector = "[data-sidebar-search-input]"),
          (e.searchInputComponentSelector =
            "[data-sidebar-search-input-component]"),
          (e.contentSelector = "[data-sidebar-search-content]"),
          (e.contentResultsSelector = "[data-sidebar-search-content-results]"),
          (e.content = e.element.querySelector(e.contentSelector)),
          (e.contentResults = e.element.querySelector(
            e.contentResultsSelector
          )),
          (e._searchInputComponent = e.element.querySelector(
            e.searchInputComponentSelector
          )),
          (e._searchInput = e.element.querySelector(e.searchInputSelector)),
          (e._resizeObserver = new ResizeObserver(
            e._handleContentResultsResize
          )),
          (e.defaultStateElement = document),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i.prototype), "connectedCallback", this).call(this),
                this.content &&
                  this.content.addEventListener(
                    "scroll",
                    this._handleContentScroll
                  ),
                this.addEventListener("click", this._handleClick),
                this.addEventListener(
                  "touchend",
                  this._handleSearchSidebarTouchEnd
                ),
                this._searchInput &&
                  this._searchInput.addEventListener(
                    "focus",
                    this._handleInputFocus
                  ),
                this.contentResults &&
                  this._resizeObserver.observe(this.contentResults);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i.prototype), "disconnectedCallback", this).call(this),
                this.content &&
                  this.content.removeEventListener(
                    "scroll",
                    this._handleContentScroll
                  ),
                this.removeEventListener("click", this._handleClick),
                this.removeEventListener(
                  "touchend",
                  this._handleSearchSidebarTouchEnd
                ),
                this._searchInput &&
                  this._searchInput.removeEventListener(
                    "focus",
                    this._handleInputFocus
                  ),
                this._resizeObserver.disconnect();
            },
          },
          {
            key: "updateViewport",
            value: function () {
              var e = this.checkContentOverflow();
              this.toggleAttribute("footer-shadow-visible", e);
            },
          },
          {
            key: "open",
            value: function () {
              var e = this;
              return Qt(_(i.prototype), "open", this)
                .call(this)
                .then(function () {
                  e._searchInput && !e._isEditorMode && e._searchInput.focus();
                });
            },
          },
          {
            key: "checkContentOverflow",
            value: function () {
              return (
                !(!this.contentResults || !this.content) &&
                this.contentResults.offsetHeight > this.content.offsetHeight
              );
            },
          },
        ]),
        i
      );
    })(li),
    hi = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this)).containers = b(
            e.querySelectorAll("[recently-viewed-container]")
          )),
          (e.cardLimit = +e.dataset.cardLimit),
          (e.visibleProductCount = 0),
          (e.sectionSettings = JSON.parse(e.dataset.sectionSettings)),
          e
        );
      }
      return (
        p(
          i,
          [
            {
              key: "connectedCallback",
              value: function () {
                this.setItems();
              },
            },
            {
              key: "setItems",
              value: function () {
                var e = localStorage.getItem("AuroraTheme-RecentlyProducts"),
                  t = this.createProducts(JSON.parse(e));
                this.containers.forEach(function (e) {
                  e.innerHTML = t;
                });
              },
            },
            {
              key: "createProducts",
              value: function (e) {
                var t = this,
                  i = "";
                return (
                  Object.keys(e)
                    .reverse()
                    .forEach(function (n) {
                      var s = t.prepareTemplate(e[n]),
                        a = t.createNodeByString(s);
                      "center" === t.sectionSettings.product_card_align &&
                        a.classList.add("product-card--center-alignment");
                      var r = t._visibleProductCount >= t.cardLimit,
                        o = n === t.dataset.productHandle;
                      r ||
                        o ||
                        ((i = "".concat(i, " ").concat(a.outerHTML)),
                        (t._visibleProductCount += 1));
                    }),
                  i
                );
              },
            },
            {
              key: "prepareTemplate",
              value: function (e) {
                return e.replaceAll(
                  /shape--square|shape--landscape|shape--portrait-xl|shape--portrait/gi,
                  "shape--".concat(this.sectionSettings.img_ratio)
                );
              },
            },
            {
              key: "createNodeByString",
              value: function (e) {
                return new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector("[recently-viewed-item]");
              },
            },
            {
              key: "setVisible",
              value: function (e) {
                this.classList.toggle("hidden", !e);
              },
            },
            {
              key: "_visibleProductCount",
              get: function () {
                return this.visibleProductCount;
              },
              set: function (e) {
                var t = e > 0;
                (this.visibleProductCount = e), this.setVisible(t);
              },
            },
          ],
          [
            {
              key: "updateProductsInLocalStorage",
              value: function (e, t) {
                if (e && t) {
                  var i = localStorage.getItem("AuroraTheme-RecentlyProducts"),
                    n = ce(v({}, JSON.parse(i)), f({}, t, e));
                  localStorage.setItem(
                    "AuroraTheme-RecentlyProducts",
                    JSON.stringify(n)
                  );
                }
              },
            },
          ]
        ),
        i
      );
    })(te),
    pi = window.Shopify,
    fi = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleContentScroll", function () {
            var t = !!e.content && e.content.scrollTop > 0;
            e.toggleAttribute("header-shadow-visible", t);
          }),
          f(x(e), "openAndRenderProductByUrl", function (t) {
            e._cache[t] &&
              e._cache[t].then(function (t) {
                var n;
                e.onThisPageRenderedQuickView &&
                  (e.onThisPageRenderedQuickView.innerHTML = ""),
                  e.isOpen
                    ? e.hide().then(function () {
                        e._setProductFromHTML(t),
                          Qt((x(e), _(i.prototype)), "open", e).call(e);
                      })
                    : (e._setProductFromHTML(t),
                      Qt((x(e), _(i.prototype)), "open", e).call(e)),
                  null == pi ||
                    null === (n = pi.PaymentButton) ||
                    void 0 === n ||
                    n.init();
              });
          }),
          (e._cache = {}),
          e
        );
      }
      return (
        p(i, [
          {
            key: "requestProductFromUrl",
            value: function (e, t) {
              var i = this;
              this._cache[e] ||
                ((this.onThisPageRenderedQuickView = document.querySelector(
                  '.shopify-section [data-quick-view-product-id="'.concat(
                    t,
                    '"]'
                  )
                )),
                this.onThisPageRenderedQuickView &&
                this.onThisPageRenderedQuickView.dataset.quickViewProductUrl ===
                  e
                  ? (this._cache[e] = V(0).then(function () {
                      return i.onThisPageRenderedQuickView;
                    }))
                  : (this._cache[e] = fetch(e)
                      .then(function (e) {
                        return e.text();
                      })
                      .then(function (e) {
                        return ge(e);
                      })));
            },
          },
          { key: "open", value: function () {} },
          {
            key: "_setProductFromHTML",
            value: function (e) {
              if (this.dataset.targetId) {
                var t = e.getElementById(this.dataset.targetId);
                if (t) {
                  hi.updateProductsInLocalStorage(
                    t.dataset.productString,
                    t.dataset.productHandle
                  );
                  var i = t.getAttribute("class") || "";
                  this.element.setAttribute("class", i),
                    (this.element.innerHTML = t.innerHTML),
                    (this.content = this.element.querySelector(
                      "[data-quick-view-content]"
                    )),
                    this.content &&
                      this.content.addEventListener(
                        "scroll",
                        this._handleContentScroll
                      );
                }
              }
            },
          },
          {
            key: "_resetProduct",
            value: function () {
              this.content &&
                (this.content.removeEventListener(
                  "scroll",
                  this._handleContentScroll
                ),
                this.onThisPageRenderedQuickView &&
                  (this.onThisPageRenderedQuickView.innerHTML =
                    this.content.innerHTML),
                (this.content = null)),
                (this.element.innerHTML = "");
            },
          },
        ]),
        i
      );
    })(li);
  function vi(e) {
    return "number" == typeof e;
  }
  function mi(e) {
    return "string" == typeof e;
  }
  function gi(e) {
    return "[object Object]" === Object.prototype.toString.call(e);
  }
  function yi(e) {
    return (
      gi(e) ||
      (function (e) {
        return Array.isArray(e);
      })(e)
    );
  }
  function bi(e) {
    return Math.abs(e);
  }
  function wi(e) {
    return e ? e / bi(e) : 0;
  }
  function Si(e, t) {
    return bi(e - t);
  }
  function xi(e) {
    return Ei(e).map(Number);
  }
  function Ci(e) {
    return e[ki(e)];
  }
  function ki(e) {
    return Math.max(0, e.length - 1);
  }
  function Ei(e) {
    return Object.keys(e);
  }
  function Ti(e, t) {
    return [e, t].reduce(function (e, t) {
      return (
        Ei(t).forEach(function (i) {
          var n = e[i],
            s = t[i],
            a = gi(n) && gi(s);
          e[i] = a ? Ti(n, s) : s;
        }),
        e
      );
    }, {});
  }
  function _i(e, t) {
    var i = Ei(e),
      n = Ei(t);
    return (
      i.length === n.length &&
      i.every(function (i) {
        var n = e[i],
          s = t[i];
        return "function" == typeof n
          ? "".concat(n) === "".concat(s)
          : yi(n) && yi(s)
          ? _i(n, s)
          : n === s;
      })
    );
  }
  function Mi(e, t) {
    var i = function (t) {
        return t < e;
      },
      n = function (e) {
        return e > t;
      },
      s = function (e) {
        return i(e) || n(e);
      },
      a = bi(e - t);
    return {
      length: a,
      max: t,
      min: e,
      constrain: function (n) {
        return s(n) ? (i(n) ? e : t) : n;
      },
      reachedAny: s,
      reachedMax: n,
      reachedMin: i,
      removeOffset: function (e) {
        return a ? e - a * Math.ceil((e - t) / a) : e;
      },
    };
  }
  function Li(e, t, i) {
    var n = function (e) {
        return i ? bi((c + e) % c) : l(e);
      },
      s = function () {
        return u;
      },
      a = function (e) {
        return (u = n(e)), d;
      },
      r = Mi(0, e),
      o = r.min,
      l = r.constrain,
      c = e + 1,
      u = n(t),
      d = {
        add: function (e) {
          return a(s() + e);
        },
        clone: function () {
          return Li(e, s(), i);
        },
        get: s,
        set: a,
        min: o,
        max: e,
      };
    return d;
  }
  function Pi() {
    var e = [],
      t = {
        add: function (i, n, s, a) {
          return (
            void 0 === a && (a = { passive: !0 }),
            i.addEventListener(n, s, a),
            e.push(function () {
              return i.removeEventListener(n, s, a);
            }),
            t
          );
        },
        removeAll: function () {
          return (
            (e = e.filter(function (e) {
              return e();
            })),
            t
          );
        },
      };
    return t;
  }
  function Ii(e) {
    var t = function (e) {
        return (n /= e), s;
      },
      i = function (e) {
        return vi(e) ? e : e.get();
      },
      n = e,
      s = {
        add: function (e) {
          return (n += i(e)), s;
        },
        divide: t,
        get: function () {
          return n;
        },
        multiply: function (e) {
          return (n *= e), s;
        },
        normalize: function () {
          return 0 !== n && t(n), s;
        },
        set: function (e) {
          return (n = i(e)), s;
        },
        subtract: function (e) {
          return (n -= i(e)), s;
        },
      };
    return s;
  }
  function Di(e, t, i, n, s) {
    var a = s.measure(10),
      r = s.measure(50),
      o = !1;
    return {
      constrain: function (s) {
        if (!o && e.reachedAny(i.get()) && e.reachedAny(t.get())) {
          var l = e.reachedMin(t.get()) ? "min" : "max",
            c = bi(e[l] - t.get()),
            u = i.get() - t.get(),
            d = Math.min(c / r, 0.85);
          i.subtract(u * d),
            !s &&
              bi(u) < a &&
              (i.set(e.constrain(i.get())), n.useSpeed(10).useMass(3));
        }
      },
      toggleActive: function (e) {
        o = !e;
      },
    };
  }
  function Ai(e, t, i, n) {
    var s = Mi(t.min + 0.1, t.max + 0.1),
      a = s.reachedMin,
      r = s.reachedMax;
    return {
      loop: function (t) {
        if (
          (function (e) {
            return 1 === e ? r(i.get()) : -1 === e && a(i.get());
          })(t)
        ) {
          var s = e * (-1 * t);
          n.forEach(function (e) {
            return e.add(s);
          });
        }
      },
    };
  }
  function zi(e) {
    var t = e.max,
      i = e.length;
    return {
      get: function (e) {
        return (e - t) / -i;
      },
    };
  }
  function Oi(e, t, i) {
    var n =
        "x" === e.scroll
          ? function (e) {
              return "translate3d(".concat(e, "px,0px,0px)");
            }
          : function (e) {
              return "translate3d(0px,".concat(e, "px,0px)");
            },
      s = i.style,
      a = !1;
    return {
      clear: function () {
        a ||
          ((s.transform = ""),
          i.getAttribute("style") || i.removeAttribute("style"));
      },
      to: function (e) {
        a || (s.transform = n(t.apply(e.get())));
      },
      toggleActive: function (e) {
        a = !e;
      },
    };
  }
  function Bi(e, t, i, n, s, a, r, o, l) {
    var c,
      u,
      d = function (e, t) {
        return e.reduce(function (e, t) {
          return e - s[t];
        }, t);
      },
      h = function (e, t) {
        return e.reduce(function (e, i) {
          return d(e, t) > 0 ? e.concat([i]) : e;
        }, []);
      },
      p = function (i, s) {
        var a = "start" === s,
          c = a ? -n : n,
          u = r.findSlideBounds([c]);
        return i.map(function (i) {
          var s = a ? 0 : -n,
            r = a ? n : 0,
            c = u.filter(function (e) {
              return e.index === i;
            })[0][a ? "end" : "start"],
            d = Ii(-1),
            h = Ii(-1),
            p = Oi(e, t, l[i]);
          return {
            index: i,
            location: h,
            translate: p,
            target: function () {
              return d.set(o.get() > c ? s : r);
            },
          };
        });
      },
      f = xi(s),
      v = xi(s).reverse(),
      m = ((c = a[0] - 1), (u = h(v, c)), p(u, "end")).concat(
        (function () {
          var e = i - a[0] - 1,
            t = h(f, e);
          return p(t, "start");
        })()
      );
    return {
      canLoop: function () {
        return m.every(function (e) {
          var t = e.index,
            n = f.filter(function (e) {
              return e !== t;
            });
          return d(n, i) <= 0.1;
        });
      },
      clear: function () {
        m.forEach(function (e) {
          return e.translate.clear();
        });
      },
      loop: function () {
        m.forEach(function (e) {
          var t = e.target,
            i = e.translate,
            n = e.location,
            s = t();
          s.get() !== n.get() &&
            (0 === s.get() ? i.clear() : i.to(s), n.set(s));
        });
      },
      loopPoints: m,
    };
  }
  function Ni(e, t, i, n, s) {
    var a,
      r,
      o,
      l,
      c = n.align,
      u = n.axis,
      d = n.direction,
      h = n.startIndex,
      p = n.inViewThreshold,
      f = n.loop,
      v = n.speed,
      m = n.dragFree,
      g = n.slidesToScroll,
      y = n.skipSnaps,
      b = n.containScroll,
      w = t.getBoundingClientRect(),
      S = i.map(function (e) {
        return e.getBoundingClientRect();
      }),
      x = (function (e) {
        var t = "rtl" === e ? -1 : 1;
        return {
          apply: function (e) {
            return e * t;
          },
        };
      })(d),
      C = (function (e, t) {
        var i = "y" === e ? "y" : "x";
        return {
          scroll: i,
          cross: "y" === e ? "x" : "y",
          startEdge: "y" === i ? "top" : "rtl" === t ? "right" : "left",
          endEdge: "y" === i ? "bottom" : "rtl" === t ? "left" : "right",
          measureSize: function (e) {
            var t = e.width,
              n = e.height;
            return "x" === i ? t : n;
          },
        };
      })(u, d),
      k = C.measureSize(w),
      E = (function (e) {
        return {
          measure: function (t) {
            return e * (t / 100);
          },
        };
      })(k),
      T = (function (e, t) {
        var i = function (e) {
            return t - e;
          },
          n = {
            start: function () {
              return 0;
            },
            center: function (e) {
              return i(e) / 2;
            },
            end: i,
          };
        return {
          measure: function (i) {
            return vi(e) ? t * Number(e) : n[e](i);
          },
        };
      })(c, k),
      _ = !f && "" !== b,
      M = (function (e, t, i, n, s) {
        var a = e.measureSize,
          r = e.startEdge,
          o = e.endEdge,
          l = i[0] && s,
          c = (function () {
            if (!l) return 0;
            var e = i[0];
            return bi(t[r] - e[r]);
          })(),
          u = (function () {
            if (!l) return 0;
            var e = window.getComputedStyle(Ci(n));
            return parseFloat(e.getPropertyValue("margin-".concat(o)));
          })(),
          d = i.map(a),
          h = i
            .map(function (e, t, i) {
              var n = !t,
                s = t === ki(i);
              return n ? d[t] + c : s ? d[t] + u : i[t + 1][r] - e[r];
            })
            .map(bi);
        return { slideSizes: d, slideSizesWithGaps: h };
      })(C, w, S, i, f || "" !== b),
      L = M.slideSizes,
      P = M.slideSizesWithGaps,
      I = (function (e, t, i) {
        var n = vi(i);
        return {
          groupSlides: function (s) {
            return n
              ? (function (e, t) {
                  return xi(e)
                    .filter(function (e) {
                      return e % t == 0;
                    })
                    .map(function (i) {
                      return e.slice(i, i + t);
                    });
                })(s, i)
              : (function (i) {
                  return xi(i)
                    .reduce(function (i, n) {
                      var s = t.slice(Ci(i), n + 1).reduce(function (e, t) {
                        return e + t;
                      }, 0);
                      return !n || s > e ? i.concat(n) : i;
                    }, [])
                    .map(function (e, t, n) {
                      return i.slice(e, n[t + 1]);
                    });
                })(s);
          },
        };
      })(k, P, g),
      D = (function (e, t, i, n, s, a, r) {
        var o,
          l = e.startEdge,
          c = e.endEdge,
          u = a.groupSlides,
          d = u(n)
            .map(function (e) {
              return Ci(e)[c] - e[0][l];
            })
            .map(bi)
            .map(t.measure),
          h = n
            .map(function (e) {
              return i[l] - e[l];
            })
            .map(function (e) {
              return -bi(e);
            }),
          p =
            ((o = Ci(h) - Ci(s)),
            u(h)
              .map(function (e) {
                return e[0];
              })
              .map(function (e, t, i) {
                var n = !t,
                  s = t === ki(i);
                return r && n ? 0 : r && s ? o : e + d[t];
              }));
        return { snaps: h, snapsAligned: p };
      })(C, T, w, S, P, I, _),
      A = D.snaps,
      z = D.snapsAligned,
      O = -Ci(A) + Ci(P),
      B = (function (e, t, i, n) {
        var s = Mi(-t + e, i[0]),
          a = i.map(s.constrain);
        return {
          snapsContained: (function () {
            if (t <= e) return [s.max];
            if ("keepSnaps" === n) return a;
            var i,
              r,
              o =
                ((i = a[0]),
                (r = Ci(a)),
                Mi(a.lastIndexOf(i), a.indexOf(r) + 1)),
              l = o.min,
              c = o.max;
            return a.slice(l, c);
          })(),
        };
      })(k, O, z, b).snapsContained,
      N = _ ? B : z,
      q = (function (e, t, i) {
        var n, s;
        return { limit: ((n = t[0]), (s = Ci(t)), Mi(i ? n - e : s, n)) };
      })(O, N, f).limit,
      $ = Li(ki(N), h, f),
      H = $.clone(),
      F = xi(i),
      V =
        ((a = function () {
          f || Q.scrollBounds.constrain(Q.dragHandler.pointerDown()),
            Q.scrollBody.seek(X).update();
          var e = Q.scrollBody.settle(X);
          e &&
            !Q.dragHandler.pointerDown() &&
            (Q.animation.stop(), s.emit("settle")),
            e || s.emit("scroll"),
            f &&
              (Q.scrollLooper.loop(Q.scrollBody.direction()),
              Q.slideLooper.loop()),
            Q.translate.to(j),
            Q.animation.proceed();
        }),
        (r = function (e, t) {
          return function () {
            e === !!l && t();
          };
        }),
        (o = function () {
          l = window.requestAnimationFrame(a);
        }),
        (l = 0),
        {
          proceed: r(!0, o),
          start: r(!1, o),
          stop: r(!0, function () {
            window.cancelAnimationFrame(l), (l = 0);
          }),
        }),
      R = N[$.get()],
      j = Ii(R),
      X = Ii(R),
      G = (function (e, t, i) {
        var n,
          s = function (e) {
            return (d = e), p;
          },
          a = function (e) {
            return (h = e), p;
          },
          r =
            ((n = Math.pow(10, 2)),
            function (e) {
              return Math.round(e * n) / n;
            }),
          o = Ii(0),
          l = Ii(0),
          c = Ii(0),
          u = 0,
          d = t,
          h = i,
          p = {
            direction: function () {
              return u;
            },
            seek: function (t) {
              c.set(t).subtract(e);
              var i,
                n = 0 + ((c.get() - 0) / 100) * (d - 0);
              return (
                (u = wi(c.get())),
                c.normalize().multiply(n).subtract(o),
                (i = c).divide(h),
                l.add(i),
                p
              );
            },
            settle: function (t) {
              var i = t.get() - e.get(),
                n = !r(i);
              return n && e.set(t), n;
            },
            update: function () {
              o.add(l), e.add(o), l.multiply(0);
            },
            useBaseMass: function () {
              return a(i);
            },
            useBaseSpeed: function () {
              return s(t);
            },
            useMass: a,
            useSpeed: s,
          };
        return p;
      })(j, v, 1),
      W = (function (e, t, i, n, s) {
        var a = function (e) {
            return e.concat().sort(function (e, t) {
              return bi(e) - bi(t);
            })[0];
          },
          r = function (t, n) {
            var s = [t, t + i, t - i];
            if (!e) return s[0];
            if (!n) return a(s);
            var r = s.filter(function (e) {
              return wi(e) === n;
            });
            return a(r);
          },
          o = n.reachedAny,
          l = n.removeOffset,
          c = n.constrain;
        return {
          byDistance: function (i, n) {
            var a = s.get() + i,
              u = (function (i) {
                var n = e ? l(i) : c(i);
                return {
                  index: t
                    .map(function (e) {
                      return e - n;
                    })
                    .map(function (e) {
                      return r(e, 0);
                    })
                    .map(function (e, t) {
                      return { diff: e, index: t };
                    })
                    .sort(function (e, t) {
                      return bi(e.diff) - bi(t.diff);
                    })[0].index,
                  distance: n,
                };
              })(a),
              d = u.index,
              h = u.distance,
              p = !e && o(a);
            if (!n || p) return { index: d, distance: i };
            var f = t[d] - h;
            return { index: d, distance: i + r(f, 0) };
          },
          byIndex: function (e, i) {
            var n = t[e] - s.get();
            return { index: e, distance: r(n, i) };
          },
          shortcut: r,
        };
      })(f, N, O, q, X),
      Y = (function (e, t, i, n, s, a) {
        var r = function (n) {
          var r = n.distance,
            o = n.index !== t.get();
          r && (e.start(), s.add(r)),
            o && (i.set(t.get()), t.set(n.index), a.emit("select"));
        };
        return {
          distance: function (e, t) {
            var i = n.byDistance(e, t);
            r(i);
          },
          index: function (e, i) {
            var s = t.clone().set(e),
              a = n.byIndex(s.get(), i);
            r(a);
          },
        };
      })(V, $, H, W, X, s),
      U = (function (e, t, i, n, s, a, r) {
        var o = function (t, s) {
            var a = t || d,
              r = (function (e) {
                var t = e || 0;
                return i.map(function (e) {
                  return Mi(u, e - u).constrain(e * t);
                });
              })(s);
            return a.reduce(function (t, s) {
              var a = n.map(function (t, n) {
                return {
                  start: t - i[n] + r[n] + s,
                  end: t + e - r[n] + s,
                  index: n,
                };
              });
              return t.concat(a);
            }, []);
          },
          l = s.removeOffset,
          c = s.constrain,
          u = 0.5,
          d = a ? [0, t, -t] : [0],
          h = o(d, r);
        return {
          check: function (e, t) {
            var i = a ? l(e) : c(e);
            return (t || h).reduce(function (e, t) {
              var n = t.index,
                s = t.start,
                a = t.end;
              return -1 === e.indexOf(n) && s < i && a > i ? e.concat([n]) : e;
            }, []);
          },
          findSlideBounds: o,
        };
      })(k, O, L, A, q, f, p),
      K = (function (e, t, i, n, s, a, r, o, l, c, u, d, h, p, f, v) {
        var m = function (e) {
            if (
              !(
                ((B = !s.isTouchEvent(e)) && 0 !== e.button) ||
                ((t = e.target), (r = t.nodeName || ""), S.indexOf(r) > -1)
              )
            ) {
              var t,
                r,
                o = Si(n.get(), a.get()) >= 2,
                c = B || !o;
              (A = !0),
                s.pointerDown(e),
                C.set(n),
                n.set(a),
                l.useBaseMass().useSpeed(80),
                (function () {
                  var e = B ? document : i;
                  E.add(e, "touchmove", g, x)
                    .add(e, "touchend", y)
                    .add(e, "mousemove", g, x)
                    .add(e, "mouseup", y);
                })(),
                (I = s.readPoint(e)),
                (D = s.readPoint(e, w)),
                d.emit("pointerDown"),
                c && (O = !1);
            }
          },
          g = function (e) {
            if (!z && !B) {
              if (!e.cancelable) return y(e);
              var i = s.readPoint(e),
                a = s.readPoint(e, w),
                o = Si(i, I),
                l = Si(a, D);
              if (!(z = o > l) && !O) return y(e);
            }
            var c = s.pointerMove(e);
            !O && c && (O = !0),
              r.start(),
              n.add(t.apply(c)),
              e.preventDefault();
          },
          y = function (e) {
            var i = c.byDistance(0, !1).index !== u.get(),
              a = s.pointerUp(e) * (f ? M : _)[B ? "mouse" : "touch"],
              r = (function (e, t) {
                var i = u.clone().add(-1 * wi(e)),
                  n = i.get() === u.min || i.get() === u.max,
                  s = c.byDistance(e, !f).distance;
                return f || bi(e) < T
                  ? s
                  : !p && n
                  ? 0.4 * s
                  : v && t
                  ? 0.5 * s
                  : c.byIndex(i.get(), 0).distance;
              })(t.apply(a), i),
              h = (function (e, t) {
                if (0 === e || 0 === t) return 0;
                if (bi(e) <= bi(t)) return 0;
                var i = Si(bi(e), bi(t));
                return bi(i / e);
              })(a, r),
              m = Si(n.get(), C.get()) >= 0.5,
              g = i && h > 0.75,
              y = bi(a) < T,
              b = g ? 10 : L,
              w = g ? P + 2.5 * h : P;
            m && !B && (O = !0),
              (z = !1),
              (A = !1),
              E.removeAll(),
              l.useSpeed(y ? 9 : b).useMass(w),
              o.distance(r, !f),
              (B = !1),
              d.emit("pointerUp");
          },
          b = function (e) {
            O && (e.stopPropagation(), e.preventDefault());
          },
          w = e.cross,
          S = ["INPUT", "SELECT", "TEXTAREA"],
          x = { passive: !1 },
          C = Ii(0),
          k = Pi(),
          E = Pi(),
          T = h.measure(20),
          _ = { mouse: 300, touch: 400 },
          M = { mouse: 500, touch: 600 },
          L = f ? 5 : 16,
          P = 1,
          I = 0,
          D = 0,
          A = !1,
          z = !1,
          O = !1,
          B = !1;
        return {
          addActivationEvents: function () {
            var e = i;
            k.add(
              e,
              "dragstart",
              function (e) {
                return e.preventDefault();
              },
              x
            )
              .add(e, "touchmove", function () {}, x)
              .add(e, "touchend", function () {})
              .add(e, "touchstart", m)
              .add(e, "mousedown", m)
              .add(e, "touchcancel", y)
              .add(e, "contextmenu", y)
              .add(e, "click", b, !0);
          },
          clickAllowed: function () {
            return !O;
          },
          pointerDown: function () {
            return A;
          },
          removeAllEvents: function () {
            k.removeAll(), E.removeAll();
          },
        };
      })(
        C,
        x,
        e,
        X,
        (function (e) {
          var t,
            i,
            n = function (e) {
              return (
                "undefined" != typeof TouchEvent && e instanceof TouchEvent
              );
            },
            s = function (e) {
              return e.timeStamp;
            },
            a = function (t, i) {
              var s = i || e.scroll,
                a = "client".concat("x" === s ? "X" : "Y");
              return (n(t) ? t.touches[0] : t)[a];
            };
          return {
            isTouchEvent: n,
            pointerDown: function (e) {
              return (t = e), (i = e), a(e);
            },
            pointerMove: function (e) {
              var n = a(e) - a(i),
                r = s(e) - s(t) > 170;
              return (i = e), r && (t = e), n;
            },
            pointerUp: function (e) {
              if (!t || !i) return 0;
              var n = a(i) - a(t),
                r = s(e) - s(t),
                o = s(e) - s(i) > 170,
                l = n / r;
              return r && !o && bi(l) > 0.1 ? l : 0;
            },
            readPoint: a,
          };
        })(C),
        j,
        V,
        Y,
        G,
        W,
        $,
        s,
        E,
        f,
        m,
        y
      ),
      Q = {
        containerRect: w,
        slideRects: S,
        animation: V,
        axis: C,
        direction: x,
        dragHandler: K,
        eventStore: Pi(),
        percentOfView: E,
        index: $,
        indexPrevious: H,
        limit: q,
        location: j,
        options: n,
        scrollBody: G,
        scrollBounds: Di(q, j, X, G, E),
        scrollLooper: Ai(O, q, j, [j, X]),
        scrollProgress: zi(q),
        scrollSnaps: N,
        scrollTarget: W,
        scrollTo: Y,
        slideLooper: Bi(C, x, k, O, P, N, U, j, i),
        slidesToScroll: I,
        slidesInView: U,
        slideIndexes: F,
        target: X,
        translate: Oi(C, x, t),
      };
    return Q;
  }
  var qi = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "",
    direction: "ltr",
    slidesToScroll: 1,
    breakpoints: {},
    dragFree: !1,
    draggable: !0,
    inViewThreshold: 0,
    loop: !1,
    skipSnaps: !1,
    speed: 10,
    startIndex: 0,
    active: !0,
  };
  function $i() {
    var e = function (e, t) {
      return Ti(e, t || {});
    };
    return {
      merge: e,
      areEqual: function (e, t) {
        return (
          JSON.stringify(Ei(e.breakpoints || {})) ===
            JSON.stringify(Ei(t.breakpoints || {})) && _i(e, t)
        );
      },
      atMedia: function (t) {
        var i = t.breakpoints || {},
          n = Ei(i)
            .filter(function (e) {
              return window.matchMedia(e).matches;
            })
            .map(function (e) {
              return i[e];
            })
            .reduce(function (t, i) {
              return e(t, i);
            }, {});
        return e(t, n);
      },
    };
  }
  function Hi(e, t, i) {
    var n,
      s,
      a,
      r,
      o = function (e, t) {
        var i = d();
        l(), k(p.merge({ startIndex: i }, e), t), v.emit("reInit");
      },
      l = function () {
        n.dragHandler.removeAllEvents(),
          n.animation.stop(),
          n.eventStore.removeAll(),
          n.translate.clear(),
          n.slideLooper.clear(),
          f.destroy();
      },
      c = function (e) {
        var t = n[e ? "target" : "location"].get(),
          i = S.loop ? "removeOffset" : "constrain";
        return n.slidesInView.check(n.limit[i](t));
      },
      u = function (e, t, i) {
        S.active &&
          !b &&
          (n.scrollBody.useBaseMass().useSpeed(t ? 100 : S.speed),
          n.scrollTo.index(e, i || 0));
      },
      d = function () {
        return n.index.get();
      },
      h = Pi(),
      p = $i(),
      f = (function () {
        var e = function (e) {
            var t = i(e.options);
            return function () {
              return !n(t, i(e.options));
            };
          },
          t = $i(),
          i = t.atMedia,
          n = t.areEqual,
          s = [],
          a = [],
          r = {
            init: function (t, n) {
              return (
                (a = t.map(e)),
                (s = t.filter(function (e) {
                  return i(e.options).active;
                })).forEach(function (e) {
                  return e.init(n);
                }),
                t.reduce(function (e, t) {
                  var i;
                  return Object.assign(e, (((i = {})[t.name] = t), i));
                }, {})
              );
            },
            destroy: function () {
              s = s.filter(function (e) {
                return e.destroy();
              });
            },
            haveChanged: function () {
              return a.some(function (e) {
                return e();
              });
            },
          };
        return r;
      })(),
      v = (function () {
        var e = function (e) {
            return t[e] || [];
          },
          t = {},
          i = {
            emit: function (t) {
              return (
                e(t).forEach(function (e) {
                  return e(t);
                }),
                i
              );
            },
            off: function (n, s) {
              return (
                (t[n] = e(n).filter(function (e) {
                  return e !== s;
                })),
                i
              );
            },
            on: function (n, s) {
              return (t[n] = e(n).concat([s])), i;
            },
          };
        return i;
      })(),
      m = v.on,
      g = v.off,
      y = o,
      b = !1,
      w = p.merge(qi, Hi.globalOptions),
      S = p.merge(w),
      x = [],
      C = 0;
    function k(t, i) {
      if (!b) {
        if (
          ((w = p.merge(w, t)),
          (S = p.atMedia(w)),
          (function () {
            var t = S.container,
              i = S.slides,
              n = mi(t) ? e.querySelector(t) : t;
            a = n || e.children[0];
            var s = mi(i) ? a.querySelectorAll(i) : i;
            r = [].slice.call(s || a.children);
          })(),
          (n = Ni(e, a, r, S, v)),
          (C = n.axis.measureSize(e.getBoundingClientRect())),
          !S.active)
        )
          return l();
        if (
          (n.translate.to(n.location), (x = i || x), (s = f.init(x, E)), S.loop)
        ) {
          if (!n.slideLooper.canLoop())
            return l(), k({ loop: !1 }, i), void (w = p.merge(w, { loop: !0 }));
          n.slideLooper.loop();
        }
        S.draggable &&
          a.offsetParent &&
          r.length &&
          n.dragHandler.addActivationEvents();
      }
    }
    var E = {
      canScrollNext: function () {
        return n.index.clone().add(1).get() !== d();
      },
      canScrollPrev: function () {
        return n.index.clone().add(-1).get() !== d();
      },
      clickAllowed: function () {
        return n.dragHandler.clickAllowed();
      },
      containerNode: function () {
        return a;
      },
      internalEngine: function () {
        return n;
      },
      destroy: function () {
        b || ((b = !0), h.removeAll(), l(), v.emit("destroy"));
      },
      off: g,
      on: m,
      plugins: function () {
        return s;
      },
      previousScrollSnap: function () {
        return n.indexPrevious.get();
      },
      reInit: y,
      rootNode: function () {
        return e;
      },
      scrollNext: function (e) {
        var t = n.index.clone().add(1);
        u(t.get(), !0 === e, -1);
      },
      scrollPrev: function (e) {
        var t = n.index.clone().add(-1);
        u(t.get(), !0 === e, 1);
      },
      scrollProgress: function () {
        return n.scrollProgress.get(n.location.get());
      },
      scrollSnapList: function () {
        return n.scrollSnaps.map(n.scrollProgress.get);
      },
      scrollTo: u,
      selectedScrollSnap: d,
      slideNodes: function () {
        return r;
      },
      slidesInView: c,
      slidesNotInView: function (e) {
        var t = c(e);
        return n.slideIndexes.filter(function (e) {
          return -1 === t.indexOf(e);
        });
      },
    };
    return (
      k(t, i),
      h.add(window, "resize", function () {
        var t = p.atMedia(w),
          i = !p.areEqual(t, S),
          s = n.axis.measureSize(e.getBoundingClientRect()),
          a = C !== s,
          r = f.haveChanged();
        (a || i || r) && o(), v.emit("resize");
      }),
      setTimeout(function () {
        return v.emit("init");
      }, 0),
      E
    );
  }
  (Hi.globalOptions = void 0), (Hi.optionsHandler = $i);
  var Fi = {
    active: !0,
    breakpoints: {},
    selected: "is-selected",
    draggable: "is-draggable",
    dragging: "is-dragging",
  };
  function Vi(e, t) {
    var i = e.classList;
    t && i.contains(t) && i.remove(t);
  }
  function Ri(e, t) {
    var i = e.classList;
    t && !i.contains(t) && i.add(t);
  }
  function ji(e) {
    var t,
      i,
      n,
      s,
      a = function (e) {
        "pointerDown" === e ? Ri(n, t.dragging) : Vi(n, t.dragging);
      },
      r = function () {
        var e = i.slidesInView(!0);
        i.slidesNotInView(!0).forEach(function (e) {
          return Vi(s[e], t.selected);
        }),
          e.forEach(function (e) {
            return Ri(s[e], t.selected);
          });
      },
      o = Hi.optionsHandler(),
      l = o.merge(Fi, ji.globalOptions),
      c = ["select", "pointerUp"],
      u = ["pointerDown", "pointerUp"],
      d = {
        name: "classNames",
        options: o.merge(l, e),
        init: function (e) {
          (i = e),
            (t = o.atMedia(d.options)),
            (n = i.rootNode()),
            (s = i.slideNodes()),
            i.internalEngine().options.draggable && Ri(n, t.draggable),
            t.dragging &&
              u.forEach(function (e) {
                return i.on(e, a);
              }),
            t.selected &&
              (c.forEach(function (e) {
                return i.on(e, r);
              }),
              r());
        },
        destroy: function () {
          Vi(n, t.draggable),
            u.forEach(function (e) {
              return i.off(e, a);
            }),
            c.forEach(function (e) {
              return i.off(e, r);
            }),
            s.forEach(function (e) {
              return Vi(e, t.selected);
            });
        },
      };
    return d;
  }
  ji.globalOptions = void 0;
  var Xi,
    Gi,
    Wi,
    Yi = "idle",
    Ui = "running",
    Ki = "paused",
    Qi = "resumed",
    Zi = (function () {
      "use strict";
      function e(t, i) {
        d(this, e),
          (this.interval = i),
          (this.callback = t),
          (this.state = Yi),
          (this.pausedTime = 0),
          (this.remainingTime = 0);
      }
      return (
        p(e, [
          {
            key: "proxyCallback",
            value: function () {
              (this.lastFireTime = new Date()), this.callback();
            },
          },
          {
            key: "start",
            value: function () {
              var e = this;
              (this.timerId = setInterval(function () {
                return e.proxyCallback();
              }, this.interval)),
                (this.lastFireTime = new Date()),
                (this.state = Ui);
            },
          },
          {
            key: "pause",
            value: function () {
              (this.state !== Ui && this.state !== Qi) ||
                ((this.remainingTime =
                  this.interval -
                  (new Date() - this.lastFireTime) +
                  this.pausedTime),
                (this.lastPauseTime = new Date()),
                clearInterval(this.timerId),
                clearTimeout(this.resumeId),
                (this.state = Ki));
            },
          },
          {
            key: "resume",
            value: function () {
              var e = this;
              this.state === Ki &&
                ((this.pausedTime += new Date() - this.lastPauseTime),
                (this.state = Qi),
                (this.resumeId = setTimeout(function () {
                  return e.timeoutCallback();
                }, this.remainingTime)));
            },
          },
          {
            key: "timeoutCallback",
            value: function () {
              this.state === Qi &&
                ((this.pausedTime = 0), this.proxyCallback(), this.start());
            },
          },
          {
            key: "stop",
            value: function () {
              this.state !== Yi &&
                (clearInterval(this.timerId),
                clearTimeout(this.resumeId),
                (this.state = Yi));
            },
          },
          {
            key: "setInterval",
            value: function (e) {
              this.state === Ui
                ? (this.pause(), (this.interval = e), this.resume())
                : (this.interval = e);
            },
          },
        ]),
        e
      );
    })(),
    Ji = {};
  (Xi = Ji),
    (Gi = function () {
      return en;
    }),
    (Wi = function (e) {
      return (en = e);
    }),
    Object.defineProperty(Xi, "debounce", {
      get: Gi,
      set: Wi,
      enumerable: !0,
      configurable: !0,
    });
  var en = function (e, t) {
      var i;
      return function () {
        for (var n = arguments.length, s = new Array(n), a = 0; a < n; a++)
          s[a] = arguments[a];
        clearTimeout(i),
          (i = setTimeout(function () {
            return e.apply(void 0, s);
          }, t));
      };
    },
    tn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        d(this, i),
          f(
            x((e = t.call(this))),
            "attributeChangedCallback",
            function (t, i, n) {
              i !== n && e.reInit();
            }
          ),
          f(x(e), "_handleCarouselTargetKeyDown", function (t) {
            t.preventDefault();
            var i = e.focusableTargets.findIndex(function (e) {
                return e === t.target;
              }),
              n = e.focusableTargets[i],
              s = e.focusableTargets[i + 1],
              a = e.focusableTargets[i - 1];
            9 === t.keyCode &&
              (t.preventDefault(),
              document.activeElement === n && e.focusScroll(n),
              t.shiftKey ||
                (s ? e.focusScroll(s) : document.activeElement.blur()),
              t.shiftKey &&
                (a ? e.focusScroll(a) : document.activeElement.blur()));
          }),
          f(
            x(e),
            "_handleCarouselResize",
            (0, Ji.debounce)(function () {
              if (e._isEditorMode) {
                var t = ci() ? "mobile" : "desktop";
                e.lastViewModeIsMobile !== t &&
                  e.forceStopped &&
                  (e.forcePlay(), e.changePlayState(!0)),
                  (e.lastViewModeIsMobile = t);
              }
              e.reInit();
            }, 100)
          ),
          f(x(e), "focusScroll", function (t) {
            var i = e.slides.findIndex(function (e) {
              return e.contains(t);
            });
            -1 !== i && (e.embla.scrollTo(i, !0), e.forceStop()), t.focus();
          }),
          f(x(e), "_handleCarouselEnter", function () {
            ci() || e.changePlayState(!1);
          }),
          f(x(e), "_handleCarouselSelect", function () {
            e.isTouchOnCarousel && e.forceStop();
          }),
          f(x(e), "_handleCarouselPointerUp", function () {
            e.isTouchOnCarousel = !1;
          }),
          f(x(e), "_handleCarouselPointerDown", function () {
            e.isTouchOnCarousel = !0;
          }),
          f(x(e), "_handleCarouselLeave", function () {
            ci() || e.changePlayState(!0);
          }),
          f(x(e), "_handleKeydown", function (t) {
            var i = t.key || t.keyCode,
              n = Z(i),
              s = Q(i);
            n && e.embla.scrollPrev(), s && e.embla.scrollNext();
          }),
          f(x(e), "_handleBlockSelect", function (t) {
            var i = t.detail,
              n = i.sectionId,
              s = i.blockId,
              a = i.load;
            if (e.dataset.sectionId === n) {
              var r = e.embla.slideNodes().findIndex(function (e) {
                var t;
                return (
                  (null === (t = e.attributes["block-id"]) || void 0 === t
                    ? void 0
                    : t.value) === s
                );
              });
              -1 !== r && (e.embla.scrollTo(r, a), e.forceStop());
            }
          }),
          f(x(e), "_handleSectionLoad", function (t) {
            var i = t.detail.sectionId;
            e.dataset.sectionId === i && e.reInit();
          }),
          f(x(e), "_getOptions", function () {
            return {
              loop: "infinite" === e.dataset.loop,
              dragFree: e.dataset.dragFree,
              draggable:
                !e.hasAttribute("data-draggable") ||
                "true" === e.dataset.draggable,
              skipSnaps: e.dataset.skipSnaps || !0,
              align: e.dataset.align || "start",
              inViewThreshold: +(e.dataset.inViewThreshhold || 0) || 0.75,
              containScroll: e.hasAttribute("data-contain-scroll")
                ? e.dataset.containScroll
                : "trimSnaps",
              axis: "vertical" === e.dataset.axis ? "y" : "x",
              speed: e._getSpeed(),
            };
          }),
          f(x(e), "_getPlugins", function () {
            return [e._getClassNamesPlugin()];
          }),
          f(x(e), "changePlayState", function (t) {
            e.withAutoplay &&
              (e.forceStopped ||
                ((e.isPlay = t),
                t ? e.autoplay.play() : e.autoplay.pause(),
                e.emit("changePlayState", {})));
          }),
          f(x(e), "reInit", function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : {},
              i = v({}, e._getOptions(), t),
              n = e._getPlugins();
            e.embla.reInit(i, n);
          }),
          f(x(e), "scrollNext", function () {
            e.embla.scrollNext();
          }),
          f(x(e), "scrollPrev", function () {
            e.embla.scrollPrev();
          }),
          f(x(e), "canScrollNext", function () {
            return e.embla.canScrollNext();
          }),
          f(x(e), "canScrollPrev", function () {
            return e.embla.canScrollPrev();
          });
        var n = +(e.dataset.autoplayInterval || 0);
        return (
          (e.withAutoplay = n > 0),
          (e.isPlay = n > 0),
          (e.forceStopped = !1),
          (e.resizeObserver = new ResizeObserver(e._handleCarouselResize)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._setCarousel(),
                (this.focusableTargets = b(this.querySelectorAll(W()))),
                this.focusableTargets.forEach(function (t) {
                  t.addEventListener("keydown", e._handleCarouselTargetKeyDown);
                }),
                this.withStopOnHover &&
                  (j(this, "mouseenter", this._handleCarouselEnter),
                  j(this, "mouseleave", this._handleCarouselLeave)),
                j(this, "keydown", this._handleKeydown),
                this.resizeObserver.observe(this),
                this.embla.on("select", this._handleCarouselSelect),
                this.embla.on("pointerUp", this._handleCarouselPointerUp),
                this.embla.on("pointerDown", this._handleCarouselPointerDown),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.focusableTargets.forEach(function (t) {
                t.removeEventListener(
                  "keydown",
                  e._handleCarouselTargetKeyDown
                );
              }),
                this.resizeObserver.disconnect(),
                this.withStopOnHover &&
                  (X(this, "mouseenter", this._handleCarouselEnter),
                  X(this, "mouseleave", this._handleCarouselLeave)),
                X(this, "keydown", this._handleKeydown),
                this.embla.off("select", this._handleCarouselSelect),
                this.embla.off("pointerUp", this._handleCarouselPointerUp),
                this.embla.off("pointerDown", this._handleCarouselPointerDown),
                this._isEditorMode && this._editor.destroy(),
                this.embla.destroy();
            },
          },
          {
            key: "_setCarousel",
            value: function () {
              var e,
                t,
                i,
                n = this.querySelector("[data-carousel-viewport]");
              n &&
                ((this.embla = Hi(n, this._getOptions(), this._getPlugins())),
                this.withAutoplay &&
                  ((this.autoplay =
                    ((e = this.embla),
                    (t = 1e3 * this.autoplayInterval),
                    (i = new Zi(function () {
                      var t = e.scrollSnapList().length - 1;
                      e.selectedScrollSnap() === t
                        ? e.scrollTo(0)
                        : e.scrollNext();
                    }, t)),
                    {
                      play: function () {
                        i.resume();
                      },
                      stop: function () {
                        i.stop();
                      },
                      start: function () {
                        i.start();
                      },
                      pause: function () {
                        i.pause();
                      },
                    })),
                  this.autoplay.start()));
            },
          },
          {
            key: "_getClassNamesPlugin",
            value: function () {
              return ji();
            },
          },
          {
            key: "_getSpeed",
            value: function () {
              return ui() || "fade" === this.dataset.animation ? 100 : 10;
            },
          },
          {
            key: "forceStop",
            value: function () {
              this.withAutoplay &&
                (this.autoplay.stop(),
                (this.isPlay = !1),
                (this.forceStopped = !0),
                this.emit("forceChangePlayState", {}));
            },
          },
          {
            key: "forcePlay",
            value: function () {
              this.withAutoplay &&
                ((this.forceStopped = !1),
                (this.isPlay = !0),
                this.autoplay.start(),
                this.changePlayState(!1),
                this.emit("forceChangePlayState", {}));
            },
          },
          {
            key: "withStopOnHover",
            get: function () {
              return this.hasAttribute("with-stop-on-hover");
            },
          },
          {
            key: "autoplayInterval",
            get: function () {
              return +(this.dataset.autoplayInterval || 0);
            },
          },
          {
            key: "slides",
            get: function () {
              return b(this.embla.slideNodes());
            },
          },
        ]),
        i
      );
    })(te),
    nn = tn,
    sn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.call(this))),
            "_handleCarouselChangePlayState",
            function () {
              e.updatePlayState();
            }
          ),
          f(x(e), "_handleButtonClick", function (t) {
            t.stopPropagation(),
              e._carousel &&
                (e._carousel.forceStopped
                  ? e._carousel.forcePlay()
                  : e._carousel.forceStop());
          }),
          (e.button = e.querySelector("[data-carousel-play-button]")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.updatePlayState(),
                this.button &&
                  this.button.addEventListener(
                    "click",
                    this._handleButtonClick
                  ),
                this._carousel &&
                  (customElements.upgrade(this._carousel),
                  this._carousel.subscribe(
                    "forceChangePlayState",
                    this._handleCarouselChangePlayState
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                this._carousel &&
                  this._carousel.unsubscribe(
                    "forceChangePlayState",
                    this._handleCarouselChangePlayState
                  );
            },
          },
          {
            key: "updatePlayState",
            value: function () {
              if (this._carousel && this.button) {
                var e = this._carousel.forceStopped;
                this.button.setAttribute(
                  "data-autoplay-stopped",
                  e ? "true" : "false"
                );
              }
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        i
      );
    })(te);
  function an() {
    return (
      (an =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var n in i)
              Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
          }
          return e;
        }),
      an.apply(this, arguments)
    );
  }
  function rn(e, t) {
    if (e.length !== t.length) throw new Error("vectors must be same length");
    return e.map(function (e, i) {
      return e + t[i];
    });
  }
  function on(e) {
    return Math.max.apply(Math, e.map(Math.abs));
  }
  function ln(e) {
    return (
      Object.freeze(e),
      Object.values(e).forEach(function (e) {
        null === e || "object" != typeof e || Object.isFrozen(e) || ln(e);
      }),
      e
    );
  }
  var cn = [1, 18, ("undefined" != typeof window && window.innerHeight) || 800],
    un = [-1, -1, -1],
    dn = ln({ preventWheelAction: !0, reverseSign: [!0, !0, !1] });
  var hn = function (e) {
      void 0 === e && (e = {});
      var t,
        i,
        n,
        s = (function () {
          var e = function (e, i) {
              t[e] = (t[e] || []).filter(function (e) {
                return e !== i;
              });
            },
            t = {};
          return ln({
            on: function (i, n) {
              return (
                (t[i] = (t[i] || []).concat(n)),
                function () {
                  return e(i, n);
                }
              );
            },
            off: e,
            dispatch: function (e, i) {
              e in t &&
                t[e].forEach(function (e) {
                  return e(i);
                });
            },
          });
        })(),
        a = s.on,
        r = s.off,
        o = s.dispatch,
        l = dn,
        c = {
          isStarted: !1,
          isStartPublished: !1,
          isMomentum: !1,
          startTime: 0,
          lastAbsDelta: 1 / 0,
          axisMovement: [0, 0, 0],
          axisVelocity: [0, 0, 0],
          accelerationFactors: [],
          scrollPoints: [],
          scrollPointsToMerge: [],
          willEndTimeout: 400,
        },
        u = !1,
        d = function (e) {
          Array.isArray(e)
            ? e.forEach(function (e) {
                return f(e);
              })
            : f(e);
        },
        h = function (e) {
          return (
            void 0 === e && (e = {}),
            Object.values(e).some(function (e) {
              return null == e;
            })
              ? l
              : (l = ln(an({}, dn, l, e)))
          );
        },
        p = function (e) {
          var n = an(
            {
              event: t,
              isStart: !1,
              isEnding: !1,
              isMomentumCancel: !1,
              isMomentum: c.isMomentum,
              axisDelta: [0, 0, 0],
              axisVelocity: c.axisVelocity,
              axisMovement: c.axisMovement,
              get axisMovementProjection() {
                return rn(
                  n.axisMovement,
                  n.axisVelocity.map(function (e) {
                    return void 0 === t && (t = 0.996), (e * t) / (1 - t);
                    var t;
                  })
                );
              },
            },
            e
          );
          o("wheel", an({}, n, { previous: i })), (i = n);
        },
        f = function (e) {
          var i = (function (e) {
              return an({}, e, {
                axisDelta: e.axisDelta.map(function (e) {
                  return (t = e), Math.min(Math.max(-700, t), 700);
                  var t;
                }),
              });
            })(
              (function (e, t) {
                if (!t) return e;
                var i =
                  !0 === t
                    ? un
                    : t.map(function (e) {
                        return e ? -1 : 1;
                      });
                return an({}, e, {
                  axisDelta: e.axisDelta.map(function (e, t) {
                    return e * i[t];
                  }),
                });
              })(
                (function (e) {
                  var t = e.deltaX * cn[e.deltaMode],
                    i = e.deltaY * cn[e.deltaMode],
                    n = (e.deltaZ || 0) * cn[e.deltaMode];
                  return { timeStamp: e.timeStamp, axisDelta: [t, i, n] };
                })(e),
                l.reverseSign
              )
            ),
            n = i.axisDelta,
            s = i.timeStamp,
            a = on(n);
          e.preventDefault &&
            (function (e, t) {
              var i = l.preventWheelAction,
                n = t[0],
                s = t[1],
                a = t[2];
              if ("boolean" == typeof i) return i;
              switch (i) {
                case "x":
                  return Math.abs(n) >= e;
                case "y":
                  return Math.abs(s) >= e;
                case "z":
                  return Math.abs(a) >= e;
                default:
                  return !1;
              }
            })(a, n) &&
            e.preventDefault(),
            c.isStarted
              ? c.isMomentum &&
                a > Math.max(2, 2 * c.lastAbsDelta) &&
                (k(!0), x())
              : x(),
            0 === a && Object.is && Object.is(e.deltaX, -0)
              ? (u = !0)
              : ((t = e),
                (c.axisMovement = rn(c.axisMovement, n)),
                (c.lastAbsDelta = a),
                c.scrollPointsToMerge.push({ axisDelta: n, timeStamp: s }),
                v(),
                p({ axisDelta: n, isStart: !c.isStartPublished }),
                (c.isStartPublished = !0),
                C());
        },
        v = function () {
          var e;
          2 === c.scrollPointsToMerge.length
            ? (c.scrollPoints.unshift({
                axisDeltaSum: c.scrollPointsToMerge
                  .map(function (e) {
                    return e.axisDelta;
                  })
                  .reduce(rn),
                timeStamp:
                  ((e = c.scrollPointsToMerge.map(function (e) {
                    return e.timeStamp;
                  })),
                  e.reduce(function (e, t) {
                    return e + t;
                  }) / e.length),
              }),
              g(),
              (c.scrollPointsToMerge.length = 0),
              (c.scrollPoints.length = 1),
              c.isMomentum || w())
            : c.isStartPublished || m();
        },
        m = function () {
          var e;
          c.axisVelocity = ((e = c.scrollPointsToMerge),
          e[e.length - 1]).axisDelta.map(function (e) {
            return e / c.willEndTimeout;
          });
        },
        g = function () {
          var e = c.scrollPoints,
            t = e[0],
            i = e[1];
          if (i && t) {
            var n = t.timeStamp - i.timeStamp;
            if (!(n <= 0)) {
              var s = t.axisDeltaSum.map(function (e) {
                  return e / n;
                }),
                a = s.map(function (e, t) {
                  return e / (c.axisVelocity[t] || 1);
                });
              (c.axisVelocity = s), c.accelerationFactors.push(a), y(n);
            }
          }
        },
        y = function (e) {
          var t = 12 * Math.ceil(e / 10);
          c.isMomentum || (t = Math.max(100, 2 * t)),
            (c.willEndTimeout = Math.min(1e3, Math.round(t)));
        },
        b = function (e) {
          return 0 === e || (e <= 0.96 && e >= 0.6);
        },
        w = function () {
          if (c.accelerationFactors.length >= 5) {
            if (u && ((u = !1), on(c.axisVelocity) >= 0.2)) return void S();
            var e = c.accelerationFactors.slice(-5);
            e.every(function (e) {
              var t = !!e.reduce(function (e, t) {
                  return e && e < 1 && e === t ? 1 : 0;
                }),
                i = e.filter(b).length === e.length;
              return t || i;
            }) && S(),
              (c.accelerationFactors = e);
          }
        },
        S = function () {
          c.isMomentum = !0;
        },
        x = function () {
          ((c = {
            isStarted: !1,
            isStartPublished: !1,
            isMomentum: !1,
            startTime: 0,
            lastAbsDelta: 1 / 0,
            axisMovement: [0, 0, 0],
            axisVelocity: [0, 0, 0],
            accelerationFactors: [],
            scrollPoints: [],
            scrollPointsToMerge: [],
            willEndTimeout: 400,
          }).isStarted = !0),
            (c.startTime = Date.now()),
            (i = void 0),
            (u = !1);
        },
        C = function () {
          clearTimeout(n), (n = setTimeout(k, c.willEndTimeout));
        },
        k = function (e) {
          void 0 === e && (e = !1),
            c.isStarted &&
              (c.isMomentum && e
                ? p({ isEnding: !0, isMomentumCancel: !0 })
                : p({ isEnding: !0 }),
              (c.isMomentum = !1),
              (c.isStarted = !1));
        },
        E = (function (e) {
          var t = [],
            i = function (i) {
              i.removeEventListener("wheel", e),
                (t = t.filter(function (e) {
                  return e !== i;
                }));
            };
          return ln({
            observe: function (n) {
              return (
                n.addEventListener("wheel", e, { passive: !1 }),
                t.push(n),
                function () {
                  return i(n);
                }
              );
            },
            unobserve: i,
            disconnect: function () {
              t.forEach(i);
            },
          });
        })(d),
        T = E.observe,
        _ = E.unobserve,
        M = E.disconnect;
      return (
        h(e),
        ln({
          on: a,
          off: r,
          observe: T,
          unobserve: _,
          disconnect: M,
          feedWheel: d,
          updateOptions: h,
        })
      );
    },
    pn = {
      active: !0,
      breakpoints: {},
      wheelDraggingClass: "is-wheel-dragging",
      forceWheelAxis: void 0,
      target: void 0,
    };
  vn.globalOptions = void 0;
  var fn = !1;
  function vn(e) {
    var t,
      i = Hi.optionsHandler(),
      n = i.merge(pn, vn.globalOptions),
      s = function () {},
      a = {
        name: "wheelGestures",
        options: i.merge(n, e),
        init: function (e) {
          var n, r;
          t = i.atMedia(a.options);
          var o,
            l = e.internalEngine(),
            c = null != (n = t.target) ? n : e.containerNode().parentNode,
            u = null != (r = t.forceWheelAxis) ? r : l.options.axis,
            d = hn({ preventWheelAction: u, reverseSign: [!0, !0, !1] }),
            h = d.observe(c),
            p = d.on("wheel", function (e) {
              var i = e.axisDelta,
                n = i[0],
                a = i[1],
                r = "x" === u ? n : a,
                l = "x" === u ? a : n,
                d = e.isMomentum && e.previous && !e.previous.isMomentum,
                h = (e.isEnding && !e.isMomentum) || d;
              Math.abs(r) > Math.abs(l) &&
                !f &&
                !e.isMomentum &&
                (function (e) {
                  try {
                    y((o = new MouseEvent("mousedown", e.event)));
                  } catch (e) {
                    return (
                      fn &&
                        console.warn(
                          "Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"
                        ),
                      s()
                    );
                  }
                  (f = !0),
                    document.documentElement.addEventListener(
                      "mousemove",
                      m,
                      !0
                    ),
                    document.documentElement.addEventListener("mouseup", m, !0),
                    document.documentElement.addEventListener(
                      "mousedown",
                      m,
                      !0
                    ),
                    t.wheelDraggingClass &&
                      c.classList.add(t.wheelDraggingClass);
                })(e),
                f &&
                  (h
                    ? (function (e) {
                        (f = !1),
                          y(g("mouseup", e)),
                          v(),
                          t.wheelDraggingClass &&
                            c.classList.remove(t.wheelDraggingClass);
                      })(e)
                    : y(g("mousemove", e)));
            }),
            f = !1;
          function v() {
            document.documentElement.removeEventListener("mousemove", m, !0),
              document.documentElement.removeEventListener("mouseup", m, !0),
              document.documentElement.removeEventListener("mousedown", m, !0);
          }
          function m(e) {
            f && e.isTrusted && e.stopImmediatePropagation();
          }
          function g(e, t) {
            var i, n;
            if (u === l.options.axis) {
              var s = t.axisMovement;
              (i = s[0]), (n = s[1]);
            } else {
              var a = t.axisMovement;
              (n = a[0]), (i = a[1]);
            }
            return new MouseEvent(e, {
              clientX: o.clientX + i,
              clientY: o.clientY + n,
              screenX: o.screenX + i,
              screenY: o.screenY + n,
              movementX: i,
              movementY: n,
              button: 0,
              bubbles: !0,
              cancelable: !0,
              composed: !0,
            });
          }
          function y(t) {
            e.containerNode().dispatchEvent(t);
          }
          s = function () {
            h(), p(), v();
          };
        },
        destroy: function () {
          return s();
        },
      };
    return a;
  }
  var mn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleDotCarouselSettle", function () {
            e.updateDots();
          }),
          f(x(e), "_handleCarouselReInit", function () {
            e.embla.reInit(e._getOptions(), e._getPlugins());
          }),
          f(
            x(e),
            "_handleCarouselResize",
            (0, Ji.debounce)(function () {
              e.embla.reInit(e._getOptions(), e._getPlugins()), e.updateDots();
            }, 100)
          ),
          f(x(e), "_handleCarouselSelect", function () {
            if (e._carousel) {
              var t = b(e.embla.slideNodes()),
                i = e._carousel.embla.selectedScrollSnap();
              t.forEach(function (e) {
                var t = +e.dataset.dotIndex === i;
                e.classList.toggle("is-primary", t);
              }),
                e.embla.scrollTo(i);
            }
          }),
          f(x(e), "_getOptions", function () {
            return {
              inViewThreshold: +(e.dataset.inViewThreshhold || 0) || 0.5,
              containScroll: e.hasAttribute("data-contain-scroll")
                ? e.dataset.containScroll
                : "keepSnaps",
              align: e.dataset.align || "center",
              speed: e._getSpeed(),
              skipSnaps: e.hasAttribute("data-skip-snaps"),
              draggable: e.hasAttribute("is-draggable"),
              axis: e._axis,
            };
          }),
          f(x(e), "_getPlugins", function () {
            var t = [],
              i = ji();
            if ((t.push(i), e.hasAttribute("data-with-wheel-gestures"))) {
              var n = vn({ forceWheelAxis: e._axis });
              t.push(n);
            }
            return t;
          }),
          f(x(e), "scrollNext", function () {
            e._carousel && e._carousel.embla.scrollNext();
          }),
          f(x(e), "scrollPrev", function () {
            e._carousel && e._carousel.embla.scrollPrev();
          }),
          f(x(e), "canScrollNext", function () {
            return !!e._carousel && e._carousel.embla.canScrollNext();
          }),
          f(x(e), "canScrollPrev", function () {
            return !!e._carousel && e._carousel.embla.canScrollPrev();
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._init(),
                this.updateDots(),
                this._carousel &&
                  (this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ),
                  this._carousel.embla.on(
                    "select",
                    this._handleCarouselSelect
                  )),
                this.embla.on("resize", this._handleCarouselResize),
                this.embla.on("settle", this._handleDotCarouselSettle);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off("reInit", this._handleCarouselReInit),
                this._carousel.embla.off("select", this._handleCarouselSelect)),
                this.embla.off("settle", this._handleDotCarouselSettle),
                this.embla.off("resize", this._handleCarouselResize),
                this.embla.destroy();
            },
          },
          {
            key: "_getSpeed",
            value: function () {
              return ui() ? 100 : 80;
            },
          },
          {
            key: "_init",
            value: function () {
              var e = this.querySelector("[data-carousel-viewport]");
              e && (this.embla = Hi(e, this._getOptions(), this._getPlugins()));
            },
          },
          {
            key: "updateDots",
            value: function () {
              var e = b(this.embla.slideNodes()),
                t = e.map(function (e, t) {
                  return t;
                }),
                i = this.embla.slidesInView();
              e.forEach(function (e, n) {
                e.classList.remove("is-prev-prev");
                var s = i[0],
                  a = i[i.length - 1],
                  r = t[0],
                  o = t[t.length - 1];
                (n !== s && n !== a) ||
                  n === o ||
                  n === r ||
                  e.classList.add("is-prev-prev");
              });
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
          {
            key: "_axis",
            get: function () {
              return "vertical" === this.dataset.axis ? "y" : "x";
            },
          },
        ]),
        i
      );
    })(te),
    gn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.call(this))),
            "_handleCarouselForceChangePlayState",
            function () {
              if (e._autoplayLoader && e._carousel) {
                var t = e._carousel.forceStopped;
                e._autoplayLoader.setAttribute(
                  "data-autoplay-stopped",
                  t ? "true" : "false"
                );
              }
            }
          ),
          f(x(e), "_handleCarouselChangePlayState", function () {
            e._updateAutoplayIndicator();
          }),
          f(x(e), "_handleDotClick", function () {
            e.scroll();
          }),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e.scroll());
          }),
          (e._autoplayLoader = e.querySelector("[data-autoplay-indicator]")),
          (e._dotsCarousel = e.closest("carousel-dots")),
          (e.dotIndex = +e.dataset.dotIndex),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._updateAutoplayIndicator(),
                this._carousel &&
                  (customElements.upgrade(this._carousel),
                  this._carousel.subscribe(
                    "changePlayState",
                    this._handleCarouselChangePlayState
                  ),
                  this._carousel.subscribe(
                    "forceChangePlayState",
                    this._handleCarouselForceChangePlayState
                  )),
                this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleDotClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.unsubscribe(
                  "changePlayState",
                  this._handleCarouselChangePlayState
                ),
                this._carousel.unsubscribe(
                  "forceChangePlayState",
                  this._handleCarouselForceChangePlayState
                )),
                this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleDotClick);
            },
          },
          {
            key: "_updateAutoplayIndicator",
            value: function () {
              if (this._carousel) {
                var e = this._carousel.isPlay;
                this._autoplayLoader &&
                  this._autoplayLoader.setAttribute(
                    "data-play-state",
                    e ? "true" : "false"
                  );
              }
            },
          },
          {
            key: "scroll",
            value: function () {
              this._carousel &&
                (this._carousel.embla.scrollTo(this.dotIndex),
                this._carousel.forceStop());
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        i
      );
    })(te),
    yn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.trigger();
            }
          ),
          f(x(e), "_handleCarouselReInit", function () {
            e._update();
          }),
          f(x(e), "_handleCarouselSelect", function () {
            e._update();
          }),
          f(
            x(e),
            "_handleCarouselScroll",
            (0, Ji.debounce)(function () {
              e._update();
            }, 100)
          ),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e.trigger());
          }),
          f(x(e), "_updateDisabled", function () {
            e.toggleAttribute("disabled", !e._canScroll());
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._update(),
                this._carousel &&
                  (this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ),
                  this._carousel.embla.on("select", this._handleCarouselSelect),
                  this._carousel.embla.on(
                    "scroll",
                    this._handleCarouselScroll
                  )),
                this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off("reInit", this._handleCarouselReInit),
                this._carousel.embla.off("select", this._handleCarouselSelect),
                this._carousel.embla.off("scroll", this._handleCarouselScroll)),
                this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "_update",
            value: function () {
              this._updateDisabled(), this._updateVisible();
            },
          },
          {
            key: "_updateVisible",
            value: function () {
              if (this._carousel) {
                var e =
                    b(Array(this._carousel.embla.slideNodes().length).keys())
                      .length - 1,
                  t = this._carousel.embla.slidesInView(),
                  i =
                    "next" === this.dataset.scrollDirection
                      ? t.includes(e)
                      : t.includes(0);
                this.toggleAttribute("has-not-slides-not-in-view", i);
              }
            },
          },
          {
            key: "_canScroll",
            value: function () {
              return (
                !!this._carousel &&
                ("next" === this.dataset.scrollDirection
                  ? this._carousel.canScrollNext()
                  : this._carousel.canScrollPrev())
              );
            },
          },
          {
            key: "trigger",
            value: function () {
              if (this._carousel) {
                var e = this._carousel,
                  t = e.scrollNext,
                  i = e.scrollPrev;
                "next" === this.dataset.scrollDirection ? t() : i();
              }
            },
          },
          {
            key: "_carousel",
            get: function () {
              var e = this.closest("carousel-dots"),
                t = this.closest("carousel-component");
              return e || t;
            },
          },
        ]),
        i
      );
    })(te),
    bn = yn,
    wn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleProgress", function () {
            e.updateProgressBar();
          }),
          f(x(e), "_handleCarouselReInit", function () {
            e.updateProgressBar();
          }),
          (e._eventSetProgress =
            "scroll" === e.dataset.target ? "scroll" : "settle"),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateProgressBar(),
                this._carousel &&
                  (this._carousel.embla.on(
                    this._eventSetProgress,
                    this._handleProgress
                  ),
                  this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off(
                  this._eventSetProgress,
                  this._handleProgress
                ),
                this._carousel.embla.off("reInit", this._handleCarouselReInit));
            },
          },
          {
            key: "updateProgressBar",
            value: function () {
              var e = this.querySelector("[data-carousel-progress-indicator]");
              if (e) {
                var t = this.getProgress(),
                  i = "vertical" === this.dataset.axis;
                e.style.transform = i
                  ? "translate3d(0, ".concat(t, "%, 0)")
                  : "translate3d(".concat(t, "%, 0, 0)");
              }
            },
          },
          {
            key: "getProgress",
            value: function () {
              return "scroll" === this.dataset.target
                ? this.getProgressByScroll()
                : this.getProgressBySlideInView();
            },
          },
          {
            key: "getProgressBySlideInView",
            value: function () {
              if (!this._carousel) return 0;
              var e = this._carousel.embla.slideNodes().length,
                t = this._carousel.embla.slidesInView(),
                i = t[t.length - 1] + 1,
                n = 100 / e;
              return Math.ceil(n * i);
            },
          },
          {
            key: "getProgressByScroll",
            value: function () {
              if (!this._carousel) return 0;
              var e = this._carousel.embla.scrollProgress();
              return 100 * Math.max(0, Math.min(1, e));
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        i
      );
    })(te),
    Sn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.call(this))),
            "_handleResize",
            (0, Ji.debounce)(function () {
              e._setHidden(!1), e.updatePosition();
              var t = e._headerSection.getBoundingClientRect();
              e.headerSectionBottom = t.bottom;
            }, 100)
          ),
          f(x(e), "_handleScroll", function () {
            ci() && e._updateVisibleAfterScroll(), e._setScrollStatus();
          }),
          f(x(e), "_handleDrodpownHide", function () {
            e.classList.remove("header--light-bordered");
          }),
          f(x(e), "_handleDropdownShow", function () {
            e.classList.add("header--light-bordered");
          }),
          (e._lastScrollPosition = 0),
          (e._resizeObserver = new ResizeObserver(e._handleResize)),
          (e._dropdowns = b(e.querySelectorAll("[data-header-dropdown]"))),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._setSticky(),
                this.updatePosition(),
                j(window, "scroll", this._handleScroll),
                this._dropdowns.forEach(function (t) {
                  customElements.upgrade(t),
                    t.subscribe("show", e._handleDropdownShow),
                    t.subscribe("hide", e._handleDrodpownHide);
                }),
                this._resizeObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              X(window, "scroll", this._handleScroll),
                this._dropdowns.forEach(function (t) {
                  t.unsubscribe("show", e._handleDropdownShow),
                    t.unsubscribe("hide", e._handleDrodpownHide);
                }),
                this._resizeObserver.disconnect();
            },
          },
          {
            key: "_setScrollStatus",
            value: function () {
              if (this._headerSection) {
                var e = Math.abs(parseInt(document.body.style.top || "0")),
                  t = (window.scrollY || e) > this.headerSectionBottom;
                this._headerSection.toggleAttribute("scrolled", t);
              }
            },
          },
          {
            key: "_updateVisibleAfterScroll",
            value: function () {
              if (this._headerSection) {
                var e = window.scrollY,
                  t = this._lastScrollPosition < e,
                  i = e > this.headerSectionBottom,
                  n = t && i;
                this._setHidden(n), 0 !== e && (this._lastScrollPosition = e);
              }
            },
          },
          {
            key: "_setHidden",
            value: function (e) {
              this._headerSection &&
                this._headerSection.setAttribute(
                  "aria-hidden",
                  e ? "true" : "false"
                );
            },
          },
          {
            key: "_setSticky",
            value: function () {
              this._headerSection &&
                (this._headerSection.setAttribute("mobile-sticky", ""),
                this._headerSection.toggleAttribute(
                  "desktop-sticky",
                  this._isSticky
                ));
            },
          },
          {
            key: "updatePosition",
            value: function () {
              if (this._headerSection) {
                var e,
                  t = this.getBoundingClientRect();
                "header-bottom-side",
                  (e = "".concat(t.bottom, "px")),
                  document.documentElement.style.setProperty(
                    "--gsc-".concat("header-bottom-side"),
                    e
                  );
              }
            },
          },
          {
            key: "_isSticky",
            get: function () {
              return this.hasAttribute("is-sticky");
            },
          },
          {
            key: "_headerSection",
            get: function () {
              return document.querySelector(".shopify-section-header");
            },
          },
        ]),
        i
      );
    })(te),
    xn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleSectionLoad", function () {}),
          f(x(e), "_handleSectionSelect", function (t) {
            var i = t.detail.sectionId;
            e.isVisible && e.dataset.sectionId === i && (e.mount(), e.reset());
          }),
          f(x(e), "_handleSectionDeselect", function (t) {
            var i = t.detail.sectionId;
            e.isVisible && e.dataset.sectionId === i && (e.reset(), e.hide(!0));
          }),
          f(x(e), "_handleBlockSelect", function (t) {
            var i = t.detail,
              n = i.blockId,
              s = i.sectionId;
            if (e.dataset.sectionId === s) {
              var a = e.pages.find(function (e) {
                return e.getAttribute("block-id") === n;
              });
              if (!a) return;
              e.open(), e.setPage(a);
            }
          }),
          f(x(e), "_handleBlockDeselect", function (t) {
            var i = t.detail,
              n = i.blockId,
              s = i.sectionId;
            if (e.dataset.sectionId === s) {
              if (
                !e.pages.find(function (e) {
                  return e.getAttribute("block-id") === n;
                })
              )
                return;
              e.hide(!0);
            }
          }),
          f(x(e), "handlePageKeydown", function (t) {
            var i = t.target,
              n = i.closest("drawer-menu-page");
            if (n) {
              var s = n.querySelectorAll(W()),
                a = i === s[s.length - 1],
                r = i === s[0],
                o = t.shiftKey;
              9 === t.keyCode &&
                ((o && r) || (!o && a)) &&
                (t.preventDefault(), e.focusOnToggler());
            }
          }),
          (e.header = document.querySelector("header-component")),
          (e.pages = b(e.element.querySelectorAll("drawer-menu-page"))),
          (e.pageMap = e.generatePageMap()),
          (e.homePage = e.pageMap.Menu),
          (e.toggler = document.getElementById("DrawerMenuToggler")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              Qt(_(i.prototype), "connectedCallback", this).call(this),
                this.mountBlocks(),
                this.pages.forEach(function (t) {
                  t.addEventListener("keydown", e.handlePageKeydown);
                }),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ),
                  this._editor.subscribe(
                    "SECTION_SELECT",
                    this._handleSectionSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_DESELECT",
                    this._handleSectionDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              Qt(_(i.prototype), "disconnectedCallback", this).call(this),
                this.pages.forEach(function (t) {
                  t.removeEventListener("keydown", e.handlePageKeydown);
                }),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "focusOnToggler",
            value: function () {
              this.toggler && (this.toggler.focus(), this.hide());
            },
          },
          {
            key: "generatePageMap",
            value: function () {
              return this.pages.reduce(function (e, t) {
                var i = t.dataset.pageId;
                return i ? ce(v({}, e), f({}, i, t)) : e;
              }, {});
            },
          },
          {
            key: "setPage",
            value: function (e) {
              var t,
                i =
                  e.dataset.pageId ===
                  (null === (t = this.openedPage) || void 0 === t
                    ? void 0
                    : t.dataset.prevPageId),
                n = e.hasAttribute("data-empty-menu");
              this.openedPage &&
                (i || n) &&
                this.setPageVisible(this.openedPage, !1);
              var s = e.querySelector(W());
              s && s.focus(), this.setPageVisible(e, !0), (this.openedPage = e);
            },
          },
          {
            key: "reset",
            value: function () {
              var e = this;
              this.pages.forEach(function (t) {
                e.setPageVisible(t, !1);
              }),
                this.setPageVisible(this.homePage, !0),
                (this.openedPage = this.homePage);
            },
          },
          {
            key: "setPageVisible",
            value: function (e, t) {
              e.setAttribute("aria-hidden", t ? "false" : "true");
            },
          },
          {
            key: "open",
            value: function () {
              return (
                this.header && this.header.updatePosition(),
                Qt(_(i.prototype), "open", this).call(this)
              );
            },
          },
          {
            key: "hide",
            value: function (e) {
              return (
                this.reset(), Qt(_(i.prototype), "hide", this).call(this, e)
              );
            },
          },
          {
            key: "mountBlocks",
            value: function () {
              var e = this.element.querySelectorAll(
                  "[data-drawer-menu-target-block-id]"
                ),
                t = this.element.querySelector("#drawer-menu-blocks-template"),
                i = fe(t);
              e.forEach(function (e) {
                var t = e.getAttribute("data-drawer-menu-target-block-id"),
                  n = i.querySelector(
                    '[data-drawer-menu-block-id="'.concat(t, '"]')
                  );
                n &&
                  ((e.className = ""
                    .concat(e.className, " ")
                    .concat(n.className)),
                  (e.innerHTML = n.innerHTML));
              });
            },
          },
          {
            key: "getPage",
            value: function (e) {
              return this.pageMap[e];
            },
          },
          {
            key: "isVisible",
            get: function () {
              var e = matchMedia("(max-width: 1016px)").matches;
              return this.hasAttribute("data-drawer-menu-is-section") || e;
            },
          },
        ]),
        i
      );
    })(li),
    Cn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleBlockScroll", function () {
            if (e.block) {
              var t = e.block.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t);
            }
          }),
          (e.block = e.querySelector("[data-drawer-menu-content]")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.block &&
                this.block.addEventListener("scroll", this._handleBlockScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.block &&
                this.block.removeEventListener(
                  "scroll",
                  this._handleBlockScroll
                );
            },
          },
        ]),
        i
      );
    })(te),
    kn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handlePageLinkClick",
            function (t) {
              t.preventDefault(), e.setPage();
            }
          ),
          f(x(e), "_handleKeyUp", function (t) {
            t.preventDefault();
            var i = t.key || t.keyCode;
            K(i) && e.setPage();
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "click", this._handlePageLinkClick),
                j(this, "keyup", this._handleKeyUp);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "click", this._handlePageLinkClick),
                X(this, "keyup", this._handleKeyUp);
            },
          },
          {
            key: "setPage",
            value: function () {
              var e = this.closest("drawer-menu"),
                t = this.dataset.pageId;
              if (t && e) {
                var i = e.getPage(t);
                i && e.setPage(i);
              }
            },
          },
        ]),
        i
      );
    })(te),
    En = kn,
    Tn = (function () {
      "use strict";
      function e(t) {
        d(this, e), (this._element = t);
      }
      return (
        p(e, [
          {
            key: "show",
            value: function () {
              this._element.classList.remove("hidden");
            },
          },
          {
            key: "hide",
            value: function () {
              this._element.classList.add("hidden");
            },
          },
        ]),
        e
      );
    })(),
    _n = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return d(this, i), ((e = t.call(this)).cache = {}), e;
      }
      return (
        p(i, [
          {
            key: "updateTargetsFromHTML",
            value: function (e) {
              if (this.dataset.containerId) {
                var t = e.getElementById(this.dataset.containerId),
                  i = document.getElementById(this.dataset.containerId);
                t &&
                  i &&
                  t
                    .querySelectorAll(".".concat(this.dataset.target))
                    .forEach(function (e) {
                      return i.appendChild(e);
                    });
              }
            },
          },
          {
            key: "updateResultsFromHTML",
            value: function (e) {
              if (this.dataset.containerId) {
                var t = e.getElementById(this.dataset.containerId),
                  i = document.getElementById(this.dataset.containerId);
                t &&
                  i &&
                  ((i.innerHTML = t.innerHTML),
                  i.scrollIntoView({ behavior: "smooth" }));
              }
            },
          },
          {
            key: "updateFromHTML",
            value: function (e) {
              var t = e.querySelector("pagination-component");
              t && (this.innerHTML = t.innerHTML);
            },
          },
          {
            key: "loadingOverlay",
            get: function () {
              var e = document.getElementById(this.dataset.overlayId || "");
              return new Tn(e);
            },
          },
        ]),
        i
      );
    })(te),
    Mn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e._fetchResults();
            }
          ),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e._fetchResults());
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "_fetchResults",
            value: function () {
              var e = this,
                t = this.dataset.url;
              t &&
                (this._setLoadingStatus(!0),
                fetch(t)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (t) {
                    var i = ge(t);
                    e._setLoadingStatus(!1),
                      e._updateFromHTML(i),
                      e._updatePaginationFromHTML(i);
                  })
                  .catch(function () {
                    S.notification &&
                      S.notification.show(
                        "Error in pagination load button component",
                        "warning"
                      );
                  }));
            },
          },
          {
            key: "_updatePaginationFromHTML",
            value: function (e) {
              var t = this.closest("pagination-component");
              t && (t.updateTargetsFromHTML(e), t.updateFromHTML(e));
            },
          },
          {
            key: "_setPaginationUrl",
            value: function (e) {
              this.dataset.url = e.dataset.url;
            },
          },
          {
            key: "_removePagination",
            value: function () {
              var e = this.closest("pagination-component");
              e && e.remove();
            },
          },
          {
            key: "_updateFromHTML",
            value: function (e) {
              var t = e.querySelector("pagination-load-button");
              t ? this._setPaginationUrl(t) : this._removePagination();
            },
          },
          {
            key: "_setLoadingStatus",
            value: function (e) {
              this.toggleAttribute("disabled", e),
                this.classList.toggle("loading", e);
            },
          },
        ]),
        i
      );
    })(te),
    Ln = Mn,
    Pn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.apply(this, arguments))), "_handleLinkClick", function () {
            e._fetchResults();
          }),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e._fetchResults());
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleLinkClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleLinkClick);
            },
          },
          {
            key: "_fetchResults",
            value: function () {
              var e = this.closest("pagination-component"),
                t = this.dataset.url;
              e &&
                t &&
                (e.cache[t]
                  ? this._updatePaginationFromHTML(e.cache[t])
                  : this._getFromUrl(t));
            },
          },
          {
            key: "_getFromUrl",
            value: function (e) {
              var t = this,
                i = this.closest("pagination-component");
              i &&
                (i.loadingOverlay.show(),
                fetch(e)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (n) {
                    var s = ge(n);
                    i.loadingOverlay.hide(),
                      (i.cache[e] = s),
                      t._updatePaginationFromHTML(s);
                  })
                  .catch(function () {
                    S.notification &&
                      S.notification.show(
                        "Error in pagination link component",
                        "warning"
                      );
                  }));
            },
          },
          {
            key: "_updatePaginationFromHTML",
            value: function (e) {
              var t = this.closest("pagination-component");
              t && (t.updateResultsFromHTML(e), t.updateFromHTML(e));
            },
          },
        ]),
        i
      );
    })(te),
    In = Pn,
    Dn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleIntersectionObserve", function (t) {
            var i = e.dataset.url;
            if (i) {
              if (!t[0].isIntersecting) return;
              e._intersectionObserver.unobserve(x(e)),
                e._preloaderComponent.show(),
                fetch(i)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (t) {
                    var i = ge(t),
                      n = e.closest("pagination-component");
                    e._preloaderComponent.hide(),
                      e._updateFromHTML(i),
                      n && n.updateTargetsFromHTML(i);
                  })
                  .catch(function () {
                    S.notification &&
                      S.notification.show(
                        "Error in infinite scroll component",
                        "warning"
                      );
                  });
            }
          }),
          (e._observerOptions = {
            root: null,
            rootMargin: "0px 0px 200px 0px",
          }),
          (e._preloaderSelector = ".loading-spinner"),
          (e._preloader = e.querySelector(e._preloaderSelector)),
          (e._preloaderComponent = new Tn(e._preloader)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              (this._intersectionObserver = new IntersectionObserver(
                this._handleIntersectionObserve,
                this._observerOptions
              )),
                this._intersectionObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._intersectionObserver.disconnect();
            },
          },
          {
            key: "_updateFromHTML",
            value: function (e) {
              var t = e.querySelector("pagination-infinite-scroll"),
                i = null == t ? void 0 : t.dataset.url;
              t && i
                ? (this._setPaginationUrl(i),
                  this._intersectionObserver.observe(this))
                : this.removeAttribute("data-url");
            },
          },
          {
            key: "_setPaginationUrl",
            value: function (e) {
              this.dataset.url = e;
            },
          },
        ]),
        i
      );
    })(te),
    An = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleCarouselSelect", function () {
            e._removeVideo();
          }),
          f(x(e), "_handlePosterClick", function () {
            e.loadContent();
          }),
          (e._poster = e.querySelector('[id^="Deferred-Poster-"]')),
          (e._carousel = e.closest("carousel-component")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.hasAttribute("data-autoplay") && this.loadContent(),
                j(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.off(
                    "select",
                    this._handleCarouselSelect
                  );
            },
          },
          {
            key: "loadContent",
            value: function () {
              this.getAttribute("loaded") ||
                (this._addVideo(), this.setAttribute("loaded", "true"));
            },
          },
          {
            key: "_removeVideo",
            value: function () {
              var e = this.querySelector("video,  iframe");
              e && (e.remove(), this.removeAttribute("loaded"));
            },
          },
          {
            key: "_addVideo",
            value: function () {
              var e = document.createElement("div"),
                t = this.querySelector("template"),
                i = null == t ? void 0 : t.content;
              if (i && i.firstElementChild) {
                var n = i.firstElementChild.cloneNode(!0);
                e.appendChild(n);
                var s = e.querySelector("video, model-viewer, iframe");
                s && (this.appendChild(s), "VIDEO" === s.tagName && s.play());
              }
            },
          },
        ]),
        i
      );
    })(te),
    zn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.fetchAvailability();
            },
          },
          {
            key: "fetchAvailability",
            value: function () {
              var e = this,
                t = ""
                  .concat(this.dataset.baseUrl, "variants/")
                  .concat(
                    this.dataset.variantId,
                    "/?section_id=pickup-availability"
                  );
              fetch(t)
                .then(function (e) {
                  return e.text();
                })
                .then(function (t) {
                  var i = ge(t).querySelector(".shopify-section");
                  e.updateSidebarFromHTML(i), e.updateContentFromHTML(i);
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show(
                      "Error in pickup availability component",
                      "warning"
                    );
                });
            },
          },
          {
            key: "updateVariantId",
            value: function (e) {
              this.dataset.variantId = e;
            },
          },
          {
            key: "updateContentFromHTML",
            value: function (e) {
              var t = this.querySelector("pickup-availability-content"),
                i = e.querySelector("pickup-availability-content");
              t && i && (t.innerHTML = i.innerHTML);
            },
          },
          {
            key: "updateSidebarFromHTML",
            value: function (e) {
              var t = document.querySelector("#pickup-availability-sidebar"),
                i = e.querySelector("#pickup-availability-sidebar template");
              t && i && t.updateTemplate(i);
            },
          },
        ]),
        i
      );
    })(te),
    On = zn,
    Bn = (function () {
      "use strict";
      function e(t) {
        d(this, e),
          (this._element = t),
          (this._text = this._element.querySelector("[data-button-text]"));
      }
      return (
        p(e, [
          {
            key: "setDisable",
            value: function (e) {
              this._element.toggleAttribute("disabled", e);
            },
          },
          {
            key: "setLoading",
            value: function (e) {
              this._element.classList.toggle("loading", e);
            },
          },
          {
            key: "setText",
            value: function (e) {
              this._text && (this._text.textContent = e);
            },
          },
        ]),
        e
      );
    })(),
    Nn = window.routes,
    qn = (function () {
      "use strict";
      function e() {
        d(this, e);
      }
      return (
        p(e, [
          {
            key: "change",
            value: function (e) {
              return fetch(Nn.cart_change_url, e).then(function (e) {
                return e.text();
              });
            },
          },
          {
            key: "add",
            value: function (e) {
              return fetch(Nn.cart_add_url, e).then(function (e) {
                return e.text();
              });
            },
          },
          {
            key: "update",
            value: function (e) {
              return fetch("".concat(Nn.cart_update_url), e);
            },
          },
          {
            key: "get",
            value: function () {
              return fetch(Nn.cart_url).then(function (e) {
                return e.text();
              });
            },
          },
        ]),
        e
      );
    })(),
    $n = function () {
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/".concat(
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "json"
          ),
        },
      };
    },
    Hn = new ((function () {
      "use strict";
      function e(t) {
        var i = this;
        d(this, e),
          f(this, "requestProductFromUrl", function (e, t) {
            i._element && i._element.requestProductFromUrl(e, t);
          }),
          f(this, "openAndRenderProductByUrl", function (e) {
            i._element && i._element.openAndRenderProductByUrl(e);
          }),
          (this._element = document.querySelector("#".concat(t)));
      }
      return (
        p(e, [
          {
            key: "hide",
            value: function () {
              return this._element ? this._element.hide() : V();
            },
          },
          {
            key: "isOpen",
            get: function () {
              return !!this._element && this._element.isOpen;
            },
          },
        ]),
        e
      );
    })())("Quick-view"),
    Fn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleFormSubmit", function (t) {
            t.preventDefault();
            var i = e._getQueryConfig();
            e.setDisable(!0),
              e.setLoading(!0),
              e._cartApi
                .add(i)
                .then(function (t) {
                  var i = JSON.parse(t);
                  if ((e.setDisable(!1), e.setLoading(!1), i.description)) {
                    if (!S.notification) return;
                    var n = Object.keys(i.description)
                      .map(function (e) {
                        return "".concat(e, ": ").concat(i.description[e]);
                      })
                      .join(" , ");
                    S.notification.show(n, "warning");
                  } else {
                    if (e.cart) return e._cartApi.get();
                    e.sidebar
                      ? e.updateSidebarCartByParsedState(i)
                      : e.updatePopupByParsedState(i);
                  }
                })
                .then(function (t) {
                  if (e.cart && t) {
                    var i = ge(t);
                    e.updateCartByHTML(i);
                  }
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show(
                      "Error in product form component",
                      "warning"
                    );
                });
          }),
          (e.sidebar = document.querySelector("#sidebar-component-for-cart")),
          (e.cart = document.querySelector("#cart-page-component")),
          (e.cartNotificationPopup = document.querySelector(
            "#CartNotificationPopup"
          )),
          (e.formSelector = "form"),
          (e.variantInputSelector = "[data-product-form-variant]"),
          (e.form = e.querySelector(e.formSelector)),
          e.form &&
            (e.variantInput = e.form.querySelector(e.variantInputSelector)),
          (e._cartApi = new qn()),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this.form, "submit", this._handleFormSubmit);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this.form, "submit", this._handleFormSubmit);
            },
          },
          {
            key: "updateCartByHTML",
            value: function (e) {
              this.cart &&
                (this.cart.updateByHTML(e),
                this.cart.updateEmptyStatus(!1),
                this.showCallbackAfterCloseDialogWindow(function () {}));
            },
          },
          {
            key: "updateSidebarCartByParsedState",
            value: function (e) {
              var t = this;
              this.sidebar &&
                (this.sidebar.updateEmptyStatus(!1),
                this.showCallbackAfterCloseDialogWindow(function () {
                  t.sidebar && t.sidebar.purchaseHandler(e);
                }));
            },
          },
          {
            key: "updatePopupByParsedState",
            value: function (e) {
              var t = this;
              this.showCallbackAfterCloseDialogWindow(function () {
                t.cartNotificationPopup &&
                  t.cartNotificationPopup.showProductFromParsedState(e, e.id);
              });
            },
          },
          {
            key: "showCallbackAfterCloseDialogWindow",
            value: function (e) {
              return V(0).then(function () {
                Hn.isOpen || e(), Hn.isOpen && Hn.hide().then(e);
              });
            },
          },
          {
            key: "_getFormData",
            value: function () {
              return JSON.parse(
                (function (e) {
                  var t = {},
                    i = new FormData(e),
                    n = !0,
                    s = !1,
                    a = void 0;
                  try {
                    for (
                      var r, o = i.keys()[Symbol.iterator]();
                      !(n = (r = o.next()).done);
                      n = !0
                    ) {
                      var l = r.value,
                        c = /(?:^(properties\[))(.*?)(?:\]$)/;
                      c.test(l)
                        ? ((t.properties = t.properties || {}),
                          (t.properties[c.exec(l)[2]] = i.get(l)))
                        : (t[l] = i.get(l));
                    }
                  } catch (e) {
                    (s = !0), (a = e);
                  } finally {
                    try {
                      n || null == o.return || o.return();
                    } finally {
                      if (s) throw a;
                    }
                  }
                  return JSON.stringify(t);
                })(this.form)
              );
            },
          },
          {
            key: "_getQueryConfig",
            value: function () {
              var e = $n("javascript"),
                t = [
                  "cart-count",
                  this.sidebar ? this.sidebar.sectionId : "cart-drawer",
                  "cart-notification-popup-content",
                ];
              return (
                (e.headers["X-Requested-With"] = "XMLHttpRequest"),
                (e.body = JSON.stringify(
                  ce(v({}, this._getFormData()), {
                    sections: t,
                    sections_url: window.location.pathname,
                  })
                )),
                e
              );
            },
          },
          {
            key: "setLoading",
            value: function (e) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t
              ) {
                new Bn(t).setLoading(e);
              });
            },
          },
          {
            key: "setDisable",
            value: function (e) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t
              ) {
                new Bn(t).setDisable(e);
              });
            },
          },
          {
            key: "setButtonText",
            value: function (e) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t
              ) {
                new Bn(t).setText(e);
              });
            },
          },
        ]),
        i
      );
    })(te),
    Vn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleWindowScroll", function () {
            if (e.button && e.form) {
              var t = window.scrollY,
                i = e.form.offsetTop + e.form.offsetHeight,
                n = e.footer ? e.footer.offsetTop : 0,
                s = window.innerHeight + t < n && t > i;
              e.toggleAttribute("visible", s),
                document.body.toggleAttribute(
                  "is-product-form-button-fixed",
                  s
                );
            }
          }),
          (e.button = e.querySelector("[data-product-form-button]")),
          (e.footer = document.querySelector(
            ".shopify-section.shopify-section-footer"
          )),
          (e.form = e.closest("product-form")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
        ]),
        i
      );
    })(te),
    Rn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this)).blockSelector = "[data-product-block-item]"),
          (e.containerSelector = "[data-product-block-container]"),
          (e.activeTemplate = e.querySelector(e.blockSelector)),
          (e.activeTemplateContainer = e.querySelector(e.containerSelector)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "updateByVariantId",
            value: function (e) {
              var t = this.querySelector(
                '[data-product-block-template="'.concat(e, '"]')
              );
              if (this.activeTemplate && this.activeTemplateContainer) {
                var i = ve(t);
                i &&
                  (this.activeTemplate.remove(),
                  (this.activeTemplate = i),
                  this.activeTemplateContainer.appendChild(i));
              }
            },
          },
        ]),
        i
      );
    })(te),
    jn = window.Shopify,
    Xn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handlePosterClick", function () {
            e._loadContent();
          }),
          f(x(e), "_handleCarouselSelect", function () {
            e._carousel && e._setCarouselDraggable(!0);
          }),
          (e._poster = e.querySelector('[id^="Deferred-Poster-"]')),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.off(
                    "select",
                    this._handleCarouselSelect
                  );
            },
          },
          {
            key: "_loadContent",
            value: function () {
              this.getAttribute("loaded") ||
                (this._addModel(),
                this.setAttribute("loaded", !0),
                this._carousel && this._setCarouselDraggable(!1)),
                jn.loadFeatures([
                  {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: this.setupModelViewerUI.bind(this),
                  },
                ]);
            },
          },
          {
            key: "_addModel",
            value: function () {
              var e = this.querySelector("template");
              if (e && e.content) {
                var t = e.content,
                  i = document.createElement("div");
                i.appendChild(t.firstElementChild.cloneNode(!0));
                var n = i.querySelector("model-viewer");
                this.appendChild(n);
              }
            },
          },
          {
            key: "setupModelViewerUI",
            value: function (e) {
              e ||
                (this.modelViewerUI = new jn.ModelViewerUI(
                  this.querySelector("model-viewer")
                ));
            },
          },
          {
            key: "_setCarouselDraggable",
            value: function (e) {
              var t = this.querySelector(".shopify-model-viewer-ui");
              (this._carousel.dataset.draggable = e ? "true" : "false"),
                this._carousel.reInit(),
                e && t && (t.remove(), this.removeAttribute("loaded"));
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        i
      );
    })(te);
  (window.ProductModel = {
    loadShopifyXR: function () {
      jn.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR: function (e) {
      var t = this;
      e ||
        (window.ShopifyXR
          ? (document
              .querySelectorAll('[id^="ProductJSON-"]')
              .forEach(function (e) {
                window.ShopifyXR.addModels(JSON.parse(e.textContent)),
                  e.remove();
              }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", function () {
              return t.setupShopifyXR();
            }));
    },
  }),
    window.addEventListener("DOMContentLoaded", function () {
      jn.designMode &&
        document
          .querySelectorAll("[data-shopify-xr-hidden]")
          .forEach(function (e) {
            return e.classList.add("hidden");
          }),
        window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  var Gn = (function () {
      "use strict";
      function e(t) {
        d(this, e), (this.element = t);
      }
      return (
        p(e, [
          {
            key: "show",
            value: function () {
              var e = this;
              this.element.classList.remove("hidden"),
                V(2500).then(function () {
                  e.element.classList.add("hidden");
                });
            },
          },
        ]),
        e
      );
    })(),
    Wn = (function () {
      "use strict";
      function e(t) {
        d(this, e), (this.element = t);
      }
      return (
        p(e, [
          {
            key: "setDisable",
            value: function (e) {
              this.element.setDisable(e);
            },
          },
        ]),
        e
      );
    })(),
    Yn = (function () {
      "use strict";
      function e(t) {
        d(this, e), (this.element = t);
      }
      return (
        p(e, [
          {
            key: "setLoading",
            value: function (e) {
              this.element.toggleAttribute("is-loading", e);
            },
          },
        ]),
        e
      );
    })(),
    Un = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "removeFromCart", function () {
            e.expand()
              .then(function () {
                return e.collapse();
              })
              .then(function () {
                return e.remove();
              });
          }),
          f(x(e), "expand", function () {
            return e._setMaxHeight(e.scrollHeight), V(e._transitionDuration);
          }),
          f(x(e), "collapse", function () {
            return e._setMaxHeight(0), V(e._transitionDuration);
          }),
          f(x(e), "showCheckmark", function () {
            var t = e.querySelector(e._checkmarkSelector);
            t && new Gn(t).show();
          }),
          f(x(e), "setLoading", function (t) {
            var i = e.querySelector(e._totalsSelector);
            i && new Yn(i).setLoading(t);
          }),
          f(x(e), "_handleCartItemResize", function () {
            e._setMaxHeight(e.scrollHeight);
          }),
          (e._checkmarkSelector = "[data-cart-item-checkmark]"),
          (e._bodySelector = "[data-cart-item-body]"),
          (e._totalsSelector = "[data-cart-item-totals]"),
          (e._quantitySelector = "[data-cart-item-quantity]"),
          (e.styles = getComputedStyle(x(e))),
          (e.resizeObserver = new ResizeObserver(e._handleCartItemResize)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this.querySelector(this._bodySelector);
              e && this.resizeObserver.observe(e);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.resizeObserver.disconnect();
            },
          },
          {
            key: "_setMaxHeight",
            value: function (e) {
              this.style.maxHeight = "".concat(e, "px");
            },
          },
          {
            key: "setQuantityDisabled",
            value: function (e) {
              var t = this.querySelector(this._quantitySelector);
              t && new Wn(t).setDisable(e);
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        i
      );
    })(te),
    Kn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleCartItemChange", function (t) {
            var i = e.querySelector(
              "#CartItem-".concat(+t.target.dataset.index)
            );
            i && i.setLoading(!0);
          }),
          f(
            x(e),
            "_handleCartChange",
            (0, Ji.debounce)(function (t) {
              e.updateItem(+t.target.dataset.index, t.target.value);
            }, 500)
          ),
          (e._cartApi = new qn()),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "change", this._handleCartChange),
                j(this, "change", this._handleCartItemChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "change", this._handleCartChange),
                X(this, "change", this._handleCartItemChange);
            },
          },
          {
            key: "getConfigByItemIndexAndQuantity",
            value: function (e, t) {
              return ce(v({}, $n()), {
                body: JSON.stringify({ line: e + 1, quantity: t }),
              });
            },
          },
          {
            key: "updateItem",
            value: function (e, t) {
              var i = this,
                n = this.getConfigByItemIndexAndQuantity(e, t),
                s = this.querySelector("#CartItem-".concat(e));
              if (s) {
                var a = +t;
                +(s.dataset.quantity || 0) !== a
                  ? (0 === a &&
                      (this.updateEmptyStatus(1 === this._cartItemCount),
                      s.removeFromCart()),
                    this.setButtonLoading(!0),
                    s.setQuantityDisabled(!0),
                    this._cartApi
                      .change(n)
                      .then(function () {
                        return i._cartApi.get();
                      })
                      .then(function (e) {
                        var t = ge(e);
                        i.setButtonLoading(!1),
                          s.setQuantityDisabled(!1),
                          s.setLoading(!1),
                          i.updateByHTML(t);
                      })
                      .catch(function () {
                        i._showError();
                      }))
                  : s.setLoading(!1);
              }
            },
          },
          {
            key: "_showError",
            value: function () {
              if (S.notification) {
                var e = window.cartStrings;
                S.notification.show(e.error, "warning");
              }
            },
          },
          {
            key: "updateEmptyStatus",
            value: function (e) {
              this._updateCartEmptyStatus(e),
                this._updateSubtotalEmptyStatus(e);
            },
          },
          {
            key: "_updateCartEmptyStatus",
            value: function (e) {
              this.classList.toggle("is-empty", e);
            },
          },
          {
            key: "_updateSubtotalEmptyStatus",
            value: function (e) {
              var t = document.getElementById(this.sectionIds.local.subtotal);
              t && t.classList.toggle("is-empty", e);
            },
          },
          {
            key: "updateByHTML",
            value: function (e) {
              this.updateFreeShippingBarByHTML(e),
                [
                  "#".concat(
                    this.sectionIds.local.cartItems,
                    " [data-cart-page-items]"
                  ),
                  "#CartCount",
                  "#StickyCartCount",
                  "#".concat(
                    this.sectionIds.local.subtotal,
                    " [data-cart-page-subtotal-price]"
                  ),
                ].forEach(function (t) {
                  var i = document.querySelector(t),
                    n = e.querySelector(t);
                  i && n && (i.innerHTML = n.innerHTML);
                });
            },
          },
          {
            key: "updateFreeShippingBarByHTML",
            value: function (e) {
              var t = "#".concat(
                  this.sectionIds.local.cartItems,
                  " [data-cart-page-free-shipping-bar] cart-free-shipping-bar"
                ),
                i = document.querySelector(t),
                n = e.querySelector(t);
              if (i && n) {
                var s = Y(n),
                  a = n.dataset.cartTotal || 0;
                i.updateProgressByCartTotal(+a), U(s);
              }
            },
          },
          {
            key: "setButtonLoading",
            value: function (e) {
              var t = document.getElementById(this.sectionIds.local.subtotal);
              if (t) {
                var i = t.querySelector("[data-cart-page-checkout-button]");
                i &&
                  (i.toggleAttribute("disabled", e),
                  i.classList.toggle("loading", e));
              }
            },
          },
          {
            key: "_cartItemCount",
            get: function () {
              return this.querySelectorAll("cart-item").length;
            },
          },
          {
            key: "sectionIds",
            get: function () {
              return {
                local: {
                  subtotal: "CartPage-SubtotalSection",
                  cartItems: "CartPage-CartItemsSection",
                },
              };
            },
          },
        ]),
        i
      );
    })(te),
    Qn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleCartItemChange", function (t) {
            var i = e.querySelector(
              "#CartItem-".concat(+t.target.dataset.index)
            );
            i && i.setLoading(!0);
          }),
          f(
            x(e),
            "_handleCartChange",
            (0, Ji.debounce)(function (t) {
              e.updateItem(+t.target.dataset.index, t.target.value);
            }, 500)
          ),
          f(x(e), "_handleViewportScroll", function () {
            if (e.viewport) {
              var t = e.checkContentOverflow(),
                i = e.viewport.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t && i);
            }
          }),
          f(x(e), "_handleContentResultsResize", function () {
            e.updateViewport();
          }),
          (e.sectionId = e.dataset.sectionId || "cart-drawer"),
          (e._sections = ["cart-count", e.sectionId]),
          (e.resultsSelector = "[data-sidebar-cart-results]"),
          (e.viewportSelector = "[data-sidebar-cart-viewport]"),
          (e.headerSelector = "[data-sidebar-cart-header]"),
          (e.footerSelector = "[data-sidebar-cart-footer]"),
          (e.viewport = e.element.querySelector(e.viewportSelector)),
          (e.results = e.element.querySelector(e.resultsSelector)),
          (e.header = e.element.querySelector(e.headerSelector)),
          (e.footer = e.element.querySelector(e.footerSelector)),
          (e._cartApi = new qn()),
          (e._resizeObserver = new ResizeObserver(
            e._handleContentResultsResize
          )),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i.prototype), "connectedCallback", this).call(this),
                j(this, "change", this._handleCartChange),
                j(this, "change", this._handleCartItemChange),
                this.viewport &&
                  this.viewport.addEventListener(
                    "scroll",
                    this._handleViewportScroll
                  ),
                this.results && this._resizeObserver.observe(this.results);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i.prototype), "disconnectedCallback", this).call(this),
                X(this, "change", this._handleCartChange),
                X(this, "change", this._handleCartItemChange),
                this.viewport &&
                  this.viewport.removeEventListener(
                    "scroll",
                    this._handleViewportScroll
                  ),
                this._resizeObserver.disconnect();
            },
          },
          {
            key: "updateItem",
            value: function (e, t) {
              var i = this,
                n = this.querySelector("#CartItem-".concat(e)),
                s = this.element.querySelector("[data-cart-checkout-button]");
              if (n && s) {
                var a = this._getQueryConfig(e, t),
                  r = new Bn(s),
                  o = +t;
                +(n.dataset.quantity || 0) !== o
                  ? (r.setLoading(!0),
                    r.setDisable(!0),
                    n.setQuantityDisabled(!0),
                    0 === o &&
                      (this.updateEmptyStatus(1 === this._cartItemCount),
                      n.removeFromCart()),
                    this._cartApi
                      .change(a)
                      .then(function (e) {
                        var t = JSON.parse(e);
                        r.setLoading(!1),
                          r.setDisable(!1),
                          n.setLoading(!1),
                          n.setQuantityDisabled(!1),
                          i.updateByParsedState(t);
                      })
                      .catch(function () {
                        i._showError();
                      }))
                  : n.setLoading(!1);
              }
            },
          },
          {
            key: "updateViewport",
            value: function () {
              var e = this.checkContentOverflow();
              this.toggleAttribute("footer-shadow-visible", e);
            },
          },
          {
            key: "checkContentOverflow",
            value: function () {
              return (
                !(!this.results || !this.viewport) &&
                this.results.offsetHeight > this.viewport.offsetHeight
              );
            },
          },
          {
            key: "_showError",
            value: function () {
              var e = this.querySelector("#SidebarCartNotification");
              if (e) {
                var t = new w(e),
                  i = window.cartStrings;
                t.show(i.error, "warning");
              }
            },
          },
          {
            key: "updateByParsedState",
            value: function (e) {
              var t = ge(e.sections[this.sectionId]).querySelector(
                  "#CartInSidebar"
                ),
                i = ve(t),
                n = Y(i);
              this.mount(),
                this.updateHeaderFromNode(i),
                this.updateFreeShippingBarFromNode(i),
                this.updateCartItemsFromNode(i),
                this.updateFooterFromNode(i),
                this._updateCartCountInHeader(e),
                U(n);
            },
          },
          {
            key: "purchaseHandler",
            value: function (e) {
              var t = this,
                i = ge(e.sections[this.sectionId]).querySelector(
                  "#CartInSidebar"
                ),
                n = ve(i),
                s = Y(n);
              this.mount(),
                this.updateHeaderFromNode(n),
                this.updateCartItemsFromNode(n),
                this.updateFooterFromNode(n),
                this._updateCartCountInHeader(e),
                U(s);
              var a = this.element.querySelector(
                'cart-item[data-variant-id="'.concat(e.id, '"]')
              );
              a &&
                (1 === e.quantity
                  ? a
                      .collapse()
                      .then(function () {
                        return t.open();
                      })
                      .then(function () {
                        return a.expand();
                      })
                      .then(function () {
                        t.updateFreeShippingBarFromNode(n), a.showCheckmark();
                      })
                  : this.open().then(function () {
                      t.updateFreeShippingBarFromNode(n), a.showCheckmark();
                    }));
            },
          },
          {
            key: "updateHeaderFromNode",
            value: function (e) {
              this.updateElementBySelectorFromNode(
                "[data-sidebar-cart-header]",
                e
              );
            },
          },
          {
            key: "updateEmptyStatus",
            value: function (e) {
              this.toggleAttribute("is-empty", e);
            },
          },
          {
            key: "updateFooterFromNode",
            value: function (e) {
              this.updateElementBySelectorFromNode(
                "[data-sidebar-cart-footer]",
                e
              );
            },
          },
          {
            key: "updateCartItemsFromNode",
            value: function (e) {
              this.updateElementBySelectorFromNode(
                "[data-sidebar-cart-items]",
                e
              );
            },
          },
          {
            key: "updateFreeShippingBarFromNode",
            value: function (e) {
              var t =
                  "[data-sidebar-cart-free-shipping-bar] cart-free-shipping-bar",
                i = this.element.querySelector(t),
                n = e.querySelector(t);
              if (i && n) {
                var s = n.dataset.cartTotal || 0;
                i.updateProgressByCartTotal(+s);
              }
            },
          },
          {
            key: "updateElementBySelectorFromNode",
            value: function (e, t) {
              var i = t.querySelector(e),
                n = this.element.querySelector(e);
              n && i && (n.innerHTML = i.innerHTML);
            },
          },
          {
            key: "_updateCartCountInHeader",
            value: function (e) {
              var t = ge(e.sections["cart-count"]),
                i = document.getElementById("CartCount"),
                n = document.getElementById("StickyCartCount"),
                s = t.querySelector("#CartCount");
              n && s && (n.innerHTML = s.innerHTML),
                i && s && (i.innerHTML = s.innerHTML);
            },
          },
          {
            key: "_getQueryConfig",
            value: function (e, t) {
              return ce(v({}, $n()), {
                body: JSON.stringify({
                  line: e + 1,
                  quantity: t,
                  sections: this._sections,
                  sections_url: window.location.pathname,
                }),
              });
            },
          },
          {
            key: "_cartItemCount",
            get: function () {
              return this.element.querySelectorAll("cart-item").length;
            },
          },
        ]),
        i
      );
    })(li),
    Zn = window.Shopify,
    Jn = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "setProgress", function (t) {
            e.style.setProperty(
              "--gsc-free-shipping-progress",
              "".concat(t, "%")
            );
          }),
          f(x(e), "setMessage", function (t) {
            var i = e.querySelector(e.messageNodeSelector);
            i && (i.innerHTML = t);
          }),
          (e.messageNodeSelector = "[data-cart-free-shipping-bar-message]"),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this.dataset.cartTotal || 0;
              this.updateProgressByCartTotal(+e);
            },
          },
          {
            key: "updateProgressByCartTotal",
            value: function (e) {
              var t = this.dataset.currencyFormat || "",
                i = +(this.dataset.threshold || 0),
                n = +Zn.currency.rate,
                s = this.dataset.progressMessage || "",
                a = this.dataset.achievedMessage || "",
                r = i * n,
                o = +(r - e).toFixed(2),
                l = r / 100;
              if (o > 0) {
                var c = t.replace(/{{.+?}}/g, "".concat(o));
                this.setMessage(s.replace("[value]", c)),
                  this.setProgress(e / l);
              } else this.setMessage(a), this.setProgress(100);
            },
          },
        ]),
        i
      );
    })(te),
    es = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setReady();
            },
          },
          {
            key: "updateFirstMediaByVariant",
            value: function (e) {
              var t =
                arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              if (e && e.featured_media) {
                var i = this.querySelector(
                  '[data-media-id="'.concat(e.featured_media.id, '"]')
                );
                i && i.scrollIntoView({ behavior: t ? "auto" : "smooth" });
              }
            },
          },
          {
            key: "setReady",
            value: function () {
              this.setAttribute("ready", "");
            },
          },
        ]),
        i
      );
    })(te),
    ts = es,
    is = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this)).carouselSelector =
            "[data-product-media-carousel-component]"),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setReady();
            },
          },
          {
            key: "updateFirstMediaByVariant",
            value: function (e) {
              var t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                i = this.querySelector(this.carouselSelector);
              if (e && e.featured_media && i) {
                var n = i.embla.slideNodes().findIndex(function (t) {
                  return (
                    !!t.dataset.mediaId &&
                    +t.dataset.mediaId == +e.featured_media.id
                  );
                });
                i.embla.scrollTo(n, t);
              }
            },
          },
          {
            key: "setReady",
            value: function () {
              this.setAttribute("ready", "");
            },
          },
        ]),
        i
      );
    })(te),
    ns = is,
    ss = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleVariantChange", function () {
            e._updateForm(),
              e._setInventoryStatusAvailable(e.variant),
              e.variant
                ? (e._form.setDisable(!0),
                  e._form.setLoading(!0),
                  e._pickupAvailability && e._updatePickupAvailability(),
                  e._updateURL(),
                  e._updateVariantInput(),
                  e._updateProduct(),
                  e._updateFirstMediaByVariant(e.variant))
                : e._setButtonsUnavailable();
          }),
          f(x(e), "_handleLabelFocus", function (t) {
            var i = t.target.getAttribute("for");
            e
              .querySelector('input[id="'.concat(i, '"]'))
              .dispatchEvent(new MouseEvent("click", { button: 0, which: 1 })),
              document.addEventListener("keydown", e._handleLabelKeydown);
          }),
          f(x(e), "_handleLabelKeydown", function (t) {
            var i = t.target.closest("[data-variant-picker-option-labels]");
            if (
              "ArrowLeft" === t.key ||
              "ArrowRight" === t.key ||
              "ArrowUp" === t.key ||
              "ArrowDown" === t.key
            )
              if (i) {
                var n = b(i.querySelectorAll("label")),
                  s = n.findIndex(function (e) {
                    return e === t.target;
                  }),
                  a = n[s],
                  r = n[0],
                  o = n[n.length - 1],
                  l = n[s + 1],
                  c = n[s - 1];
                1 !== n.length && t.preventDefault();
                var u = function (e) {
                    a.removeAttribute("tabindex"),
                      e.setAttribute("tabindex", 0),
                      e.focus();
                  },
                  d = function () {
                    u(l || r);
                  },
                  h = function () {
                    u(c || o);
                  };
                (0,
                { ArrowLeft: h, ArrowRight: d, ArrowUp: h, ArrowDown: d }[
                  t.key
                ])();
              } else
                document.removeEventListener("keydown", e._handleLabelKeydown);
          }),
          (e._pickupAvailability = document.getElementById(
            "product-pickup-availability-"
              .concat(e.dataset.productId, "-")
              .concat(e.dataset.section)
          )),
          (e._elements = [
            "sticky-product-buy-btn",
            "product-buy-btn",
            "product-quantity",
          ]),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._updateVariant(),
                setTimeout(function () {
                  e._updateOptionsAvailable(), e.setFocusListeners();
                }, 100),
                this.dataset.selectedVariantId &&
                  this._updateFirstMediaByVariant(this.variant, !0),
                j(this, "change", this._handleVariantChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "change", this._handleVariantChange);
            },
          },
          {
            key: "_updateLabels",
            value: function () {
              var e = this,
                t = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                i = this.querySelectorAll(
                  "[data-variant-picker-option-labels]"
                );
              t.forEach(function (t, n) {
                var s = b(i[n].querySelectorAll("label")),
                  a = b(t.querySelectorAll("input")),
                  r = e.getCheckedInput(a),
                  o = i[n].querySelector(
                    "[data-dropdown-variant-picker-label]"
                  );
                o && o.toggleAttribute("no-available", !e.variant.available),
                  s.forEach(function (e) {
                    var t = e.getAttribute("for") === r.id;
                    if (o && t) {
                      var i = o.closest("dropdown-opener");
                      (o.innerHTML = e.innerHTML), i.trigger();
                    }
                    e.classList.toggle("selected", t);
                  });
              });
            },
          },
          {
            key: "_setInventoryStatusAvailable",
            value: function (e) {
              var t = document.getElementById(
                "product-stock-inner-"
                  .concat(this.dataset.productId, "-")
                  .concat(this.dataset.section)
              );
              t && t.classList.toggle("hidden", !e);
            },
          },
          {
            key: "_setButtonsUnavailable",
            value: function () {
              this._form.setDisable(!0),
                this._form.setText(window.variantStrings.unavailable);
            },
          },
          {
            key: "_updateVariant",
            value: function () {
              var e = this,
                t = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                i = this._getVariants(),
                n = b(t).map(function (t) {
                  var i = b(t.querySelectorAll("input"));
                  return e.getCheckedInput(i).value;
                });
              this.variant = i.find(function (e) {
                return !e.options
                  .map(function (e, t) {
                    return n[t] === e;
                  })
                  .includes(!1);
              });
            },
          },
          {
            key: "setFocusListeners",
            value: function () {
              if ("dropdown" === this.dataset.type) {
                var e = b(this.querySelectorAll("float-element"))
                  .map(function (e) {
                    return b(e.element.querySelectorAll("label"));
                  })
                  .reduce(function (e, t) {
                    return b(e).concat(b(t));
                  }, []);
                this.setListenersForLabels(e);
              } else {
                var t = b(this.querySelectorAll("label"));
                this.setListenersForLabels(t);
              }
            },
          },
          {
            key: "setListenersForLabels",
            value: function (e) {
              var t = this;
              e.forEach(function (e) {
                e.addEventListener("focus", t._handleLabelFocus);
              });
            },
          },
          {
            key: "removeListenersForLabels",
            value: function (e) {
              var t = this;
              e.forEach(function (e) {
                e.addEventListener("focus", t._handleLabelFocus);
              });
            },
          },
          {
            key: "_updateOptionsAvailable",
            value: function () {
              var e = this,
                t = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                i = function (e) {
                  return t[e] ? b(t[e].querySelectorAll("input")) : null;
                },
                n = i(0),
                s = i(1),
                a = i(2),
                r = this._getVariants(),
                o = function () {
                  for (
                    var e = arguments.length, t = new Array(e), i = 0;
                    i < e;
                    i++
                  )
                    t[i] = arguments[i];
                  return r.reduce(function (e, i) {
                    var n =
                      !t ||
                      t.every(function (e) {
                        return i.options.includes(e.value);
                      });
                    return i.available && n ? b(e).concat([i.options]) : e;
                  }, []);
                },
                l = function (t, i) {
                  var n = !0,
                    s = !1,
                    a = void 0;
                  try {
                    for (
                      var r,
                        o = function () {
                          var t = r.value,
                            n = t.value,
                            s = !1;
                          i.forEach(function (e) {
                            e.includes(n) && (s = !0);
                          });
                          var a,
                            o = 'label[for="'.concat(t.id, '"]');
                          (e.querySelector(o)
                            ? e.querySelector(o)
                            : ((a = o),
                              b(e.querySelectorAll("float-element"))
                                .find(function (e) {
                                  return e.element.querySelector(a);
                                })
                                .element.querySelector(a))
                          ).toggleAttribute("no-available", !s);
                        },
                        l = t[Symbol.iterator]();
                      !(n = (r = l.next()).done);
                      n = !0
                    )
                      o();
                  } catch (e) {
                    (s = !0), (a = e);
                  } finally {
                    try {
                      n || null == l.return || l.return();
                    } finally {
                      if (s) throw a;
                    }
                  }
                };
              l(n, o()),
                s && l(s, o(this.getCheckedInput(n))),
                a && l(a, o(this.getCheckedInput(n), this.getCheckedInput(s)));
            },
          },
          {
            key: "_getVariants",
            value: function () {
              var e = this.querySelector("[data-variant-picker-variants]");
              return JSON.parse(e.textContent);
            },
          },
          {
            key: "_updateFirstMediaByVariant",
            value: function (e, t) {
              document
                .querySelectorAll(
                  "#product-media-"
                    .concat(this.dataset.productId, "-")
                    .concat(this.dataset.section)
                )
                .forEach(function (i) {
                  return i.updateFirstMediaByVariant(e, t);
                });
            },
          },
          {
            key: "_updateForm",
            value: function () {
              this._updateVariant(),
                this._updateLabels(),
                this._updateOptionsAvailable();
            },
          },
          {
            key: "_updateURL",
            value: function () {
              if (this.variant && "true" === this.dataset.updateUrl) {
                var e = ""
                  .concat(this.dataset.url, "?variant=")
                  .concat(this.variant.id);
                window.history.replaceState({}, "", e);
              }
            },
          },
          {
            key: "_updateVariantInput",
            value: function () {
              var e = this._form.variantInput;
              (e.value = this.variant.id),
                e.dispatchEvent(new Event("change", { bubbles: !0 }));
            },
          },
          {
            key: "_updatePickupAvailability",
            value: function () {
              this._pickupAvailability.updateVariantId(this.variant.id),
                this._pickupAvailability.fetchAvailability();
            },
          },
          {
            key: "_updateProduct",
            value: function () {
              var e = this,
                t = ""
                  .concat(this.dataset.url, "?variant=")
                  .concat(this.variant.id, "&section_id=")
                  .concat(this.dataset.sectionIdWithoutPrefix);
              this._updateBlocksByVariantId(this.variant.id),
                fetch(t)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (t) {
                    var i = ge(t),
                      n = e.variant.available;
                    e._form.setDisable(!n),
                      e._form.setLoading(!1),
                      e._updateElements(i);
                  })
                  .catch(function () {
                    S.notification &&
                      S.notification.show(
                        "Error in variant picker component",
                        "warning"
                      );
                  })
                  .finally(function () {
                    // console.log("Variant Changed:" + this.variant);
                  });
            },
          },
          {
            key: "_updateElements",
            value: function (e) {
              var t = this;
              this._elements.forEach(function (i) {
                var n = ""
                    .concat(i, "-")
                    .concat(t.dataset.productId, "-")
                    .concat(t.dataset.section),
                  s = document.getElementById(n);
                s && (s.innerHTML = e.getElementById(n).innerHTML);
              });
            },
          },
          {
            key: "_updateBlocksByVariantId",
            value: function (e) {
              var t = this;
              ["product-price", "product-sku", "product-stock"].forEach(
                function (i) {
                  var n = document.getElementById(
                    ""
                      .concat(i, "-")
                      .concat(t.dataset.productId, "-")
                      .concat(t.dataset.section)
                  );
                  n && n.updateByVariantId(e);
                }
              );
            },
          },
          {
            key: "getCheckedInput",
            value: function (e) {
              return e.find(function (e) {
                return e.checked;
              });
            },
          },
          {
            key: "_form",
            get: function () {
              return document.getElementById(
                "product-form-component-"
                  .concat(this.dataset.productId, "-")
                  .concat(this.dataset.section)
              );
            },
          },
        ]),
        i
      );
    })(te),
    as = ss,
    rs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleClick", function () {
            e.updateSelected();
          }),
          f(x(e), "_handleMouseEnter", function (t) {
            e.updateActiveValue(t.target.dataset.value);
          }),
          f(x(e), "_handleMouseLeave", function () {
            e.updateSelected();
          }),
          (e.activeValueSelector = "[data-color-swatches-picker-active-value]"),
          (e.activeValue = e.querySelector(e.activeValueSelector)),
          (e.labelSelector = "[data-color-swatches-picker-label]"),
          (e.labels = b(e.querySelectorAll(e.labelSelector))),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this.addEventListener("click", this._handleClick),
                this.labels.forEach(function (t) {
                  t.addEventListener("mouseenter", e._handleMouseEnter),
                    t.addEventListener("mouseleave", e._handleMouseLeave);
                });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.removeEventListener("click", this._handleClick),
                this.labels.forEach(function (t) {
                  t.removeEventListener("mouseenter", e._handleMouseEnter),
                    t.removeEventListener("mouseleave", e._handleMouseLeave);
                });
            },
          },
          {
            key: "updateSelected",
            value: function () {
              var e = this.querySelector(
                "".concat(this.labelSelector, ".selected")
              );
              if (e) {
                var t = e.getAttribute("data-value") || "";
                this.updateActiveValue(t);
              }
            },
          },
          {
            key: "updateActiveValue",
            value: function (e) {
              this.activeValue && (this.activeValue.innerHTML = e);
            },
          },
        ]),
        i
      );
    })(te),
    os = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleKeydown", function (t) {
            var i = t.key || t.keyCode;
            (i === H || i === F) &&
              (e.isZoomed ? e.zoomedImage.reset() : e.hide());
          }),
          f(x(e), "_handleCarouselInit", function () {
            e._updateCarouselDraggableState();
          }),
          f(x(e), "_handleCarouselSelect", function () {
            e.updateSelectedSlideNumber();
          }),
          (e.selectors = {
            carousel: "[data-product-modal-carousel]",
            carouselButtons: "[data-product-modal-carousel-button]",
            carouselSlide: "[data-product-modal-slide]",
            carouselSelectedSlideNumber:
              "[data-product-modal-selected-slide-number]",
            carouselSlideNumber: "[data-product-modal-slide-number]",
            zoomCursor: "zoom-cursor",
          }),
          e.element &&
            ((e.carousel = e.element.querySelector(e.selectors.carousel)),
            (e.carouselButtons = e.carousel.querySelectorAll(
              e.selectors.carouselButtons
            )),
            (e._slides = b(
              e.element.querySelectorAll(e.selectors.carouselSlide)
            )),
            (e._selectedSlideNumber = e.element.querySelector(
              e.selectors.carouselSelectedSlideNumber
            )),
            (e._slideNumber = e.element.querySelector(
              e.selectors.carouselSlideNumber
            ))),
          (e._zoomCursor = document.querySelector(e.selectors.zoomCursor)),
          (e.mediaIndexMap = e._createMediaIndexMap()),
          (e.isZoomed = !1),
          e
        );
      }
      return (
        p(i, [
          {
            key: "openAndShowMediaById",
            value: function (e) {
              if ((this.show(), this.carousel)) {
                var t = this.mediaIndexMap[e];
                this.carousel.embla.scrollTo(t, !0),
                  this.carouselButtons[0] && this.carouselButtons[0].focus(),
                  this.updateSelectedSlideNumber();
              }
            },
          },
          {
            key: "_initCarousel",
            value: function () {
              this.carousel &&
                (this.carousel.embla.on("select", this._handleCarouselSelect),
                this.carousel.embla.on("init", this._handleCarouselInit));
            },
          },
          {
            key: "_resetCarousel",
            value: function () {
              this.carousel &&
                (this.carousel.embla.off("select", this._handleCarouselSelect),
                this.carousel.embla.off("init", this._handleCarouselInit));
            },
          },
          {
            key: "hide",
            value: function () {
              this._resetCarousel(),
                Qt(_(i.prototype), "hide", this).call(this),
                (this.isZoomed = !1),
                this.updateModal(),
                this.emit("hide", {});
            },
          },
          {
            key: "show",
            value: function () {
              Qt(_(i.prototype), "show", this).call(this), this._initCarousel();
            },
          },
          {
            key: "updateSelectedSlideNumber",
            value: function () {
              if (this._selectedSlideNumber && this.carousel) {
                var e = this.carousel.embla.selectedScrollSnap() + 1;
                this._selectedSlideNumber.innerHTML = "".concat(e);
              }
            },
          },
          {
            key: "updateModal",
            value: function () {
              this._updateCarouselDraggableState(),
                this._updateZoomCursorState(),
                this._updateZoomState();
            },
          },
          {
            key: "_createMediaIndexMap",
            value: function () {
              return this._slides.reduce(function (e, t, i) {
                return t.dataset.mediaId
                  ? ce(v({}, e), f({}, t.dataset.mediaId, i))
                  : e;
              }, {});
            },
          },
          {
            key: "_updateCarouselDraggableState",
            value: function () {
              this.carousel &&
                (ci()
                  ? this.carousel.reInit({ draggable: !this.isZoomed })
                  : this.carousel.reInit({ draggable: !1 }));
            },
          },
          {
            key: "_updateZoomCursorState",
            value: function () {
              this._zoomCursor && this._zoomCursor.updateState(this.isZoomed);
            },
          },
          {
            key: "_updateZoomState",
            value: function () {
              this.toggleAttribute("zoom-enabled", this.isZoomed);
            },
          },
        ]),
        i
      );
    })(Ut),
    ls = os,
    cs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleImageLoad", function () {
            e.setPreloaderVisible(!1);
          }),
          f(x(e), "_handleModalHide", function () {
            e.reset();
          }),
          f(x(e), "_handleCarouselSelect", function () {
            e.reset();
          }),
          f(x(e), "_handleTouchStart", function (t) {
            t.preventDefault(),
              (e.fingers = t.touches.length),
              (e.firstMove = !0),
              e.detectDoubleTap(t);
          }),
          f(x(e), "_handleTouchMove", function (t) {
            if ((t.preventDefault(), !e._isDoubleTapped)) {
              if (e.firstMove)
                e.updateGesture(t), (e.startMoveTouches = t.touches.length);
              else if (e._lastGesture)
                switch (e._lastGesture) {
                  case "zoom":
                    2 === e.startMoveTouches &&
                      2 === t.touches.length &&
                      e.pinch(t);
                    break;
                  case "drag":
                    if (1 === e.startMoveTouches && 1 === t.touches.length) {
                      var i = t.targetTouches[0],
                        n = i.clientX,
                        s = i.clientY;
                      e.drag(n, s);
                    }
                }
              else e.setGesture("none", t);
              e.firstMove = !1;
            }
          }),
          f(x(e), "_handleTouchEnd", function (t) {
            t.preventDefault(),
              (e.fingers = t.touches.length),
              e.updateGesture(t);
          }),
          f(x(e), "_handleMouseDown", function (t) {
            t.preventDefault(),
              e.startDrag(t.clientX, t.clientY),
              e.setDragging(!0);
          }),
          f(x(e), "_handleMouseUp", function (t) {
            e.setDragging(!1);
            var i = e._modal.isZoomed ? 75 : 0;
            e.zoomTimeoutId = setTimeout(function () {
              e.touchZoom(t.clientX, t.clientY);
            }, i);
          }),
          f(x(e), "_handleMouseMove", function (t) {
            if (
              (t.preventDefault(),
              clearTimeout(e.zoomTimeoutId),
              e._isDragging && e._modal.isZoomed)
            ) {
              var i = t.clientX,
                n = t.clientY;
              e.drag(i, n);
            }
          }),
          (e._image = e.querySelector("img")),
          (e._modal = e.closest("product-modal")),
          (e._carousel = e._modal.carousel),
          (e._preloader = e.querySelector(
            "[data-product-modal-image-preloader]"
          )),
          (e._currentScale = 1),
          (e._isDragging = !1),
          (e._offsetX = 0),
          (e._offsetY = 0),
          (e._startDragPoint = { x: 0, y: 0 }),
          (e._maxScale = 3),
          (e._minScale = 1),
          (e._isTapped = !1),
          (e._tapTimeout = 300),
          (e._lastGesture = null),
          e.setZoomCursorVisible(!0),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              G.observe(this._preloader),
                this._image.addEventListener(
                  "mousedown",
                  this._handleMouseDown
                ),
                this._image.addEventListener("mouseup", this._handleMouseUp),
                this._image.addEventListener(
                  "mousemove",
                  this._handleMouseMove
                ),
                this._image.addEventListener(
                  "touchstart",
                  this._handleTouchStart
                ),
                this._image.addEventListener("touchend", this._handleTouchEnd),
                this._image.addEventListener(
                  "touchmove",
                  this._handleTouchMove
                ),
                this._image.addEventListener("load", this._handleImageLoad),
                customElements.upgrade(this._modal),
                this._modal.subscribe("hide", this._handleModalHide),
                this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              G.unobserve(this._preloader),
                this._image.removeEventListener(
                  "mousedown",
                  this._handleMouseDown
                ),
                this._image.removeEventListener("mouseup", this._handleMouseUp),
                this._image.removeEventListener(
                  "mousemove",
                  this._handleMouseMove
                ),
                this._image.removeEventListener(
                  "touchstart",
                  this._handleTouchStart
                ),
                this._image.removeEventListener(
                  "touchend",
                  this._handleTouchEnd
                ),
                this._image.removeEventListener(
                  "touchmove",
                  this._handleTouchMove
                ),
                this._image.removeEventListener("load", this._handleImageLoad),
                this._modal.unsubscribe("hide", this._handleModalHide),
                this._carousel.embla.off("select", this._handleCarouselSelect);
            },
          },
          {
            key: "detectDoubleTap",
            value: function (e) {
              var t = this;
              if (this._isTappedTimeout && 1 === this.fingers)
                switch (
                  (clearTimeout(this._isTappedTimeout),
                  (this._isTappedTimeout = null),
                  (this._isDoubleTapped = !0),
                  this.touchZoom(
                    e.changedTouches[0].clientX,
                    e.changedTouches[0].clientY
                  ),
                  this._lastGesture)
                ) {
                  case "zoom":
                    this.setPinchScaling(!1);
                    break;
                  case "drag":
                    this.setDragging(!1);
                }
              else
                this._isTappedTimeout = setTimeout(function () {
                  (t._isTappedTimeout = null), (t._isDoubleTapped = !1);
                }, this._tapTimeout);
            },
          },
          {
            key: "updateGesture",
            value: function (e) {
              2 === this.fingers
                ? this.setGesture("zoom")
                : 1 === this.fingers
                ? this.setGesture("drag", e)
                : this.setGesture("none", e);
            },
          },
          {
            key: "setGesture",
            value: function (e, t) {
              if (this._lastGesture !== e) {
                if (this._lastGesture && !e)
                  switch (this._lastGesture) {
                    case "zoom":
                      this.setPinchScaling(!1);
                      break;
                    case "drag":
                      this.setDragging(!1);
                  }
                switch (e) {
                  case "zoom":
                    this.setPinchScaling(!0);
                    break;
                  case "drag":
                    this.startDrag(
                      t.changedTouches[0].clientX,
                      t.changedTouches[0].clientY
                    ),
                      this.setDragging(!0);
                    break;
                  case "none":
                    this.setDragging(!1), this.setPinchScaling(!1);
                }
              }
              this._lastGesture = e;
            },
          },
          {
            key: "pinch",
            value: function (e) {
              var t = this.getDistanceBetweenTouches(e),
                i = t > this.lastDistanceBetweenTouches,
                n = i ? 0.125 : -0.125,
                s = this.getNewScale(this.currentScale + n),
                a = this.getTouchCenter(e),
                r = (a.x - this._offsetX) / this.currentScale,
                o = (a.y - this._offsetY) / this.currentScale;
              (this.lastDistanceBetweenTouches = t),
                i || 1 !== s
                  ? this.setTransform({
                      scale: s,
                      offsetX: a.x - r * s,
                      offsetY: a.y - o * s,
                    })
                  : this.reset();
            },
          },
          {
            key: "getDistanceBetweenTouches",
            value: function (e) {
              return Math.hypot(
                e.touches[0].pageX - e.touches[1].pageX,
                e.touches[0].pageY - e.touches[1].pageY
              );
            },
          },
          {
            key: "startDrag",
            value: function (e, t) {
              (this._startDragPoint = {
                x: e - this._offsetX,
                y: t - this._offsetY,
              }),
                (this.dragStartPointX = e),
                (this.dragStartPointY = t);
            },
          },
          {
            key: "drag",
            value: function (e, t) {
              var i = this.dragStartPointX > e,
                n = this.dragStartPointY > t,
                s = this.getNewScale(this.currentScale),
                a = e - this._startDragPoint.x,
                r = t - this._startDragPoint.y,
                o = this.getIntersectBounds({
                  isRightDrag: i,
                  isBottomDrag: n,
                });
              (o.right || o.left) && (a = this._offsetX),
                (o.bottom || o.top) && (r = this._offsetY),
                this.setTransform({ scale: s, offsetX: a, offsetY: r });
            },
          },
          {
            key: "getIntersectBounds",
            value: function (e) {
              var t = e.isRightDrag,
                i = e.isBottomDrag,
                n = this._image.getBoundingClientRect(),
                s = t ? -8 : 8,
                a = i ? -8 : 8;
              return {
                right: t && n.right + s < window.innerWidth,
                left: !t && n.left + s > 0,
                bottom: i && n.bottom + a < window.innerHeight,
                top: !i && n.top + a > 0,
              };
            },
          },
          {
            key: "getTouchCenter",
            value: function (e) {
              var t = function (e, t) {
                  return e + t;
                },
                i = b(e.touches),
                n = i.length;
              return {
                x:
                  i
                    .map(function (e) {
                      return e.pageX;
                    })
                    .reduce(t) / n,
                y:
                  i
                    .map(function (e) {
                      return e.pageY;
                    })
                    .reduce(t) / n,
              };
            },
          },
          {
            key: "setTransform",
            value: function (e) {
              var t = e.offsetX,
                i = e.offsetY,
                n = e.scale;
              (this.style.transform = "translate3d("
                .concat(t, "px, ")
                .concat(i, "px, 0) scale3d(")
                .concat(n, ", ")
                .concat(n, ", 1)")),
                (this._offsetX = t),
                (this._offsetY = i),
                (this.currentScale = n);
            },
          },
          {
            key: "touchZoom",
            value: function (e, t) {
              var i,
                n,
                s,
                a = (e - this._offsetX) / this.currentScale,
                r = (t - this._offsetY) / this.currentScale;
              this._modal.isZoomed
                ? ((i = this.getNewScale(1)), (n = 0), (s = 0))
                : ((n = e - a * (i = this.getNewScale(3))), (s = t - r * i)),
                (this.style.cursor = this._modal.isZoomed ? "" : "grab"),
                this.setZoomCursorVisible(this._modal.isZoomed),
                this.setTransform({ scale: i, offsetX: n, offsetY: s });
            },
          },
          {
            key: "reset",
            value: function () {
              this.setTransform({ scale: 1, offsetX: 0, offsetY: 0 });
            },
          },
          {
            key: "getNewScale",
            value: function (e) {
              return Math.max(this._minScale, Math.min(this._maxScale, e));
            },
          },
          {
            key: "setPinchScaling",
            value: function (e) {
              this.toggleAttribute("is-pinch-scaling", e),
                (this._isPinchScaling = e);
            },
          },
          {
            key: "setDragging",
            value: function (e) {
              this.toggleAttribute("is-dragging", e), (this._isDragging = e);
            },
          },
          {
            key: "setZoomCursorVisible",
            value: function (e) {
              this._image.toggleAttribute("data-zoom-cursor-target", e);
            },
          },
          {
            key: "setModalZoom",
            value: function (e) {
              (this._modal.isZoomed = e),
                this._modal.isZoomed && (this._modal.zoomedImage = this),
                this._modal.updateModal();
            },
          },
          {
            key: "setPreloaderVisible",
            value: function (e) {
              this._preloader.classList.toggle("hidden", !e),
                this._image.toggleAttribute("is-loaded", !e);
            },
          },
          {
            key: "currentScale",
            get: function () {
              return this._currentScale;
            },
            set: function (e) {
              this._currentScale !== e &&
                (this.setModalZoom(e > 1), (this._currentScale = e));
            },
          },
        ]),
        i
      );
    })(te),
    us = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "showModal",
            value: function () {
              if (this.dataset.modal) {
                var e = document.querySelector(this.dataset.modal);
                e && e.openAndShowMediaById(this.dataset.mediaId);
              }
            },
          },
        ]),
        i
      );
    })(ii),
    ds = us,
    hs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.call(this))),
            "_handleIntersectionObserve",
            function (t, i) {
              if (t[0].isIntersecting) {
                i.unobserve(x(e));
                var n = e.dataset.url;
                n &&
                  fetch(n)
                    .then(function (e) {
                      return e.text();
                    })
                    .then(function (t) {
                      var i = ge(t);
                      e._updateByHTML(i);
                    })
                    .catch(function () {
                      S.notification &&
                        S.notification.show(
                          "Error in product recommendations component",
                          "warning"
                        );
                    });
              }
            }
          ),
          (e._intersectionObserver = new IntersectionObserver(
            e._handleIntersectionObserve,
            { rootMargin: "0px 0px 200px 0px" }
          )),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._intersectionObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._intersectionObserver.disconnect();
            },
          },
          {
            key: "_updateByHTML",
            value: function (e) {
              var t = e.querySelector("product-recommendations");
              t && (this.innerHTML = t.innerHTML);
            },
          },
        ]),
        i
      );
    })(te),
    ps = window.routes,
    fs = (function () {
      "use strict";
      function e() {
        d(this, e);
      }
      return (
        p(e, [
          {
            key: "get",
            value: function (e) {
              var t = this._prepareQuery(e);
              return fetch(t).then(function (e) {
                return e.text();
              });
            },
          },
          {
            key: "_prepareQuery",
            value: function (e) {
              var t = e.searchQuery,
                i = e.sectionId,
                n = ps.predictive_search_url,
                s = "section_id=".concat(i);
              return ""
                .concat(n, "?q=")
                .concat(t, "&")
                .concat("resources[limit]=999", "&")
                .concat(s);
            },
          },
        ]),
        e
      );
    })(),
    vs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.call(this))),
            "_handleInputChange",
            (0, Ji.debounce)(function () {
              e._searchQuery ? e._renderResults() : e._resetResults();
            }, 500)
          ),
          (e._cache = {}),
          (e.sidebar = e.closest("#SearchSidebar")),
          (e.inputComponentSelector = "[data-sidebar-search-input-component]"),
          (e.contentResults = "[data-sidebar-search-content-results]"),
          (e.footerSelector = "[data-sidebar-search-footer]"),
          (e.itemSelector = "[data-sidebar-search-item]"),
          e.sidebar &&
            (e._results = e.sidebar.element.querySelector(e.contentResults)),
          (e._predictiveSearchAPI = new fs()),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this._inputComponent, "input", this._handleInputChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._inputComponent, "input", this._handleInputChange);
            },
          },
          {
            key: "_renderResults",
            value: function () {
              this._cache[this._searchQuery]
                ? this._renderFromCache(this._searchQuery)
                : this._renderFromUrl(this._searchQuery);
            },
          },
          {
            key: "_resetResults",
            value: function () {
              this.sidebar &&
                this._updateResultsFromHTML(this.sidebar.defaultStateElement);
            },
          },
          {
            key: "_renderFromCache",
            value: function (e) {
              try {
                this._updateResultsFromHTML(this._cache[e]);
              } catch (e) {
                if (!S.notification) return;
                S.notification.show(
                  "Error in search component when try update from cache",
                  "warning"
                );
              }
            },
          },
          {
            key: "_renderFromUrl",
            value: function (e) {
              var t,
                i = this,
                n =
                  (null === (t = this.sidebar) || void 0 === t
                    ? void 0
                    : t.dataset.sectionId) || "search-sidebar";
              this._predictiveSearchAPI
                .get({ searchQuery: this._searchQuery, sectionId: n })
                .then(function (t) {
                  var n = ge(t);
                  (i._cache[e] = n), i._updateResultsFromHTML(n);
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show("Error in search component", "warning");
                });
            },
          },
          {
            key: "_updateResultsFromHTML",
            value: function (e) {
              var t = e.getElementById("SearchSidebar");
              if (t) {
                var i = t.querySelector("template"),
                  n = ve(i).querySelector(this.contentResults);
                this.updateResultsHTML(n.innerHTML), this.updateFooterVisible();
              }
            },
          },
          {
            key: "updateResultsHTML",
            value: function (e) {
              this._results && (this._results.innerHTML = e);
            },
          },
          {
            key: "updateFooterVisible",
            value: function () {
              if (this.sidebar) {
                var e = this.sidebar.element.querySelector(this.footerSelector),
                  t = this.sidebar.element.querySelectorAll(this.itemSelector);
                e && e.classList.toggle("hidden", 0 === t.length);
              }
            },
          },
          {
            key: "_searchQuery",
            get: function () {
              return this._inputComponent
                ? this._inputComponent.value.trim()
                : "";
            },
          },
          {
            key: "_inputComponent",
            get: function () {
              return this.sidebar
                ? this.sidebar.querySelector(this.inputComponentSelector)
                : null;
            },
          },
        ]),
        i
      );
    })(te),
    ms = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.update();
            }
          ),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e.update());
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.closest("cart-component, sidebar-cart"),
                t = this.dataset.index;
              e && t && e.updateItem(+t, 0);
            },
          },
        ]),
        i
      );
    })(te),
    gs = ms,
    ys = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e._copy();
            }
          ),
          f(x(e), "_copy", function () {
            var t = e.dataset.value;
            t &&
              navigator.clipboard &&
              navigator.clipboard.writeText(t).then(function () {
                e._showTooltip();
              });
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "_showTooltip",
            value: function () {
              var e = this.dataset.tooltipId;
              if (e) {
                var t = document.querySelector("#".concat(e));
                t &&
                  (t.show(),
                  V(1e3).then(function () {
                    t.hide();
                  }));
              }
            },
          },
        ]),
        i
      );
    })(te),
    bs = ys,
    ws = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        d(this, i),
          f(x((e = t.call(this))), "_init", function () {
            e._target &&
              Pt(e._target, x(e), function () {
                It(e._target, e, e._getOptions()).then(function (t) {
                  e._updatePosition(t), e._updateArrow(t);
                });
              });
          }),
          f(x(e), "show", function () {
            e._mount(), e._setVisible(!0), e.emit("show", {});
          }),
          f(x(e), "hide", function () {
            e._setVisible(!1), e._unmount(), e.emit("hide", {});
          });
        var n = e.querySelector("template");
        return (
          (e.element = ve(n)),
          (e._arrow = e.element.querySelector("[data-float-element-arrow]")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._init();
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._unmount();
            },
          },
          {
            key: "_updatePosition",
            value: function (e) {
              var t = e.x,
                i = e.y;
              Object.assign(this.style, {
                left: "".concat(t, "px"),
                top: "".concat(i, "px"),
              });
            },
          },
          {
            key: "_getOptions",
            value: function () {
              return {
                placement: this._placement,
                middleware: this._getMiddleware(),
                strategy: "absolute",
              };
            },
          },
          {
            key: "_getMiddleware",
            value: function () {
              var e = this.dataset.alignmentAxisOffset || 0,
                t = this.dataset.mainAxisOffset || 0,
                i = [Ye({ alignmentAxis: +e, mainAxis: +t }), Xe(), Ke()];
              return this._arrow && i.push(He({ element: this._arrow })), i;
            },
          },
          {
            key: "_updateArrow",
            value: function (e) {
              var t = e.placement,
                i = e.middlewareData;
              if (this._arrow) {
                var n = i.arrow,
                  s = n.x,
                  a = n.y,
                  r = {
                    top: "bottom",
                    right: "left",
                    bottom: "top",
                    left: "right",
                  }[t.split("-")[0]];
                Object.assign(
                  this._arrow.style,
                  f(
                    {
                      left: null != s ? "".concat(s, "px") : "",
                      top: null != a ? "".concat(a, "px") : "",
                      right: "",
                      bottom: "",
                    },
                    r,
                    "-5px"
                  )
                );
              }
            },
          },
          {
            key: "_mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.setAttribute("aria-hidden", e ? "false" : "true");
            },
          },
          {
            key: "_target",
            get: function () {
              return document.querySelector(
                '[data-clipboard-button-tooltip-target-id="'.concat(
                  this.id,
                  '"]'
                )
              );
            },
          },
          {
            key: "_placement",
            get: function () {
              return this.dataset.placement || "bottom-end";
            },
          },
        ]),
        i
      );
    })(te),
    Ss = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "setImagesAttributes",
            value: function () {
              var e = this.querySelectorAll("img"),
                t = [80, 160, 300, 400, 500, 680, 900];
              e.forEach(function (e) {
                var i = t
                  .map(function (t) {
                    return ""
                      .concat(e.dataset.imageUrl, "&width=")
                      .concat(t, " ")
                      .concat(t, "w");
                  })
                  .join(",");
                e.dataset.srcset = i;
              });
            },
          },
        ]),
        i
      );
    })(te),
    xs = Ss,
    Cs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "handleMouseEnter", function () {
            var t = e.dataset.url,
              i = e.dataset.id;
            t && i && Hn.requestProductFromUrl(t, i);
          }),
          f(x(e), "handleQuickViewBtnClick", function () {
            var t = e.dataset.url;
            t && Hn.openAndRenderProductByUrl(t);
          }),
          f(x(e), "handleResize", function () {
            e.buttons && e.setButtonsOverflow(),
              e.mediaTabs && e.mediaTabs.update(),
              e.colorSwatches && e.colorSwatches.update();
          }),
          f(x(e), "handleImageLoad", function () {
            var t;
            (e.loadedImageCount += 1),
              e.loadedImageCount ===
                (null === (t = e.images) || void 0 === t ? void 0 : t.length) &&
                (e.removePreloader(), e.showImages());
          }),
          (e.resizeObserver = new ResizeObserver(e.handleResize)),
          (e.lastButtonsWidth = 0),
          (e.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e.preloaderSelector = "[data-product-card-preloader]"),
          (e.imagesContainerSelector = "[data-product-card-media-container]"),
          (e.buttonsSelector = "[data-product-card-buttons]"),
          (e.imagesSelector = "[data-product-card-featured-image]"),
          (e.mediaTabsSelector = "[data-product-card-media-tabs]"),
          (e.colorSwatchesSelector = "[data-product-card-color-swatches]"),
          (e.quickViewBtn = e.querySelector(e.quickViewBtnSelector)),
          (e.preloader = e.querySelector(e.preloaderSelector)),
          (e.imagesContainer = e.querySelector(e.imagesContainerSelector)),
          (e.buttons = e.querySelector(e.buttonsSelector)),
          (e.buttonList = b(e.querySelectorAll("[data-product-card-button]"))),
          (e.images = b(e.querySelectorAll(e.imagesSelector))),
          (e.mediaTabs = e.querySelector(e.mediaTabsSelector)),
          (e.colorSwatches = e.querySelector(e.colorSwatchesSelector)),
          (e.loadedImageCount = 0),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this.setImagesAttributes(),
                this.images.forEach(function (t) {
                  t.addEventListener("load", e.handleImageLoad);
                }),
                this.resizeObserver.observe(this),
                G.observe(this),
                this.addEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.images.forEach(function (t) {
                t.removeEventListener("load", e.handleImageLoad);
              }),
                this.resizeObserver.disconnect(),
                G.unobserve(this),
                this.removeEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "setButtonsOverflow",
            value: function () {
              if (this.buttons) {
                var e = this.getButtonsWidth(),
                  t = this.buttons.offsetWidth < e;
                t && (this.lastButtonsWidth = this.buttons.offsetWidth),
                  this.buttons.classList.toggle(
                    "product-card__btns--overflowed",
                    t
                  );
              }
            },
          },
          {
            key: "getButtonsWidth",
            value: function () {
              return this.buttonList.reduce(
                function (e, t) {
                  var i = t.querySelector("[data-product-card-button-text]");
                  return e + (20 + ((i ? i.offsetWidth : 0) + 8) + 10) + 8;
                },
                this.buttonList.length > 1 ? 8 : 0
              );
            },
          },
          {
            key: "removePreloader",
            value: function () {
              this.preloader && (this.preloader.remove(), G.unobserve(this));
            },
          },
          {
            key: "showImages",
            value: function () {
              this.imagesContainer &&
                this.imagesContainer.setAttribute("visible", "");
            },
          },
        ]),
        i
      );
    })(xs),
    ks = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.call(this))),
            "_handleResize",
            (0, Ji.debounce)(function () {
              e._setMaxLines();
            }, 100)
          ),
          (e._resizeObserver = new ResizeObserver(e._handleResize)),
          (e.targetSelector = "[data-quote-line-clamp-target]"),
          (e.lineClampSelector = "[data-quote-line-clamp]"),
          (e._lineClamp = e.querySelector(e.lineClampSelector)),
          (e._target = e.querySelector(e.targetSelector)),
          (e.styles = getComputedStyle(e._target)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._resizeObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._resizeObserver.disconnect();
            },
          },
          {
            key: "_setMaxLines",
            value: function () {
              var e = this._getMaxLines();
              e &&
                this._target &&
                (this._target.style.setProperty(
                  "--gsc-max-lines",
                  "".concat(e)
                ),
                this.setAttribute("data-line-clamp-setter-is-ready", ""));
            },
          },
          {
            key: "_getMaxLines",
            value: function () {
              if (!this._lineClamp || !this._target) return 0;
              var e = this.styles.lineHeight,
                t = this._lineClamp.offsetHeight;
              return Math.floor(t / parseFloat(e));
            },
          },
        ]),
        i
      );
    })(te),
    Es = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleItemClick", function (t) {
            e._input &&
              e._dropdownBtnLabel &&
              e._dropdown &&
              (e._input.setAttribute("value", t.target.dataset.value),
              e._setActiveItem(t.target.dataset.value),
              (e._dropdownBtnLabel.innerHTML = t.target.dataset.value),
              e._dropdown.hide());
          }),
          (e._input = e.querySelector("input")),
          (e._dropdown = e.querySelector("float-element")),
          (e._dropdownBtnLabel = e.querySelector(".dropdown__toggle-label")),
          e._createItems(),
          (e._items = b(e.querySelectorAll(".dropdown__item"))),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._items.forEach(function (t) {
                j(t, "click", e._handleItemClick);
              });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this._items.forEach(function (t) {
                X(t, "click", e._handleItemClick);
              });
            },
          },
          {
            key: "_setActiveItem",
            value: function (e) {
              this._items.forEach(function (t) {
                t.classList.toggle("active", t.dataset.value === e);
              });
            },
          },
          {
            key: "_createItems",
            value: function () {
              var e = this;
              this.querySelectorAll("option").forEach(function (t) {
                if (e._dropdown) {
                  var i = document.createElement("div");
                  i.classList.add("dropdown__item"),
                    (i.dataset.value = t.value),
                    (i.dataset.provinces = t.dataset.provinces),
                    (i.innerHTML = t.innerHTML),
                    e._dropdown.appendChild(i);
                }
              });
            },
          },
        ]),
        i
      );
    })(te),
    Ts = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleWindowClick", function (t) {
            var i = t.target,
              n = i.closest("search-input");
            e._input !== i && !n && e._updateResetButtonVisible();
          }),
          f(x(e), "_handleInputChange", function () {
            e._updateResetButtonVisible();
          }),
          f(x(e), "_handleResetBtnClick", function (t) {
            t.preventDefault(), e.reset();
          }),
          (e._inputSelector = "[data-search-field-input]"),
          (e._resetBtnSelector = "[data-search-field-reset-button]"),
          (e._input = e.querySelector(e._inputSelector)),
          (e._resetBtn = e.querySelector(e._resetBtnSelector)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this._input, "input", this._handleInputChange),
                j(window, "click", this._handleWindowClick),
                j(this._resetBtn, "click", this._handleResetBtnClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._input, "input", this._handleInputChange),
                X(window, "click", this._handleWindowClick),
                X(this._resetBtn, "click", this._handleResetBtnClick);
            },
          },
          {
            key: "reset",
            value: function () {
              if (this._input) {
                var e = new Event("input", { bubbles: !0 });
                (this._input.value = ""),
                  this._input.dispatchEvent(e),
                  this._input.focus();
              }
            },
          },
          {
            key: "_updateResetButtonVisible",
            value: function () {
              if (this._resetBtn) {
                var e = this._hasInputValue();
                this._resetBtn.classList.toggle("hidden", !e);
              }
            },
          },
          {
            key: "_hasInputValue",
            value: function () {
              return !!this._input && this._input.value.trim().length > 0;
            },
          },
          {
            key: "value",
            get: function () {
              return this._input ? this._input.value : "";
            },
          },
        ]),
        i
      );
    })(te),
    _s = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleButtonClick", function () {
            e._togglePasswordVisible();
          }),
          (e._inputSelector = "[data-password-field-input]"),
          (e._buttonSelector = "[data-password-field-button]"),
          (e._input = e.querySelector(e._inputSelector)),
          (e._button = e.querySelector(e._buttonSelector)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this._button, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._button, "click", this._handleButtonClick);
            },
          },
          {
            key: "_togglePasswordVisible",
            value: function () {
              if (this._input) {
                var e = "password" === this._input.getAttribute("type"),
                  t = e ? "text" : "password";
                this._input.setAttribute("type", t), this._setButton(e);
              }
            },
          },
          {
            key: "_setButton",
            value: function (e) {
              this._button &&
                this._button.toggleAttribute("password-visible", e);
            },
          },
        ]),
        i
      );
    })(te),
    Ms = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleMutations", function (t) {
            t.forEach(function (t) {
              if ("attributes" === t.type) {
                var i = t.target.matches(e.zoomTargetSelector);
                e._setVisible(i);
              }
            });
          }),
          f(x(e), "_handleMouseMove", function (t) {
            var i = t.target,
              n = !!i.closest(e.zoomTargetSelector),
              s = ci();
            e._isVisible &&
              ((e.style.top = "".concat(t.clientY, "px")),
              (e.style.left = "".concat(t.clientX, "px"))),
              s ||
                (e._setVisible(n),
                n && e.mutationObserver.observe(i, { attributes: !0 }));
          }),
          (e.zoomTargetSelector = "[data-zoom-cursor-target]"),
          (e.mutationObserver = new MutationObserver(e._handleMutations)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._autoCheckTargets();
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(window, "mousemove", this._handleMouseMove),
                this.mutationObserver.disconnect(),
                clearInterval(this.checkTargetsIntervalID);
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.toggleAttribute("visible", e),
                (document.body.style.cursor = e ? "none" : "");
            },
          },
          {
            key: "updateState",
            value: function (e) {
              this.toggleAttribute("zoomed", e);
            },
          },
          {
            key: "_autoCheckTargets",
            value: function () {
              var e = this;
              this.checkTargetsIntervalID = setInterval(function () {
                document.querySelectorAll(e.zoomTargetSelector).length &&
                  !e.isHandlerSetted &&
                  (j(window, "mousemove", e._handleMouseMove),
                  (e.isHandlerSetted = !0));
              }, 1e3);
            },
          },
          {
            key: "_isVisible",
            get: function () {
              return this.hasAttribute("visible");
            },
          },
        ]),
        i
      );
    })(te),
    Ls = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleHistoryChange", function (t) {
            var i = t.state.searchParams || e._searchParamsInitial;
            i !== e._searchParamsPrev && e.updateBySearchParams(i);
          }),
          (e._cache = {}),
          (e._searchParamsInitial = window.location.search.slice(1)),
          (e._searchParamsPrev = window.location.search.slice(1)),
          (e.sortQuery = ""),
          (e.filterQuery = ""),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(window, "popstate", this._handleHistoryChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(window, "popstate", this._handleHistoryChange);
            },
          },
          {
            key: "_formatParams",
            value: function (e) {
              this._searchParamsPrev = e;
              var t = this.dataset.baseParams || "";
              return "".concat(t).concat(e);
            },
          },
          {
            key: "updateBySearchParams",
            value: function (e) {
              this.updateShopBySearchParams(e),
                this.updateFiltersBySearchParams(e);
            },
          },
          {
            key: "updateShopBySearchParams",
            value: function (e) {
              var t = this,
                i = this._createUrl(e);
              this._cache[i]
                ? this._updateElements(this._cache[i])
                : this._getFromUrl(i).then(function (e) {
                    return t._updateElements(e);
                  }),
                this._updateURL(e, i);
            },
          },
          {
            key: "updateFiltersBySearchParams",
            value: function (e) {
              var t = this._createUrl(e),
                i = document.querySelector("#SidebarFiltersMobile"),
                n = document.querySelector("#SidebarFiltersDesktop");
              if (i && n) {
                var s = [i, n];
                s.forEach(function (e) {
                  e.loadingOverlay.show();
                });
                var a = function (e) {
                  s.forEach(function (t) {
                    t.updateHTML(e), t.loadingOverlay.hide();
                  });
                };
                this._cache[t]
                  ? a(this._cache[t])
                  : this._getFromUrl(t).then(function (e) {
                      return a(e);
                    });
              }
            },
          },
          {
            key: "_getFromUrl",
            value: function (e) {
              var t = this,
                i = this.querySelector("#ShopProductsOverlay"),
                n = i ? new Tn(i) : null;
              n && n.show();
              var s = ""
                .concat(e, "&section_id=")
                .concat(this.dataset.sectionId);
              return fetch(s)
                .then(function (e) {
                  return e.text();
                })
                .then(function (i) {
                  var s = ge(i);
                  return (t._cache[e] = s), n && n.hide(), s;
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show("Error in shop component", "warning");
                });
            },
          },
          {
            key: "_updateURL",
            value: function (e, t) {
              history.pushState({ searchParams: e }, "", t);
            },
          },
          {
            key: "_createUrl",
            value: function (e) {
              var t = this._formatParams(e) || "";
              return "".concat(window.location.pathname, "?").concat(t);
            },
          },
          {
            key: "_updateElements",
            value: function (e) {
              [
                "ShopProducts",
                "ShopProductCount",
                "ShopSortList",
                "ShopActiveFilters",
              ].forEach(function (t) {
                var i = document.getElementById(t),
                  n = e.getElementById(t);
                i && n && (i.innerHTML = n.innerHTML);
              });
            },
          },
          {
            key: "resetQueries",
            value: function () {
              (this.sortQuery = ""), (this.filterQuery = "");
            },
          },
        ]),
        i
      );
    })(te),
    Ps = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this)).optionsSelector =
            "[data-shop-active-filters-options]"),
          (e.removeBtnSelector = "[data-shop-active-filters-remove-btn]"),
          e
        );
      }
      return (
        p(i, [
          {
            key: "reset",
            value: function () {
              this.innerHTML = "";
            },
          },
          {
            key: "setDisable",
            value: function () {
              this.options && this.options.setAttribute("disabled", "");
            },
          },
          {
            key: "options",
            get: function () {
              return this.querySelector(this.optionsSelector);
            },
          },
          {
            key: "buttons",
            get: function () {
              return b(this.querySelectorAll(this.removeBtnSelector));
            },
          },
        ]),
        i
      );
    })(te),
    Is = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleFormScroll", function () {
            if (e.form) {
              var t = e.form.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t);
            }
          }),
          f(x(e), "_handleClick", function (e) {
            var t = e.target.closest("[data-filters-checkbox]");
            t && t.setAttribute("selected", "");
          }),
          f(x(e), "_handleInputChange", function (t) {
            "INPUT" === t.target.tagName && e._change();
          }),
          (e.form = e.element.querySelector("[data-filters-form]")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i.prototype), "connectedCallback", this).call(this),
                j(this.form, "scroll", this._handleFormScroll),
                j(this, "change", this._handleInputChange),
                j(this, "click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i.prototype), "disconnectedCallback", this).call(this),
                X(this.form, "scroll", this._handleFormScroll),
                X(this, "change", this._handleInputChange),
                X(this, "click", this._handleClick);
            },
          },
          { key: "_change", value: function () {} },
          {
            key: "_createFilterQuery",
            value: function () {
              if (this._form && this._shop) {
                var e = new FormData(this._form),
                  t = new URLSearchParams(e).toString();
                this._shop.filterQuery = t;
              }
            },
          },
          {
            key: "updateHTML",
            value: function (e) {
              var t = this.getAttribute("id"),
                i = t ? e.getElementById(t) : null,
                n = i ? i.querySelector("template") : null;
              if (n) {
                var s = ve(n);
                this.updateFormFromElement(s), this.updateHeaderFromElement(s);
              }
            },
          },
          {
            key: "updateHeaderFromElement",
            value: function (e) {
              var t = this.element.querySelector("[data-filters-header]"),
                i = e.querySelector("[data-filters-header]");
              t && i && (t.innerHTML = i.innerHTML);
            },
          },
          {
            key: "updateFormFromElement",
            value: function (e) {
              var t = this.element.querySelector("[data-filters-form]"),
                i = e.querySelector("[data-filters-form]");
              t && i && (t.innerHTML = i.innerHTML);
            },
          },
          {
            key: "_form",
            get: function () {
              return this.element.querySelector("form");
            },
          },
          {
            key: "_shop",
            get: function () {
              return this.element.closest("shop-component");
            },
          },
          {
            key: "_searchParams",
            get: function () {
              return this._shop
                ? [this._shop.filterQuery, this._shop.sortQuery].join("&")
                : "";
            },
          },
          {
            key: "loadingOverlay",
            get: function () {
              var e = this.element.querySelector(
                "[data-filters-loading-overlay]"
              );
              return e ? new Tn(e) : null;
            },
          },
        ]),
        i
      );
    })(li),
    Ds = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "_change",
            value: function () {
              this._shop &&
                (this._createFilterQuery(),
                this._shop.updateBySearchParams(this._searchParams));
            },
          },
        ]),
        i
      );
    })(Is),
    As = Ds,
    zs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "_change",
            value: function () {
              this._shop &&
                (this._createFilterQuery(),
                this._shop.updateFiltersBySearchParams(this._searchParams),
                this._setButtonForReset());
            },
          },
          {
            key: "_setButtonForReset",
            value: function () {
              var e = this.element.querySelector("filter-remove-btn");
              e && e.classList.contains("hidden") && de(e);
            },
          },
        ]),
        i
      );
    })(Is),
    Os = zs,
    Bs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.update();
            }
          ),
          f(x(e), "_handleKeyDown", function (t) {
            K(t.key || t.keyCode) && (t.preventDefault(), e.update());
          }),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.closest("shop-active-filters"),
                t = this.closest("shop-component"),
                i = this.dataset.url;
              if (e) {
                var n = this.hasAttribute(
                  "data-shop-active-filters-remove-btn"
                );
                this.hasAttribute("data-shop-active-filters-reset") &&
                  e.reset(),
                  n &&
                    (1 === e.buttons.length
                      ? e.reset()
                      : (e.setDisable(), this.remove()));
              }
              if (i && t) {
                var s =
                  -1 === i.indexOf("?") ? "" : i.slice(i.indexOf("?") + 1);
                t.resetQueries(), t.updateBySearchParams(s);
              }
            },
          },
        ]),
        i
      );
    })(te),
    Ns = Bs,
    qs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.call(this))),
            "_handleFormSubmit",
            (0, Ji.debounce)(function (t) {
              t.preventDefault();
              var i = e.closest("shop-component"),
                n = e.closest("sidebar-component"),
                s = t.target;
              if ((n && n.hide(), i && s)) {
                var a = e._getSortQuery(s),
                  r = [i.filterQuery, a].join("&");
                (i.sortQuery = a), i.updateBySearchParams(r);
              }
            }, 250)
          ),
          f(x(e), "_handleLabelKeyDown", function (e) {
            if (K(e.key || e.keyCode)) {
              e.preventDefault();
              var t = e.target.querySelector("input");
              if (t) {
                var i = new MouseEvent("click", { button: 0, which: 1 });
                t.dispatchEvent(i);
              }
            }
          }),
          (e.labelSelector = "[data-sort-list-label]"),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setListenersForLabels(),
                j(this._form, "input", this._handleFormSubmit);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeListenersForLabels(),
                X(this._form, "input", this._handleFormSubmit);
            },
          },
          {
            key: "_getSortQuery",
            value: function (e) {
              var t = e.closest("form");
              if (t) {
                var i = new FormData(t);
                return new URLSearchParams(i).toString();
              }
              return "";
            },
          },
          {
            key: "setListenersForLabels",
            value: function () {
              var e = this;
              b(this.querySelectorAll(this.labelSelector)).forEach(function (
                t
              ) {
                t.addEventListener("keydown", e._handleLabelKeyDown);
              });
            },
          },
          {
            key: "removeListenersForLabels",
            value: function () {
              var e = this;
              b(this.querySelectorAll(this.labelSelector)).forEach(function (
                t
              ) {
                t.removeEventListener("keydown", e._handleLabelKeyDown);
              });
            },
          },
          {
            key: "_form",
            get: function () {
              return this.querySelector("form");
            },
          },
        ]),
        i
      );
    })(te),
    $s = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleRangeInput", function (t) {
            var i = e.querySelector("[data-price-range-max-input]"),
              n = e.querySelector("[data-price-range-min-input]");
            if (e._progress && n && i) {
              var s = e._progress.offsetLeft + e._progress.offsetWidth / 2,
                a = t.offsetX < s;
              n.toggleAttribute("targeted", a),
                i.toggleAttribute("targeted", !a);
            }
          }),
          f(x(e), "_handleNumberChange", function () {
            if (e._minNumberInput && e._maxNumberInput) {
              var t = parseInt(e._minNumberInput.value),
                i = parseInt(e._maxNumberInput.value);
              e._updateMinRangeInput(t), e._updateMaxRangeInput(i);
            }
          }),
          f(x(e), "_handleRangeChange", function () {
            if (e._minRangeInput && e._maxRangeInput) {
              var t = parseInt(e._minRangeInput.value),
                i = parseInt(e._maxRangeInput.value);
              e._updateMaxPriceInput(i),
                e._updateMaxRangeInput(i),
                e._updateMinPriceInput(t),
                e._updateMinRangeInput(t);
            }
          }),
          (e._minNumberInput = e.querySelector(
            "[data-price-min-range-number]"
          )),
          (e._maxNumberInput = e.querySelector(
            "[data-price-max-range-number]"
          )),
          (e._rangeWrapper = e.querySelector(
            "[data-price-range-inputs-wrapper]"
          )),
          (e._minRangeInput = e.querySelector("[data-price-min-range-input]")),
          (e._maxRangeInput = e.querySelector("[data-price-max-range-input]")),
          (e._progress = e.querySelector("[data-price-range-progress]")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this._minRangeInput &&
                this._updateMinRangeInput(+this._minRangeInput.value),
                this._maxRangeInput &&
                  this._updateMaxRangeInput(+this._maxRangeInput.value),
                j(this._minNumberInput, "input", this._handleNumberChange),
                j(this._maxNumberInput, "input", this._handleNumberChange),
                j(this._minRangeInput, "input", this._handleRangeChange),
                j(this._maxRangeInput, "input", this._handleRangeChange),
                j(this._rangeWrapper, "mouseenter", this._handleRangeInput),
                j(this._rangeWrapper, "mousemove", this._handleRangeInput);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._minNumberInput, "input", this._handleNumberChange),
                X(this._maxNumberInput, "input", this._handleNumberChange),
                X(this._minRangeInput, "input", this._handleRangeChange),
                X(this._maxRangeInput, "input", this._handleRangeChange),
                X(this._rangeWrapper, "mouseenter", this._handleRangeInput),
                X(this._rangeWrapper, "mousemove", this._handleRangeInput);
            },
          },
          {
            key: "_updateMaxRangeInput",
            value: function (e) {
              if (this._maxRangeInput && this._progress) {
                var t = 100 - (e / +this._maxRangeInput.max) * 100;
                (this._maxRangeInput.value = "".concat(e)),
                  (this._progress.style.right = "".concat(t, "%"));
              }
            },
          },
          {
            key: "_updateMinRangeInput",
            value: function (e) {
              if (this._minRangeInput && this._progress) {
                var t = (e / +this._minRangeInput.max) * 100;
                (this._minRangeInput.value = "".concat(e)),
                  (this._progress.style.left = "".concat(t, "%"));
              }
            },
          },
          {
            key: "_updateMaxPriceInput",
            value: function (e) {
              this._maxNumberInput &&
                (this._maxNumberInput.value = e.toFixed(2));
            },
          },
          {
            key: "_updateMinPriceInput",
            value: function (e) {
              this._minNumberInput &&
                (this._minNumberInput.value = e.toFixed(2));
            },
          },
        ]),
        i
      );
    })(te),
    Hs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleSectionLoad", function (t) {
            e.dataset.sectionId === t.detail.sectionId && e.reset();
          }),
          f(x(e), "_handleItemClick", function (t) {
            var i = t.target.closest(e.itemSelector);
            if (i) {
              var n = +(i.dataset.value || 1);
              e._switch(n);
            }
          }),
          f(x(e), "_handleKeyDown", function (t) {
            if (K(t.key || t.keyCode)) {
              t.preventDefault();
              var i = t.target.closest(e.itemSelector);
              if (i) {
                var n = +(i.dataset.value || 1);
                e._switch(n);
              }
            }
          }),
          (e.itemSelector = "[data-column-switcher-item]"),
          (e.targetSelector = "[data-column-switcher-target]"),
          (e.items = b(e.querySelectorAll(e.itemSelector))),
          (e._cssVariable = e.dataset.columnSwitcherCssVariable || ""),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._init(),
                this.items.forEach(function (t) {
                  j(t, "keydown", e._handleKeyDown),
                    j(t, "click", e._handleItemClick);
                }),
                this._isEditorMode &&
                  this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.items.forEach(function (t) {
                X(t, "keydown", e._handleKeyDown),
                  X(t, "click", e._handleItemClick);
              }),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "updateByColumnCount",
            value: function (e) {
              this._selectSwitch(e), this._updateColumnCount(e);
            },
          },
          {
            key: "_selectSwitch",
            value: function (e) {
              this.items.forEach(function (t) {
                var i = +(t.getAttribute("data-value") || 1);
                t.classList.toggle("selected", i === e);
              });
            },
          },
          {
            key: "_updateColumnCount",
            value: function (e) {
              var t = this.closest(this.targetSelector);
              t &&
                (t.style.setProperty(
                  "--gsc-".concat(this._cssVariable),
                  e.toString()
                ),
                localStorage.setItem(
                  "products-".concat(this._cssVariable),
                  e.toString()
                ));
            },
          },
          {
            key: "_init",
            value: function () {
              var e = localStorage.getItem(
                "products-".concat(this._cssVariable)
              );
              if (e && "null" !== e) {
                var t = Number(e);
                t > 0 && this.updateByColumnCount(t);
              }
            },
          },
          {
            key: "_switch",
            value: function (e) {
              this.updateByColumnCount(e);
            },
          },
          {
            key: "reset",
            value: function () {
              this.dataset.default &&
                this._switch(Number(this.dataset.default));
            },
          },
        ]),
        i
      );
    })(te),
    Fs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(
            x((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              var t = e.closest("shop-component"),
                i = e.closest("#SidebarFiltersMobile");
              if (t) {
                var n = [t.filterQuery, t.sortQuery].join("&");
                t.updateShopBySearchParams(n);
              }
              i && i.hide();
            }
          ),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "click", this._handleButtonClick);
            },
          },
        ]),
        i
      );
    })(te),
    Vs = Fs,
    Rs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleButtonMouseDown", function (t) {
            t.preventDefault(), e.startMove();
          }),
          f(x(e), "_handleButtonMouseUp", function () {
            e.endMove();
          }),
          f(x(e), "_handleMouseMove", function (t) {
            e._isMoved && e.moveSeparator(t.pageX);
          }),
          f(x(e), "_handleButtonKeyUp", function (t) {
            if (e._btn) {
              var i = t.key || t.keyCode,
                n = Z(i),
                s = Q(i);
              if (n || s) {
                var a = e._btn.getBoundingClientRect(),
                  r = a.right - a.width / 2,
                  o = n ? r - e._movingStep : r + e._movingStep;
                e.moveSeparator(o);
              }
            }
          }),
          f(x(e), "_handleTouchStart", function () {
            e.startMove();
          }),
          f(x(e), "_handleTouchEnd", function () {
            e.endMove();
          }),
          f(x(e), "_handleTouchMove", function (t) {
            e._isMoved &&
              (t.preventDefault(), e.moveSeparator(t.targetTouches[0].clientX));
          }),
          (e._btnSelector = "[data-before-after-images-button]"),
          (e._btn = e.querySelector(e._btnSelector)),
          (e._isMoved = !1),
          (e._movingStep = 20),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setSeparatorPosition(
                Number(this.dataset.initialDragPosition)
              ),
                j(this._btn, "keyup", this._handleButtonKeyUp),
                j(this._btn, "mousedown", this._handleButtonMouseDown),
                j(document, "mouseup", this._handleButtonMouseUp),
                j(document, "mousemove", this._handleMouseMove),
                j(this._btn, "touchstart", this._handleTouchStart),
                j(this, "touchmove", this._handleTouchMove),
                j(document, "touchend", this._handleTouchEnd);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._btn, "keyup", this._handleButtonKeyUp),
                X(this._btn, "mousedown", this._handleButtonMouseDown),
                X(document, "mouseup", this._handleButtonMouseUp),
                X(document, "mousemove", this._handleMouseMove),
                X(this._btn, "touchstart", this._handleTouchStart),
                X(this, "touchmove", this._handleTouchMove),
                X(document, "touchend", this._handleTouchEnd);
            },
          },
          {
            key: "startMove",
            value: function () {
              this._isMoved = !0;
            },
          },
          {
            key: "endMove",
            value: function () {
              this._isMoved = !1;
            },
          },
          {
            key: "setSeparatorPosition",
            value: function (e) {
              this.style.setProperty("--gsc-drag-position", "".concat(e, "%"));
            },
          },
          {
            key: "moveSeparator",
            value: function (e) {
              var t = this.getBoundingClientRect();
              if (e <= t.left) this.setSeparatorPosition(0);
              else if (e >= t.right) this.setSeparatorPosition(100);
              else {
                var i =
                  Math.floor(((e - t.left) / this.offsetWidth) * 1e3) / 10;
                this.setSeparatorPosition(i);
              }
            },
          },
        ]),
        i
      );
    })(te),
    js = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleFormScroll", function () {
            if (e.viewport) {
              var t = e.viewport.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t);
            }
          }),
          (e.viewport = e.element.querySelector(
            "[data-product-information-drawer-viewport]"
          )),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i.prototype), "connectedCallback", this).call(this),
                j(this.viewport, "scroll", this._handleFormScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i.prototype), "disconnectedCallback", this).call(this),
                X(this.viewport, "scroll", this._handleFormScroll);
            },
          },
        ]),
        i
      );
    })(li),
    Xs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this)).content = e.querySelector(
            "[data-tabs-element-content]"
          )),
          (e.styles = getComputedStyle(x(e))),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateMaxHeight(this.isVisible);
            },
          },
          {
            key: "show",
            value: function () {
              return this.setVisible(!0), V(this.transitionDuration);
            },
          },
          {
            key: "hide",
            value: function () {
              return this.setVisible(!1), V(this.transitionDuration);
            },
          },
          {
            key: "setVisible",
            value: function (e) {
              this.setAttribute("aria-hidden", e ? "false" : "true"),
                this.updateMaxHeight(e);
            },
          },
          {
            key: "updateMaxHeight",
            value: function (e) {
              if (this.content) {
                var t = e ? this.content.offsetHeight : 0;
                this.style.maxHeight = "".concat(t, "px");
              }
            },
          },
          {
            key: "isVisible",
            get: function () {
              return "false" === this.getAttribute("aria-hidden");
            },
          },
          {
            key: "transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        i
      );
    })(te),
    Gs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "_handleWindowScroll", function () {
            e._lastScrollPosition || (e._lastScrollPosition = window.scrollY),
              e.updateVisibleStatus(),
              e.updateExtendStatus();
          }),
          f(
            x(e),
            "updateExtendStatus",
            (0, Ji.debounce)(function () {
              if (Math.abs(window.scrollY - e._lastScrollPosition) > 24) {
                var t = e._lastScrollPosition > window.scrollY;
                e.toggleAttribute("is-extended", t);
              }
              e._lastScrollPosition = 0;
            }, 50)
          ),
          (e.products = document.getElementById("ShopProducts")),
          (e.footer = document.querySelector(".shopify-section-footer")),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i.prototype), "connectedCallback", this).call(this),
                window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i.prototype), "disconnectedCallback", this).call(this),
                window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "updateVisibleStatus",
            value: function () {
              var e = this.footer ? this.footer.offsetTop : 0,
                t = this.products.getBoundingClientRect(),
                i = window.innerHeight + window.scrollY < e,
                n = t.top < 0,
                s = i && n;
              this.toggleAttribute("is-visible", s),
                document.body.toggleAttribute("is-filters-button-fixed", s);
            },
          },
        ]),
        i
      );
    })(oi),
    Ws = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this)).checkbox = e.querySelector(
            "[data-recipient-form-checkbox]"
          )),
          (e.timezoneInput = e.querySelector(
            "[data-recipient-form-timezone-input]"
          )),
          (e.inputs = e.querySelectorAll(
            "[data-recipient-form-input], [data-recipient-form-timezone-input]"
          )),
          (e.fields = e.querySelector("[data-recipient-form-fields]")),
          (e.timezoneInput.value = new Date().getTimezoneOffset()),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("change", this.handleChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("change", this.handleChange);
            },
          },
          {
            key: "handleChange",
            value: function () {
              var e = this.checkbox.checked;
              this.updateMaxHeight(e),
                this.updateInputDisable(!e),
                e || this.clearInputs();
            },
          },
          {
            key: "clearInputs",
            value: function () {
              this.inputs.forEach(function (e) {
                e.value = "";
              });
            },
          },
          {
            key: "updateInputDisable",
            value: function (e) {
              this.inputs.forEach(function (t) {
                t.disabled = e;
              });
            },
          },
          {
            key: "reset",
            value: function () {
              (this.checkbox.checked = !1), this.clearInputs();
            },
          },
          {
            key: "updateMaxHeight",
            value: function (e) {
              if (this.fields) {
                var t = e ? this.fields.scrollHeight : 0;
                this.fields.style.maxHeight = "".concat(t, "px");
              }
            },
          },
        ]),
        i
      );
    })(te),
    Ys = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setImagesAttributes();
            },
          },
        ]),
        i
      );
    })(xs),
    Us = Ys,
    Ks = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setImagesAttributes();
            },
          },
        ]),
        i
      );
    })(xs),
    Qs = Ks,
    Zs = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          ((e = t.call(this)).element =
            e.querySelector(".color-swatch") || x(e)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setValue();
            },
          },
          { key: "disconnectedCallback", value: function () {} },
          {
            key: "setValue",
            value: function () {
              var e = this;
              if (!this.hasAttribute("is-image")) {
                var t = this.dataset.color.toLowerCase().trim(),
                  i = this.dataset.colorsPatterns.split("\n");
                this.isColor(t) || this.element.setAttribute("not-valid", ""),
                  this.setPropertyValue(t),
                  i.forEach(function (i) {
                    var n = i.split("::"),
                      s = n[0],
                      a = n[1];
                    s.toLowerCase().trim() !== t || e.setPropertyValue(a);
                  });
              }
            },
          },
          {
            key: "getGradientValue",
            value: function (e) {
              var t = "90deg, ";
              return (
                e.forEach(function (i, n) {
                  var s = 100 / e.length,
                    a = "".concat(s * n, "%"),
                    r = "".concat(s * (n + 1), "%"),
                    o = ""
                      .concat(i, " ")
                      .concat(a, ", ")
                      .concat(i, " ")
                      .concat(r);
                  (t = "".concat(t, " ").concat(o)),
                    n !== e.length - 1 && (t = "".concat(t, ", "));
                }),
                "linear-gradient(".concat(t, ")")
              );
            },
          },
          {
            key: "setPropertyValue",
            value: function (e) {
              var t = this.isImage(e),
                i = this.isUrl(e),
                n = this.isGradient(e),
                s = this.isColor(e);
              if (i)
                this.element.removeAttribute("not-valid"),
                  this.element.style.setProperty(
                    "--gsc-color-swatch-value",
                    "url(".concat(e, ")")
                  );
              else if (t);
              else if (n) {
                var a = e.split("/"),
                  r = this.getGradientValue(a);
                this.element.removeAttribute("not-valid"),
                  this.element.style.setProperty("--gsc-color-swatch-value", r);
              } else
                s && this.element.removeAttribute("not-valid"),
                  this.element.style.setProperty("--gsc-color-swatch-value", e);
            },
          },
          {
            key: "isColor",
            value: function (e) {
              var t = new Option().style;
              return (t.color = e), "" !== t.color;
            },
          },
          {
            key: "isImage",
            value: function (e) {
              return e.includes(".png") || e.includes(".jp");
            },
          },
          {
            key: "isUrl",
            value: function (e) {
              return e.includes("http");
            },
          },
          {
            key: "isGradient",
            value: function (e) {
              return e.includes("/");
            },
          },
        ]),
        i
      );
    })(te),
    Js = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "handleMouseEnter", function () {
            var t = e.dataset.url,
              i = e.dataset.id;
            t && i && Hn.requestProductFromUrl(t, i);
          }),
          f(x(e), "handleQuickViewBtnClick", function () {
            var t = e.dataset.url;
            t && Hn.openAndRenderProductByUrl(t);
          }),
          (e.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e.quickViewBtn = e.querySelector(e.quickViewBtnSelector)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setImagesAttributes(),
                this.addEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
        ]),
        i
      );
    })(xs),
    ea = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        var e;
        return (
          d(this, i),
          f(x((e = t.call(this))), "handleMouseEnter", function () {
            var t = e.dataset.url,
              i = e.dataset.id;
            t && i && Hn.requestProductFromUrl(t, i);
          }),
          f(x(e), "handleQuickViewBtnClick", function () {
            var t = e.dataset.url;
            t && Hn.openAndRenderProductByUrl(t);
          }),
          (e.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e.quickViewBtn = e.querySelector(e.quickViewBtnSelector)),
          e
        );
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.setImagesAttributes(),
                this.addEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
        ]),
        i
      );
    })(xs),
    ta = (function (e) {
      "use strict";
      E(i, e);
      var t = L(i);
      function i() {
        return d(this, i), t.apply(this, arguments);
      }
      return (
        p(i, [
          {
            key: "connectedCallback",
            value: function () {
              this.loadProducts();
            },
          },
          {
            key: "loadProducts",
            value: function () {
              var e = this;
              fetch(this.dataset.url)
                .then(function (e) {
                  return e.text();
                })
                .then(function (t) {
                  var i = ge(t);
                  e._updateByHTML(i);
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show(
                      "Error in product recommendations component",
                      "warning"
                    );
                });
            },
          },
          {
            key: "_updateByHTML",
            value: function (e) {
              var t = e.querySelector("#".concat(this.id));
              t &&
                ((this.innerHTML = t.innerHTML),
                this.toggleAttribute("is-ready", this.hasChildNodes()));
            },
          },
        ]),
        i
      );
    })(te),
    ia = [
      { tag: "login-component", component: ie },
      { tag: "back-to-top-button", component: ne },
      { tag: "sticky-cart-button", component: se },
      { tag: "quantity-component", component: ae },
      { tag: "quantity-btn", component: re },
      { tag: "localization-selector", component: oe },
      { tag: "notification-component", component: le },
      { tag: "tabs-component", component: ye },
      { tag: "tab-component", component: Xs },
      { tag: "list-component", component: be },
      { tag: "list-btn", component: Se },
      { tag: "float-element", component: At },
      { tag: "float-element-btn", component: $t },
      { tag: "dropdown-opener", component: Ht },
      { tag: "tooltip-trigger", component: Vt },
      { tag: "accordeon-component", component: Rt },
      { tag: "accordeon-btn", component: Xt },
      { tag: "product-media-tabs", component: Gt },
      { tag: "color-swatches", component: Yt },
      { tag: "modal-component", component: Ut },
      { tag: "password-modal", component: Zt },
      { tag: "cart-notification-popup", component: ei },
      { tag: "modal-opener", component: ii },
      { tag: "password-modal-opener", component: si },
      { tag: "modal-close-btn", component: ri },
      { tag: "sidebar-button", component: oi },
      { tag: "sidebar-component", component: li },
      { tag: "search-sidebar", component: di },
      { tag: "quick-view", component: fi },
      { tag: "carousel-component", component: nn },
      { tag: "carousel-play-button", component: sn },
      { tag: "carousel-dots", component: mn },
      { tag: "carousel-dot", component: gn },
      { tag: "carousel-btn", component: bn },
      { tag: "carousel-progress", component: wn },
      { tag: "header-component", component: Sn },
      { tag: "drawer-menu", component: xn },
      { tag: "drawer-menu-page", component: Cn },
      { tag: "drawer-menu-page-link", component: En },
      { tag: "pagination-component", component: _n },
      { tag: "pagination-load-button", component: Ln },
      { tag: "pagination-link", component: In },
      { tag: "pagination-infinite-scroll", component: Dn },
      { tag: "deferred-media", component: An },
      { tag: "pickup-availability", component: On },
      { tag: "product-form", component: Fn },
      { tag: "product-form-button", component: Vn },
      { tag: "product-block", component: Rn },
      { tag: "product-model", component: Xn },
      { tag: "cart-item", component: Un },
      { tag: "cart-component", component: Kn },
      { tag: "sidebar-cart", component: Qn },
      { tag: "cart-free-shipping-bar", component: Jn },
      { tag: "product-media", component: ts },
      { tag: "product-media-carousel", component: ns },
      { tag: "variant-picker", component: as },
      { tag: "color-swatches-picker", component: rs },
      { tag: "product-modal", component: ls },
      { tag: "product-modal-image-wrap", component: cs },
      { tag: "product-modal-opener", component: ds },
      { tag: "product-recommendations", component: hs },
      { tag: "product-related-block", component: ta },
      { tag: "recently-viewed", component: hi },
      { tag: "search-sidebar-form-wrapper", component: vs },
      { tag: "cart-remove-button", component: gs },
      { tag: "clipboard-button", component: bs },
      { tag: "clipboard-button-tooltip", component: ws },
      { tag: "product-card", component: Cs },
      { tag: "horizontal-product-card", component: Js },
      { tag: "vertical-product-card", component: ea },
      { tag: "max-lines-component", component: ks },
      { tag: "country-selector", component: Es },
      { tag: "search-field", component: Ts },
      { tag: "password-field", component: _s },
      { tag: "zoom-cursor", component: Ms },
      { tag: "shop-component", component: Ls },
      { tag: "shop-active-filters", component: Ps },
      { tag: "sidebar-filters-desktop", component: As },
      { tag: "sidebar-filters-mobile", component: Os },
      { tag: "filter-remove-btn", component: Ns },
      { tag: "sort-list", component: qs },
      { tag: "price-range", component: $s },
      { tag: "column-switcher", component: Hs },
      { tag: "filters-submit-btn", component: Vs },
      { tag: "before-after-images", component: Rs },
      { tag: "product-information-drawer", component: js },
      { tag: "sidebar-filters-sticky-mobile-button", component: Gs },
      { tag: "recipient-form", component: Ws },
      { tag: "collection-card", component: Us },
      { tag: "article-card", component: Qs },
      { tag: "shape-swatch", component: Zs },
    ];
  (window.recentlyViewed = hi),
    ia.forEach(function (e) {
      var t = e.tag,
        i = e.component;
      customElements.define(t, i);
    }),
    (window.bodyElement = S),
    window.addEventListener("load", function () {
      !(function (e) {
        var t = (null == e ? void 0 : e.lazyClass) || "lazy",
          i = (null == e ? void 0 : e.lazyBackgroundClass) || "lazy-bg",
          n = (null == e ? void 0 : e.lazyBackgroundLoaded) || "lazy-bg-loaded",
          s = (null == e ? void 0 : e.threshold) || 200,
          l = (null == e ? void 0 : e.events) || {},
          c = (null == e ? void 0 : e.observeChanges) || !1,
          d = (null == e ? void 0 : e.observeRootSelector) || "body",
          h = (null == e ? void 0 : e.mutationObserverOptions) || {
            childList: !0,
            subtree: !0,
          },
          p = "video.".concat(t, ",.").concat(i),
          f = Array.from(document.querySelectorAll(p)),
          v = !0,
          m = !1,
          g = void 0;
        try {
          for (
            var y, b = f[Symbol.iterator]();
            !(v = (y = b.next()).done);
            v = !0
          )
            a(y.value, l);
        } catch (e) {
          (m = !0), (g = e);
        } finally {
          try {
            v || null == b.return || b.return();
          } finally {
            if (m) throw g;
          }
        }
        var w = !0,
          S = !1,
          x = void 0;
        if (!0 === r && !1 === o) {
          var C = new IntersectionObserver(
              function (e) {
                var s = !0,
                  a = !1,
                  r = void 0;
                try {
                  for (
                    var o,
                      l = function () {
                        var e = o.value;
                        if (e.isIntersecting || e.intersectionRatio) {
                          var s = e.target;
                          u(s, t, i, n),
                            C.unobserve(s),
                            (f = f.filter(function (e) {
                              return e != s;
                            })),
                            0 === f.length && !1 === c && C.disconnect();
                        }
                      },
                      d = e[Symbol.iterator]();
                    !(s = (o = d.next()).done);
                    s = !0
                  )
                    l();
                } catch (e) {
                  (a = !0), (r = e);
                } finally {
                  try {
                    s || null == d.return || d.return();
                  } finally {
                    if (a) throw r;
                  }
                }
              },
              { rootMargin: "".concat(s, "px 0%") }
            ),
            k = !0,
            E = !1,
            T = void 0;
          try {
            for (
              var _, M = f[Symbol.iterator]();
              !(k = (_ = M.next()).done);
              k = !0
            ) {
              var L = _.value;
              C.observe(L);
            }
          } catch (e) {
            (E = !0), (T = e);
          } finally {
            try {
              k || null == M.return || M.return();
            } finally {
              if (E) throw T;
            }
          }
          c &&
            new MutationObserver(function () {
              var e = document.querySelectorAll(p),
                t = !0,
                i = !1,
                n = void 0;
              try {
                for (
                  var s, c = e[Symbol.iterator]();
                  !(t = (s = c.next()).done);
                  t = !0
                ) {
                  var u = s.value;
                  !1 === f.includes(u) &&
                    (f.push(u), a(u, l), !0 === r && !1 === o && C.observe(u));
                }
              } catch (e) {
                (i = !0), (n = e);
              } finally {
                try {
                  t || null == c.return || c.return();
                } finally {
                  if (i) throw n;
                }
              }
            }).observe(document.querySelector(d), h);
        } else if (o)
          try {
            for (
              var P, I = f[Symbol.iterator]();
              !(w = (P = I.next()).done);
              w = !0
            )
              u(P.value, t, i, n);
          } catch (e) {
            (S = !0), (x = e);
          } finally {
            try {
              w || null == I.return || I.return();
            } finally {
              if (S) throw x;
            }
          }
      })({ lazyClass: "yall-video-lazy", threshold: 0, observeChanges: !0 });
    });
})(),
  (function (e, t) {
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = e.document
          ? t(e, !0)
          : function (e) {
              if (!e.document)
                throw new Error("jQuery requires a window with a document");
              return t(e);
            })
      : t(e);
  })("undefined" != typeof window ? window : this, function (e, t) {
    var i = [],
      n = i.slice,
      s = i.concat,
      a = i.push,
      r = i.indexOf,
      o = {},
      l = o.toString,
      c = o.hasOwnProperty,
      u = {},
      d = e.document,
      h = "2.1.3",
      p = function (e, t) {
        return new p.fn.init(e, t);
      },
      f = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      v = /^-ms-/,
      m = /-([\da-z])/gi,
      g = function (e, t) {
        return t.toUpperCase();
      };
    function y(e) {
      var t = e.length,
        i = p.type(e);
      return (
        "function" !== i &&
        !p.isWindow(e) &&
        (!(1 !== e.nodeType || !t) ||
          "array" === i ||
          0 === t ||
          ("number" == typeof t && t > 0 && t - 1 in e))
      );
    }
    (p.fn = p.prototype =
      {
        jquery: h,
        constructor: p,
        selector: "",
        length: 0,
        toArray: function () {
          return n.call(this);
        },
        get: function (e) {
          return null != e
            ? e < 0
              ? this[e + this.length]
              : this[e]
            : n.call(this);
        },
        pushStack: function (e) {
          var t = p.merge(this.constructor(), e);
          return (t.prevObject = this), (t.context = this.context), t;
        },
        each: function (e, t) {
          return p.each(this, e, t);
        },
        map: function (e) {
          return this.pushStack(
            p.map(this, function (t, i) {
              return e.call(t, i, t);
            })
          );
        },
        slice: function () {
          return this.pushStack(n.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        eq: function (e) {
          var t = this.length,
            i = +e + (e < 0 ? t : 0);
          return this.pushStack(i >= 0 && i < t ? [this[i]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor(null);
        },
        push: a,
        sort: i.sort,
        splice: i.splice,
      }),
      (p.extend = p.fn.extend =
        function () {
          var e,
            t,
            i,
            n,
            s,
            a,
            r = arguments[0] || {},
            o = 1,
            l = arguments.length,
            c = !1;
          for (
            "boolean" == typeof r && ((c = r), (r = arguments[o] || {}), o++),
              "object" == typeof r || p.isFunction(r) || (r = {}),
              o === l && ((r = this), o--);
            o < l;
            o++
          )
            if (null != (e = arguments[o]))
              for (t in e)
                (i = r[t]),
                  r !== (n = e[t]) &&
                    (c && n && (p.isPlainObject(n) || (s = p.isArray(n)))
                      ? (s
                          ? ((s = !1), (a = i && p.isArray(i) ? i : []))
                          : (a = i && p.isPlainObject(i) ? i : {}),
                        (r[t] = p.extend(c, a, n)))
                      : void 0 !== n && (r[t] = n));
          return r;
        }),
      p.extend({
        expando: "jQuery" + (h + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (e) {
          throw new Error(e);
        },
        noop: function () {},
        isFunction: function (e) {
          return "function" === p.type(e);
        },
        isArray: Array.isArray,
        isWindow: function (e) {
          return null != e && e === e.window;
        },
        isNumeric: function (e) {
          return !p.isArray(e) && e - parseFloat(e) + 1 >= 0;
        },
        isPlainObject: function (e) {
          return (
            "object" === p.type(e) &&
            !e.nodeType &&
            !p.isWindow(e) &&
            !(
              e.constructor && !c.call(e.constructor.prototype, "isPrototypeOf")
            )
          );
        },
        isEmptyObject: function (e) {
          var t;
          for (t in e) return !1;
          return !0;
        },
        type: function (e) {
          return null == e
            ? e + ""
            : "object" == typeof e || "function" == typeof e
            ? o[l.call(e)] || "object"
            : typeof e;
        },
        globalEval: function (e) {
          var t,
            i = eval;
          (e = p.trim(e)) &&
            (1 === e.indexOf("use strict")
              ? (((t = d.createElement("script")).text = e),
                d.head.appendChild(t).parentNode.removeChild(t))
              : i(e));
        },
        camelCase: function (e) {
          return e.replace(v, "ms-").replace(m, g);
        },
        nodeName: function (e, t) {
          return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        },
        each: function (e, t, i) {
          var n = 0,
            s = e.length,
            a = y(e);
          if (i) {
            if (a) for (; n < s && !1 !== t.apply(e[n], i); n++);
            else for (n in e) if (!1 === t.apply(e[n], i)) break;
          } else if (a) for (; n < s && !1 !== t.call(e[n], n, e[n]); n++);
          else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
          return e;
        },
        trim: function (e) {
          return null == e ? "" : (e + "").replace(f, "");
        },
        makeArray: function (e, t) {
          var i = t || [];
          return (
            null != e &&
              (y(Object(e))
                ? p.merge(i, "string" == typeof e ? [e] : e)
                : a.call(i, e)),
            i
          );
        },
        inArray: function (e, t, i) {
          return null == t ? -1 : r.call(t, e, i);
        },
        merge: function (e, t) {
          for (var i = +t.length, n = 0, s = e.length; n < i; n++)
            e[s++] = t[n];
          return (e.length = s), e;
        },
        grep: function (e, t, i) {
          for (var n = [], s = 0, a = e.length, r = !i; s < a; s++)
            !t(e[s], s) !== r && n.push(e[s]);
          return n;
        },
        map: function (e, t, i) {
          var n,
            a = 0,
            r = e.length,
            o = [];
          if (y(e)) for (; a < r; a++) null != (n = t(e[a], a, i)) && o.push(n);
          else for (a in e) null != (n = t(e[a], a, i)) && o.push(n);
          return s.apply([], o);
        },
        guid: 1,
        proxy: function (e, t) {
          var i, s, a;
          if (
            ("string" == typeof t && ((i = e[t]), (t = e), (e = i)),
            p.isFunction(e))
          )
            return (
              (s = n.call(arguments, 2)),
              (a = function () {
                return e.apply(t || this, s.concat(n.call(arguments)));
              }),
              (a.guid = e.guid = e.guid || p.guid++),
              a
            );
        },
        now: Date.now,
        support: u,
      }),
      p.each(
        "Boolean Number String Function Array Date RegExp Object Error".split(
          " "
        ),
        function (e, t) {
          o["[object " + t + "]"] = t.toLowerCase();
        }
      );
    var b = (function (e) {
      var t,
        i,
        n,
        s,
        a,
        r,
        o,
        l,
        c,
        u,
        d,
        h,
        p,
        f,
        v,
        m,
        g,
        y,
        b,
        w = "sizzle" + 1 * new Date(),
        S = e.document,
        x = 0,
        C = 0,
        k = re(),
        E = re(),
        T = re(),
        _ = function (e, t) {
          return e === t && (d = !0), 0;
        },
        M = 1 << 31,
        L = {}.hasOwnProperty,
        P = [],
        I = P.pop,
        D = P.push,
        A = P.push,
        z = P.slice,
        O = function (e, t) {
          for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
          return -1;
        },
        B =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        N = "[\\x20\\t\\r\\n\\f]",
        q = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        $ = q.replace("w", "w#"),
        H =
          "\\[" +
          N +
          "*(" +
          q +
          ")(?:" +
          N +
          "*([*^$|!~]?=)" +
          N +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          $ +
          "))|)" +
          N +
          "*\\]",
        F =
          ":(" +
          q +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          H +
          ")*)|.*)\\)|)",
        V = new RegExp(N + "+", "g"),
        R = new RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g"),
        j = new RegExp("^" + N + "*," + N + "*"),
        X = new RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"),
        G = new RegExp("=" + N + "*([^\\]'\"]*?)" + N + "*\\]", "g"),
        W = new RegExp(F),
        Y = new RegExp("^" + $ + "$"),
        U = {
          ID: new RegExp("^#(" + q + ")"),
          CLASS: new RegExp("^\\.(" + q + ")"),
          TAG: new RegExp("^(" + q.replace("w", "w*") + ")"),
          ATTR: new RegExp("^" + H),
          PSEUDO: new RegExp("^" + F),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              N +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              N +
              "*(?:([+-]|)" +
              N +
              "*(\\d+)|))" +
              N +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + B + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              N +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              N +
              "*((?:-\\d)?\\d*)" +
              N +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        K = /^(?:input|select|textarea|button)$/i,
        Q = /^h\d$/i,
        Z = /^[^{]+\{\s*\[native \w/,
        J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ee = /[+~]/,
        te = /'|\\/g,
        ie = new RegExp("\\\\([\\da-f]{1,6}" + N + "?|(" + N + ")|.)", "ig"),
        ne = function (e, t, i) {
          var n = "0x" + t - 65536;
          return n != n || i
            ? t
            : n < 0
            ? String.fromCharCode(n + 65536)
            : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320);
        },
        se = function () {
          h();
        };
      try {
        A.apply((P = z.call(S.childNodes)), S.childNodes),
          P[S.childNodes.length].nodeType;
      } catch (e) {
        A = {
          apply: P.length
            ? function (e, t) {
                D.apply(e, z.call(t));
              }
            : function (e, t) {
                for (var i = e.length, n = 0; (e[i++] = t[n++]); );
                e.length = i - 1;
              },
        };
      }
      function ae(e, t, n, s) {
        var a, o, c, u, d, f, g, y, x, C;
        if (
          ((t ? t.ownerDocument || t : S) !== p && h(t),
          (n = n || []),
          (u = (t = t || p).nodeType),
          "string" != typeof e || !e || (1 !== u && 9 !== u && 11 !== u))
        )
          return n;
        if (!s && v) {
          if (11 !== u && (a = J.exec(e)))
            if ((c = a[1])) {
              if (9 === u) {
                if (!(o = t.getElementById(c)) || !o.parentNode) return n;
                if (o.id === c) return n.push(o), n;
              } else if (
                t.ownerDocument &&
                (o = t.ownerDocument.getElementById(c)) &&
                b(t, o) &&
                o.id === c
              )
                return n.push(o), n;
            } else {
              if (a[2]) return A.apply(n, t.getElementsByTagName(e)), n;
              if ((c = a[3]) && i.getElementsByClassName)
                return A.apply(n, t.getElementsByClassName(c)), n;
            }
          if (i.qsa && (!m || !m.test(e))) {
            if (
              ((y = g = w),
              (x = t),
              (C = 1 !== u && e),
              1 === u && "object" !== t.nodeName.toLowerCase())
            ) {
              for (
                f = r(e),
                  (g = t.getAttribute("id"))
                    ? (y = g.replace(te, "\\$&"))
                    : t.setAttribute("id", y),
                  y = "[id='" + y + "'] ",
                  d = f.length;
                d--;

              )
                f[d] = y + me(f[d]);
              (x = (ee.test(e) && fe(t.parentNode)) || t), (C = f.join(","));
            }
            if (C)
              try {
                return A.apply(n, x.querySelectorAll(C)), n;
              } catch (e) {
              } finally {
                g || t.removeAttribute("id");
              }
          }
        }
        return l(e.replace(R, "$1"), t, n, s);
      }
      function re() {
        var e = [];
        return function t(i, s) {
          return (
            e.push(i + " ") > n.cacheLength && delete t[e.shift()],
            (t[i + " "] = s)
          );
        };
      }
      function oe(e) {
        return (e[w] = !0), e;
      }
      function le(e) {
        var t = p.createElement("div");
        try {
          return !!e(t);
        } catch (e) {
          return !1;
        } finally {
          t.parentNode && t.parentNode.removeChild(t), (t = null);
        }
      }
      function ce(e, t) {
        for (var i = e.split("|"), s = e.length; s--; ) n.attrHandle[i[s]] = t;
      }
      function ue(e, t) {
        var i = t && e,
          n =
            i &&
            1 === e.nodeType &&
            1 === t.nodeType &&
            (~t.sourceIndex || M) - (~e.sourceIndex || M);
        if (n) return n;
        if (i) for (; (i = i.nextSibling); ) if (i === t) return -1;
        return e ? 1 : -1;
      }
      function de(e) {
        return function (t) {
          return "input" === t.nodeName.toLowerCase() && t.type === e;
        };
      }
      function he(e) {
        return function (t) {
          var i = t.nodeName.toLowerCase();
          return ("input" === i || "button" === i) && t.type === e;
        };
      }
      function pe(e) {
        return oe(function (t) {
          return (
            (t = +t),
            oe(function (i, n) {
              for (var s, a = e([], i.length, t), r = a.length; r--; )
                i[(s = a[r])] && (i[s] = !(n[s] = i[s]));
            })
          );
        });
      }
      function fe(e) {
        return e && void 0 !== e.getElementsByTagName && e;
      }
      for (t in ((i = ae.support = {}),
      (a = ae.isXML =
        function (e) {
          var t = e && (e.ownerDocument || e).documentElement;
          return !!t && "HTML" !== t.nodeName;
        }),
      (h = ae.setDocument =
        function (e) {
          var t,
            s,
            r = e ? e.ownerDocument || e : S;
          return r !== p && 9 === r.nodeType && r.documentElement
            ? ((p = r),
              (f = r.documentElement),
              (s = r.defaultView) &&
                s !== s.top &&
                (s.addEventListener
                  ? s.addEventListener("unload", se, !1)
                  : s.attachEvent && s.attachEvent("onunload", se)),
              (v = !a(r)),
              (i.attributes = le(function (e) {
                return (e.className = "i"), !e.getAttribute("className");
              })),
              (i.getElementsByTagName = le(function (e) {
                return (
                  e.appendChild(r.createComment("")),
                  !e.getElementsByTagName("*").length
                );
              })),
              (i.getElementsByClassName = Z.test(r.getElementsByClassName)),
              (i.getById = le(function (e) {
                return (
                  (f.appendChild(e).id = w),
                  !r.getElementsByName || !r.getElementsByName(w).length
                );
              })),
              i.getById
                ? ((n.find.ID = function (e, t) {
                    if (void 0 !== t.getElementById && v) {
                      var i = t.getElementById(e);
                      return i && i.parentNode ? [i] : [];
                    }
                  }),
                  (n.filter.ID = function (e) {
                    var t = e.replace(ie, ne);
                    return function (e) {
                      return e.getAttribute("id") === t;
                    };
                  }))
                : (delete n.find.ID,
                  (n.filter.ID = function (e) {
                    var t = e.replace(ie, ne);
                    return function (e) {
                      var i =
                        void 0 !== e.getAttributeNode &&
                        e.getAttributeNode("id");
                      return i && i.value === t;
                    };
                  })),
              (n.find.TAG = i.getElementsByTagName
                ? function (e, t) {
                    return void 0 !== t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : i.qsa
                      ? t.querySelectorAll(e)
                      : void 0;
                  }
                : function (e, t) {
                    var i,
                      n = [],
                      s = 0,
                      a = t.getElementsByTagName(e);
                    if ("*" === e) {
                      for (; (i = a[s++]); ) 1 === i.nodeType && n.push(i);
                      return n;
                    }
                    return a;
                  }),
              (n.find.CLASS =
                i.getElementsByClassName &&
                function (e, t) {
                  if (v) return t.getElementsByClassName(e);
                }),
              (g = []),
              (m = []),
              (i.qsa = Z.test(r.querySelectorAll)) &&
                (le(function (e) {
                  (f.appendChild(e).innerHTML =
                    "<a id='" +
                    w +
                    "'></a><select id='" +
                    w +
                    "-\f]' msallowcapture=''><option selected=''></option></select>"),
                    e.querySelectorAll("[msallowcapture^='']").length &&
                      m.push("[*^$]=" + N + "*(?:''|\"\")"),
                    e.querySelectorAll("[selected]").length ||
                      m.push("\\[" + N + "*(?:value|" + B + ")"),
                    e.querySelectorAll("[id~=" + w + "-]").length ||
                      m.push("~="),
                    e.querySelectorAll(":checked").length || m.push(":checked"),
                    e.querySelectorAll("a#" + w + "+*").length ||
                      m.push(".#.+[+~]");
                }),
                le(function (e) {
                  var t = r.createElement("input");
                  t.setAttribute("type", "hidden"),
                    e.appendChild(t).setAttribute("name", "D"),
                    e.querySelectorAll("[name=d]").length &&
                      m.push("name" + N + "*[*^$|!~]?="),
                    e.querySelectorAll(":enabled").length ||
                      m.push(":enabled", ":disabled"),
                    e.querySelectorAll("*,:x"),
                    m.push(",.*:");
                })),
              (i.matchesSelector = Z.test(
                (y =
                  f.matches ||
                  f.webkitMatchesSelector ||
                  f.mozMatchesSelector ||
                  f.oMatchesSelector ||
                  f.msMatchesSelector)
              )) &&
                le(function (e) {
                  (i.disconnectedMatch = y.call(e, "div")),
                    y.call(e, "[s!='']:x"),
                    g.push("!=", F);
                }),
              (m = m.length && new RegExp(m.join("|"))),
              (g = g.length && new RegExp(g.join("|"))),
              (t = Z.test(f.compareDocumentPosition)),
              (b =
                t || Z.test(f.contains)
                  ? function (e, t) {
                      var i = 9 === e.nodeType ? e.documentElement : e,
                        n = t && t.parentNode;
                      return (
                        e === n ||
                        !(
                          !n ||
                          1 !== n.nodeType ||
                          !(i.contains
                            ? i.contains(n)
                            : e.compareDocumentPosition &&
                              16 & e.compareDocumentPosition(n))
                        )
                      );
                    }
                  : function (e, t) {
                      if (t)
                        for (; (t = t.parentNode); ) if (t === e) return !0;
                      return !1;
                    }),
              (_ = t
                ? function (e, t) {
                    if (e === t) return (d = !0), 0;
                    var n =
                      !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return (
                      n ||
                      (1 &
                        (n =
                          (e.ownerDocument || e) === (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1) ||
                      (!i.sortDetached && t.compareDocumentPosition(e) === n)
                        ? e === r || (e.ownerDocument === S && b(S, e))
                          ? -1
                          : t === r || (t.ownerDocument === S && b(S, t))
                          ? 1
                          : u
                          ? O(u, e) - O(u, t)
                          : 0
                        : 4 & n
                        ? -1
                        : 1)
                    );
                  }
                : function (e, t) {
                    if (e === t) return (d = !0), 0;
                    var i,
                      n = 0,
                      s = e.parentNode,
                      a = t.parentNode,
                      o = [e],
                      l = [t];
                    if (!s || !a)
                      return e === r
                        ? -1
                        : t === r
                        ? 1
                        : s
                        ? -1
                        : a
                        ? 1
                        : u
                        ? O(u, e) - O(u, t)
                        : 0;
                    if (s === a) return ue(e, t);
                    for (i = e; (i = i.parentNode); ) o.unshift(i);
                    for (i = t; (i = i.parentNode); ) l.unshift(i);
                    for (; o[n] === l[n]; ) n++;
                    return n
                      ? ue(o[n], l[n])
                      : o[n] === S
                      ? -1
                      : l[n] === S
                      ? 1
                      : 0;
                  }),
              r)
            : p;
        }),
      (ae.matches = function (e, t) {
        return ae(e, null, null, t);
      }),
      (ae.matchesSelector = function (e, t) {
        if (
          ((e.ownerDocument || e) !== p && h(e),
          (t = t.replace(G, "='$1']")),
          i.matchesSelector && v && (!g || !g.test(t)) && (!m || !m.test(t)))
        )
          try {
            var n = y.call(e, t);
            if (
              n ||
              i.disconnectedMatch ||
              (e.document && 11 !== e.document.nodeType)
            )
              return n;
          } catch (e) {}
        return ae(t, p, null, [e]).length > 0;
      }),
      (ae.contains = function (e, t) {
        return (e.ownerDocument || e) !== p && h(e), b(e, t);
      }),
      (ae.attr = function (e, t) {
        (e.ownerDocument || e) !== p && h(e);
        var s = n.attrHandle[t.toLowerCase()],
          a = s && L.call(n.attrHandle, t.toLowerCase()) ? s(e, t, !v) : void 0;
        return void 0 !== a
          ? a
          : i.attributes || !v
          ? e.getAttribute(t)
          : (a = e.getAttributeNode(t)) && a.specified
          ? a.value
          : null;
      }),
      (ae.error = function (e) {
        throw new Error("Syntax error, unrecognized expression: " + e);
      }),
      (ae.uniqueSort = function (e) {
        var t,
          n = [],
          s = 0,
          a = 0;
        if (
          ((d = !i.detectDuplicates),
          (u = !i.sortStable && e.slice(0)),
          e.sort(_),
          d)
        ) {
          for (; (t = e[a++]); ) t === e[a] && (s = n.push(a));
          for (; s--; ) e.splice(n[s], 1);
        }
        return (u = null), e;
      }),
      (s = ae.getText =
        function (e) {
          var t,
            i = "",
            n = 0,
            a = e.nodeType;
          if (a) {
            if (1 === a || 9 === a || 11 === a) {
              if ("string" == typeof e.textContent) return e.textContent;
              for (e = e.firstChild; e; e = e.nextSibling) i += s(e);
            } else if (3 === a || 4 === a) return e.nodeValue;
          } else for (; (t = e[n++]); ) i += s(t);
          return i;
        }),
      (n = ae.selectors =
        {
          cacheLength: 50,
          createPseudo: oe,
          match: U,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (e) {
              return (
                (e[1] = e[1].replace(ie, ne)),
                (e[3] = (e[3] || e[4] || e[5] || "").replace(ie, ne)),
                "~=" === e[2] && (e[3] = " " + e[3] + " "),
                e.slice(0, 4)
              );
            },
            CHILD: function (e) {
              return (
                (e[1] = e[1].toLowerCase()),
                "nth" === e[1].slice(0, 3)
                  ? (e[3] || ae.error(e[0]),
                    (e[4] = +(e[4]
                      ? e[5] + (e[6] || 1)
                      : 2 * ("even" === e[3] || "odd" === e[3]))),
                    (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                  : e[3] && ae.error(e[0]),
                e
              );
            },
            PSEUDO: function (e) {
              var t,
                i = !e[6] && e[2];
              return U.CHILD.test(e[0])
                ? null
                : (e[3]
                    ? (e[2] = e[4] || e[5] || "")
                    : i &&
                      W.test(i) &&
                      (t = r(i, !0)) &&
                      (t = i.indexOf(")", i.length - t) - i.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))),
                  e.slice(0, 3));
            },
          },
          filter: {
            TAG: function (e) {
              var t = e.replace(ie, ne).toLowerCase();
              return "*" === e
                ? function () {
                    return !0;
                  }
                : function (e) {
                    return e.nodeName && e.nodeName.toLowerCase() === t;
                  };
            },
            CLASS: function (e) {
              var t = k[e + " "];
              return (
                t ||
                ((t = new RegExp("(^|" + N + ")" + e + "(" + N + "|$)")) &&
                  k(e, function (e) {
                    return t.test(
                      ("string" == typeof e.className && e.className) ||
                        (void 0 !== e.getAttribute &&
                          e.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (e, t, i) {
              return function (n) {
                var s = ae.attr(n, e);
                return null == s
                  ? "!=" === t
                  : !t ||
                      ((s += ""),
                      "=" === t
                        ? s === i
                        : "!=" === t
                        ? s !== i
                        : "^=" === t
                        ? i && 0 === s.indexOf(i)
                        : "*=" === t
                        ? i && s.indexOf(i) > -1
                        : "$=" === t
                        ? i && s.slice(-i.length) === i
                        : "~=" === t
                        ? (" " + s.replace(V, " ") + " ").indexOf(i) > -1
                        : "|=" === t &&
                          (s === i || s.slice(0, i.length + 1) === i + "-"));
              };
            },
            CHILD: function (e, t, i, n, s) {
              var a = "nth" !== e.slice(0, 3),
                r = "last" !== e.slice(-4),
                o = "of-type" === t;
              return 1 === n && 0 === s
                ? function (e) {
                    return !!e.parentNode;
                  }
                : function (t, i, l) {
                    var c,
                      u,
                      d,
                      h,
                      p,
                      f,
                      v = a !== r ? "nextSibling" : "previousSibling",
                      m = t.parentNode,
                      g = o && t.nodeName.toLowerCase(),
                      y = !l && !o;
                    if (m) {
                      if (a) {
                        for (; v; ) {
                          for (d = t; (d = d[v]); )
                            if (
                              o
                                ? d.nodeName.toLowerCase() === g
                                : 1 === d.nodeType
                            )
                              return !1;
                          f = v = "only" === e && !f && "nextSibling";
                        }
                        return !0;
                      }
                      if (((f = [r ? m.firstChild : m.lastChild]), r && y)) {
                        for (
                          p =
                            (c = (u = m[w] || (m[w] = {}))[e] || [])[0] === x &&
                            c[1],
                            h = c[0] === x && c[2],
                            d = p && m.childNodes[p];
                          (d = (++p && d && d[v]) || (h = p = 0) || f.pop());

                        )
                          if (1 === d.nodeType && ++h && d === t) {
                            u[e] = [x, p, h];
                            break;
                          }
                      } else if (
                        y &&
                        (c = (t[w] || (t[w] = {}))[e]) &&
                        c[0] === x
                      )
                        h = c[1];
                      else
                        for (
                          ;
                          (d = (++p && d && d[v]) || (h = p = 0) || f.pop()) &&
                          ((o
                            ? d.nodeName.toLowerCase() !== g
                            : 1 !== d.nodeType) ||
                            !++h ||
                            (y && ((d[w] || (d[w] = {}))[e] = [x, h]),
                            d !== t));

                        );
                      return (h -= s) === n || (h % n == 0 && h / n >= 0);
                    }
                  };
            },
            PSEUDO: function (e, t) {
              var i,
                s =
                  n.pseudos[e] ||
                  n.setFilters[e.toLowerCase()] ||
                  ae.error("unsupported pseudo: " + e);
              return s[w]
                ? s(t)
                : s.length > 1
                ? ((i = [e, e, "", t]),
                  n.setFilters.hasOwnProperty(e.toLowerCase())
                    ? oe(function (e, i) {
                        for (var n, a = s(e, t), r = a.length; r--; )
                          e[(n = O(e, a[r]))] = !(i[n] = a[r]);
                      })
                    : function (e) {
                        return s(e, 0, i);
                      })
                : s;
            },
          },
          pseudos: {
            not: oe(function (e) {
              var t = [],
                i = [],
                n = o(e.replace(R, "$1"));
              return n[w]
                ? oe(function (e, t, i, s) {
                    for (var a, r = n(e, null, s, []), o = e.length; o--; )
                      (a = r[o]) && (e[o] = !(t[o] = a));
                  })
                : function (e, s, a) {
                    return (
                      (t[0] = e), n(t, null, a, i), (t[0] = null), !i.pop()
                    );
                  };
            }),
            has: oe(function (e) {
              return function (t) {
                return ae(e, t).length > 0;
              };
            }),
            contains: oe(function (e) {
              return (
                (e = e.replace(ie, ne)),
                function (t) {
                  return (t.textContent || t.innerText || s(t)).indexOf(e) > -1;
                }
              );
            }),
            lang: oe(function (e) {
              return (
                Y.test(e || "") || ae.error("unsupported lang: " + e),
                (e = e.replace(ie, ne).toLowerCase()),
                function (t) {
                  var i;
                  do {
                    if (
                      (i = v
                        ? t.lang
                        : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                    )
                      return (
                        (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-")
                      );
                  } while ((t = t.parentNode) && 1 === t.nodeType);
                  return !1;
                }
              );
            }),
            target: function (t) {
              var i = e.location && e.location.hash;
              return i && i.slice(1) === t.id;
            },
            root: function (e) {
              return e === f;
            },
            focus: function (e) {
              return (
                e === p.activeElement &&
                (!p.hasFocus || p.hasFocus()) &&
                !!(e.type || e.href || ~e.tabIndex)
              );
            },
            enabled: function (e) {
              return !1 === e.disabled;
            },
            disabled: function (e) {
              return !0 === e.disabled;
            },
            checked: function (e) {
              var t = e.nodeName.toLowerCase();
              return (
                ("input" === t && !!e.checked) ||
                ("option" === t && !!e.selected)
              );
            },
            selected: function (e) {
              return (
                e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
              );
            },
            empty: function (e) {
              for (e = e.firstChild; e; e = e.nextSibling)
                if (e.nodeType < 6) return !1;
              return !0;
            },
            parent: function (e) {
              return !n.pseudos.empty(e);
            },
            header: function (e) {
              return Q.test(e.nodeName);
            },
            input: function (e) {
              return K.test(e.nodeName);
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase();
              return ("input" === t && "button" === e.type) || "button" === t;
            },
            text: function (e) {
              var t;
              return (
                "input" === e.nodeName.toLowerCase() &&
                "text" === e.type &&
                (null == (t = e.getAttribute("type")) ||
                  "text" === t.toLowerCase())
              );
            },
            first: pe(function () {
              return [0];
            }),
            last: pe(function (e, t) {
              return [t - 1];
            }),
            eq: pe(function (e, t, i) {
              return [i < 0 ? i + t : i];
            }),
            even: pe(function (e, t) {
              for (var i = 0; i < t; i += 2) e.push(i);
              return e;
            }),
            odd: pe(function (e, t) {
              for (var i = 1; i < t; i += 2) e.push(i);
              return e;
            }),
            lt: pe(function (e, t, i) {
              for (var n = i < 0 ? i + t : i; --n >= 0; ) e.push(n);
              return e;
            }),
            gt: pe(function (e, t, i) {
              for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
              return e;
            }),
          },
        }),
      (n.pseudos.nth = n.pseudos.eq),
      { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
        n.pseudos[t] = de(t);
      for (t in { submit: !0, reset: !0 }) n.pseudos[t] = he(t);
      function ve() {}
      function me(e) {
        for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
        return n;
      }
      function ge(e, t, i) {
        var n = t.dir,
          s = i && "parentNode" === n,
          a = C++;
        return t.first
          ? function (t, i, a) {
              for (; (t = t[n]); ) if (1 === t.nodeType || s) return e(t, i, a);
            }
          : function (t, i, r) {
              var o,
                l,
                c = [x, a];
              if (r) {
                for (; (t = t[n]); )
                  if ((1 === t.nodeType || s) && e(t, i, r)) return !0;
              } else
                for (; (t = t[n]); )
                  if (1 === t.nodeType || s) {
                    if (
                      (o = (l = t[w] || (t[w] = {}))[n]) &&
                      o[0] === x &&
                      o[1] === a
                    )
                      return (c[2] = o[2]);
                    if (((l[n] = c), (c[2] = e(t, i, r)))) return !0;
                  }
            };
      }
      function ye(e) {
        return e.length > 1
          ? function (t, i, n) {
              for (var s = e.length; s--; ) if (!e[s](t, i, n)) return !1;
              return !0;
            }
          : e[0];
      }
      function be(e, t, i, n, s) {
        for (var a, r = [], o = 0, l = e.length, c = null != t; o < l; o++)
          (a = e[o]) && ((i && !i(a, n, s)) || (r.push(a), c && t.push(o)));
        return r;
      }
      function we(e, t, i, n, s, a) {
        return (
          n && !n[w] && (n = we(n)),
          s && !s[w] && (s = we(s, a)),
          oe(function (a, r, o, l) {
            var c,
              u,
              d,
              h = [],
              p = [],
              f = r.length,
              v =
                a ||
                (function (e, t, i) {
                  for (var n = 0, s = t.length; n < s; n++) ae(e, t[n], i);
                  return i;
                })(t || "*", o.nodeType ? [o] : o, []),
              m = !e || (!a && t) ? v : be(v, h, e, o, l),
              g = i ? (s || (a ? e : f || n) ? [] : r) : m;
            if ((i && i(m, g, o, l), n))
              for (c = be(g, p), n(c, [], o, l), u = c.length; u--; )
                (d = c[u]) && (g[p[u]] = !(m[p[u]] = d));
            if (a) {
              if (s || e) {
                if (s) {
                  for (c = [], u = g.length; u--; )
                    (d = g[u]) && c.push((m[u] = d));
                  s(null, (g = []), c, l);
                }
                for (u = g.length; u--; )
                  (d = g[u]) &&
                    (c = s ? O(a, d) : h[u]) > -1 &&
                    (a[c] = !(r[c] = d));
              }
            } else (g = be(g === r ? g.splice(f, g.length) : g)), s ? s(null, r, g, l) : A.apply(r, g);
          })
        );
      }
      function Se(e) {
        for (
          var t,
            i,
            s,
            a = e.length,
            r = n.relative[e[0].type],
            o = r || n.relative[" "],
            l = r ? 1 : 0,
            u = ge(
              function (e) {
                return e === t;
              },
              o,
              !0
            ),
            d = ge(
              function (e) {
                return O(t, e) > -1;
              },
              o,
              !0
            ),
            h = [
              function (e, i, n) {
                var s =
                  (!r && (n || i !== c)) ||
                  ((t = i).nodeType ? u(e, i, n) : d(e, i, n));
                return (t = null), s;
              },
            ];
          l < a;
          l++
        )
          if ((i = n.relative[e[l].type])) h = [ge(ye(h), i)];
          else {
            if ((i = n.filter[e[l].type].apply(null, e[l].matches))[w]) {
              for (s = ++l; s < a && !n.relative[e[s].type]; s++);
              return we(
                l > 1 && ye(h),
                l > 1 &&
                  me(
                    e
                      .slice(0, l - 1)
                      .concat({ value: " " === e[l - 2].type ? "*" : "" })
                  ).replace(R, "$1"),
                i,
                l < s && Se(e.slice(l, s)),
                s < a && Se((e = e.slice(s))),
                s < a && me(e)
              );
            }
            h.push(i);
          }
        return ye(h);
      }
      return (
        (ve.prototype = n.filters = n.pseudos),
        (n.setFilters = new ve()),
        (r = ae.tokenize =
          function (e, t) {
            var i,
              s,
              a,
              r,
              o,
              l,
              c,
              u = E[e + " "];
            if (u) return t ? 0 : u.slice(0);
            for (o = e, l = [], c = n.preFilter; o; ) {
              for (r in ((i && !(s = j.exec(o))) ||
                (s && (o = o.slice(s[0].length) || o), l.push((a = []))),
              (i = !1),
              (s = X.exec(o)) &&
                ((i = s.shift()),
                a.push({ value: i, type: s[0].replace(R, " ") }),
                (o = o.slice(i.length))),
              n.filter))
                !(s = U[r].exec(o)) ||
                  (c[r] && !(s = c[r](s))) ||
                  ((i = s.shift()),
                  a.push({ value: i, type: r, matches: s }),
                  (o = o.slice(i.length)));
              if (!i) break;
            }
            return t ? o.length : o ? ae.error(e) : E(e, l).slice(0);
          }),
        (o = ae.compile =
          function (e, t) {
            var i,
              s = [],
              a = [],
              o = T[e + " "];
            if (!o) {
              for (t || (t = r(e)), i = t.length; i--; )
                (o = Se(t[i]))[w] ? s.push(o) : a.push(o);
              (o = T(
                e,
                (function (e, t) {
                  var i = t.length > 0,
                    s = e.length > 0,
                    a = function (a, r, o, l, u) {
                      var d,
                        h,
                        f,
                        v = 0,
                        m = "0",
                        g = a && [],
                        y = [],
                        b = c,
                        w = a || (s && n.find.TAG("*", u)),
                        S = (x += null == b ? 1 : Math.random() || 0.1),
                        C = w.length;
                      for (
                        u && (c = r !== p && r);
                        m !== C && null != (d = w[m]);
                        m++
                      ) {
                        if (s && d) {
                          for (h = 0; (f = e[h++]); )
                            if (f(d, r, o)) {
                              l.push(d);
                              break;
                            }
                          u && (x = S);
                        }
                        i && ((d = !f && d) && v--, a && g.push(d));
                      }
                      if (((v += m), i && m !== v)) {
                        for (h = 0; (f = t[h++]); ) f(g, y, r, o);
                        if (a) {
                          if (v > 0)
                            for (; m--; ) g[m] || y[m] || (y[m] = I.call(l));
                          y = be(y);
                        }
                        A.apply(l, y),
                          u &&
                            !a &&
                            y.length > 0 &&
                            v + t.length > 1 &&
                            ae.uniqueSort(l);
                      }
                      return u && ((x = S), (c = b)), g;
                    };
                  return i ? oe(a) : a;
                })(a, s)
              )),
                (o.selector = e);
            }
            return o;
          }),
        (l = ae.select =
          function (e, t, s, a) {
            var l,
              c,
              u,
              d,
              h,
              p = "function" == typeof e && e,
              f = !a && r((e = p.selector || e));
            if (((s = s || []), 1 === f.length)) {
              if (
                (c = f[0] = f[0].slice(0)).length > 2 &&
                "ID" === (u = c[0]).type &&
                i.getById &&
                9 === t.nodeType &&
                v &&
                n.relative[c[1].type]
              ) {
                if (
                  !(t = (n.find.ID(u.matches[0].replace(ie, ne), t) || [])[0])
                )
                  return s;
                p && (t = t.parentNode), (e = e.slice(c.shift().value.length));
              }
              for (
                l = U.needsContext.test(e) ? 0 : c.length;
                l-- && ((u = c[l]), !n.relative[(d = u.type)]);

              )
                if (
                  (h = n.find[d]) &&
                  (a = h(
                    u.matches[0].replace(ie, ne),
                    (ee.test(c[0].type) && fe(t.parentNode)) || t
                  ))
                ) {
                  if ((c.splice(l, 1), !(e = a.length && me(c))))
                    return A.apply(s, a), s;
                  break;
                }
            }
            return (
              (p || o(e, f))(
                a,
                t,
                !v,
                s,
                (ee.test(e) && fe(t.parentNode)) || t
              ),
              s
            );
          }),
        (i.sortStable = w.split("").sort(_).join("") === w),
        (i.detectDuplicates = !!d),
        h(),
        (i.sortDetached = le(function (e) {
          return 1 & e.compareDocumentPosition(p.createElement("div"));
        })),
        le(function (e) {
          return (
            (e.innerHTML = "<a href='#'></a>"),
            "#" === e.firstChild.getAttribute("href")
          );
        }) ||
          ce("type|href|height|width", function (e, t, i) {
            if (!i)
              return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
          }),
        (i.attributes &&
          le(function (e) {
            return (
              (e.innerHTML = "<input/>"),
              e.firstChild.setAttribute("value", ""),
              "" === e.firstChild.getAttribute("value")
            );
          })) ||
          ce("value", function (e, t, i) {
            if (!i && "input" === e.nodeName.toLowerCase())
              return e.defaultValue;
          }),
        le(function (e) {
          return null == e.getAttribute("disabled");
        }) ||
          ce(B, function (e, t, i) {
            var n;
            if (!i)
              return !0 === e[t]
                ? t.toLowerCase()
                : (n = e.getAttributeNode(t)) && n.specified
                ? n.value
                : null;
          }),
        ae
      );
    })(e);
    (p.find = b),
      (p.expr = b.selectors),
      (p.expr[":"] = p.expr.pseudos),
      (p.unique = b.uniqueSort),
      (p.text = b.getText),
      (p.isXMLDoc = b.isXML),
      (p.contains = b.contains);
    var w = p.expr.match.needsContext,
      S = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      x = /^.[^:#\[\.,]*$/;
    function C(e, t, i) {
      if (p.isFunction(t))
        return p.grep(e, function (e, n) {
          return !!t.call(e, n, e) !== i;
        });
      if (t.nodeType)
        return p.grep(e, function (e) {
          return (e === t) !== i;
        });
      if ("string" == typeof t) {
        if (x.test(t)) return p.filter(t, e, i);
        t = p.filter(t, e);
      }
      return p.grep(e, function (e) {
        return r.call(t, e) >= 0 !== i;
      });
    }
    (p.filter = function (e, t, i) {
      var n = t[0];
      return (
        i && (e = ":not(" + e + ")"),
        1 === t.length && 1 === n.nodeType
          ? p.find.matchesSelector(n, e)
            ? [n]
            : []
          : p.find.matches(
              e,
              p.grep(t, function (e) {
                return 1 === e.nodeType;
              })
            )
      );
    }),
      p.fn.extend({
        find: function (e) {
          var t,
            i = this.length,
            n = [],
            s = this;
          if ("string" != typeof e)
            return this.pushStack(
              p(e).filter(function () {
                for (t = 0; t < i; t++) if (p.contains(s[t], this)) return !0;
              })
            );
          for (t = 0; t < i; t++) p.find(e, s[t], n);
          return (
            ((n = this.pushStack(i > 1 ? p.unique(n) : n)).selector = this
              .selector
              ? this.selector + " " + e
              : e),
            n
          );
        },
        filter: function (e) {
          return this.pushStack(C(this, e || [], !1));
        },
        not: function (e) {
          return this.pushStack(C(this, e || [], !0));
        },
        is: function (e) {
          return !!C(
            this,
            "string" == typeof e && w.test(e) ? p(e) : e || [],
            !1
          ).length;
        },
      });
    var k,
      E = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    ((p.fn.init = function (e, t) {
      var i, n;
      if (!e) return this;
      if ("string" == typeof e) {
        if (
          !(i =
            "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
              ? [null, e, null]
              : E.exec(e)) ||
          (!i[1] && t)
        )
          return !t || t.jquery
            ? (t || k).find(e)
            : this.constructor(t).find(e);
        if (i[1]) {
          if (
            ((t = t instanceof p ? t[0] : t),
            p.merge(
              this,
              p.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : d, !0)
            ),
            S.test(i[1]) && p.isPlainObject(t))
          )
            for (i in t)
              p.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
          return this;
        }
        return (
          (n = d.getElementById(i[2])) &&
            n.parentNode &&
            ((this.length = 1), (this[0] = n)),
          (this.context = d),
          (this.selector = e),
          this
        );
      }
      return e.nodeType
        ? ((this.context = this[0] = e), (this.length = 1), this)
        : p.isFunction(e)
        ? void 0 !== k.ready
          ? k.ready(e)
          : e(p)
        : (void 0 !== e.selector &&
            ((this.selector = e.selector), (this.context = e.context)),
          p.makeArray(e, this));
    }).prototype = p.fn),
      (k = p(d));
    var T = /^(?:parents|prev(?:Until|All))/,
      _ = { children: !0, contents: !0, next: !0, prev: !0 };
    function M(e, t) {
      for (; (e = e[t]) && 1 !== e.nodeType; );
      return e;
    }
    p.extend({
      dir: function (e, t, i) {
        for (var n = [], s = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
          if (1 === e.nodeType) {
            if (s && p(e).is(i)) break;
            n.push(e);
          }
        return n;
      },
      sibling: function (e, t) {
        for (var i = []; e; e = e.nextSibling)
          1 === e.nodeType && e !== t && i.push(e);
        return i;
      },
    }),
      p.fn.extend({
        has: function (e) {
          var t = p(e, this),
            i = t.length;
          return this.filter(function () {
            for (var e = 0; e < i; e++) if (p.contains(this, t[e])) return !0;
          });
        },
        closest: function (e, t) {
          for (
            var i,
              n = 0,
              s = this.length,
              a = [],
              r =
                w.test(e) || "string" != typeof e ? p(e, t || this.context) : 0;
            n < s;
            n++
          )
            for (i = this[n]; i && i !== t; i = i.parentNode)
              if (
                i.nodeType < 11 &&
                (r
                  ? r.index(i) > -1
                  : 1 === i.nodeType && p.find.matchesSelector(i, e))
              ) {
                a.push(i);
                break;
              }
          return this.pushStack(a.length > 1 ? p.unique(a) : a);
        },
        index: function (e) {
          return e
            ? "string" == typeof e
              ? r.call(p(e), this[0])
              : r.call(this, e.jquery ? e[0] : e)
            : this[0] && this[0].parentNode
            ? this.first().prevAll().length
            : -1;
        },
        add: function (e, t) {
          return this.pushStack(p.unique(p.merge(this.get(), p(e, t))));
        },
        addBack: function (e) {
          return this.add(
            null == e ? this.prevObject : this.prevObject.filter(e)
          );
        },
      }),
      p.each(
        {
          parent: function (e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null;
          },
          parents: function (e) {
            return p.dir(e, "parentNode");
          },
          parentsUntil: function (e, t, i) {
            return p.dir(e, "parentNode", i);
          },
          next: function (e) {
            return M(e, "nextSibling");
          },
          prev: function (e) {
            return M(e, "previousSibling");
          },
          nextAll: function (e) {
            return p.dir(e, "nextSibling");
          },
          prevAll: function (e) {
            return p.dir(e, "previousSibling");
          },
          nextUntil: function (e, t, i) {
            return p.dir(e, "nextSibling", i);
          },
          prevUntil: function (e, t, i) {
            return p.dir(e, "previousSibling", i);
          },
          siblings: function (e) {
            return p.sibling((e.parentNode || {}).firstChild, e);
          },
          children: function (e) {
            return p.sibling(e.firstChild);
          },
          contents: function (e) {
            return e.contentDocument || p.merge([], e.childNodes);
          },
        },
        function (e, t) {
          p.fn[e] = function (i, n) {
            var s = p.map(this, t, i);
            return (
              "Until" !== e.slice(-5) && (n = i),
              n && "string" == typeof n && (s = p.filter(n, s)),
              this.length > 1 &&
                (_[e] || p.unique(s), T.test(e) && s.reverse()),
              this.pushStack(s)
            );
          };
        }
      );
    var L,
      P = /\S+/g,
      I = {};
    function D() {
      d.removeEventListener("DOMContentLoaded", D, !1),
        e.removeEventListener("load", D, !1),
        p.ready();
    }
    (p.Callbacks = function (e) {
      e =
        "string" == typeof e
          ? I[e] ||
            (function (e) {
              var t = (I[e] = {});
              return (
                p.each(e.match(P) || [], function (e, i) {
                  t[i] = !0;
                }),
                t
              );
            })(e)
          : p.extend({}, e);
      var t,
        i,
        n,
        s,
        a,
        r,
        o = [],
        l = !e.once && [],
        c = function (d) {
          for (
            t = e.memory && d, i = !0, r = s || 0, s = 0, a = o.length, n = !0;
            o && r < a;
            r++
          )
            if (!1 === o[r].apply(d[0], d[1]) && e.stopOnFalse) {
              t = !1;
              break;
            }
          (n = !1),
            o && (l ? l.length && c(l.shift()) : t ? (o = []) : u.disable());
        },
        u = {
          add: function () {
            if (o) {
              var i = o.length;
              !(function t(i) {
                p.each(i, function (i, n) {
                  var s = p.type(n);
                  "function" === s
                    ? (e.unique && u.has(n)) || o.push(n)
                    : n && n.length && "string" !== s && t(n);
                });
              })(arguments),
                n ? (a = o.length) : t && ((s = i), c(t));
            }
            return this;
          },
          remove: function () {
            return (
              o &&
                p.each(arguments, function (e, t) {
                  for (var i; (i = p.inArray(t, o, i)) > -1; )
                    o.splice(i, 1), n && (i <= a && a--, i <= r && r--);
                }),
              this
            );
          },
          has: function (e) {
            return e ? p.inArray(e, o) > -1 : !(!o || !o.length);
          },
          empty: function () {
            return (o = []), (a = 0), this;
          },
          disable: function () {
            return (o = l = t = void 0), this;
          },
          disabled: function () {
            return !o;
          },
          lock: function () {
            return (l = void 0), t || u.disable(), this;
          },
          locked: function () {
            return !l;
          },
          fireWith: function (e, t) {
            return (
              !o ||
                (i && !l) ||
                ((t = [e, (t = t || []).slice ? t.slice() : t]),
                n ? l.push(t) : c(t)),
              this
            );
          },
          fire: function () {
            return u.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!i;
          },
        };
      return u;
    }),
      p.extend({
        Deferred: function (e) {
          var t = [
              ["resolve", "done", p.Callbacks("once memory"), "resolved"],
              ["reject", "fail", p.Callbacks("once memory"), "rejected"],
              ["notify", "progress", p.Callbacks("memory")],
            ],
            i = "pending",
            n = {
              state: function () {
                return i;
              },
              always: function () {
                return s.done(arguments).fail(arguments), this;
              },
              then: function () {
                var e = arguments;
                return p
                  .Deferred(function (i) {
                    p.each(t, function (t, a) {
                      var r = p.isFunction(e[t]) && e[t];
                      s[a[1]](function () {
                        var e = r && r.apply(this, arguments);
                        e && p.isFunction(e.promise)
                          ? e
                              .promise()
                              .done(i.resolve)
                              .fail(i.reject)
                              .progress(i.notify)
                          : i[a[0] + "With"](
                              this === n ? i.promise() : this,
                              r ? [e] : arguments
                            );
                      });
                    }),
                      (e = null);
                  })
                  .promise();
              },
              promise: function (e) {
                return null != e ? p.extend(e, n) : n;
              },
            },
            s = {};
          return (
            (n.pipe = n.then),
            p.each(t, function (e, a) {
              var r = a[2],
                o = a[3];
              (n[a[1]] = r.add),
                o &&
                  r.add(
                    function () {
                      i = o;
                    },
                    t[1 ^ e][2].disable,
                    t[2][2].lock
                  ),
                (s[a[0]] = function () {
                  return (
                    s[a[0] + "With"](this === s ? n : this, arguments), this
                  );
                }),
                (s[a[0] + "With"] = r.fireWith);
            }),
            n.promise(s),
            e && e.call(s, s),
            s
          );
        },
        when: function (e) {
          var t,
            i,
            s,
            a = 0,
            r = n.call(arguments),
            o = r.length,
            l = 1 !== o || (e && p.isFunction(e.promise)) ? o : 0,
            c = 1 === l ? e : p.Deferred(),
            u = function (e, i, s) {
              return function (a) {
                (i[e] = this),
                  (s[e] = arguments.length > 1 ? n.call(arguments) : a),
                  s === t ? c.notifyWith(i, s) : --l || c.resolveWith(i, s);
              };
            };
          if (o > 1)
            for (
              t = new Array(o), i = new Array(o), s = new Array(o);
              a < o;
              a++
            )
              r[a] && p.isFunction(r[a].promise)
                ? r[a]
                    .promise()
                    .done(u(a, s, r))
                    .fail(c.reject)
                    .progress(u(a, i, t))
                : --l;
          return l || c.resolveWith(s, r), c.promise();
        },
      }),
      (p.fn.ready = function (e) {
        return p.ready.promise().done(e), this;
      }),
      p.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function (e) {
          e ? p.readyWait++ : p.ready(!0);
        },
        ready: function (e) {
          (!0 === e ? --p.readyWait : p.isReady) ||
            ((p.isReady = !0),
            (!0 !== e && --p.readyWait > 0) ||
              (L.resolveWith(d, [p]),
              p.fn.triggerHandler &&
                (p(d).triggerHandler("ready"), p(d).off("ready"))));
        },
      }),
      (p.ready.promise = function (t) {
        return (
          L ||
            ((L = p.Deferred()),
            "complete" === d.readyState
              ? setTimeout(p.ready)
              : (d.addEventListener("DOMContentLoaded", D, !1),
                e.addEventListener("load", D, !1))),
          L.promise(t)
        );
      }),
      p.ready.promise();
    var A = (p.access = function (e, t, i, n, s, a, r) {
      var o = 0,
        l = e.length,
        c = null == i;
      if ("object" === p.type(i))
        for (o in ((s = !0), i)) p.access(e, t, o, i[o], !0, a, r);
      else if (
        void 0 !== n &&
        ((s = !0),
        p.isFunction(n) || (r = !0),
        c &&
          (r
            ? (t.call(e, n), (t = null))
            : ((c = t),
              (t = function (e, t, i) {
                return c.call(p(e), i);
              }))),
        t)
      )
        for (; o < l; o++) t(e[o], i, r ? n : n.call(e[o], o, t(e[o], i)));
      return s ? e : c ? t.call(e) : l ? t(e[0], i) : a;
    });
    function z() {
      Object.defineProperty((this.cache = {}), 0, {
        get: function () {
          return {};
        },
      }),
        (this.expando = p.expando + z.uid++);
    }
    (p.acceptData = function (e) {
      return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    }),
      (z.uid = 1),
      (z.accepts = p.acceptData),
      (z.prototype = {
        key: function (e) {
          if (!z.accepts(e)) return 0;
          var t = {},
            i = e[this.expando];
          if (!i) {
            i = z.uid++;
            try {
              (t[this.expando] = { value: i }), Object.defineProperties(e, t);
            } catch (n) {
              (t[this.expando] = i), p.extend(e, t);
            }
          }
          return this.cache[i] || (this.cache[i] = {}), i;
        },
        set: function (e, t, i) {
          var n,
            s = this.key(e),
            a = this.cache[s];
          if ("string" == typeof t) a[t] = i;
          else if (p.isEmptyObject(a)) p.extend(this.cache[s], t);
          else for (n in t) a[n] = t[n];
          return a;
        },
        get: function (e, t) {
          var i = this.cache[this.key(e)];
          return void 0 === t ? i : i[t];
        },
        access: function (e, t, i) {
          var n;
          return void 0 === t || (t && "string" == typeof t && void 0 === i)
            ? void 0 !== (n = this.get(e, t))
              ? n
              : this.get(e, p.camelCase(t))
            : (this.set(e, t, i), void 0 !== i ? i : t);
        },
        remove: function (e, t) {
          var i,
            n,
            s,
            a = this.key(e),
            r = this.cache[a];
          if (void 0 === t) this.cache[a] = {};
          else {
            p.isArray(t)
              ? (n = t.concat(t.map(p.camelCase)))
              : ((s = p.camelCase(t)),
                (n = t in r ? [t, s] : (n = s) in r ? [n] : n.match(P) || [])),
              (i = n.length);
            for (; i--; ) delete r[n[i]];
          }
        },
        hasData: function (e) {
          return !p.isEmptyObject(this.cache[e[this.expando]] || {});
        },
        discard: function (e) {
          e[this.expando] && delete this.cache[e[this.expando]];
        },
      });
    var O = new z(),
      B = new z(),
      N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      q = /([A-Z])/g;
    function $(e, t, i) {
      var n;
      if (void 0 === i && 1 === e.nodeType)
        if (
          ((n = "data-" + t.replace(q, "-$1").toLowerCase()),
          "string" == typeof (i = e.getAttribute(n)))
        ) {
          try {
            i =
              "true" === i ||
              ("false" !== i &&
                ("null" === i
                  ? null
                  : +i + "" === i
                  ? +i
                  : N.test(i)
                  ? p.parseJSON(i)
                  : i));
          } catch (e) {}
          B.set(e, t, i);
        } else i = void 0;
      return i;
    }
    p.extend({
      hasData: function (e) {
        return B.hasData(e) || O.hasData(e);
      },
      data: function (e, t, i) {
        return B.access(e, t, i);
      },
      removeData: function (e, t) {
        B.remove(e, t);
      },
      _data: function (e, t, i) {
        return O.access(e, t, i);
      },
      _removeData: function (e, t) {
        O.remove(e, t);
      },
    }),
      p.fn.extend({
        data: function (e, t) {
          var i,
            n,
            s,
            a = this[0],
            r = a && a.attributes;
          if (void 0 === e) {
            if (
              this.length &&
              ((s = B.get(a)), 1 === a.nodeType && !O.get(a, "hasDataAttrs"))
            ) {
              for (i = r.length; i--; )
                r[i] &&
                  0 === (n = r[i].name).indexOf("data-") &&
                  ((n = p.camelCase(n.slice(5))), $(a, n, s[n]));
              O.set(a, "hasDataAttrs", !0);
            }
            return s;
          }
          return "object" == typeof e
            ? this.each(function () {
                B.set(this, e);
              })
            : A(
                this,
                function (t) {
                  var i,
                    n = p.camelCase(e);
                  if (a && void 0 === t)
                    return void 0 !== (i = B.get(a, e)) ||
                      void 0 !== (i = B.get(a, n)) ||
                      void 0 !== (i = $(a, n, void 0))
                      ? i
                      : void 0;
                  this.each(function () {
                    var i = B.get(this, n);
                    B.set(this, n, t),
                      -1 !== e.indexOf("-") &&
                        void 0 !== i &&
                        B.set(this, e, t);
                  });
                },
                null,
                t,
                arguments.length > 1,
                null,
                !0
              );
        },
        removeData: function (e) {
          return this.each(function () {
            B.remove(this, e);
          });
        },
      }),
      p.extend({
        queue: function (e, t, i) {
          var n;
          if (e)
            return (
              (t = (t || "fx") + "queue"),
              (n = O.get(e, t)),
              i &&
                (!n || p.isArray(i)
                  ? (n = O.access(e, t, p.makeArray(i)))
                  : n.push(i)),
              n || []
            );
        },
        dequeue: function (e, t) {
          t = t || "fx";
          var i = p.queue(e, t),
            n = i.length,
            s = i.shift(),
            a = p._queueHooks(e, t);
          "inprogress" === s && ((s = i.shift()), n--),
            s &&
              ("fx" === t && i.unshift("inprogress"),
              delete a.stop,
              s.call(
                e,
                function () {
                  p.dequeue(e, t);
                },
                a
              )),
            !n && a && a.empty.fire();
        },
        _queueHooks: function (e, t) {
          var i = t + "queueHooks";
          return (
            O.get(e, i) ||
            O.access(e, i, {
              empty: p.Callbacks("once memory").add(function () {
                O.remove(e, [t + "queue", i]);
              }),
            })
          );
        },
      }),
      p.fn.extend({
        queue: function (e, t) {
          var i = 2;
          return (
            "string" != typeof e && ((t = e), (e = "fx"), i--),
            arguments.length < i
              ? p.queue(this[0], e)
              : void 0 === t
              ? this
              : this.each(function () {
                  var i = p.queue(this, e, t);
                  p._queueHooks(this, e),
                    "fx" === e && "inprogress" !== i[0] && p.dequeue(this, e);
                })
          );
        },
        dequeue: function (e) {
          return this.each(function () {
            p.dequeue(this, e);
          });
        },
        clearQueue: function (e) {
          return this.queue(e || "fx", []);
        },
        promise: function (e, t) {
          var i,
            n = 1,
            s = p.Deferred(),
            a = this,
            r = this.length,
            o = function () {
              --n || s.resolveWith(a, [a]);
            };
          for (
            "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
            r--;

          )
            (i = O.get(a[r], e + "queueHooks")) &&
              i.empty &&
              (n++, i.empty.add(o));
          return o(), s.promise(t);
        },
      });
    var H,
      F,
      V = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      R = ["Top", "Right", "Bottom", "Left"],
      j = function (e, t) {
        return (
          (e = t || e),
          "none" === p.css(e, "display") || !p.contains(e.ownerDocument, e)
        );
      },
      X = /^(?:checkbox|radio)$/i;
    (H = d.createDocumentFragment().appendChild(d.createElement("div"))),
      (F = d.createElement("input")).setAttribute("type", "radio"),
      F.setAttribute("checked", "checked"),
      F.setAttribute("name", "t"),
      H.appendChild(F),
      (u.checkClone = H.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (H.innerHTML = "<textarea>x</textarea>"),
      (u.noCloneChecked = !!H.cloneNode(!0).lastChild.defaultValue);
    var G = "undefined";
    u.focusinBubbles = "onfocusin" in e;
    var W = /^key/,
      Y = /^(?:mouse|pointer|contextmenu)|click/,
      U = /^(?:focusinfocus|focusoutblur)$/,
      K = /^([^.]*)(?:\.(.+)|)$/;
    function Q() {
      return !0;
    }
    function Z() {
      return !1;
    }
    function J() {
      try {
        return d.activeElement;
      } catch (e) {}
    }
    (p.event = {
      global: {},
      add: function (e, t, i, n, s) {
        var a,
          r,
          o,
          l,
          c,
          u,
          d,
          h,
          f,
          v,
          m,
          g = O.get(e);
        if (g)
          for (
            i.handler && ((i = (a = i).handler), (s = a.selector)),
              i.guid || (i.guid = p.guid++),
              (l = g.events) || (l = g.events = {}),
              (r = g.handle) ||
                (r = g.handle =
                  function (t) {
                    return typeof p !== G && p.event.triggered !== t.type
                      ? p.event.dispatch.apply(e, arguments)
                      : void 0;
                  }),
              c = (t = (t || "").match(P) || [""]).length;
            c--;

          )
            (f = m = (o = K.exec(t[c]) || [])[1]),
              (v = (o[2] || "").split(".").sort()),
              f &&
                ((d = p.event.special[f] || {}),
                (f = (s ? d.delegateType : d.bindType) || f),
                (d = p.event.special[f] || {}),
                (u = p.extend(
                  {
                    type: f,
                    origType: m,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: s,
                    needsContext: s && p.expr.match.needsContext.test(s),
                    namespace: v.join("."),
                  },
                  a
                )),
                (h = l[f]) ||
                  (((h = l[f] = []).delegateCount = 0),
                  (d.setup && !1 !== d.setup.call(e, n, v, r)) ||
                    (e.addEventListener && e.addEventListener(f, r, !1))),
                d.add &&
                  (d.add.call(e, u),
                  u.handler.guid || (u.handler.guid = i.guid)),
                s ? h.splice(h.delegateCount++, 0, u) : h.push(u),
                (p.event.global[f] = !0));
      },
      remove: function (e, t, i, n, s) {
        var a,
          r,
          o,
          l,
          c,
          u,
          d,
          h,
          f,
          v,
          m,
          g = O.hasData(e) && O.get(e);
        if (g && (l = g.events)) {
          for (c = (t = (t || "").match(P) || [""]).length; c--; )
            if (
              ((f = m = (o = K.exec(t[c]) || [])[1]),
              (v = (o[2] || "").split(".").sort()),
              f)
            ) {
              for (
                d = p.event.special[f] || {},
                  h = l[(f = (n ? d.delegateType : d.bindType) || f)] || [],
                  o =
                    o[2] &&
                    new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  r = a = h.length;
                a--;

              )
                (u = h[a]),
                  (!s && m !== u.origType) ||
                    (i && i.guid !== u.guid) ||
                    (o && !o.test(u.namespace)) ||
                    (n && n !== u.selector && ("**" !== n || !u.selector)) ||
                    (h.splice(a, 1),
                    u.selector && h.delegateCount--,
                    d.remove && d.remove.call(e, u));
              r &&
                !h.length &&
                ((d.teardown && !1 !== d.teardown.call(e, v, g.handle)) ||
                  p.removeEvent(e, f, g.handle),
                delete l[f]);
            } else for (f in l) p.event.remove(e, f + t[c], i, n, !0);
          p.isEmptyObject(l) && (delete g.handle, O.remove(e, "events"));
        }
      },
      trigger: function (t, i, n, s) {
        var a,
          r,
          o,
          l,
          u,
          h,
          f,
          v = [n || d],
          m = c.call(t, "type") ? t.type : t,
          g = c.call(t, "namespace") ? t.namespace.split(".") : [];
        if (
          ((r = o = n = n || d),
          3 !== n.nodeType &&
            8 !== n.nodeType &&
            !U.test(m + p.event.triggered) &&
            (m.indexOf(".") >= 0 &&
              ((g = m.split(".")), (m = g.shift()), g.sort()),
            (u = m.indexOf(":") < 0 && "on" + m),
            ((t = t[p.expando]
              ? t
              : new p.Event(m, "object" == typeof t && t)).isTrigger = s
              ? 2
              : 3),
            (t.namespace = g.join(".")),
            (t.namespace_re = t.namespace
              ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (t.result = void 0),
            t.target || (t.target = n),
            (i = null == i ? [t] : p.makeArray(i, [t])),
            (f = p.event.special[m] || {}),
            s || !f.trigger || !1 !== f.trigger.apply(n, i)))
        ) {
          if (!s && !f.noBubble && !p.isWindow(n)) {
            for (
              l = f.delegateType || m, U.test(l + m) || (r = r.parentNode);
              r;
              r = r.parentNode
            )
              v.push(r), (o = r);
            o === (n.ownerDocument || d) &&
              v.push(o.defaultView || o.parentWindow || e);
          }
          for (a = 0; (r = v[a++]) && !t.isPropagationStopped(); )
            (t.type = a > 1 ? l : f.bindType || m),
              (h = (O.get(r, "events") || {})[t.type] && O.get(r, "handle")) &&
                h.apply(r, i),
              (h = u && r[u]) &&
                h.apply &&
                p.acceptData(r) &&
                ((t.result = h.apply(r, i)),
                !1 === t.result && t.preventDefault());
          return (
            (t.type = m),
            s ||
              t.isDefaultPrevented() ||
              (f._default && !1 !== f._default.apply(v.pop(), i)) ||
              !p.acceptData(n) ||
              (u &&
                p.isFunction(n[m]) &&
                !p.isWindow(n) &&
                ((o = n[u]) && (n[u] = null),
                (p.event.triggered = m),
                n[m](),
                (p.event.triggered = void 0),
                o && (n[u] = o))),
            t.result
          );
        }
      },
      dispatch: function (e) {
        e = p.event.fix(e);
        var t,
          i,
          s,
          a,
          r,
          o,
          l = n.call(arguments),
          c = (O.get(this, "events") || {})[e.type] || [],
          u = p.event.special[e.type] || {};
        if (
          ((l[0] = e),
          (e.delegateTarget = this),
          !u.preDispatch || !1 !== u.preDispatch.call(this, e))
        ) {
          for (
            o = p.event.handlers.call(this, e, c), t = 0;
            (a = o[t++]) && !e.isPropagationStopped();

          )
            for (
              e.currentTarget = a.elem, i = 0;
              (r = a.handlers[i++]) && !e.isImmediatePropagationStopped();

            )
              (e.namespace_re && !e.namespace_re.test(r.namespace)) ||
                ((e.handleObj = r),
                (e.data = r.data),
                void 0 !==
                  (s = (
                    (p.event.special[r.origType] || {}).handle || r.handler
                  ).apply(a.elem, l)) &&
                  !1 === (e.result = s) &&
                  (e.preventDefault(), e.stopPropagation()));
          return u.postDispatch && u.postDispatch.call(this, e), e.result;
        }
      },
      handlers: function (e, t) {
        var i,
          n,
          s,
          a,
          r = [],
          o = t.delegateCount,
          l = e.target;
        if (o && l.nodeType && (!e.button || "click" !== e.type))
          for (; l !== this; l = l.parentNode || this)
            if (!0 !== l.disabled || "click" !== e.type) {
              for (n = [], i = 0; i < o; i++)
                void 0 === n[(s = (a = t[i]).selector + " ")] &&
                  (n[s] = a.needsContext
                    ? p(s, this).index(l) >= 0
                    : p.find(s, this, null, [l]).length),
                  n[s] && n.push(a);
              n.length && r.push({ elem: l, handlers: n });
            }
        return o < t.length && r.push({ elem: this, handlers: t.slice(o) }), r;
      },
      props:
        "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
          " "
        ),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (e, t) {
          return (
            null == e.which &&
              (e.which = null != t.charCode ? t.charCode : t.keyCode),
            e
          );
        },
      },
      mouseHooks: {
        props:
          "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(
            " "
          ),
        filter: function (e, t) {
          var i,
            n,
            s,
            a = t.button;
          return (
            null == e.pageX &&
              null != t.clientX &&
              ((n = (i = e.target.ownerDocument || d).documentElement),
              (s = i.body),
              (e.pageX =
                t.clientX +
                ((n && n.scrollLeft) || (s && s.scrollLeft) || 0) -
                ((n && n.clientLeft) || (s && s.clientLeft) || 0)),
              (e.pageY =
                t.clientY +
                ((n && n.scrollTop) || (s && s.scrollTop) || 0) -
                ((n && n.clientTop) || (s && s.clientTop) || 0))),
            e.which ||
              void 0 === a ||
              (e.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0),
            e
          );
        },
      },
      fix: function (e) {
        if (e[p.expando]) return e;
        var t,
          i,
          n,
          s = e.type,
          a = e,
          r = this.fixHooks[s];
        for (
          r ||
            (this.fixHooks[s] = r =
              Y.test(s) ? this.mouseHooks : W.test(s) ? this.keyHooks : {}),
            n = r.props ? this.props.concat(r.props) : this.props,
            e = new p.Event(a),
            t = n.length;
          t--;

        )
          e[(i = n[t])] = a[i];
        return (
          e.target || (e.target = d),
          3 === e.target.nodeType && (e.target = e.target.parentNode),
          r.filter ? r.filter(e, a) : e
        );
      },
      special: {
        load: { noBubble: !0 },
        focus: {
          trigger: function () {
            if (this !== J() && this.focus) return this.focus(), !1;
          },
          delegateType: "focusin",
        },
        blur: {
          trigger: function () {
            if (this === J() && this.blur) return this.blur(), !1;
          },
          delegateType: "focusout",
        },
        click: {
          trigger: function () {
            if (
              "checkbox" === this.type &&
              this.click &&
              p.nodeName(this, "input")
            )
              return this.click(), !1;
          },
          _default: function (e) {
            return p.nodeName(e.target, "a");
          },
        },
        beforeunload: {
          postDispatch: function (e) {
            void 0 !== e.result &&
              e.originalEvent &&
              (e.originalEvent.returnValue = e.result);
          },
        },
      },
      simulate: function (e, t, i, n) {
        var s = p.extend(new p.Event(), i, {
          type: e,
          isSimulated: !0,
          originalEvent: {},
        });
        n ? p.event.trigger(s, null, t) : p.event.dispatch.call(t, s),
          s.isDefaultPrevented() && i.preventDefault();
      },
    }),
      (p.removeEvent = function (e, t, i) {
        e.removeEventListener && e.removeEventListener(t, i, !1);
      }),
      (p.Event = function (e, t) {
        if (!(this instanceof p.Event)) return new p.Event(e, t);
        e && e.type
          ? ((this.originalEvent = e),
            (this.type = e.type),
            (this.isDefaultPrevented =
              e.defaultPrevented ||
              (void 0 === e.defaultPrevented && !1 === e.returnValue)
                ? Q
                : Z))
          : (this.type = e),
          t && p.extend(this, t),
          (this.timeStamp = (e && e.timeStamp) || p.now()),
          (this[p.expando] = !0);
      }),
      (p.Event.prototype = {
        isDefaultPrevented: Z,
        isPropagationStopped: Z,
        isImmediatePropagationStopped: Z,
        preventDefault: function () {
          var e = this.originalEvent;
          (this.isDefaultPrevented = Q),
            e && e.preventDefault && e.preventDefault();
        },
        stopPropagation: function () {
          var e = this.originalEvent;
          (this.isPropagationStopped = Q),
            e && e.stopPropagation && e.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var e = this.originalEvent;
          (this.isImmediatePropagationStopped = Q),
            e && e.stopImmediatePropagation && e.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      p.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (e, t) {
          p.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function (e) {
              var i,
                n = e.relatedTarget,
                s = e.handleObj;
              return (
                (n && (n === this || p.contains(this, n))) ||
                  ((e.type = s.origType),
                  (i = s.handler.apply(this, arguments)),
                  (e.type = t)),
                i
              );
            },
          };
        }
      ),
      u.focusinBubbles ||
        p.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
          var i = function (e) {
            p.event.simulate(t, e.target, p.event.fix(e), !0);
          };
          p.event.special[t] = {
            setup: function () {
              var n = this.ownerDocument || this,
                s = O.access(n, t);
              s || n.addEventListener(e, i, !0), O.access(n, t, (s || 0) + 1);
            },
            teardown: function () {
              var n = this.ownerDocument || this,
                s = O.access(n, t) - 1;
              s
                ? O.access(n, t, s)
                : (n.removeEventListener(e, i, !0), O.remove(n, t));
            },
          };
        }),
      p.fn.extend({
        on: function (e, t, i, n, s) {
          var a, r;
          if ("object" == typeof e) {
            for (r in ("string" != typeof t && ((i = i || t), (t = void 0)), e))
              this.on(r, t, i, e[r], s);
            return this;
          }
          if (
            (null == i && null == n
              ? ((n = t), (i = t = void 0))
              : null == n &&
                ("string" == typeof t
                  ? ((n = i), (i = void 0))
                  : ((n = i), (i = t), (t = void 0))),
            !1 === n)
          )
            n = Z;
          else if (!n) return this;
          return (
            1 === s &&
              ((a = n),
              (n = function (e) {
                return p().off(e), a.apply(this, arguments);
              }),
              (n.guid = a.guid || (a.guid = p.guid++))),
            this.each(function () {
              p.event.add(this, e, n, i, t);
            })
          );
        },
        one: function (e, t, i, n) {
          return this.on(e, t, i, n, 1);
        },
        off: function (e, t, i) {
          var n, s;
          if (e && e.preventDefault && e.handleObj)
            return (
              (n = e.handleObj),
              p(e.delegateTarget).off(
                n.namespace ? n.origType + "." + n.namespace : n.origType,
                n.selector,
                n.handler
              ),
              this
            );
          if ("object" == typeof e) {
            for (s in e) this.off(s, t, e[s]);
            return this;
          }
          return (
            (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
            !1 === i && (i = Z),
            this.each(function () {
              p.event.remove(this, e, i, t);
            })
          );
        },
        trigger: function (e, t) {
          return this.each(function () {
            p.event.trigger(e, t, this);
          });
        },
        triggerHandler: function (e, t) {
          var i = this[0];
          if (i) return p.event.trigger(e, t, i, !0);
        },
      });
    var ee =
        /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      te = /<([\w:]+)/,
      ie = /<|&#?\w+;/,
      ne = /<(?:script|style|link)/i,
      se = /checked\s*(?:[^=]|=\s*.checked.)/i,
      ae = /^$|\/(?:java|ecma)script/i,
      re = /^true\/(.*)/,
      oe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      le = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
      };
    function ce(e, t) {
      return p.nodeName(e, "table") &&
        p.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr")
        ? e.getElementsByTagName("tbody")[0] ||
            e.appendChild(e.ownerDocument.createElement("tbody"))
        : e;
    }
    function ue(e) {
      return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function de(e) {
      var t = re.exec(e.type);
      return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
    }
    function he(e, t) {
      for (var i = 0, n = e.length; i < n; i++)
        O.set(e[i], "globalEval", !t || O.get(t[i], "globalEval"));
    }
    function pe(e, t) {
      var i, n, s, a, r, o, l, c;
      if (1 === t.nodeType) {
        if (
          O.hasData(e) &&
          ((a = O.access(e)), (r = O.set(t, a)), (c = a.events))
        )
          for (s in (delete r.handle, (r.events = {}), c))
            for (i = 0, n = c[s].length; i < n; i++) p.event.add(t, s, c[s][i]);
        B.hasData(e) && ((o = B.access(e)), (l = p.extend({}, o)), B.set(t, l));
      }
    }
    function fe(e, t) {
      var i = e.getElementsByTagName
        ? e.getElementsByTagName(t || "*")
        : e.querySelectorAll
        ? e.querySelectorAll(t || "*")
        : [];
      return void 0 === t || (t && p.nodeName(e, t)) ? p.merge([e], i) : i;
    }
    (le.optgroup = le.option),
      (le.tbody = le.tfoot = le.colgroup = le.caption = le.thead),
      (le.th = le.td),
      p.extend({
        clone: function (e, t, i) {
          var n,
            s,
            a,
            r,
            o,
            l,
            c,
            d = e.cloneNode(!0),
            h = p.contains(e.ownerDocument, e);
          if (
            !(
              u.noCloneChecked ||
              (1 !== e.nodeType && 11 !== e.nodeType) ||
              p.isXMLDoc(e)
            )
          )
            for (r = fe(d), n = 0, s = (a = fe(e)).length; n < s; n++)
              (o = a[n]),
                (l = r[n]),
                (c = void 0),
                "input" === (c = l.nodeName.toLowerCase()) && X.test(o.type)
                  ? (l.checked = o.checked)
                  : ("input" !== c && "textarea" !== c) ||
                    (l.defaultValue = o.defaultValue);
          if (t)
            if (i)
              for (
                a = a || fe(e), r = r || fe(d), n = 0, s = a.length;
                n < s;
                n++
              )
                pe(a[n], r[n]);
            else pe(e, d);
          return (
            (r = fe(d, "script")).length > 0 && he(r, !h && fe(e, "script")), d
          );
        },
        buildFragment: function (e, t, i, n) {
          for (
            var s,
              a,
              r,
              o,
              l,
              c,
              u = t.createDocumentFragment(),
              d = [],
              h = 0,
              f = e.length;
            h < f;
            h++
          )
            if ((s = e[h]) || 0 === s)
              if ("object" === p.type(s)) p.merge(d, s.nodeType ? [s] : s);
              else if (ie.test(s)) {
                for (
                  a = a || u.appendChild(t.createElement("div")),
                    r = (te.exec(s) || ["", ""])[1].toLowerCase(),
                    o = le[r] || le._default,
                    a.innerHTML = o[1] + s.replace(ee, "<$1></$2>") + o[2],
                    c = o[0];
                  c--;

                )
                  a = a.lastChild;
                p.merge(d, a.childNodes), ((a = u.firstChild).textContent = "");
              } else d.push(t.createTextNode(s));
          for (u.textContent = "", h = 0; (s = d[h++]); )
            if (
              (!n || -1 === p.inArray(s, n)) &&
              ((l = p.contains(s.ownerDocument, s)),
              (a = fe(u.appendChild(s), "script")),
              l && he(a),
              i)
            )
              for (c = 0; (s = a[c++]); ) ae.test(s.type || "") && i.push(s);
          return u;
        },
        cleanData: function (e) {
          for (
            var t, i, n, s, a = p.event.special, r = 0;
            void 0 !== (i = e[r]);
            r++
          ) {
            if (p.acceptData(i) && (s = i[O.expando]) && (t = O.cache[s])) {
              if (t.events)
                for (n in t.events)
                  a[n] ? p.event.remove(i, n) : p.removeEvent(i, n, t.handle);
              O.cache[s] && delete O.cache[s];
            }
            delete B.cache[i[B.expando]];
          }
        },
      }),
      p.fn.extend({
        text: function (e) {
          return A(
            this,
            function (e) {
              return void 0 === e
                ? p.text(this)
                : this.empty().each(function () {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      (this.textContent = e);
                  });
            },
            null,
            e,
            arguments.length
          );
        },
        append: function () {
          return this.domManip(arguments, function (e) {
            (1 !== this.nodeType &&
              11 !== this.nodeType &&
              9 !== this.nodeType) ||
              ce(this, e).appendChild(e);
          });
        },
        prepend: function () {
          return this.domManip(arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = ce(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function () {
          return this.domManip(arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function () {
          return this.domManip(arguments, function (e) {
            this.parentNode &&
              this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        remove: function (e, t) {
          for (
            var i, n = e ? p.filter(e, this) : this, s = 0;
            null != (i = n[s]);
            s++
          )
            t || 1 !== i.nodeType || p.cleanData(fe(i)),
              i.parentNode &&
                (t && p.contains(i.ownerDocument, i) && he(fe(i, "script")),
                i.parentNode.removeChild(i));
          return this;
        },
        empty: function () {
          for (var e, t = 0; null != (e = this[t]); t++)
            1 === e.nodeType && (p.cleanData(fe(e, !1)), (e.textContent = ""));
          return this;
        },
        clone: function (e, t) {
          return (
            (e = null != e && e),
            (t = null == t ? e : t),
            this.map(function () {
              return p.clone(this, e, t);
            })
          );
        },
        html: function (e) {
          return A(
            this,
            function (e) {
              var t = this[0] || {},
                i = 0,
                n = this.length;
              if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
              if (
                "string" == typeof e &&
                !ne.test(e) &&
                !le[(te.exec(e) || ["", ""])[1].toLowerCase()]
              ) {
                e = e.replace(ee, "<$1></$2>");
                try {
                  for (; i < n; i++)
                    1 === (t = this[i] || {}).nodeType &&
                      (p.cleanData(fe(t, !1)), (t.innerHTML = e));
                  t = 0;
                } catch (e) {}
              }
              t && this.empty().append(e);
            },
            null,
            e,
            arguments.length
          );
        },
        replaceWith: function () {
          var e = arguments[0];
          return (
            this.domManip(arguments, function (t) {
              (e = this.parentNode),
                p.cleanData(fe(this)),
                e && e.replaceChild(t, this);
            }),
            e && (e.length || e.nodeType) ? this : this.remove()
          );
        },
        detach: function (e) {
          return this.remove(e, !0);
        },
        domManip: function (e, t) {
          e = s.apply([], e);
          var i,
            n,
            a,
            r,
            o,
            l,
            c = 0,
            d = this.length,
            h = this,
            f = d - 1,
            v = e[0],
            m = p.isFunction(v);
          if (
            m ||
            (d > 1 && "string" == typeof v && !u.checkClone && se.test(v))
          )
            return this.each(function (i) {
              var n = h.eq(i);
              m && (e[0] = v.call(this, i, n.html())), n.domManip(e, t);
            });
          if (
            d &&
            ((n = (i = p.buildFragment(e, this[0].ownerDocument, !1, this))
              .firstChild),
            1 === i.childNodes.length && (i = n),
            n)
          ) {
            for (r = (a = p.map(fe(i, "script"), ue)).length; c < d; c++)
              (o = i),
                c !== f &&
                  ((o = p.clone(o, !0, !0)), r && p.merge(a, fe(o, "script"))),
                t.call(this[c], o, c);
            if (r)
              for (
                l = a[a.length - 1].ownerDocument, p.map(a, de), c = 0;
                c < r;
                c++
              )
                (o = a[c]),
                  ae.test(o.type || "") &&
                    !O.access(o, "globalEval") &&
                    p.contains(l, o) &&
                    (o.src
                      ? p._evalUrl && p._evalUrl(o.src)
                      : p.globalEval(o.textContent.replace(oe, "")));
          }
          return this;
        },
      }),
      p.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (e, t) {
          p.fn[e] = function (e) {
            for (var i, n = [], s = p(e), r = s.length - 1, o = 0; o <= r; o++)
              (i = o === r ? this : this.clone(!0)),
                p(s[o])[t](i),
                a.apply(n, i.get());
            return this.pushStack(n);
          };
        }
      );
    var ve,
      me = {};
    function ge(t, i) {
      var n,
        s = p(i.createElement(t)).appendTo(i.body),
        a =
          e.getDefaultComputedStyle && (n = e.getDefaultComputedStyle(s[0]))
            ? n.display
            : p.css(s[0], "display");
      return s.detach(), a;
    }
    function ye(e) {
      var t = d,
        i = me[e];
      return (
        i ||
          (("none" !== (i = ge(e, t)) && i) ||
            ((t = (ve = (
              ve || p("<iframe frameborder='0' width='0' height='0'/>")
            ).appendTo(t.documentElement))[0].contentDocument).write(),
            t.close(),
            (i = ge(e, t)),
            ve.detach()),
          (me[e] = i)),
        i
      );
    }
    var be = /^margin/,
      we = new RegExp("^(" + V + ")(?!px)[a-z%]+$", "i"),
      Se = function (t) {
        return t.ownerDocument.defaultView.opener
          ? t.ownerDocument.defaultView.getComputedStyle(t, null)
          : e.getComputedStyle(t, null);
      };
    function xe(e, t, i) {
      var n,
        s,
        a,
        r,
        o = e.style;
      return (
        (i = i || Se(e)) && (r = i.getPropertyValue(t) || i[t]),
        i &&
          ("" !== r || p.contains(e.ownerDocument, e) || (r = p.style(e, t)),
          we.test(r) &&
            be.test(t) &&
            ((n = o.width),
            (s = o.minWidth),
            (a = o.maxWidth),
            (o.minWidth = o.maxWidth = o.width = r),
            (r = i.width),
            (o.width = n),
            (o.minWidth = s),
            (o.maxWidth = a))),
        void 0 !== r ? r + "" : r
      );
    }
    function Ce(e, t) {
      return {
        get: function () {
          if (!e()) return (this.get = t).apply(this, arguments);
          delete this.get;
        },
      };
    }
    !(function () {
      var t,
        i,
        n = d.documentElement,
        s = d.createElement("div"),
        a = d.createElement("div");
      function r() {
        (a.style.cssText =
          "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute"),
          (a.innerHTML = ""),
          n.appendChild(s);
        var r = e.getComputedStyle(a, null);
        (t = "1%" !== r.top), (i = "4px" === r.width), n.removeChild(s);
      }
      a.style &&
        ((a.style.backgroundClip = "content-box"),
        (a.cloneNode(!0).style.backgroundClip = ""),
        (u.clearCloneStyle = "content-box" === a.style.backgroundClip),
        (s.style.cssText =
          "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute"),
        s.appendChild(a),
        e.getComputedStyle &&
          p.extend(u, {
            pixelPosition: function () {
              return r(), t;
            },
            boxSizingReliable: function () {
              return null == i && r(), i;
            },
            reliableMarginRight: function () {
              var t,
                i = a.appendChild(d.createElement("div"));
              return (
                (i.style.cssText = a.style.cssText =
                  "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
                (i.style.marginRight = i.style.width = "0"),
                (a.style.width = "1px"),
                n.appendChild(s),
                (t = !parseFloat(e.getComputedStyle(i, null).marginRight)),
                n.removeChild(s),
                a.removeChild(i),
                t
              );
            },
          }));
    })(),
      (p.swap = function (e, t, i, n) {
        var s,
          a,
          r = {};
        for (a in t) (r[a] = e.style[a]), (e.style[a] = t[a]);
        for (a in ((s = i.apply(e, n || [])), t)) e.style[a] = r[a];
        return s;
      });
    var ke = /^(none|table(?!-c[ea]).+)/,
      Ee = new RegExp("^(" + V + ")(.*)$", "i"),
      Te = new RegExp("^([+-])=(" + V + ")", "i"),
      _e = { position: "absolute", visibility: "hidden", display: "block" },
      Me = { letterSpacing: "0", fontWeight: "400" },
      Le = ["Webkit", "O", "Moz", "ms"];
    function Pe(e, t) {
      if (t in e) return t;
      for (var i = t[0].toUpperCase() + t.slice(1), n = t, s = Le.length; s--; )
        if ((t = Le[s] + i) in e) return t;
      return n;
    }
    function Ie(e, t, i) {
      var n = Ee.exec(t);
      return n ? Math.max(0, n[1] - (i || 0)) + (n[2] || "px") : t;
    }
    function De(e, t, i, n, s) {
      for (
        var a = i === (n ? "border" : "content") ? 4 : "width" === t ? 1 : 0,
          r = 0;
        a < 4;
        a += 2
      )
        "margin" === i && (r += p.css(e, i + R[a], !0, s)),
          n
            ? ("content" === i && (r -= p.css(e, "padding" + R[a], !0, s)),
              "margin" !== i &&
                (r -= p.css(e, "border" + R[a] + "Width", !0, s)))
            : ((r += p.css(e, "padding" + R[a], !0, s)),
              "padding" !== i &&
                (r += p.css(e, "border" + R[a] + "Width", !0, s)));
      return r;
    }
    function Ae(e, t, i) {
      var n = !0,
        s = "width" === t ? e.offsetWidth : e.offsetHeight,
        a = Se(e),
        r = "border-box" === p.css(e, "boxSizing", !1, a);
      if (s <= 0 || null == s) {
        if (
          (((s = xe(e, t, a)) < 0 || null == s) && (s = e.style[t]), we.test(s))
        )
          return s;
        (n = r && (u.boxSizingReliable() || s === e.style[t])),
          (s = parseFloat(s) || 0);
      }
      return s + De(e, t, i || (r ? "border" : "content"), n, a) + "px";
    }
    function ze(e, t) {
      for (var i, n, s, a = [], r = 0, o = e.length; r < o; r++)
        (n = e[r]).style &&
          ((a[r] = O.get(n, "olddisplay")),
          (i = n.style.display),
          t
            ? (a[r] || "none" !== i || (n.style.display = ""),
              "" === n.style.display &&
                j(n) &&
                (a[r] = O.access(n, "olddisplay", ye(n.nodeName))))
            : ((s = j(n)),
              ("none" === i && s) ||
                O.set(n, "olddisplay", s ? i : p.css(n, "display"))));
      for (r = 0; r < o; r++)
        (n = e[r]).style &&
          ((t && "none" !== n.style.display && "" !== n.style.display) ||
            (n.style.display = t ? a[r] || "" : "none"));
      return e;
    }
    function Oe(e, t, i, n, s) {
      return new Oe.prototype.init(e, t, i, n, s);
    }
    p.extend({
      cssHooks: {
        opacity: {
          get: function (e, t) {
            if (t) {
              var i = xe(e, "opacity");
              return "" === i ? "1" : i;
            }
          },
        },
      },
      cssNumber: {
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: { float: "cssFloat" },
      style: function (e, t, i, n) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var s,
            a,
            r,
            o = p.camelCase(t),
            l = e.style;
          if (
            ((t = p.cssProps[o] || (p.cssProps[o] = Pe(l, o))),
            (r = p.cssHooks[t] || p.cssHooks[o]),
            void 0 === i)
          )
            return r && "get" in r && void 0 !== (s = r.get(e, !1, n))
              ? s
              : l[t];
          "string" === (a = typeof i) &&
            (s = Te.exec(i)) &&
            ((i = (s[1] + 1) * s[2] + parseFloat(p.css(e, t))), (a = "number")),
            null != i &&
              i == i &&
              ("number" !== a || p.cssNumber[o] || (i += "px"),
              u.clearCloneStyle ||
                "" !== i ||
                0 !== t.indexOf("background") ||
                (l[t] = "inherit"),
              (r && "set" in r && void 0 === (i = r.set(e, i, n))) ||
                (l[t] = i));
        }
      },
      css: function (e, t, i, n) {
        var s,
          a,
          r,
          o = p.camelCase(t);
        return (
          (t = p.cssProps[o] || (p.cssProps[o] = Pe(e.style, o))),
          (r = p.cssHooks[t] || p.cssHooks[o]) &&
            "get" in r &&
            (s = r.get(e, !0, i)),
          void 0 === s && (s = xe(e, t, n)),
          "normal" === s && t in Me && (s = Me[t]),
          "" === i || i
            ? ((a = parseFloat(s)), !0 === i || p.isNumeric(a) ? a || 0 : s)
            : s
        );
      },
    }),
      p.each(["height", "width"], function (e, t) {
        p.cssHooks[t] = {
          get: function (e, i, n) {
            if (i)
              return ke.test(p.css(e, "display")) && 0 === e.offsetWidth
                ? p.swap(e, _e, function () {
                    return Ae(e, t, n);
                  })
                : Ae(e, t, n);
          },
          set: function (e, i, n) {
            var s = n && Se(e);
            return Ie(
              0,
              i,
              n
                ? De(e, t, n, "border-box" === p.css(e, "boxSizing", !1, s), s)
                : 0
            );
          },
        };
      }),
      (p.cssHooks.marginRight = Ce(u.reliableMarginRight, function (e, t) {
        if (t)
          return p.swap(e, { display: "inline-block" }, xe, [e, "marginRight"]);
      })),
      p.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
        (p.cssHooks[e + t] = {
          expand: function (i) {
            for (
              var n = 0, s = {}, a = "string" == typeof i ? i.split(" ") : [i];
              n < 4;
              n++
            )
              s[e + R[n] + t] = a[n] || a[n - 2] || a[0];
            return s;
          },
        }),
          be.test(e) || (p.cssHooks[e + t].set = Ie);
      }),
      p.fn.extend({
        css: function (e, t) {
          return A(
            this,
            function (e, t, i) {
              var n,
                s,
                a = {},
                r = 0;
              if (p.isArray(t)) {
                for (n = Se(e), s = t.length; r < s; r++)
                  a[t[r]] = p.css(e, t[r], !1, n);
                return a;
              }
              return void 0 !== i ? p.style(e, t, i) : p.css(e, t);
            },
            e,
            t,
            arguments.length > 1
          );
        },
        show: function () {
          return ze(this, !0);
        },
        hide: function () {
          return ze(this);
        },
        toggle: function (e) {
          return "boolean" == typeof e
            ? e
              ? this.show()
              : this.hide()
            : this.each(function () {
                j(this) ? p(this).show() : p(this).hide();
              });
        },
      }),
      (p.Tween = Oe),
      (Oe.prototype = {
        constructor: Oe,
        init: function (e, t, i, n, s, a) {
          (this.elem = e),
            (this.prop = i),
            (this.easing = s || "swing"),
            (this.options = t),
            (this.start = this.now = this.cur()),
            (this.end = n),
            (this.unit = a || (p.cssNumber[i] ? "" : "px"));
        },
        cur: function () {
          var e = Oe.propHooks[this.prop];
          return e && e.get ? e.get(this) : Oe.propHooks._default.get(this);
        },
        run: function (e) {
          var t,
            i = Oe.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = t =
                  p.easing[this.easing](
                    e,
                    this.options.duration * e,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = t = e),
            (this.now = (this.end - this.start) * t + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            i && i.set ? i.set(this) : Oe.propHooks._default.set(this),
            this
          );
        },
      }),
      (Oe.prototype.init.prototype = Oe.prototype),
      (Oe.propHooks = {
        _default: {
          get: function (e) {
            var t;
            return null == e.elem[e.prop] ||
              (e.elem.style && null != e.elem.style[e.prop])
              ? (t = p.css(e.elem, e.prop, "")) && "auto" !== t
                ? t
                : 0
              : e.elem[e.prop];
          },
          set: function (e) {
            p.fx.step[e.prop]
              ? p.fx.step[e.prop](e)
              : e.elem.style &&
                (null != e.elem.style[p.cssProps[e.prop]] || p.cssHooks[e.prop])
              ? p.style(e.elem, e.prop, e.now + e.unit)
              : (e.elem[e.prop] = e.now);
          },
        },
      }),
      (Oe.propHooks.scrollTop = Oe.propHooks.scrollLeft =
        {
          set: function (e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
          },
        }),
      (p.easing = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
      }),
      (p.fx = Oe.prototype.init),
      (p.fx.step = {});
    var Be,
      Ne,
      qe = /^(?:toggle|show|hide)$/,
      $e = new RegExp("^(?:([+-])=|)(" + V + ")([a-z%]*)$", "i"),
      He = /queueHooks$/,
      Fe = [
        function (e, t, i) {
          var n,
            s,
            a,
            r,
            o,
            l,
            c,
            u = this,
            d = {},
            h = e.style,
            f = e.nodeType && j(e),
            v = O.get(e, "fxshow");
          i.queue ||
            (null == (o = p._queueHooks(e, "fx")).unqueued &&
              ((o.unqueued = 0),
              (l = o.empty.fire),
              (o.empty.fire = function () {
                o.unqueued || l();
              })),
            o.unqueued++,
            u.always(function () {
              u.always(function () {
                o.unqueued--, p.queue(e, "fx").length || o.empty.fire();
              });
            }));
          1 === e.nodeType &&
            ("height" in t || "width" in t) &&
            ((i.overflow = [h.overflow, h.overflowX, h.overflowY]),
            "inline" ===
              ("none" === (c = p.css(e, "display"))
                ? O.get(e, "olddisplay") || ye(e.nodeName)
                : c) &&
              "none" === p.css(e, "float") &&
              (h.display = "inline-block"));
          i.overflow &&
            ((h.overflow = "hidden"),
            u.always(function () {
              (h.overflow = i.overflow[0]),
                (h.overflowX = i.overflow[1]),
                (h.overflowY = i.overflow[2]);
            }));
          for (n in t)
            if (((s = t[n]), qe.exec(s))) {
              if (
                (delete t[n],
                (a = a || "toggle" === s),
                s === (f ? "hide" : "show"))
              ) {
                if ("show" !== s || !v || void 0 === v[n]) continue;
                f = !0;
              }
              d[n] = (v && v[n]) || p.style(e, n);
            } else c = void 0;
          if (p.isEmptyObject(d))
            "inline" === ("none" === c ? ye(e.nodeName) : c) && (h.display = c);
          else
            for (n in (v
              ? "hidden" in v && (f = v.hidden)
              : (v = O.access(e, "fxshow", {})),
            a && (v.hidden = !f),
            f
              ? p(e).show()
              : u.done(function () {
                  p(e).hide();
                }),
            u.done(function () {
              var t;
              for (t in (O.remove(e, "fxshow"), d)) p.style(e, t, d[t]);
            }),
            d))
              (r = Xe(f ? v[n] : 0, n, u)),
                n in v ||
                  ((v[n] = r.start),
                  f &&
                    ((r.end = r.start),
                    (r.start = "width" === n || "height" === n ? 1 : 0)));
        },
      ],
      Ve = {
        "*": [
          function (e, t) {
            var i = this.createTween(e, t),
              n = i.cur(),
              s = $e.exec(t),
              a = (s && s[3]) || (p.cssNumber[e] ? "" : "px"),
              r =
                (p.cssNumber[e] || ("px" !== a && +n)) &&
                $e.exec(p.css(i.elem, e)),
              o = 1,
              l = 20;
            if (r && r[3] !== a) {
              (a = a || r[3]), (s = s || []), (r = +n || 1);
              do {
                (r /= o = o || ".5"), p.style(i.elem, e, r + a);
              } while (o !== (o = i.cur() / n) && 1 !== o && --l);
            }
            return (
              s &&
                ((r = i.start = +r || +n || 0),
                (i.unit = a),
                (i.end = s[1] ? r + (s[1] + 1) * s[2] : +s[2])),
              i
            );
          },
        ],
      };
    function Re() {
      return (
        setTimeout(function () {
          Be = void 0;
        }),
        (Be = p.now())
      );
    }
    function je(e, t) {
      var i,
        n = 0,
        s = { height: e };
      for (t = t ? 1 : 0; n < 4; n += 2 - t)
        s["margin" + (i = R[n])] = s["padding" + i] = e;
      return t && (s.opacity = s.width = e), s;
    }
    function Xe(e, t, i) {
      for (
        var n, s = (Ve[t] || []).concat(Ve["*"]), a = 0, r = s.length;
        a < r;
        a++
      )
        if ((n = s[a].call(i, t, e))) return n;
    }
    function Ge(e, t, i) {
      var n,
        s,
        a = 0,
        r = Fe.length,
        o = p.Deferred().always(function () {
          delete l.elem;
        }),
        l = function () {
          if (s) return !1;
          for (
            var t = Be || Re(),
              i = Math.max(0, c.startTime + c.duration - t),
              n = 1 - (i / c.duration || 0),
              a = 0,
              r = c.tweens.length;
            a < r;
            a++
          )
            c.tweens[a].run(n);
          return (
            o.notifyWith(e, [c, n, i]),
            n < 1 && r ? i : (o.resolveWith(e, [c]), !1)
          );
        },
        c = o.promise({
          elem: e,
          props: p.extend({}, t),
          opts: p.extend(!0, { specialEasing: {} }, i),
          originalProperties: t,
          originalOptions: i,
          startTime: Be || Re(),
          duration: i.duration,
          tweens: [],
          createTween: function (t, i) {
            var n = p.Tween(
              e,
              c.opts,
              t,
              i,
              c.opts.specialEasing[t] || c.opts.easing
            );
            return c.tweens.push(n), n;
          },
          stop: function (t) {
            var i = 0,
              n = t ? c.tweens.length : 0;
            if (s) return this;
            for (s = !0; i < n; i++) c.tweens[i].run(1);
            return t ? o.resolveWith(e, [c, t]) : o.rejectWith(e, [c, t]), this;
          },
        }),
        u = c.props;
      for (
        !(function (e, t) {
          var i, n, s, a, r;
          for (i in e)
            if (
              ((s = t[(n = p.camelCase(i))]),
              (a = e[i]),
              p.isArray(a) && ((s = a[1]), (a = e[i] = a[0])),
              i !== n && ((e[n] = a), delete e[i]),
              (r = p.cssHooks[n]) && ("expand" in r))
            )
              for (i in ((a = r.expand(a)), delete e[n], a))
                (i in e) || ((e[i] = a[i]), (t[i] = s));
            else t[n] = s;
        })(u, c.opts.specialEasing);
        a < r;
        a++
      )
        if ((n = Fe[a].call(c, e, u, c.opts))) return n;
      return (
        p.map(u, Xe, c),
        p.isFunction(c.opts.start) && c.opts.start.call(e, c),
        p.fx.timer(p.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
        c
          .progress(c.opts.progress)
          .done(c.opts.done, c.opts.complete)
          .fail(c.opts.fail)
          .always(c.opts.always)
      );
    }
    (p.Animation = p.extend(Ge, {
      tweener: function (e, t) {
        p.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.split(" "));
        for (var i, n = 0, s = e.length; n < s; n++)
          (i = e[n]), (Ve[i] = Ve[i] || []), Ve[i].unshift(t);
      },
      prefilter: function (e, t) {
        t ? Fe.unshift(e) : Fe.push(e);
      },
    })),
      (p.speed = function (e, t, i) {
        var n =
          e && "object" == typeof e
            ? p.extend({}, e)
            : {
                complete: i || (!i && t) || (p.isFunction(e) && e),
                duration: e,
                easing: (i && t) || (t && !p.isFunction(t) && t),
              };
        return (
          (n.duration = p.fx.off
            ? 0
            : "number" == typeof n.duration
            ? n.duration
            : n.duration in p.fx.speeds
            ? p.fx.speeds[n.duration]
            : p.fx.speeds._default),
          (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
          (n.old = n.complete),
          (n.complete = function () {
            p.isFunction(n.old) && n.old.call(this),
              n.queue && p.dequeue(this, n.queue);
          }),
          n
        );
      }),
      p.fn.extend({
        fadeTo: function (e, t, i, n) {
          return this.filter(j)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: t }, e, i, n);
        },
        animate: function (e, t, i, n) {
          var s = p.isEmptyObject(e),
            a = p.speed(t, i, n),
            r = function () {
              var t = Ge(this, p.extend({}, e), a);
              (s || O.get(this, "finish")) && t.stop(!0);
            };
          return (
            (r.finish = r),
            s || !1 === a.queue ? this.each(r) : this.queue(a.queue, r)
          );
        },
        stop: function (e, t, i) {
          var n = function (e) {
            var t = e.stop;
            delete e.stop, t(i);
          };
          return (
            "string" != typeof e && ((i = t), (t = e), (e = void 0)),
            t && !1 !== e && this.queue(e || "fx", []),
            this.each(function () {
              var t = !0,
                s = null != e && e + "queueHooks",
                a = p.timers,
                r = O.get(this);
              if (s) r[s] && r[s].stop && n(r[s]);
              else for (s in r) r[s] && r[s].stop && He.test(s) && n(r[s]);
              for (s = a.length; s--; )
                a[s].elem !== this ||
                  (null != e && a[s].queue !== e) ||
                  (a[s].anim.stop(i), (t = !1), a.splice(s, 1));
              (!t && i) || p.dequeue(this, e);
            })
          );
        },
        finish: function (e) {
          return (
            !1 !== e && (e = e || "fx"),
            this.each(function () {
              var t,
                i = O.get(this),
                n = i[e + "queue"],
                s = i[e + "queueHooks"],
                a = p.timers,
                r = n ? n.length : 0;
              for (
                i.finish = !0,
                  p.queue(this, e, []),
                  s && s.stop && s.stop.call(this, !0),
                  t = a.length;
                t--;

              )
                a[t].elem === this &&
                  a[t].queue === e &&
                  (a[t].anim.stop(!0), a.splice(t, 1));
              for (t = 0; t < r; t++)
                n[t] && n[t].finish && n[t].finish.call(this);
              delete i.finish;
            })
          );
        },
      }),
      p.each(["toggle", "show", "hide"], function (e, t) {
        var i = p.fn[t];
        p.fn[t] = function (e, n, s) {
          return null == e || "boolean" == typeof e
            ? i.apply(this, arguments)
            : this.animate(je(t, !0), e, n, s);
        };
      }),
      p.each(
        {
          slideDown: je("show"),
          slideUp: je("hide"),
          slideToggle: je("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (e, t) {
          p.fn[e] = function (e, i, n) {
            return this.animate(t, e, i, n);
          };
        }
      ),
      (p.timers = []),
      (p.fx.tick = function () {
        var e,
          t = 0,
          i = p.timers;
        for (Be = p.now(); t < i.length; t++)
          (e = i[t])() || i[t] !== e || i.splice(t--, 1);
        i.length || p.fx.stop(), (Be = void 0);
      }),
      (p.fx.timer = function (e) {
        p.timers.push(e), e() ? p.fx.start() : p.timers.pop();
      }),
      (p.fx.interval = 13),
      (p.fx.start = function () {
        Ne || (Ne = setInterval(p.fx.tick, p.fx.interval));
      }),
      (p.fx.stop = function () {
        clearInterval(Ne), (Ne = null);
      }),
      (p.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (p.fn.delay = function (e, t) {
        return (
          (e = (p.fx && p.fx.speeds[e]) || e),
          (t = t || "fx"),
          this.queue(t, function (t, i) {
            var n = setTimeout(t, e);
            i.stop = function () {
              clearTimeout(n);
            };
          })
        );
      }),
      (function () {
        var e = d.createElement("input"),
          t = d.createElement("select"),
          i = t.appendChild(d.createElement("option"));
        (e.type = "checkbox"),
          (u.checkOn = "" !== e.value),
          (u.optSelected = i.selected),
          (t.disabled = !0),
          (u.optDisabled = !i.disabled),
          ((e = d.createElement("input")).value = "t"),
          (e.type = "radio"),
          (u.radioValue = "t" === e.value);
      })();
    var We,
      Ye = p.expr.attrHandle;
    p.fn.extend({
      attr: function (e, t) {
        return A(this, p.attr, e, t, arguments.length > 1);
      },
      removeAttr: function (e) {
        return this.each(function () {
          p.removeAttr(this, e);
        });
      },
    }),
      p.extend({
        attr: function (e, t, i) {
          var n,
            s,
            a = e.nodeType;
          if (e && 3 !== a && 8 !== a && 2 !== a)
            return typeof e.getAttribute === G
              ? p.prop(e, t, i)
              : ((1 === a && p.isXMLDoc(e)) ||
                  ((t = t.toLowerCase()),
                  (n =
                    p.attrHooks[t] ||
                    (p.expr.match.bool.test(t) ? We : undefined))),
                void 0 === i
                  ? n && "get" in n && null !== (s = n.get(e, t))
                    ? s
                    : null == (s = p.find.attr(e, t))
                    ? void 0
                    : s
                  : null !== i
                  ? n && "set" in n && void 0 !== (s = n.set(e, i, t))
                    ? s
                    : (e.setAttribute(t, i + ""), i)
                  : void p.removeAttr(e, t));
        },
        removeAttr: function (e, t) {
          var i,
            n,
            s = 0,
            a = t && t.match(P);
          if (a && 1 === e.nodeType)
            for (; (i = a[s++]); )
              (n = p.propFix[i] || i),
                p.expr.match.bool.test(i) && (e[n] = !1),
                e.removeAttribute(i);
        },
        attrHooks: {
          type: {
            set: function (e, t) {
              if (!u.radioValue && "radio" === t && p.nodeName(e, "input")) {
                var i = e.value;
                return e.setAttribute("type", t), i && (e.value = i), t;
              }
            },
          },
        },
      }),
      (We = {
        set: function (e, t, i) {
          return !1 === t ? p.removeAttr(e, i) : e.setAttribute(i, i), i;
        },
      }),
      p.each(p.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var i = Ye[t] || p.find.attr;
        Ye[t] = function (e, t, n) {
          var s, a;
          return (
            n ||
              ((a = Ye[t]),
              (Ye[t] = s),
              (s = null != i(e, t, n) ? t.toLowerCase() : null),
              (Ye[t] = a)),
            s
          );
        };
      });
    var Ue = /^(?:input|select|textarea|button)$/i;
    p.fn.extend({
      prop: function (e, t) {
        return A(this, p.prop, e, t, arguments.length > 1);
      },
      removeProp: function (e) {
        return this.each(function () {
          delete this[p.propFix[e] || e];
        });
      },
    }),
      p.extend({
        propFix: { for: "htmlFor", class: "className" },
        prop: function (e, t, i) {
          var n,
            s,
            a = e.nodeType;
          if (e && 3 !== a && 8 !== a && 2 !== a)
            return (
              (1 !== a || !p.isXMLDoc(e)) &&
                ((t = p.propFix[t] || t), (s = p.propHooks[t])),
              void 0 !== i
                ? s && "set" in s && void 0 !== (n = s.set(e, i, t))
                  ? n
                  : (e[t] = i)
                : s && "get" in s && null !== (n = s.get(e, t))
                ? n
                : e[t]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (e) {
              return e.hasAttribute("tabindex") || Ue.test(e.nodeName) || e.href
                ? e.tabIndex
                : -1;
            },
          },
        },
      }),
      u.optSelected ||
        (p.propHooks.selected = {
          get: function (e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null;
          },
        }),
      p.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          p.propFix[this.toLowerCase()] = this;
        }
      );
    var Ke = /[\t\r\n\f]/g;
    p.fn.extend({
      addClass: function (e) {
        var t,
          i,
          n,
          s,
          a,
          r,
          o = "string" == typeof e && e,
          l = 0,
          c = this.length;
        if (p.isFunction(e))
          return this.each(function (t) {
            p(this).addClass(e.call(this, t, this.className));
          });
        if (o)
          for (t = (e || "").match(P) || []; l < c; l++)
            if (
              (n =
                1 === (i = this[l]).nodeType &&
                (i.className
                  ? (" " + i.className + " ").replace(Ke, " ")
                  : " "))
            ) {
              for (a = 0; (s = t[a++]); )
                n.indexOf(" " + s + " ") < 0 && (n += s + " ");
              (r = p.trim(n)), i.className !== r && (i.className = r);
            }
        return this;
      },
      removeClass: function (e) {
        var t,
          i,
          n,
          s,
          a,
          r,
          o = 0 === arguments.length || ("string" == typeof e && e),
          l = 0,
          c = this.length;
        if (p.isFunction(e))
          return this.each(function (t) {
            p(this).removeClass(e.call(this, t, this.className));
          });
        if (o)
          for (t = (e || "").match(P) || []; l < c; l++)
            if (
              (n =
                1 === (i = this[l]).nodeType &&
                (i.className ? (" " + i.className + " ").replace(Ke, " ") : ""))
            ) {
              for (a = 0; (s = t[a++]); )
                for (; n.indexOf(" " + s + " ") >= 0; )
                  n = n.replace(" " + s + " ", " ");
              (r = e ? p.trim(n) : ""), i.className !== r && (i.className = r);
            }
        return this;
      },
      toggleClass: function (e, t) {
        var i = typeof e;
        return "boolean" == typeof t && "string" === i
          ? t
            ? this.addClass(e)
            : this.removeClass(e)
          : p.isFunction(e)
          ? this.each(function (i) {
              p(this).toggleClass(e.call(this, i, this.className, t), t);
            })
          : this.each(function () {
              if ("string" === i)
                for (
                  var t, n = 0, s = p(this), a = e.match(P) || [];
                  (t = a[n++]);

                )
                  s.hasClass(t) ? s.removeClass(t) : s.addClass(t);
              else
                (i !== G && "boolean" !== i) ||
                  (this.className &&
                    O.set(this, "__className__", this.className),
                  (this.className =
                    this.className || !1 === e
                      ? ""
                      : O.get(this, "__className__") || ""));
            });
      },
      hasClass: function (e) {
        for (var t = " " + e + " ", i = 0, n = this.length; i < n; i++)
          if (
            1 === this[i].nodeType &&
            (" " + this[i].className + " ").replace(Ke, " ").indexOf(t) >= 0
          )
            return !0;
        return !1;
      },
    });
    var Qe = /\r/g;
    p.fn.extend({
      val: function (e) {
        var t,
          i,
          n,
          s = this[0];
        return arguments.length
          ? ((n = p.isFunction(e)),
            this.each(function (i) {
              var s;
              1 === this.nodeType &&
                (null == (s = n ? e.call(this, i, p(this).val()) : e)
                  ? (s = "")
                  : "number" == typeof s
                  ? (s += "")
                  : p.isArray(s) &&
                    (s = p.map(s, function (e) {
                      return null == e ? "" : e + "";
                    })),
                ((t =
                  p.valHooks[this.type] ||
                  p.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in t &&
                  void 0 !== t.set(this, s, "value")) ||
                  (this.value = s));
            }))
          : s
          ? (t = p.valHooks[s.type] || p.valHooks[s.nodeName.toLowerCase()]) &&
            "get" in t &&
            void 0 !== (i = t.get(s, "value"))
            ? i
            : "string" == typeof (i = s.value)
            ? i.replace(Qe, "")
            : null == i
            ? ""
            : i
          : void 0;
      },
    }),
      p.extend({
        valHooks: {
          option: {
            get: function (e) {
              var t = p.find.attr(e, "value");
              return null != t ? t : p.trim(p.text(e));
            },
          },
          select: {
            get: function (e) {
              for (
                var t,
                  i,
                  n = e.options,
                  s = e.selectedIndex,
                  a = "select-one" === e.type || s < 0,
                  r = a ? null : [],
                  o = a ? s + 1 : n.length,
                  l = s < 0 ? o : a ? s : 0;
                l < o;
                l++
              )
                if (
                  ((i = n[l]).selected || l === s) &&
                  (u.optDisabled
                    ? !i.disabled
                    : null === i.getAttribute("disabled")) &&
                  (!i.parentNode.disabled ||
                    !p.nodeName(i.parentNode, "optgroup"))
                ) {
                  if (((t = p(i).val()), a)) return t;
                  r.push(t);
                }
              return r;
            },
            set: function (e, t) {
              for (
                var i, n, s = e.options, a = p.makeArray(t), r = s.length;
                r--;

              )
                ((n = s[r]).selected = p.inArray(n.value, a) >= 0) && (i = !0);
              return i || (e.selectedIndex = -1), a;
            },
          },
        },
      }),
      p.each(["radio", "checkbox"], function () {
        (p.valHooks[this] = {
          set: function (e, t) {
            if (p.isArray(t))
              return (e.checked = p.inArray(p(e).val(), t) >= 0);
          },
        }),
          u.checkOn ||
            (p.valHooks[this].get = function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            });
      }),
      p.each(
        "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
          " "
        ),
        function (e, t) {
          p.fn[t] = function (e, i) {
            return arguments.length > 0
              ? this.on(t, null, e, i)
              : this.trigger(t);
          };
        }
      ),
      p.fn.extend({
        hover: function (e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        },
        bind: function (e, t, i) {
          return this.on(e, null, t, i);
        },
        unbind: function (e, t) {
          return this.off(e, null, t);
        },
        delegate: function (e, t, i, n) {
          return this.on(t, e, i, n);
        },
        undelegate: function (e, t, i) {
          return 1 === arguments.length
            ? this.off(e, "**")
            : this.off(t, e || "**", i);
        },
      });
    var Ze = p.now(),
      Je = /\?/;
    (p.parseJSON = function (e) {
      return JSON.parse(e + "");
    }),
      (p.parseXML = function (e) {
        var t;
        if (!e || "string" != typeof e) return null;
        try {
          t = new DOMParser().parseFromString(e, "text/xml");
        } catch (e) {
          t = void 0;
        }
        return (
          (t && !t.getElementsByTagName("parsererror").length) ||
            p.error("Invalid XML: " + e),
          t
        );
      });
    var et = /#.*$/,
      tt = /([?&])_=[^&]*/,
      it = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      nt = /^(?:GET|HEAD)$/,
      st = /^\/\//,
      at = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
      rt = {},
      ot = {},
      lt = "*/".concat("*"),
      ct = e.location.href,
      ut = at.exec(ct.toLowerCase()) || [];
    function dt(e) {
      return function (t, i) {
        "string" != typeof t && ((i = t), (t = "*"));
        var n,
          s = 0,
          a = t.toLowerCase().match(P) || [];
        if (p.isFunction(i))
          for (; (n = a[s++]); )
            "+" === n[0]
              ? ((n = n.slice(1) || "*"), (e[n] = e[n] || []).unshift(i))
              : (e[n] = e[n] || []).push(i);
      };
    }
    function ht(e, t, i, n) {
      var s = {},
        a = e === ot;
      function r(o) {
        var l;
        return (
          (s[o] = !0),
          p.each(e[o] || [], function (e, o) {
            var c = o(t, i, n);
            return "string" != typeof c || a || s[c]
              ? a
                ? !(l = c)
                : void 0
              : (t.dataTypes.unshift(c), r(c), !1);
          }),
          l
        );
      }
      return r(t.dataTypes[0]) || (!s["*"] && r("*"));
    }
    function pt(e, t) {
      var i,
        n,
        s = p.ajaxSettings.flatOptions || {};
      for (i in t) void 0 !== t[i] && ((s[i] ? e : n || (n = {}))[i] = t[i]);
      return n && p.extend(!0, e, n), e;
    }
    p.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: ct,
        type: "GET",
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            ut[1]
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": lt,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /xml/, html: /html/, json: /json/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": p.parseJSON,
          "text xml": p.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? pt(pt(e, p.ajaxSettings), t) : pt(p.ajaxSettings, e);
      },
      ajaxPrefilter: dt(rt),
      ajaxTransport: dt(ot),
      ajax: function (e, t) {
        "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
        var i,
          n,
          s,
          a,
          r,
          o,
          l,
          c,
          u = p.ajaxSetup({}, t),
          d = u.context || u,
          h = u.context && (d.nodeType || d.jquery) ? p(d) : p.event,
          f = p.Deferred(),
          v = p.Callbacks("once memory"),
          m = u.statusCode || {},
          g = {},
          y = {},
          b = 0,
          w = "canceled",
          S = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (2 === b) {
                if (!a)
                  for (a = {}; (t = it.exec(s)); ) a[t[1].toLowerCase()] = t[2];
                t = a[e.toLowerCase()];
              }
              return null == t ? null : t;
            },
            getAllResponseHeaders: function () {
              return 2 === b ? s : null;
            },
            setRequestHeader: function (e, t) {
              var i = e.toLowerCase();
              return b || ((e = y[i] = y[i] || e), (g[e] = t)), this;
            },
            overrideMimeType: function (e) {
              return b || (u.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (b < 2) for (t in e) m[t] = [m[t], e[t]];
                else S.always(e[S.status]);
              return this;
            },
            abort: function (e) {
              var t = e || w;
              return i && i.abort(t), x(0, t), this;
            },
          };
        if (
          ((f.promise(S).complete = v.add),
          (S.success = S.done),
          (S.error = S.fail),
          (u.url = ((e || u.url || ct) + "")
            .replace(et, "")
            .replace(st, ut[1] + "//")),
          (u.type = t.method || t.type || u.method || u.type),
          (u.dataTypes = p
            .trim(u.dataType || "*")
            .toLowerCase()
            .match(P) || [""]),
          null == u.crossDomain &&
            ((o = at.exec(u.url.toLowerCase())),
            (u.crossDomain = !(
              !o ||
              (o[1] === ut[1] &&
                o[2] === ut[2] &&
                (o[3] || ("http:" === o[1] ? "80" : "443")) ===
                  (ut[3] || ("http:" === ut[1] ? "80" : "443")))
            ))),
          u.data &&
            u.processData &&
            "string" != typeof u.data &&
            (u.data = p.param(u.data, u.traditional)),
          ht(rt, u, t, S),
          2 === b)
        )
          return S;
        for (c in ((l = p.event && u.global) &&
          0 == p.active++ &&
          p.event.trigger("ajaxStart"),
        (u.type = u.type.toUpperCase()),
        (u.hasContent = !nt.test(u.type)),
        (n = u.url),
        u.hasContent ||
          (u.data &&
            ((n = u.url += (Je.test(n) ? "&" : "?") + u.data), delete u.data),
          !1 === u.cache &&
            (u.url = tt.test(n)
              ? n.replace(tt, "$1_=" + Ze++)
              : n + (Je.test(n) ? "&" : "?") + "_=" + Ze++)),
        u.ifModified &&
          (p.lastModified[n] &&
            S.setRequestHeader("If-Modified-Since", p.lastModified[n]),
          p.etag[n] && S.setRequestHeader("If-None-Match", p.etag[n])),
        ((u.data && u.hasContent && !1 !== u.contentType) || t.contentType) &&
          S.setRequestHeader("Content-Type", u.contentType),
        S.setRequestHeader(
          "Accept",
          u.dataTypes[0] && u.accepts[u.dataTypes[0]]
            ? u.accepts[u.dataTypes[0]] +
                ("*" !== u.dataTypes[0] ? ", " + lt + "; q=0.01" : "")
            : u.accepts["*"]
        ),
        u.headers))
          S.setRequestHeader(c, u.headers[c]);
        if (u.beforeSend && (!1 === u.beforeSend.call(d, S, u) || 2 === b))
          return S.abort();
        for (c in ((w = "abort"), { success: 1, error: 1, complete: 1 }))
          S[c](u[c]);
        if ((i = ht(ot, u, t, S))) {
          (S.readyState = 1),
            l && h.trigger("ajaxSend", [S, u]),
            u.async &&
              u.timeout > 0 &&
              (r = setTimeout(function () {
                S.abort("timeout");
              }, u.timeout));
          try {
            (b = 1), i.send(g, x);
          } catch (e) {
            if (!(b < 2)) throw e;
            x(-1, e);
          }
        } else x(-1, "No Transport");
        function x(e, t, a, o) {
          var c,
            g,
            y,
            w,
            x,
            C = t;
          2 !== b &&
            ((b = 2),
            r && clearTimeout(r),
            (i = void 0),
            (s = o || ""),
            (S.readyState = e > 0 ? 4 : 0),
            (c = (e >= 200 && e < 300) || 304 === e),
            a &&
              (w = (function (e, t, i) {
                for (
                  var n, s, a, r, o = e.contents, l = e.dataTypes;
                  "*" === l[0];

                )
                  l.shift(),
                    void 0 === n &&
                      (n = e.mimeType || t.getResponseHeader("Content-Type"));
                if (n)
                  for (s in o)
                    if (o[s] && o[s].test(n)) {
                      l.unshift(s);
                      break;
                    }
                if (l[0] in i) a = l[0];
                else {
                  for (s in i) {
                    if (!l[0] || e.converters[s + " " + l[0]]) {
                      a = s;
                      break;
                    }
                    r || (r = s);
                  }
                  a = a || r;
                }
                if (a) return a !== l[0] && l.unshift(a), i[a];
              })(u, S, a)),
            (w = (function (e, t, i, n) {
              var s,
                a,
                r,
                o,
                l,
                c = {},
                u = e.dataTypes.slice();
              if (u[1])
                for (r in e.converters) c[r.toLowerCase()] = e.converters[r];
              for (a = u.shift(); a; )
                if (
                  (e.responseFields[a] && (i[e.responseFields[a]] = t),
                  !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (l = a),
                  (a = u.shift()))
                )
                  if ("*" === a) a = l;
                  else if ("*" !== l && l !== a) {
                    if (!(r = c[l + " " + a] || c["* " + a]))
                      for (s in c)
                        if (
                          (o = s.split(" "))[1] === a &&
                          (r = c[l + " " + o[0]] || c["* " + o[0]])
                        ) {
                          !0 === r
                            ? (r = c[s])
                            : !0 !== c[s] && ((a = o[0]), u.unshift(o[1]));
                          break;
                        }
                    if (!0 !== r)
                      if (r && e.throws) t = r(t);
                      else
                        try {
                          t = r(t);
                        } catch (e) {
                          return {
                            state: "parsererror",
                            error: r
                              ? e
                              : "No conversion from " + l + " to " + a,
                          };
                        }
                  }
              return { state: "success", data: t };
            })(u, w, S, c)),
            c
              ? (u.ifModified &&
                  ((x = S.getResponseHeader("Last-Modified")) &&
                    (p.lastModified[n] = x),
                  (x = S.getResponseHeader("etag")) && (p.etag[n] = x)),
                204 === e || "HEAD" === u.type
                  ? (C = "nocontent")
                  : 304 === e
                  ? (C = "notmodified")
                  : ((C = w.state), (g = w.data), (c = !(y = w.error))))
              : ((y = C), (!e && C) || ((C = "error"), e < 0 && (e = 0))),
            (S.status = e),
            (S.statusText = (t || C) + ""),
            c ? f.resolveWith(d, [g, C, S]) : f.rejectWith(d, [S, C, y]),
            S.statusCode(m),
            (m = void 0),
            l && h.trigger(c ? "ajaxSuccess" : "ajaxError", [S, u, c ? g : y]),
            v.fireWith(d, [S, C]),
            l &&
              (h.trigger("ajaxComplete", [S, u]),
              --p.active || p.event.trigger("ajaxStop")));
        }
        return S;
      },
      getJSON: function (e, t, i) {
        return p.get(e, t, i, "json");
      },
      getScript: function (e, t) {
        return p.get(e, void 0, t, "script");
      },
    }),
      p.each(["get", "post"], function (e, t) {
        p[t] = function (e, i, n, s) {
          return (
            p.isFunction(i) && ((s = s || n), (n = i), (i = void 0)),
            p.ajax({ url: e, type: t, dataType: s, data: i, success: n })
          );
        };
      }),
      (p._evalUrl = function (e) {
        return p.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          async: !1,
          global: !1,
          throws: !0,
        });
      }),
      p.fn.extend({
        wrapAll: function (e) {
          var t;
          return p.isFunction(e)
            ? this.each(function (t) {
                p(this).wrapAll(e.call(this, t));
              })
            : (this[0] &&
                ((t = p(e, this[0].ownerDocument).eq(0).clone(!0)),
                this[0].parentNode && t.insertBefore(this[0]),
                t
                  .map(function () {
                    for (var e = this; e.firstElementChild; )
                      e = e.firstElementChild;
                    return e;
                  })
                  .append(this)),
              this);
        },
        wrapInner: function (e) {
          return p.isFunction(e)
            ? this.each(function (t) {
                p(this).wrapInner(e.call(this, t));
              })
            : this.each(function () {
                var t = p(this),
                  i = t.contents();
                i.length ? i.wrapAll(e) : t.append(e);
              });
        },
        wrap: function (e) {
          var t = p.isFunction(e);
          return this.each(function (i) {
            p(this).wrapAll(t ? e.call(this, i) : e);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              p.nodeName(this, "body") || p(this).replaceWith(this.childNodes);
            })
            .end();
        },
      }),
      (p.expr.filters.hidden = function (e) {
        return e.offsetWidth <= 0 && e.offsetHeight <= 0;
      }),
      (p.expr.filters.visible = function (e) {
        return !p.expr.filters.hidden(e);
      });
    var ft = /%20/g,
      vt = /\[\]$/,
      mt = /\r?\n/g,
      gt = /^(?:submit|button|image|reset|file)$/i,
      yt = /^(?:input|select|textarea|keygen)/i;
    function bt(e, t, i, n) {
      var s;
      if (p.isArray(t))
        p.each(t, function (t, s) {
          i || vt.test(e)
            ? n(e, s)
            : bt(e + "[" + ("object" == typeof s ? t : "") + "]", s, i, n);
        });
      else if (i || "object" !== p.type(t)) n(e, t);
      else for (s in t) bt(e + "[" + s + "]", t[s], i, n);
    }
    (p.param = function (e, t) {
      var i,
        n = [],
        s = function (e, t) {
          (t = p.isFunction(t) ? t() : null == t ? "" : t),
            (n[n.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
        };
      if (
        (void 0 === t && (t = p.ajaxSettings && p.ajaxSettings.traditional),
        p.isArray(e) || (e.jquery && !p.isPlainObject(e)))
      )
        p.each(e, function () {
          s(this.name, this.value);
        });
      else for (i in e) bt(i, e[i], t, s);
      return n.join("&").replace(ft, "+");
    }),
      p.fn.extend({
        serialize: function () {
          return p.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var e = p.prop(this, "elements");
            return e ? p.makeArray(e) : this;
          })
            .filter(function () {
              var e = this.type;
              return (
                this.name &&
                !p(this).is(":disabled") &&
                yt.test(this.nodeName) &&
                !gt.test(e) &&
                (this.checked || !X.test(e))
              );
            })
            .map(function (e, t) {
              var i = p(this).val();
              return null == i
                ? null
                : p.isArray(i)
                ? p.map(i, function (e) {
                    return { name: t.name, value: e.replace(mt, "\r\n") };
                  })
                : { name: t.name, value: i.replace(mt, "\r\n") };
            })
            .get();
        },
      }),
      (p.ajaxSettings.xhr = function () {
        try {
          return new XMLHttpRequest();
        } catch (e) {}
      });
    var wt = 0,
      St = {},
      xt = { 0: 200, 1223: 204 },
      Ct = p.ajaxSettings.xhr();
    e.attachEvent &&
      e.attachEvent("onunload", function () {
        for (var e in St) St[e]();
      }),
      (u.cors = !!Ct && "withCredentials" in Ct),
      (u.ajax = Ct = !!Ct),
      p.ajaxTransport(function (e) {
        var t;
        if (u.cors || (Ct && !e.crossDomain))
          return {
            send: function (i, n) {
              var s,
                a = e.xhr(),
                r = ++wt;
              if (
                (a.open(e.type, e.url, e.async, e.username, e.password),
                e.xhrFields)
              )
                for (s in e.xhrFields) a[s] = e.xhrFields[s];
              for (s in (e.mimeType &&
                a.overrideMimeType &&
                a.overrideMimeType(e.mimeType),
              e.crossDomain ||
                i["X-Requested-With"] ||
                (i["X-Requested-With"] = "XMLHttpRequest"),
              i))
                a.setRequestHeader(s, i[s]);
              (t = function (e) {
                return function () {
                  t &&
                    (delete St[r],
                    (t = a.onload = a.onerror = null),
                    "abort" === e
                      ? a.abort()
                      : "error" === e
                      ? n(a.status, a.statusText)
                      : n(
                          xt[a.status] || a.status,
                          a.statusText,
                          "string" == typeof a.responseText
                            ? { text: a.responseText }
                            : void 0,
                          a.getAllResponseHeaders()
                        ));
                };
              }),
                (a.onload = t()),
                (a.onerror = t("error")),
                (t = St[r] = t("abort"));
              try {
                a.send((e.hasContent && e.data) || null);
              } catch (e) {
                if (t) throw e;
              }
            },
            abort: function () {
              t && t();
            },
          };
      }),
      p.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /(?:java|ecma)script/ },
        converters: {
          "text script": function (e) {
            return p.globalEval(e), e;
          },
        },
      }),
      p.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
      }),
      p.ajaxTransport("script", function (e) {
        var t, i;
        if (e.crossDomain)
          return {
            send: function (n, s) {
              (t = p("<script>")
                .prop({ async: !0, charset: e.scriptCharset, src: e.url })
                .on(
                  "load error",
                  (i = function (e) {
                    t.remove(),
                      (i = null),
                      e && s("error" === e.type ? 404 : 200, e.type);
                  })
                )),
                d.head.appendChild(t[0]);
            },
            abort: function () {
              i && i();
            },
          };
      });
    var kt = [],
      Et = /(=)\?(?=&|$)|\?\?/;
    p.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e = kt.pop() || p.expando + "_" + Ze++;
        return (this[e] = !0), e;
      },
    }),
      p.ajaxPrefilter("json jsonp", function (t, i, n) {
        var s,
          a,
          r,
          o =
            !1 !== t.jsonp &&
            (Et.test(t.url)
              ? "url"
              : "string" == typeof t.data &&
                !(t.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
                Et.test(t.data) &&
                "data");
        if (o || "jsonp" === t.dataTypes[0])
          return (
            (s = t.jsonpCallback =
              p.isFunction(t.jsonpCallback)
                ? t.jsonpCallback()
                : t.jsonpCallback),
            o
              ? (t[o] = t[o].replace(Et, "$1" + s))
              : !1 !== t.jsonp &&
                (t.url += (Je.test(t.url) ? "&" : "?") + t.jsonp + "=" + s),
            (t.converters["script json"] = function () {
              return r || p.error(s + " was not called"), r[0];
            }),
            (t.dataTypes[0] = "json"),
            (a = e[s]),
            (e[s] = function () {
              r = arguments;
            }),
            n.always(function () {
              (e[s] = a),
                t[s] && ((t.jsonpCallback = i.jsonpCallback), kt.push(s)),
                r && p.isFunction(a) && a(r[0]),
                (r = a = void 0);
            }),
            "script"
          );
      }),
      (p.parseHTML = function (e, t, i) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && ((i = t), (t = !1)), (t = t || d);
        var n = S.exec(e),
          s = !i && [];
        return n
          ? [t.createElement(n[1])]
          : ((n = p.buildFragment([e], t, s)),
            s && s.length && p(s).remove(),
            p.merge([], n.childNodes));
      });
    var Tt = p.fn.load;
    (p.fn.load = function (e, t, i) {
      if ("string" != typeof e && Tt) return Tt.apply(this, arguments);
      var n,
        s,
        a,
        r = this,
        o = e.indexOf(" ");
      return (
        o >= 0 && ((n = p.trim(e.slice(o))), (e = e.slice(0, o))),
        p.isFunction(t)
          ? ((i = t), (t = void 0))
          : t && "object" == typeof t && (s = "POST"),
        r.length > 0 &&
          p
            .ajax({ url: e, type: s, dataType: "html", data: t })
            .done(function (e) {
              (a = arguments),
                r.html(n ? p("<div>").append(p.parseHTML(e)).find(n) : e);
            })
            .complete(
              i &&
                function (e, t) {
                  r.each(i, a || [e.responseText, t, e]);
                }
            ),
        this
      );
    }),
      p.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (e, t) {
          p.fn[t] = function (e) {
            return this.on(t, e);
          };
        }
      ),
      (p.expr.filters.animated = function (e) {
        return p.grep(p.timers, function (t) {
          return e === t.elem;
        }).length;
      });
    var _t = e.document.documentElement;
    function Mt(e) {
      return p.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
    }
    (p.offset = {
      setOffset: function (e, t, i) {
        var n,
          s,
          a,
          r,
          o,
          l,
          c = p.css(e, "position"),
          u = p(e),
          d = {};
        "static" === c && (e.style.position = "relative"),
          (o = u.offset()),
          (a = p.css(e, "top")),
          (l = p.css(e, "left")),
          ("absolute" === c || "fixed" === c) && (a + l).indexOf("auto") > -1
            ? ((r = (n = u.position()).top), (s = n.left))
            : ((r = parseFloat(a) || 0), (s = parseFloat(l) || 0)),
          p.isFunction(t) && (t = t.call(e, i, o)),
          null != t.top && (d.top = t.top - o.top + r),
          null != t.left && (d.left = t.left - o.left + s),
          "using" in t ? t.using.call(e, d) : u.css(d);
      },
    }),
      p.fn.extend({
        offset: function (e) {
          if (arguments.length)
            return void 0 === e
              ? this
              : this.each(function (t) {
                  p.offset.setOffset(this, e, t);
                });
          var t,
            i,
            n = this[0],
            s = { top: 0, left: 0 },
            a = n && n.ownerDocument;
          return a
            ? ((t = a.documentElement),
              p.contains(t, n)
                ? (typeof n.getBoundingClientRect !== G &&
                    (s = n.getBoundingClientRect()),
                  (i = Mt(a)),
                  {
                    top: s.top + i.pageYOffset - t.clientTop,
                    left: s.left + i.pageXOffset - t.clientLeft,
                  })
                : s)
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var e,
              t,
              i = this[0],
              n = { top: 0, left: 0 };
            return (
              "fixed" === p.css(i, "position")
                ? (t = i.getBoundingClientRect())
                : ((e = this.offsetParent()),
                  (t = this.offset()),
                  p.nodeName(e[0], "html") || (n = e.offset()),
                  (n.top += p.css(e[0], "borderTopWidth", !0)),
                  (n.left += p.css(e[0], "borderLeftWidth", !0))),
              {
                top: t.top - n.top - p.css(i, "marginTop", !0),
                left: t.left - n.left - p.css(i, "marginLeft", !0),
              }
            );
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e = this.offsetParent || _t;
              e && !p.nodeName(e, "html") && "static" === p.css(e, "position");

            )
              e = e.offsetParent;
            return e || _t;
          });
        },
      }),
      p.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (t, i) {
          var n = "pageYOffset" === i;
          p.fn[t] = function (s) {
            return A(
              this,
              function (t, s, a) {
                var r = Mt(t);
                if (void 0 === a) return r ? r[i] : t[s];
                r
                  ? r.scrollTo(n ? e.pageXOffset : a, n ? a : e.pageYOffset)
                  : (t[s] = a);
              },
              t,
              s,
              arguments.length,
              null
            );
          };
        }
      ),
      p.each(["top", "left"], function (e, t) {
        p.cssHooks[t] = Ce(u.pixelPosition, function (e, i) {
          if (i)
            return (i = xe(e, t)), we.test(i) ? p(e).position()[t] + "px" : i;
        });
      }),
      p.each({ Height: "height", Width: "width" }, function (e, t) {
        p.each(
          { padding: "inner" + e, content: t, "": "outer" + e },
          function (i, n) {
            p.fn[n] = function (n, s) {
              var a = arguments.length && (i || "boolean" != typeof n),
                r = i || (!0 === n || !0 === s ? "margin" : "border");
              return A(
                this,
                function (t, i, n) {
                  var s;
                  return p.isWindow(t)
                    ? t.document.documentElement["client" + e]
                    : 9 === t.nodeType
                    ? ((s = t.documentElement),
                      Math.max(
                        t.body["scroll" + e],
                        s["scroll" + e],
                        t.body["offset" + e],
                        s["offset" + e],
                        s["client" + e]
                      ))
                    : void 0 === n
                    ? p.css(t, i, r)
                    : p.style(t, i, n, r);
                },
                t,
                a ? n : void 0,
                a,
                null
              );
            };
          }
        );
      }),
      (p.fn.size = function () {
        return this.length;
      }),
      (p.fn.andSelf = p.fn.addBack),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return p;
        });
    var Lt = e.jQuery,
      Pt = e.$;
    return (
      (p.noConflict = function (t) {
        return (
          e.$ === p && (e.$ = Pt), t && e.jQuery === p && (e.jQuery = Lt), p
        );
      }),
      typeof t === G && (e.jQuery = e.$ = p),
      p
    );
  }),
  (function (e, t) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define(t)
      : ((e = e || self).Swiper = t());
  })(this, function () {
    "use strict";
    var e =
        "undefined" == typeof document
          ? {
              body: {},
              addEventListener: function () {},
              removeEventListener: function () {},
              activeElement: { blur: function () {}, nodeName: "" },
              querySelector: function () {
                return null;
              },
              querySelectorAll: function () {
                return [];
              },
              getElementById: function () {
                return null;
              },
              createEvent: function () {
                return { initEvent: function () {} };
              },
              createElement: function () {
                return {
                  children: [],
                  childNodes: [],
                  style: {},
                  setAttribute: function () {},
                  getElementsByTagName: function () {
                    return [];
                  },
                };
              },
              location: { hash: "" },
            }
          : document,
      t =
        "undefined" == typeof window
          ? {
              document: e,
              navigator: { userAgent: "" },
              location: {},
              history: {},
              CustomEvent: function () {
                return this;
              },
              addEventListener: function () {},
              removeEventListener: function () {},
              getComputedStyle: function () {
                return {
                  getPropertyValue: function () {
                    return "";
                  },
                };
              },
              Image: function () {},
              Date: function () {},
              screen: {},
              setTimeout: function () {},
              clearTimeout: function () {},
            }
          : window,
      i = function (e) {
        for (var t = 0; t < e.length; t += 1) this[t] = e[t];
        return (this.length = e.length), this;
      };
    function n(n, s) {
      var a = [],
        r = 0;
      if (n && !s && n instanceof i) return n;
      if (n)
        if ("string" == typeof n) {
          var o,
            l,
            c = n.trim();
          if (c.indexOf("<") >= 0 && c.indexOf(">") >= 0) {
            var u = "div";
            for (
              0 === c.indexOf("<li") && (u = "ul"),
                0 === c.indexOf("<tr") && (u = "tbody"),
                (0 !== c.indexOf("<td") && 0 !== c.indexOf("<th")) ||
                  (u = "tr"),
                0 === c.indexOf("<tbody") && (u = "table"),
                0 === c.indexOf("<option") && (u = "select"),
                (l = e.createElement(u)).innerHTML = c,
                r = 0;
              r < l.childNodes.length;
              r += 1
            )
              a.push(l.childNodes[r]);
          } else
            for (
              o =
                s || "#" !== n[0] || n.match(/[ .<>:~]/)
                  ? (s || e).querySelectorAll(n.trim())
                  : [e.getElementById(n.trim().split("#")[1])],
                r = 0;
              r < o.length;
              r += 1
            )
              o[r] && a.push(o[r]);
        } else if (n.nodeType || n === t || n === e) a.push(n);
        else if (n.length > 0 && n[0].nodeType)
          for (r = 0; r < n.length; r += 1) a.push(n[r]);
      return new i(a);
    }
    function s(e) {
      for (var t = [], i = 0; i < e.length; i += 1)
        -1 === t.indexOf(e[i]) && t.push(e[i]);
      return t;
    }
    (n.fn = i.prototype), (n.Class = i), (n.Dom7 = i);
    var a = {
      addClass: function (e) {
        if (void 0 === e) return this;
        for (var t = e.split(" "), i = 0; i < t.length; i += 1)
          for (var n = 0; n < this.length; n += 1)
            void 0 !== this[n] &&
              void 0 !== this[n].classList &&
              this[n].classList.add(t[i]);
        return this;
      },
      removeClass: function (e) {
        for (var t = e.split(" "), i = 0; i < t.length; i += 1)
          for (var n = 0; n < this.length; n += 1)
            void 0 !== this[n] &&
              void 0 !== this[n].classList &&
              this[n].classList.remove(t[i]);
        return this;
      },
      hasClass: function (e) {
        return !!this[0] && this[0].classList.contains(e);
      },
      toggleClass: function (e) {
        for (var t = e.split(" "), i = 0; i < t.length; i += 1)
          for (var n = 0; n < this.length; n += 1)
            void 0 !== this[n] &&
              void 0 !== this[n].classList &&
              this[n].classList.toggle(t[i]);
        return this;
      },
      attr: function (e, t) {
        var i = arguments;
        if (1 === arguments.length && "string" == typeof e)
          return this[0] ? this[0].getAttribute(e) : void 0;
        for (var n = 0; n < this.length; n += 1)
          if (2 === i.length) this[n].setAttribute(e, t);
          else
            for (var s in e) (this[n][s] = e[s]), this[n].setAttribute(s, e[s]);
        return this;
      },
      removeAttr: function (e) {
        for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
        return this;
      },
      data: function (e, t) {
        var i;
        if (void 0 !== t) {
          for (var n = 0; n < this.length; n += 1)
            (i = this[n]).dom7ElementDataStorage ||
              (i.dom7ElementDataStorage = {}),
              (i.dom7ElementDataStorage[e] = t);
          return this;
        }
        if ((i = this[0]))
          return i.dom7ElementDataStorage && e in i.dom7ElementDataStorage
            ? i.dom7ElementDataStorage[e]
            : i.getAttribute("data-" + e) || void 0;
      },
      transform: function (e) {
        for (var t = 0; t < this.length; t += 1) {
          var i = this[t].style;
          (i.webkitTransform = e), (i.transform = e);
        }
        return this;
      },
      transition: function (e) {
        "string" != typeof e && (e += "ms");
        for (var t = 0; t < this.length; t += 1) {
          var i = this[t].style;
          (i.webkitTransitionDuration = e), (i.transitionDuration = e);
        }
        return this;
      },
      on: function () {
        for (var e, t = [], i = arguments.length; i--; ) t[i] = arguments[i];
        var s = t[0],
          a = t[1],
          r = t[2],
          o = t[3];
        function l(e) {
          var t = e.target;
          if (t) {
            var i = e.target.dom7EventData || [];
            if ((i.indexOf(e) < 0 && i.unshift(e), n(t).is(a))) r.apply(t, i);
            else
              for (var s = n(t).parents(), o = 0; o < s.length; o += 1)
                n(s[o]).is(a) && r.apply(s[o], i);
          }
        }
        function c(e) {
          var t = (e && e.target && e.target.dom7EventData) || [];
          t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
        }
        "function" == typeof t[1] &&
          ((s = (e = t)[0]), (r = e[1]), (o = e[2]), (a = void 0)),
          o || (o = !1);
        for (var u, d = s.split(" "), h = 0; h < this.length; h += 1) {
          var p = this[h];
          if (a)
            for (u = 0; u < d.length; u += 1) {
              var f = d[u];
              p.dom7LiveListeners || (p.dom7LiveListeners = {}),
                p.dom7LiveListeners[f] || (p.dom7LiveListeners[f] = []),
                p.dom7LiveListeners[f].push({ listener: r, proxyListener: l }),
                p.addEventListener(f, l, o);
            }
          else
            for (u = 0; u < d.length; u += 1) {
              var v = d[u];
              p.dom7Listeners || (p.dom7Listeners = {}),
                p.dom7Listeners[v] || (p.dom7Listeners[v] = []),
                p.dom7Listeners[v].push({ listener: r, proxyListener: c }),
                p.addEventListener(v, c, o);
            }
        }
        return this;
      },
      off: function () {
        for (var e, t = [], i = arguments.length; i--; ) t[i] = arguments[i];
        var n = t[0],
          s = t[1],
          a = t[2],
          r = t[3];
        "function" == typeof t[1] &&
          ((n = (e = t)[0]), (a = e[1]), (r = e[2]), (s = void 0)),
          r || (r = !1);
        for (var o = n.split(" "), l = 0; l < o.length; l += 1)
          for (var c = o[l], u = 0; u < this.length; u += 1) {
            var d = this[u],
              h = void 0;
            if (
              (!s && d.dom7Listeners
                ? (h = d.dom7Listeners[c])
                : s && d.dom7LiveListeners && (h = d.dom7LiveListeners[c]),
              h && h.length)
            )
              for (var p = h.length - 1; p >= 0; p -= 1) {
                var f = h[p];
                (a && f.listener === a) ||
                (a &&
                  f.listener &&
                  f.listener.dom7proxy &&
                  f.listener.dom7proxy === a)
                  ? (d.removeEventListener(c, f.proxyListener, r),
                    h.splice(p, 1))
                  : a ||
                    (d.removeEventListener(c, f.proxyListener, r),
                    h.splice(p, 1));
              }
          }
        return this;
      },
      trigger: function () {
        for (var i = [], n = arguments.length; n--; ) i[n] = arguments[n];
        for (var s = i[0].split(" "), a = i[1], r = 0; r < s.length; r += 1)
          for (var o = s[r], l = 0; l < this.length; l += 1) {
            var c = this[l],
              u = void 0;
            try {
              u = new t.CustomEvent(o, {
                detail: a,
                bubbles: !0,
                cancelable: !0,
              });
            } catch (t) {
              (u = e.createEvent("Event")).initEvent(o, !0, !0), (u.detail = a);
            }
            (c.dom7EventData = i.filter(function (e, t) {
              return t > 0;
            })),
              c.dispatchEvent(u),
              (c.dom7EventData = []),
              delete c.dom7EventData;
          }
        return this;
      },
      transitionEnd: function (e) {
        var t,
          i = ["webkitTransitionEnd", "transitionend"],
          n = this;
        function s(a) {
          if (a.target === this)
            for (e.call(this, a), t = 0; t < i.length; t += 1) n.off(i[t], s);
        }
        if (e) for (t = 0; t < i.length; t += 1) n.on(i[t], s);
        return this;
      },
      outerWidth: function (e) {
        if (this.length > 0) {
          if (e) {
            var t = this.styles();
            return (
              this[0].offsetWidth +
              parseFloat(t.getPropertyValue("margin-right")) +
              parseFloat(t.getPropertyValue("margin-left"))
            );
          }
          return this[0].offsetWidth;
        }
        return null;
      },
      outerHeight: function (e) {
        if (this.length > 0) {
          if (e) {
            var t = this.styles();
            return (
              this[0].offsetHeight +
              parseFloat(t.getPropertyValue("margin-top")) +
              parseFloat(t.getPropertyValue("margin-bottom"))
            );
          }
          return this[0].offsetHeight;
        }
        return null;
      },
      offset: function () {
        if (this.length > 0) {
          var i = this[0],
            n = i.getBoundingClientRect(),
            s = e.body,
            a = i.clientTop || s.clientTop || 0,
            r = i.clientLeft || s.clientLeft || 0,
            o = i === t ? t.scrollY : i.scrollTop,
            l = i === t ? t.scrollX : i.scrollLeft;
          return { top: n.top + o - a, left: n.left + l - r };
        }
        return null;
      },
      css: function (e, i) {
        var n;
        if (1 === arguments.length) {
          if ("string" != typeof e) {
            for (n = 0; n < this.length; n += 1)
              for (var s in e) this[n].style[s] = e[s];
            return this;
          }
          if (this[0])
            return t.getComputedStyle(this[0], null).getPropertyValue(e);
        }
        if (2 === arguments.length && "string" == typeof e) {
          for (n = 0; n < this.length; n += 1) this[n].style[e] = i;
          return this;
        }
        return this;
      },
      each: function (e) {
        if (!e) return this;
        for (var t = 0; t < this.length; t += 1)
          if (!1 === e.call(this[t], t, this[t])) return this;
        return this;
      },
      html: function (e) {
        if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
        for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
        return this;
      },
      text: function (e) {
        if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
        for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
        return this;
      },
      is: function (s) {
        var a,
          r,
          o = this[0];
        if (!o || void 0 === s) return !1;
        if ("string" == typeof s) {
          if (o.matches) return o.matches(s);
          if (o.webkitMatchesSelector) return o.webkitMatchesSelector(s);
          if (o.msMatchesSelector) return o.msMatchesSelector(s);
          for (a = n(s), r = 0; r < a.length; r += 1) if (a[r] === o) return !0;
          return !1;
        }
        if (s === e) return o === e;
        if (s === t) return o === t;
        if (s.nodeType || s instanceof i) {
          for (a = s.nodeType ? [s] : s, r = 0; r < a.length; r += 1)
            if (a[r] === o) return !0;
          return !1;
        }
        return !1;
      },
      index: function () {
        var e,
          t = this[0];
        if (t) {
          for (e = 0; null !== (t = t.previousSibling); )
            1 === t.nodeType && (e += 1);
          return e;
        }
      },
      eq: function (e) {
        if (void 0 === e) return this;
        var t,
          n = this.length;
        return new i(
          e > n - 1
            ? []
            : e < 0
            ? (t = n + e) < 0
              ? []
              : [this[t]]
            : [this[e]]
        );
      },
      append: function () {
        for (var t, n = [], s = arguments.length; s--; ) n[s] = arguments[s];
        for (var a = 0; a < n.length; a += 1) {
          t = n[a];
          for (var r = 0; r < this.length; r += 1)
            if ("string" == typeof t) {
              var o = e.createElement("div");
              for (o.innerHTML = t; o.firstChild; )
                this[r].appendChild(o.firstChild);
            } else if (t instanceof i)
              for (var l = 0; l < t.length; l += 1) this[r].appendChild(t[l]);
            else this[r].appendChild(t);
        }
        return this;
      },
      prepend: function (t) {
        var n, s;
        for (n = 0; n < this.length; n += 1)
          if ("string" == typeof t) {
            var a = e.createElement("div");
            for (a.innerHTML = t, s = a.childNodes.length - 1; s >= 0; s -= 1)
              this[n].insertBefore(a.childNodes[s], this[n].childNodes[0]);
          } else if (t instanceof i)
            for (s = 0; s < t.length; s += 1)
              this[n].insertBefore(t[s], this[n].childNodes[0]);
          else this[n].insertBefore(t, this[n].childNodes[0]);
        return this;
      },
      next: function (e) {
        return this.length > 0
          ? e
            ? this[0].nextElementSibling && n(this[0].nextElementSibling).is(e)
              ? new i([this[0].nextElementSibling])
              : new i([])
            : this[0].nextElementSibling
            ? new i([this[0].nextElementSibling])
            : new i([])
          : new i([]);
      },
      nextAll: function (e) {
        var t = [],
          s = this[0];
        if (!s) return new i([]);
        for (; s.nextElementSibling; ) {
          var a = s.nextElementSibling;
          e ? n(a).is(e) && t.push(a) : t.push(a), (s = a);
        }
        return new i(t);
      },
      prev: function (e) {
        if (this.length > 0) {
          var t = this[0];
          return e
            ? t.previousElementSibling && n(t.previousElementSibling).is(e)
              ? new i([t.previousElementSibling])
              : new i([])
            : t.previousElementSibling
            ? new i([t.previousElementSibling])
            : new i([]);
        }
        return new i([]);
      },
      prevAll: function (e) {
        var t = [],
          s = this[0];
        if (!s) return new i([]);
        for (; s.previousElementSibling; ) {
          var a = s.previousElementSibling;
          e ? n(a).is(e) && t.push(a) : t.push(a), (s = a);
        }
        return new i(t);
      },
      parent: function (e) {
        for (var t = [], i = 0; i < this.length; i += 1)
          null !== this[i].parentNode &&
            (e
              ? n(this[i].parentNode).is(e) && t.push(this[i].parentNode)
              : t.push(this[i].parentNode));
        return n(s(t));
      },
      parents: function (e) {
        for (var t = [], i = 0; i < this.length; i += 1)
          for (var a = this[i].parentNode; a; )
            e ? n(a).is(e) && t.push(a) : t.push(a), (a = a.parentNode);
        return n(s(t));
      },
      closest: function (e) {
        var t = this;
        return void 0 === e
          ? new i([])
          : (t.is(e) || (t = t.parents(e).eq(0)), t);
      },
      find: function (e) {
        for (var t = [], n = 0; n < this.length; n += 1)
          for (var s = this[n].querySelectorAll(e), a = 0; a < s.length; a += 1)
            t.push(s[a]);
        return new i(t);
      },
      children: function (e) {
        for (var t = [], a = 0; a < this.length; a += 1)
          for (var r = this[a].childNodes, o = 0; o < r.length; o += 1)
            e
              ? 1 === r[o].nodeType && n(r[o]).is(e) && t.push(r[o])
              : 1 === r[o].nodeType && t.push(r[o]);
        return new i(s(t));
      },
      filter: function (e) {
        for (var t = [], n = 0; n < this.length; n += 1)
          e.call(this[n], n, this[n]) && t.push(this[n]);
        return new i(t);
      },
      remove: function () {
        for (var e = 0; e < this.length; e += 1)
          this[e].parentNode && this[e].parentNode.removeChild(this[e]);
        return this;
      },
      add: function () {
        for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
        var i,
          s,
          a = this;
        for (i = 0; i < e.length; i += 1) {
          var r = n(e[i]);
          for (s = 0; s < r.length; s += 1)
            (a[a.length] = r[s]), (a.length += 1);
        }
        return a;
      },
      styles: function () {
        return this[0] ? t.getComputedStyle(this[0], null) : {};
      },
    };
    Object.keys(a).forEach(function (e) {
      n.fn[e] = n.fn[e] || a[e];
    });
    var r = {
        deleteProps: function (e) {
          var t = e;
          Object.keys(t).forEach(function (e) {
            try {
              t[e] = null;
            } catch (e) {}
            try {
              delete t[e];
            } catch (e) {}
          });
        },
        nextTick: function (e, t) {
          return void 0 === t && (t = 0), setTimeout(e, t);
        },
        now: function () {
          return Date.now();
        },
        getTranslate: function (e, i) {
          var n, s, a;
          void 0 === i && (i = "x");
          var r = t.getComputedStyle(e, null);
          return (
            t.WebKitCSSMatrix
              ? ((s = r.transform || r.webkitTransform).split(",").length > 6 &&
                  (s = s
                    .split(", ")
                    .map(function (e) {
                      return e.replace(",", ".");
                    })
                    .join(", ")),
                (a = new t.WebKitCSSMatrix("none" === s ? "" : s)))
              : (n = (a =
                  r.MozTransform ||
                  r.OTransform ||
                  r.MsTransform ||
                  r.msTransform ||
                  r.transform ||
                  r
                    .getPropertyValue("transform")
                    .replace("translate(", "matrix(1, 0, 0, 1,"))
                  .toString()
                  .split(",")),
            "x" === i &&
              (s = t.WebKitCSSMatrix
                ? a.m41
                : 16 === n.length
                ? parseFloat(n[12])
                : parseFloat(n[4])),
            "y" === i &&
              (s = t.WebKitCSSMatrix
                ? a.m42
                : 16 === n.length
                ? parseFloat(n[13])
                : parseFloat(n[5])),
            s || 0
          );
        },
        parseUrlQuery: function (e) {
          var i,
            n,
            s,
            a,
            r = {},
            o = e || t.location.href;
          if ("string" == typeof o && o.length)
            for (
              a = (n = (o = o.indexOf("?") > -1 ? o.replace(/\S*\?/, "") : "")
                .split("&")
                .filter(function (e) {
                  return "" !== e;
                })).length,
                i = 0;
              i < a;
              i += 1
            )
              (s = n[i].replace(/#\S+/g, "").split("=")),
                (r[decodeURIComponent(s[0])] =
                  void 0 === s[1] ? void 0 : decodeURIComponent(s[1]) || "");
          return r;
        },
        isObject: function (e) {
          return (
            "object" == typeof e &&
            null !== e &&
            e.constructor &&
            e.constructor === Object
          );
        },
        extend: function () {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          for (var i = Object(e[0]), n = 1; n < e.length; n += 1) {
            var s = e[n];
            if (null != s)
              for (
                var a = Object.keys(Object(s)), o = 0, l = a.length;
                o < l;
                o += 1
              ) {
                var c = a[o],
                  u = Object.getOwnPropertyDescriptor(s, c);
                void 0 !== u &&
                  u.enumerable &&
                  (r.isObject(i[c]) && r.isObject(s[c])
                    ? r.extend(i[c], s[c])
                    : !r.isObject(i[c]) && r.isObject(s[c])
                    ? ((i[c] = {}), r.extend(i[c], s[c]))
                    : (i[c] = s[c]));
              }
          }
          return i;
        },
      },
      o = {
        touch:
          (t.Modernizr && !0 === t.Modernizr.touch) ||
          !!(
            t.navigator.maxTouchPoints > 0 ||
            "ontouchstart" in t ||
            (t.DocumentTouch && e instanceof t.DocumentTouch)
          ),
        pointerEvents:
          !!t.PointerEvent &&
          "maxTouchPoints" in t.navigator &&
          t.navigator.maxTouchPoints > 0,
        observer: "MutationObserver" in t || "WebkitMutationObserver" in t,
        passiveListener: (function () {
          var e = !1;
          try {
            var i = Object.defineProperty({}, "passive", {
              get: function () {
                e = !0;
              },
            });
            t.addEventListener("testPassiveListener", null, i);
          } catch (e) {}
          return e;
        })(),
        gestures: "ongesturestart" in t,
      },
      l = function (e) {
        void 0 === e && (e = {});
        var t = this;
        (t.params = e),
          (t.eventsListeners = {}),
          t.params &&
            t.params.on &&
            Object.keys(t.params.on).forEach(function (e) {
              t.on(e, t.params.on[e]);
            });
      },
      c = { components: { configurable: !0 } };
    (l.prototype.on = function (e, t, i) {
      var n = this;
      if ("function" != typeof t) return n;
      var s = i ? "unshift" : "push";
      return (
        e.split(" ").forEach(function (e) {
          n.eventsListeners[e] || (n.eventsListeners[e] = []),
            n.eventsListeners[e][s](t);
        }),
        n
      );
    }),
      (l.prototype.once = function (e, t, i) {
        var n = this;
        if ("function" != typeof t) return n;
        function s() {
          for (var i = [], a = arguments.length; a--; ) i[a] = arguments[a];
          n.off(e, s), s.f7proxy && delete s.f7proxy, t.apply(n, i);
        }
        return (s.f7proxy = t), n.on(e, s, i);
      }),
      (l.prototype.off = function (e, t) {
        var i = this;
        return i.eventsListeners
          ? (e.split(" ").forEach(function (e) {
              void 0 === t
                ? (i.eventsListeners[e] = [])
                : i.eventsListeners[e] &&
                  i.eventsListeners[e].length &&
                  i.eventsListeners[e].forEach(function (n, s) {
                    (n === t || (n.f7proxy && n.f7proxy === t)) &&
                      i.eventsListeners[e].splice(s, 1);
                  });
            }),
            i)
          : i;
      }),
      (l.prototype.emit = function () {
        for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
        var i,
          n,
          s,
          a = this;
        return a.eventsListeners
          ? ("string" == typeof e[0] || Array.isArray(e[0])
              ? ((i = e[0]), (n = e.slice(1, e.length)), (s = a))
              : ((i = e[0].events), (n = e[0].data), (s = e[0].context || a)),
            (Array.isArray(i) ? i : i.split(" ")).forEach(function (e) {
              if (a.eventsListeners && a.eventsListeners[e]) {
                var t = [];
                a.eventsListeners[e].forEach(function (e) {
                  t.push(e);
                }),
                  t.forEach(function (e) {
                    e.apply(s, n);
                  });
              }
            }),
            a)
          : a;
      }),
      (l.prototype.useModulesParams = function (e) {
        var t = this;
        t.modules &&
          Object.keys(t.modules).forEach(function (i) {
            var n = t.modules[i];
            n.params && r.extend(e, n.params);
          });
      }),
      (l.prototype.useModules = function (e) {
        void 0 === e && (e = {});
        var t = this;
        t.modules &&
          Object.keys(t.modules).forEach(function (i) {
            var n = t.modules[i],
              s = e[i] || {};
            n.instance &&
              Object.keys(n.instance).forEach(function (e) {
                var i = n.instance[e];
                t[e] = "function" == typeof i ? i.bind(t) : i;
              }),
              n.on &&
                t.on &&
                Object.keys(n.on).forEach(function (e) {
                  t.on(e, n.on[e]);
                }),
              n.create && n.create.bind(t)(s);
          });
      }),
      (c.components.set = function (e) {
        this.use && this.use(e);
      }),
      (l.installModule = function (e) {
        for (var t = [], i = arguments.length - 1; i-- > 0; )
          t[i] = arguments[i + 1];
        var n = this;
        n.prototype.modules || (n.prototype.modules = {});
        var s =
          e.name || Object.keys(n.prototype.modules).length + "_" + r.now();
        return (
          (n.prototype.modules[s] = e),
          e.proto &&
            Object.keys(e.proto).forEach(function (t) {
              n.prototype[t] = e.proto[t];
            }),
          e.static &&
            Object.keys(e.static).forEach(function (t) {
              n[t] = e.static[t];
            }),
          e.install && e.install.apply(n, t),
          n
        );
      }),
      (l.use = function (e) {
        for (var t = [], i = arguments.length - 1; i-- > 0; )
          t[i] = arguments[i + 1];
        var n = this;
        return Array.isArray(e)
          ? (e.forEach(function (e) {
              return n.installModule(e);
            }),
            n)
          : n.installModule.apply(n, [e].concat(t));
      }),
      Object.defineProperties(l, c);
    var u,
      d,
      h,
      p,
      f,
      v,
      m,
      g,
      y,
      b,
      w,
      S,
      x,
      C,
      k,
      E = {
        updateSize: function () {
          var e,
            t,
            i = this.$el;
          (e =
            void 0 !== this.params.width
              ? this.params.width
              : i[0].clientWidth),
            (t =
              void 0 !== this.params.height
                ? this.params.height
                : i[0].clientHeight),
            (0 === e && this.isHorizontal()) ||
              (0 === t && this.isVertical()) ||
              ((e =
                e -
                parseInt(i.css("padding-left"), 10) -
                parseInt(i.css("padding-right"), 10)),
              (t =
                t -
                parseInt(i.css("padding-top"), 10) -
                parseInt(i.css("padding-bottom"), 10)),
              r.extend(this, {
                width: e,
                height: t,
                size: this.isHorizontal() ? e : t,
              }));
        },
        updateSlides: function () {
          var e = this.params,
            i = this.$wrapperEl,
            n = this.size,
            s = this.rtlTranslate,
            a = this.wrongRTL,
            o = this.virtual && e.virtual.enabled,
            l = o ? this.virtual.slides.length : this.slides.length,
            c = i.children("." + this.params.slideClass),
            u = o ? this.virtual.slides.length : c.length,
            d = [],
            h = [],
            p = [];
          function f(t) {
            return !e.cssMode || t !== c.length - 1;
          }
          var v = e.slidesOffsetBefore;
          "function" == typeof v && (v = e.slidesOffsetBefore.call(this));
          var m = e.slidesOffsetAfter;
          "function" == typeof m && (m = e.slidesOffsetAfter.call(this));
          var g = this.snapGrid.length,
            y = this.snapGrid.length,
            b = e.spaceBetween,
            w = -v,
            S = 0,
            x = 0;
          if (void 0 !== n) {
            var C, k;
            "string" == typeof b &&
              b.indexOf("%") >= 0 &&
              (b = (parseFloat(b.replace("%", "")) / 100) * n),
              (this.virtualSize = -b),
              s
                ? c.css({ marginLeft: "", marginTop: "" })
                : c.css({ marginRight: "", marginBottom: "" }),
              e.slidesPerColumn > 1 &&
                ((C =
                  Math.floor(u / e.slidesPerColumn) ===
                  u / this.params.slidesPerColumn
                    ? u
                    : Math.ceil(u / e.slidesPerColumn) * e.slidesPerColumn),
                "auto" !== e.slidesPerView &&
                  "row" === e.slidesPerColumnFill &&
                  (C = Math.max(C, e.slidesPerView * e.slidesPerColumn)));
            for (
              var E,
                T = e.slidesPerColumn,
                _ = C / T,
                M = Math.floor(u / e.slidesPerColumn),
                L = 0;
              L < u;
              L += 1
            ) {
              k = 0;
              var P = c.eq(L);
              if (e.slidesPerColumn > 1) {
                var I = void 0,
                  D = void 0,
                  A = void 0;
                if ("row" === e.slidesPerColumnFill && e.slidesPerGroup > 1) {
                  var z = Math.floor(
                      L / (e.slidesPerGroup * e.slidesPerColumn)
                    ),
                    O = L - e.slidesPerColumn * e.slidesPerGroup * z,
                    B =
                      0 === z
                        ? e.slidesPerGroup
                        : Math.min(
                            Math.ceil((u - z * T * e.slidesPerGroup) / T),
                            e.slidesPerGroup
                          );
                  (I =
                    (D =
                      O - (A = Math.floor(O / B)) * B + z * e.slidesPerGroup) +
                    (A * C) / T),
                    P.css({
                      "-webkit-box-ordinal-group": I,
                      "-moz-box-ordinal-group": I,
                      "-ms-flex-order": I,
                      "-webkit-order": I,
                      order: I,
                    });
                } else
                  "column" === e.slidesPerColumnFill
                    ? ((A = L - (D = Math.floor(L / T)) * T),
                      (D > M || (D === M && A === T - 1)) &&
                        (A += 1) >= T &&
                        ((A = 0), (D += 1)))
                    : (D = L - (A = Math.floor(L / _)) * _);
                P.css(
                  "margin-" + (this.isHorizontal() ? "top" : "left"),
                  0 !== A && e.spaceBetween && e.spaceBetween + "px"
                );
              }
              if ("none" !== P.css("display")) {
                if ("auto" === e.slidesPerView) {
                  var N = t.getComputedStyle(P[0], null),
                    q = P[0].style.transform,
                    $ = P[0].style.webkitTransform;
                  if (
                    (q && (P[0].style.transform = "none"),
                    $ && (P[0].style.webkitTransform = "none"),
                    e.roundLengths)
                  )
                    k = this.isHorizontal()
                      ? P.outerWidth(!0)
                      : P.outerHeight(!0);
                  else if (this.isHorizontal()) {
                    var H = parseFloat(N.getPropertyValue("width")),
                      F = parseFloat(N.getPropertyValue("padding-left")),
                      V = parseFloat(N.getPropertyValue("padding-right")),
                      R = parseFloat(N.getPropertyValue("margin-left")),
                      j = parseFloat(N.getPropertyValue("margin-right")),
                      X = N.getPropertyValue("box-sizing");
                    k = X && "border-box" === X ? H + R + j : H + F + V + R + j;
                  } else {
                    var G = parseFloat(N.getPropertyValue("height")),
                      W = parseFloat(N.getPropertyValue("padding-top")),
                      Y = parseFloat(N.getPropertyValue("padding-bottom")),
                      U = parseFloat(N.getPropertyValue("margin-top")),
                      K = parseFloat(N.getPropertyValue("margin-bottom")),
                      Q = N.getPropertyValue("box-sizing");
                    k = Q && "border-box" === Q ? G + U + K : G + W + Y + U + K;
                  }
                  q && (P[0].style.transform = q),
                    $ && (P[0].style.webkitTransform = $),
                    e.roundLengths && (k = Math.floor(k));
                } else
                  (k = (n - (e.slidesPerView - 1) * b) / e.slidesPerView),
                    e.roundLengths && (k = Math.floor(k)),
                    c[L] &&
                      (this.isHorizontal()
                        ? (c[L].style.width = k + "px")
                        : (c[L].style.height = k + "px"));
                c[L] && (c[L].swiperSlideSize = k),
                  p.push(k),
                  e.centeredSlides
                    ? ((w = w + k / 2 + S / 2 + b),
                      0 === S && 0 !== L && (w = w - n / 2 - b),
                      0 === L && (w = w - n / 2 - b),
                      Math.abs(w) < 0.001 && (w = 0),
                      e.roundLengths && (w = Math.floor(w)),
                      x % e.slidesPerGroup == 0 && d.push(w),
                      h.push(w))
                    : (e.roundLengths && (w = Math.floor(w)),
                      (x - Math.min(this.params.slidesPerGroupSkip, x)) %
                        this.params.slidesPerGroup ==
                        0 && d.push(w),
                      h.push(w),
                      (w = w + k + b)),
                  (this.virtualSize += k + b),
                  (S = k),
                  (x += 1);
              }
            }
            if (
              ((this.virtualSize = Math.max(this.virtualSize, n) + m),
              s &&
                a &&
                ("slide" === e.effect || "coverflow" === e.effect) &&
                i.css({ width: this.virtualSize + e.spaceBetween + "px" }),
              e.setWrapperSize &&
                (this.isHorizontal()
                  ? i.css({ width: this.virtualSize + e.spaceBetween + "px" })
                  : i.css({
                      height: this.virtualSize + e.spaceBetween + "px",
                    })),
              e.slidesPerColumn > 1 &&
                ((this.virtualSize = (k + e.spaceBetween) * C),
                (this.virtualSize =
                  Math.ceil(this.virtualSize / e.slidesPerColumn) -
                  e.spaceBetween),
                this.isHorizontal()
                  ? i.css({ width: this.virtualSize + e.spaceBetween + "px" })
                  : i.css({ height: this.virtualSize + e.spaceBetween + "px" }),
                e.centeredSlides))
            ) {
              E = [];
              for (var Z = 0; Z < d.length; Z += 1) {
                var J = d[Z];
                e.roundLengths && (J = Math.floor(J)),
                  d[Z] < this.virtualSize + d[0] && E.push(J);
              }
              d = E;
            }
            if (!e.centeredSlides) {
              E = [];
              for (var ee = 0; ee < d.length; ee += 1) {
                var te = d[ee];
                e.roundLengths && (te = Math.floor(te)),
                  d[ee] <= this.virtualSize - n && E.push(te);
              }
              (d = E),
                Math.floor(this.virtualSize - n) - Math.floor(d[d.length - 1]) >
                  1 && d.push(this.virtualSize - n);
            }
            if (
              (0 === d.length && (d = [0]),
              0 !== e.spaceBetween &&
                (this.isHorizontal()
                  ? s
                    ? c.filter(f).css({ marginLeft: b + "px" })
                    : c.filter(f).css({ marginRight: b + "px" })
                  : c.filter(f).css({ marginBottom: b + "px" })),
              e.centeredSlides && e.centeredSlidesBounds)
            ) {
              var ie = 0;
              p.forEach(function (t) {
                ie += t + (e.spaceBetween ? e.spaceBetween : 0);
              });
              var ne = (ie -= e.spaceBetween) - n;
              d = d.map(function (e) {
                return e < 0 ? -v : e > ne ? ne + m : e;
              });
            }
            if (e.centerInsufficientSlides) {
              var se = 0;
              if (
                (p.forEach(function (t) {
                  se += t + (e.spaceBetween ? e.spaceBetween : 0);
                }),
                (se -= e.spaceBetween) < n)
              ) {
                var ae = (n - se) / 2;
                d.forEach(function (e, t) {
                  d[t] = e - ae;
                }),
                  h.forEach(function (e, t) {
                    h[t] = e + ae;
                  });
              }
            }
            r.extend(this, {
              slides: c,
              snapGrid: d,
              slidesGrid: h,
              slidesSizesGrid: p,
            }),
              u !== l && this.emit("slidesLengthChange"),
              d.length !== g &&
                (this.params.watchOverflow && this.checkOverflow(),
                this.emit("snapGridLengthChange")),
              h.length !== y && this.emit("slidesGridLengthChange"),
              (e.watchSlidesProgress || e.watchSlidesVisibility) &&
                this.updateSlidesOffset();
          }
        },
        updateAutoHeight: function (e) {
          var t,
            i = [],
            n = 0;
          if (
            ("number" == typeof e
              ? this.setTransition(e)
              : !0 === e && this.setTransition(this.params.speed),
            "auto" !== this.params.slidesPerView &&
              this.params.slidesPerView > 1)
          )
            if (this.params.centeredSlides)
              this.visibleSlides.each(function (e, t) {
                i.push(t);
              });
            else
              for (t = 0; t < Math.ceil(this.params.slidesPerView); t += 1) {
                var s = this.activeIndex + t;
                if (s > this.slides.length) break;
                i.push(this.slides.eq(s)[0]);
              }
          else i.push(this.slides.eq(this.activeIndex)[0]);
          for (t = 0; t < i.length; t += 1)
            if (void 0 !== i[t]) {
              var a = i[t].offsetHeight;
              n = a > n ? a : n;
            }
          n && this.$wrapperEl.css("height", n + "px");
        },
        updateSlidesOffset: function () {
          for (var e = this.slides, t = 0; t < e.length; t += 1)
            e[t].swiperSlideOffset = this.isHorizontal()
              ? e[t].offsetLeft
              : e[t].offsetTop;
        },
        updateSlidesProgress: function (e) {
          void 0 === e && (e = (this && this.translate) || 0);
          var t = this.params,
            i = this.slides,
            s = this.rtlTranslate;
          if (0 !== i.length) {
            void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset();
            var a = -e;
            s && (a = e),
              i.removeClass(t.slideVisibleClass),
              (this.visibleSlidesIndexes = []),
              (this.visibleSlides = []);
            for (var r = 0; r < i.length; r += 1) {
              var o = i[r],
                l =
                  (a +
                    (t.centeredSlides ? this.minTranslate() : 0) -
                    o.swiperSlideOffset) /
                  (o.swiperSlideSize + t.spaceBetween);
              if (
                t.watchSlidesVisibility ||
                (t.centeredSlides && t.autoHeight)
              ) {
                var c = -(a - o.swiperSlideOffset),
                  u = c + this.slidesSizesGrid[r];
                ((c >= 0 && c < this.size - 1) ||
                  (u > 1 && u <= this.size) ||
                  (c <= 0 && u >= this.size)) &&
                  (this.visibleSlides.push(o),
                  this.visibleSlidesIndexes.push(r),
                  i.eq(r).addClass(t.slideVisibleClass));
              }
              o.progress = s ? -l : l;
            }
            this.visibleSlides = n(this.visibleSlides);
          }
        },
        updateProgress: function (e) {
          if (void 0 === e) {
            var t = this.rtlTranslate ? -1 : 1;
            e = (this && this.translate && this.translate * t) || 0;
          }
          var i = this.params,
            n = this.maxTranslate() - this.minTranslate(),
            s = this.progress,
            a = this.isBeginning,
            o = this.isEnd,
            l = a,
            c = o;
          0 === n
            ? ((s = 0), (a = !0), (o = !0))
            : ((a = (s = (e - this.minTranslate()) / n) <= 0), (o = s >= 1)),
            r.extend(this, { progress: s, isBeginning: a, isEnd: o }),
            (i.watchSlidesProgress ||
              i.watchSlidesVisibility ||
              (i.centeredSlides && i.autoHeight)) &&
              this.updateSlidesProgress(e),
            a && !l && this.emit("reachBeginning toEdge"),
            o && !c && this.emit("reachEnd toEdge"),
            ((l && !a) || (c && !o)) && this.emit("fromEdge"),
            this.emit("progress", s);
        },
        updateSlidesClasses: function () {
          var e,
            t = this.slides,
            i = this.params,
            n = this.$wrapperEl,
            s = this.activeIndex,
            a = this.realIndex,
            r = this.virtual && i.virtual.enabled;
          t.removeClass(
            i.slideActiveClass +
              " " +
              i.slideNextClass +
              " " +
              i.slidePrevClass +
              " " +
              i.slideDuplicateActiveClass +
              " " +
              i.slideDuplicateNextClass +
              " " +
              i.slideDuplicatePrevClass
          ),
            (e = r
              ? this.$wrapperEl.find(
                  "." + i.slideClass + '[data-swiper-slide-index="' + s + '"]'
                )
              : t.eq(s)).addClass(i.slideActiveClass),
            i.loop &&
              (e.hasClass(i.slideDuplicateClass)
                ? n
                    .children(
                      "." +
                        i.slideClass +
                        ":not(." +
                        i.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        a +
                        '"]'
                    )
                    .addClass(i.slideDuplicateActiveClass)
                : n
                    .children(
                      "." +
                        i.slideClass +
                        "." +
                        i.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        a +
                        '"]'
                    )
                    .addClass(i.slideDuplicateActiveClass));
          var o = e
            .nextAll("." + i.slideClass)
            .eq(0)
            .addClass(i.slideNextClass);
          i.loop && 0 === o.length && (o = t.eq(0)).addClass(i.slideNextClass);
          var l = e
            .prevAll("." + i.slideClass)
            .eq(0)
            .addClass(i.slidePrevClass);
          i.loop && 0 === l.length && (l = t.eq(-1)).addClass(i.slidePrevClass),
            i.loop &&
              (o.hasClass(i.slideDuplicateClass)
                ? n
                    .children(
                      "." +
                        i.slideClass +
                        ":not(." +
                        i.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        o.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i.slideDuplicateNextClass)
                : n
                    .children(
                      "." +
                        i.slideClass +
                        "." +
                        i.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        o.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i.slideDuplicateNextClass),
              l.hasClass(i.slideDuplicateClass)
                ? n
                    .children(
                      "." +
                        i.slideClass +
                        ":not(." +
                        i.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        l.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i.slideDuplicatePrevClass)
                : n
                    .children(
                      "." +
                        i.slideClass +
                        "." +
                        i.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        l.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i.slideDuplicatePrevClass));
        },
        updateActiveIndex: function (e) {
          var t,
            i = this.rtlTranslate ? this.translate : -this.translate,
            n = this.slidesGrid,
            s = this.snapGrid,
            a = this.params,
            o = this.activeIndex,
            l = this.realIndex,
            c = this.snapIndex,
            u = e;
          if (void 0 === u) {
            for (var d = 0; d < n.length; d += 1)
              void 0 !== n[d + 1]
                ? i >= n[d] && i < n[d + 1] - (n[d + 1] - n[d]) / 2
                  ? (u = d)
                  : i >= n[d] && i < n[d + 1] && (u = d + 1)
                : i >= n[d] && (u = d);
            a.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
          }
          if (s.indexOf(i) >= 0) t = s.indexOf(i);
          else {
            var h = Math.min(a.slidesPerGroupSkip, u);
            t = h + Math.floor((u - h) / a.slidesPerGroup);
          }
          if ((t >= s.length && (t = s.length - 1), u !== o)) {
            var p = parseInt(
              this.slides.eq(u).attr("data-swiper-slide-index") || u,
              10
            );
            r.extend(this, {
              snapIndex: t,
              realIndex: p,
              previousIndex: o,
              activeIndex: u,
            }),
              this.emit("activeIndexChange"),
              this.emit("snapIndexChange"),
              l !== p && this.emit("realIndexChange"),
              (this.initialized || this.params.runCallbacksOnInit) &&
                this.emit("slideChange");
          } else
            t !== c && ((this.snapIndex = t), this.emit("snapIndexChange"));
        },
        updateClickedSlide: function (e) {
          var t = this.params,
            i = n(e.target).closest("." + t.slideClass)[0],
            s = !1;
          if (i)
            for (var a = 0; a < this.slides.length; a += 1)
              this.slides[a] === i && (s = !0);
          if (!i || !s)
            return (
              (this.clickedSlide = void 0), void (this.clickedIndex = void 0)
            );
          (this.clickedSlide = i),
            this.virtual && this.params.virtual.enabled
              ? (this.clickedIndex = parseInt(
                  n(i).attr("data-swiper-slide-index"),
                  10
                ))
              : (this.clickedIndex = n(i).index()),
            t.slideToClickedSlide &&
              void 0 !== this.clickedIndex &&
              this.clickedIndex !== this.activeIndex &&
              this.slideToClickedSlide();
        },
      },
      T = {
        getTranslate: function (e) {
          void 0 === e && (e = this.isHorizontal() ? "x" : "y");
          var t = this.params,
            i = this.rtlTranslate,
            n = this.translate,
            s = this.$wrapperEl;
          if (t.virtualTranslate) return i ? -n : n;
          if (t.cssMode) return n;
          var a = r.getTranslate(s[0], e);
          return i && (a = -a), a || 0;
        },
        setTranslate: function (e, t) {
          var i = this.rtlTranslate,
            n = this.params,
            s = this.$wrapperEl,
            a = this.wrapperEl,
            r = this.progress,
            o = 0,
            l = 0;
          this.isHorizontal() ? (o = i ? -e : e) : (l = e),
            n.roundLengths && ((o = Math.floor(o)), (l = Math.floor(l))),
            n.cssMode
              ? (a[this.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                  this.isHorizontal() ? -o : -l)
              : n.virtualTranslate ||
                s.transform("translate3d(" + o + "px, " + l + "px, 0px)"),
            (this.previousTranslate = this.translate),
            (this.translate = this.isHorizontal() ? o : l);
          var c = this.maxTranslate() - this.minTranslate();
          (0 === c ? 0 : (e - this.minTranslate()) / c) !== r &&
            this.updateProgress(e),
            this.emit("setTranslate", this.translate, t);
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e, t, i, n, s) {
          var a;
          void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === i && (i = !0),
            void 0 === n && (n = !0);
          var r = this,
            o = r.params,
            l = r.wrapperEl;
          if (r.animating && o.preventInteractionOnTransition) return !1;
          var c,
            u = r.minTranslate(),
            d = r.maxTranslate();
          if (
            ((c = n && e > u ? u : n && e < d ? d : e),
            r.updateProgress(c),
            o.cssMode)
          ) {
            var h = r.isHorizontal();
            return (
              0 === t
                ? (l[h ? "scrollLeft" : "scrollTop"] = -c)
                : l.scrollTo
                ? l.scrollTo(
                    (((a = {})[h ? "left" : "top"] = -c),
                    (a.behavior = "smooth"),
                    a)
                  )
                : (l[h ? "scrollLeft" : "scrollTop"] = -c),
              !0
            );
          }
          return (
            0 === t
              ? (r.setTransition(0),
                r.setTranslate(c),
                i &&
                  (r.emit("beforeTransitionStart", t, s),
                  r.emit("transitionEnd")))
              : (r.setTransition(t),
                r.setTranslate(c),
                i &&
                  (r.emit("beforeTransitionStart", t, s),
                  r.emit("transitionStart")),
                r.animating ||
                  ((r.animating = !0),
                  r.onTranslateToWrapperTransitionEnd ||
                    (r.onTranslateToWrapperTransitionEnd = function (e) {
                      r &&
                        !r.destroyed &&
                        e.target === this &&
                        (r.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          r.onTranslateToWrapperTransitionEnd
                        ),
                        r.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          r.onTranslateToWrapperTransitionEnd
                        ),
                        (r.onTranslateToWrapperTransitionEnd = null),
                        delete r.onTranslateToWrapperTransitionEnd,
                        i && r.emit("transitionEnd"));
                    }),
                  r.$wrapperEl[0].addEventListener(
                    "transitionend",
                    r.onTranslateToWrapperTransitionEnd
                  ),
                  r.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    r.onTranslateToWrapperTransitionEnd
                  ))),
            !0
          );
        },
      },
      _ = {
        slideTo: function (e, t, i, n) {
          var s;
          void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === i && (i = !0);
          var a = this,
            r = e;
          r < 0 && (r = 0);
          var o = a.params,
            l = a.snapGrid,
            c = a.slidesGrid,
            u = a.previousIndex,
            d = a.activeIndex,
            h = a.rtlTranslate,
            p = a.wrapperEl;
          if (a.animating && o.preventInteractionOnTransition) return !1;
          var f = Math.min(a.params.slidesPerGroupSkip, r),
            v = f + Math.floor((r - f) / a.params.slidesPerGroup);
          v >= l.length && (v = l.length - 1),
            (d || o.initialSlide || 0) === (u || 0) &&
              i &&
              a.emit("beforeSlideChangeStart");
          var m,
            g = -l[v];
          if ((a.updateProgress(g), o.normalizeSlideIndex))
            for (var y = 0; y < c.length; y += 1)
              -Math.floor(100 * g) >= Math.floor(100 * c[y]) && (r = y);
          if (a.initialized && r !== d) {
            if (!a.allowSlideNext && g < a.translate && g < a.minTranslate())
              return !1;
            if (
              !a.allowSlidePrev &&
              g > a.translate &&
              g > a.maxTranslate() &&
              (d || 0) !== r
            )
              return !1;
          }
          if (
            ((m = r > d ? "next" : r < d ? "prev" : "reset"),
            (h && -g === a.translate) || (!h && g === a.translate))
          )
            return (
              a.updateActiveIndex(r),
              o.autoHeight && a.updateAutoHeight(),
              a.updateSlidesClasses(),
              "slide" !== o.effect && a.setTranslate(g),
              "reset" !== m && (a.transitionStart(i, m), a.transitionEnd(i, m)),
              !1
            );
          if (o.cssMode) {
            var b = a.isHorizontal(),
              w = -g;
            return (
              h && (w = p.scrollWidth - p.offsetWidth - w),
              0 === t
                ? (p[b ? "scrollLeft" : "scrollTop"] = w)
                : p.scrollTo
                ? p.scrollTo(
                    (((s = {})[b ? "left" : "top"] = w),
                    (s.behavior = "smooth"),
                    s)
                  )
                : (p[b ? "scrollLeft" : "scrollTop"] = w),
              !0
            );
          }
          return (
            0 === t
              ? (a.setTransition(0),
                a.setTranslate(g),
                a.updateActiveIndex(r),
                a.updateSlidesClasses(),
                a.emit("beforeTransitionStart", t, n),
                a.transitionStart(i, m),
                a.transitionEnd(i, m))
              : (a.setTransition(t),
                a.setTranslate(g),
                a.updateActiveIndex(r),
                a.updateSlidesClasses(),
                a.emit("beforeTransitionStart", t, n),
                a.transitionStart(i, m),
                a.animating ||
                  ((a.animating = !0),
                  a.onSlideToWrapperTransitionEnd ||
                    (a.onSlideToWrapperTransitionEnd = function (e) {
                      a &&
                        !a.destroyed &&
                        e.target === this &&
                        (a.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          a.onSlideToWrapperTransitionEnd
                        ),
                        a.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          a.onSlideToWrapperTransitionEnd
                        ),
                        (a.onSlideToWrapperTransitionEnd = null),
                        delete a.onSlideToWrapperTransitionEnd,
                        a.transitionEnd(i, m));
                    }),
                  a.$wrapperEl[0].addEventListener(
                    "transitionend",
                    a.onSlideToWrapperTransitionEnd
                  ),
                  a.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    a.onSlideToWrapperTransitionEnd
                  ))),
            !0
          );
        },
        slideToLoop: function (e, t, i, n) {
          void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === i && (i = !0);
          var s = e;
          return (
            this.params.loop && (s += this.loopedSlides),
            this.slideTo(s, t, i, n)
          );
        },
        slideNext: function (e, t, i) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
          var n = this.params,
            s = this.animating,
            a = this.activeIndex < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup;
          if (n.loop) {
            if (s) return !1;
            this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft);
          }
          return this.slideTo(this.activeIndex + a, e, t, i);
        },
        slidePrev: function (e, t, i) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
          var n = this.params,
            s = this.animating,
            a = this.snapGrid,
            r = this.slidesGrid,
            o = this.rtlTranslate;
          if (n.loop) {
            if (s) return !1;
            this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft);
          }
          function l(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          var c,
            u = l(o ? this.translate : -this.translate),
            d = a.map(function (e) {
              return l(e);
            }),
            h =
              (r.map(function (e) {
                return l(e);
              }),
              a[d.indexOf(u)],
              a[d.indexOf(u) - 1]);
          return (
            void 0 === h &&
              n.cssMode &&
              a.forEach(function (e) {
                !h && u >= e && (h = e);
              }),
            void 0 !== h &&
              (c = r.indexOf(h)) < 0 &&
              (c = this.activeIndex - 1),
            this.slideTo(c, e, t, i)
          );
        },
        slideReset: function (e, t, i) {
          return (
            void 0 === e && (e = this.params.speed),
            void 0 === t && (t = !0),
            this.slideTo(this.activeIndex, e, t, i)
          );
        },
        slideToClosest: function (e, t, i, n) {
          void 0 === e && (e = this.params.speed),
            void 0 === t && (t = !0),
            void 0 === n && (n = 0.5);
          var s = this.activeIndex,
            a = Math.min(this.params.slidesPerGroupSkip, s),
            r = a + Math.floor((s - a) / this.params.slidesPerGroup),
            o = this.rtlTranslate ? this.translate : -this.translate;
          if (o >= this.snapGrid[r]) {
            var l = this.snapGrid[r];
            o - l > (this.snapGrid[r + 1] - l) * n &&
              (s += this.params.slidesPerGroup);
          } else {
            var c = this.snapGrid[r - 1];
            o - c <= (this.snapGrid[r] - c) * n &&
              (s -= this.params.slidesPerGroup);
          }
          return (
            (s = Math.max(s, 0)),
            (s = Math.min(s, this.slidesGrid.length - 1)),
            this.slideTo(s, e, t, i)
          );
        },
        slideToClickedSlide: function () {
          var e,
            t = this,
            i = t.params,
            s = t.$wrapperEl,
            a =
              "auto" === i.slidesPerView
                ? t.slidesPerViewDynamic()
                : i.slidesPerView,
            o = t.clickedIndex;
          if (i.loop) {
            if (t.animating) return;
            (e = parseInt(
              n(t.clickedSlide).attr("data-swiper-slide-index"),
              10
            )),
              i.centeredSlides
                ? o < t.loopedSlides - a / 2 ||
                  o > t.slides.length - t.loopedSlides + a / 2
                  ? (t.loopFix(),
                    (o = s
                      .children(
                        "." +
                          i.slideClass +
                          '[data-swiper-slide-index="' +
                          e +
                          '"]:not(.' +
                          i.slideDuplicateClass +
                          ")"
                      )
                      .eq(0)
                      .index()),
                    r.nextTick(function () {
                      t.slideTo(o);
                    }))
                  : t.slideTo(o)
                : o > t.slides.length - a
                ? (t.loopFix(),
                  (o = s
                    .children(
                      "." +
                        i.slideClass +
                        '[data-swiper-slide-index="' +
                        e +
                        '"]:not(.' +
                        i.slideDuplicateClass +
                        ")"
                    )
                    .eq(0)
                    .index()),
                  r.nextTick(function () {
                    t.slideTo(o);
                  }))
                : t.slideTo(o);
          } else t.slideTo(o);
        },
      },
      M = {
        loopCreate: function () {
          var t = this,
            i = t.params,
            s = t.$wrapperEl;
          s.children("." + i.slideClass + "." + i.slideDuplicateClass).remove();
          var a = s.children("." + i.slideClass);
          if (i.loopFillGroupWithBlank) {
            var r = i.slidesPerGroup - (a.length % i.slidesPerGroup);
            if (r !== i.slidesPerGroup) {
              for (var o = 0; o < r; o += 1) {
                var l = n(e.createElement("div")).addClass(
                  i.slideClass + " " + i.slideBlankClass
                );
                s.append(l);
              }
              a = s.children("." + i.slideClass);
            }
          }
          "auto" !== i.slidesPerView ||
            i.loopedSlides ||
            (i.loopedSlides = a.length),
            (t.loopedSlides = Math.ceil(
              parseFloat(i.loopedSlides || i.slidesPerView, 10)
            )),
            (t.loopedSlides += i.loopAdditionalSlides),
            t.loopedSlides > a.length && (t.loopedSlides = a.length);
          var c = [],
            u = [];
          a.each(function (e, i) {
            var s = n(i);
            e < t.loopedSlides && u.push(i),
              e < a.length && e >= a.length - t.loopedSlides && c.push(i),
              s.attr("data-swiper-slide-index", e);
          });
          for (var d = 0; d < u.length; d += 1)
            s.append(n(u[d].cloneNode(!0)).addClass(i.slideDuplicateClass));
          for (var h = c.length - 1; h >= 0; h -= 1)
            s.prepend(n(c[h].cloneNode(!0)).addClass(i.slideDuplicateClass));
        },
        loopFix: function () {
          this.emit("beforeLoopFix");
          var e,
            t = this.activeIndex,
            i = this.slides,
            n = this.loopedSlides,
            s = this.allowSlidePrev,
            a = this.allowSlideNext,
            r = this.snapGrid,
            o = this.rtlTranslate;
          (this.allowSlidePrev = !0), (this.allowSlideNext = !0);
          var l = -r[t] - this.getTranslate();
          t < n
            ? ((e = i.length - 3 * n + t),
              (e += n),
              this.slideTo(e, 0, !1, !0) &&
                0 !== l &&
                this.setTranslate((o ? -this.translate : this.translate) - l))
            : t >= i.length - n &&
              ((e = -i.length + t + n),
              (e += n),
              this.slideTo(e, 0, !1, !0) &&
                0 !== l &&
                this.setTranslate((o ? -this.translate : this.translate) - l)),
            (this.allowSlidePrev = s),
            (this.allowSlideNext = a),
            this.emit("loopFix");
        },
        loopDestroy: function () {
          var e = this.$wrapperEl,
            t = this.params,
            i = this.slides;
          e
            .children(
              "." +
                t.slideClass +
                "." +
                t.slideDuplicateClass +
                ",." +
                t.slideClass +
                "." +
                t.slideBlankClass
            )
            .remove(),
            i.removeAttr("data-swiper-slide-index");
        },
      },
      L = {
        setGrabCursor: function (e) {
          if (
            !(
              o.touch ||
              !this.params.simulateTouch ||
              (this.params.watchOverflow && this.isLocked) ||
              this.params.cssMode
            )
          ) {
            var t = this.el;
            (t.style.cursor = "move"),
              (t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
              (t.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
              (t.style.cursor = e ? "grabbing" : "grab");
          }
        },
        unsetGrabCursor: function () {
          o.touch ||
            (this.params.watchOverflow && this.isLocked) ||
            this.params.cssMode ||
            (this.el.style.cursor = "");
        },
      },
      P = {
        appendSlide: function (e) {
          var t = this.$wrapperEl,
            i = this.params;
          if (
            (i.loop && this.loopDestroy(),
            "object" == typeof e && "length" in e)
          )
            for (var n = 0; n < e.length; n += 1) e[n] && t.append(e[n]);
          else t.append(e);
          i.loop && this.loopCreate(),
            (i.observer && o.observer) || this.update();
        },
        prependSlide: function (e) {
          var t = this.params,
            i = this.$wrapperEl,
            n = this.activeIndex;
          t.loop && this.loopDestroy();
          var s = n + 1;
          if ("object" == typeof e && "length" in e) {
            for (var a = 0; a < e.length; a += 1) e[a] && i.prepend(e[a]);
            s = n + e.length;
          } else i.prepend(e);
          t.loop && this.loopCreate(),
            (t.observer && o.observer) || this.update(),
            this.slideTo(s, 0, !1);
        },
        addSlide: function (e, t) {
          var i = this.$wrapperEl,
            n = this.params,
            s = this.activeIndex;
          n.loop &&
            ((s -= this.loopedSlides),
            this.loopDestroy(),
            (this.slides = i.children("." + n.slideClass)));
          var a = this.slides.length;
          if (e <= 0) this.prependSlide(t);
          else if (e >= a) this.appendSlide(t);
          else {
            for (var r = s > e ? s + 1 : s, l = [], c = a - 1; c >= e; c -= 1) {
              var u = this.slides.eq(c);
              u.remove(), l.unshift(u);
            }
            if ("object" == typeof t && "length" in t) {
              for (var d = 0; d < t.length; d += 1) t[d] && i.append(t[d]);
              r = s > e ? s + t.length : s;
            } else i.append(t);
            for (var h = 0; h < l.length; h += 1) i.append(l[h]);
            n.loop && this.loopCreate(),
              (n.observer && o.observer) || this.update(),
              n.loop
                ? this.slideTo(r + this.loopedSlides, 0, !1)
                : this.slideTo(r, 0, !1);
          }
        },
        removeSlide: function (e) {
          var t = this.params,
            i = this.$wrapperEl,
            n = this.activeIndex;
          t.loop &&
            ((n -= this.loopedSlides),
            this.loopDestroy(),
            (this.slides = i.children("." + t.slideClass)));
          var s,
            a = n;
          if ("object" == typeof e && "length" in e) {
            for (var r = 0; r < e.length; r += 1)
              (s = e[r]),
                this.slides[s] && this.slides.eq(s).remove(),
                s < a && (a -= 1);
            a = Math.max(a, 0);
          } else
            (s = e),
              this.slides[s] && this.slides.eq(s).remove(),
              s < a && (a -= 1),
              (a = Math.max(a, 0));
          t.loop && this.loopCreate(),
            (t.observer && o.observer) || this.update(),
            t.loop
              ? this.slideTo(a + this.loopedSlides, 0, !1)
              : this.slideTo(a, 0, !1);
        },
        removeAllSlides: function () {
          for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
          this.removeSlide(e);
        },
      },
      I =
        ((u = t.navigator.platform),
        (d = t.navigator.userAgent),
        (h = {
          ios: !1,
          android: !1,
          androidChrome: !1,
          desktop: !1,
          iphone: !1,
          ipod: !1,
          ipad: !1,
          edge: !1,
          ie: !1,
          firefox: !1,
          macos: !1,
          windows: !1,
          cordova: !(!t.cordova && !t.phonegap),
          phonegap: !(!t.cordova && !t.phonegap),
          electron: !1,
        }),
        (p = t.screen.width),
        (f = t.screen.height),
        (v = d.match(/(Android);?[\s\/]+([\d.]+)?/)),
        (m = d.match(/(iPad).*OS\s([\d_]+)/)),
        (g = d.match(/(iPod)(.*OS\s([\d_]+))?/)),
        (y = !m && d.match(/(iPhone\sOS|iOS)\s([\d_]+)/)),
        (b = d.indexOf("MSIE ") >= 0 || d.indexOf("Trident/") >= 0),
        (w = d.indexOf("Edge/") >= 0),
        (S = d.indexOf("Gecko/") >= 0 && d.indexOf("Firefox/") >= 0),
        (x = "Win32" === u),
        (C = d.toLowerCase().indexOf("electron") >= 0),
        (k = "MacIntel" === u),
        !m &&
          k &&
          o.touch &&
          ((1024 === p && 1366 === f) ||
            (834 === p && 1194 === f) ||
            (834 === p && 1112 === f) ||
            (768 === p && 1024 === f)) &&
          ((m = d.match(/(Version)\/([\d.]+)/)), (k = !1)),
        (h.ie = b),
        (h.edge = w),
        (h.firefox = S),
        v &&
          !x &&
          ((h.os = "android"),
          (h.osVersion = v[2]),
          (h.android = !0),
          (h.androidChrome = d.toLowerCase().indexOf("chrome") >= 0)),
        (m || y || g) && ((h.os = "ios"), (h.ios = !0)),
        y && !g && ((h.osVersion = y[2].replace(/_/g, ".")), (h.iphone = !0)),
        m && ((h.osVersion = m[2].replace(/_/g, ".")), (h.ipad = !0)),
        g &&
          ((h.osVersion = g[3] ? g[3].replace(/_/g, ".") : null),
          (h.ipod = !0)),
        h.ios &&
          h.osVersion &&
          d.indexOf("Version/") >= 0 &&
          "10" === h.osVersion.split(".")[0] &&
          (h.osVersion = d.toLowerCase().split("version/")[1].split(" ")[0]),
        (h.webView =
          !(
            !(y || m || g) ||
            (!d.match(/.*AppleWebKit(?!.*Safari)/i) && !t.navigator.standalone)
          ) ||
          (t.matchMedia && t.matchMedia("(display-mode: standalone)").matches)),
        (h.webview = h.webView),
        (h.standalone = h.webView),
        (h.desktop = !(h.ios || h.android) || C),
        h.desktop &&
          ((h.electron = C),
          (h.macos = k),
          (h.windows = x),
          h.macos && (h.os = "macos"),
          h.windows && (h.os = "windows")),
        (h.pixelRatio = t.devicePixelRatio || 1),
        h);
    function D(i) {
      var s = this.touchEventsData,
        a = this.params,
        o = this.touches;
      if (!this.animating || !a.preventInteractionOnTransition) {
        var l = i;
        l.originalEvent && (l = l.originalEvent);
        var c = n(l.target);
        if (
          ("wrapper" !== a.touchEventsTarget ||
            c.closest(this.wrapperEl).length) &&
          ((s.isTouchEvent = "touchstart" === l.type),
          (s.isTouchEvent || !("which" in l) || 3 !== l.which) &&
            !(
              (!s.isTouchEvent && "button" in l && l.button > 0) ||
              (s.isTouched && s.isMoved)
            ))
        )
          if (
            a.noSwiping &&
            c.closest(
              a.noSwipingSelector ? a.noSwipingSelector : "." + a.noSwipingClass
            )[0]
          )
            this.allowClick = !0;
          else if (!a.swipeHandler || c.closest(a.swipeHandler)[0]) {
            (o.currentX =
              "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX),
              (o.currentY =
                "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY);
            var u = o.currentX,
              d = o.currentY,
              h = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection,
              p = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold;
            if (!h || !(u <= p || u >= t.screen.width - p)) {
              if (
                (r.extend(s, {
                  isTouched: !0,
                  isMoved: !1,
                  allowTouchCallbacks: !0,
                  isScrolling: void 0,
                  startMoving: void 0,
                }),
                (o.startX = u),
                (o.startY = d),
                (s.touchStartTime = r.now()),
                (this.allowClick = !0),
                this.updateSize(),
                (this.swipeDirection = void 0),
                a.threshold > 0 && (s.allowThresholdMove = !1),
                "touchstart" !== l.type)
              ) {
                var f = !0;
                c.is(s.formElements) && (f = !1),
                  e.activeElement &&
                    n(e.activeElement).is(s.formElements) &&
                    e.activeElement !== c[0] &&
                    e.activeElement.blur();
                var v = f && this.allowTouchMove && a.touchStartPreventDefault;
                (a.touchStartForcePreventDefault || v) && l.preventDefault();
              }
              this.emit("touchStart", l);
            }
          }
      }
    }
    function A(t) {
      var i = this.touchEventsData,
        s = this.params,
        a = this.touches,
        o = this.rtlTranslate,
        l = t;
      if ((l.originalEvent && (l = l.originalEvent), i.isTouched)) {
        if (!i.isTouchEvent || "mousemove" !== l.type) {
          var c =
              "touchmove" === l.type &&
              l.targetTouches &&
              (l.targetTouches[0] || l.changedTouches[0]),
            u = "touchmove" === l.type ? c.pageX : l.pageX,
            d = "touchmove" === l.type ? c.pageY : l.pageY;
          if (l.preventedByNestedSwiper)
            return (a.startX = u), void (a.startY = d);
          if (!this.allowTouchMove)
            return (
              (this.allowClick = !1),
              void (
                i.isTouched &&
                (r.extend(a, {
                  startX: u,
                  startY: d,
                  currentX: u,
                  currentY: d,
                }),
                (i.touchStartTime = r.now()))
              )
            );
          if (i.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
            if (this.isVertical()) {
              if (
                (d < a.startY && this.translate <= this.maxTranslate()) ||
                (d > a.startY && this.translate >= this.minTranslate())
              )
                return (i.isTouched = !1), void (i.isMoved = !1);
            } else if (
              (u < a.startX && this.translate <= this.maxTranslate()) ||
              (u > a.startX && this.translate >= this.minTranslate())
            )
              return;
          if (
            i.isTouchEvent &&
            e.activeElement &&
            l.target === e.activeElement &&
            n(l.target).is(i.formElements)
          )
            return (i.isMoved = !0), void (this.allowClick = !1);
          if (
            (i.allowTouchCallbacks && this.emit("touchMove", l),
            !(l.targetTouches && l.targetTouches.length > 1))
          ) {
            (a.currentX = u), (a.currentY = d);
            var h,
              p = a.currentX - a.startX,
              f = a.currentY - a.startY;
            if (
              !(
                this.params.threshold &&
                Math.sqrt(Math.pow(p, 2) + Math.pow(f, 2)) <
                  this.params.threshold
              )
            )
              if (
                (void 0 === i.isScrolling &&
                  ((this.isHorizontal() && a.currentY === a.startY) ||
                  (this.isVertical() && a.currentX === a.startX)
                    ? (i.isScrolling = !1)
                    : p * p + f * f >= 25 &&
                      ((h =
                        (180 * Math.atan2(Math.abs(f), Math.abs(p))) / Math.PI),
                      (i.isScrolling = this.isHorizontal()
                        ? h > s.touchAngle
                        : 90 - h > s.touchAngle))),
                i.isScrolling && this.emit("touchMoveOpposite", l),
                void 0 === i.startMoving &&
                  ((a.currentX === a.startX && a.currentY === a.startY) ||
                    (i.startMoving = !0)),
                i.isScrolling)
              )
                i.isTouched = !1;
              else if (i.startMoving) {
                (this.allowClick = !1),
                  s.cssMode || l.preventDefault(),
                  s.touchMoveStopPropagation &&
                    !s.nested &&
                    l.stopPropagation(),
                  i.isMoved ||
                    (s.loop && this.loopFix(),
                    (i.startTranslate = this.getTranslate()),
                    this.setTransition(0),
                    this.animating &&
                      this.$wrapperEl.trigger(
                        "webkitTransitionEnd transitionend"
                      ),
                    (i.allowMomentumBounce = !1),
                    !s.grabCursor ||
                      (!0 !== this.allowSlideNext &&
                        !0 !== this.allowSlidePrev) ||
                      this.setGrabCursor(!0),
                    this.emit("sliderFirstMove", l)),
                  this.emit("sliderMove", l),
                  (i.isMoved = !0);
                var v = this.isHorizontal() ? p : f;
                (a.diff = v),
                  (v *= s.touchRatio),
                  o && (v = -v),
                  (this.swipeDirection = v > 0 ? "prev" : "next"),
                  (i.currentTranslate = v + i.startTranslate);
                var m = !0,
                  g = s.resistanceRatio;
                if (
                  (s.touchReleaseOnEdges && (g = 0),
                  v > 0 && i.currentTranslate > this.minTranslate()
                    ? ((m = !1),
                      s.resistance &&
                        (i.currentTranslate =
                          this.minTranslate() -
                          1 +
                          Math.pow(
                            -this.minTranslate() + i.startTranslate + v,
                            g
                          )))
                    : v < 0 &&
                      i.currentTranslate < this.maxTranslate() &&
                      ((m = !1),
                      s.resistance &&
                        (i.currentTranslate =
                          this.maxTranslate() +
                          1 -
                          Math.pow(
                            this.maxTranslate() - i.startTranslate - v,
                            g
                          ))),
                  m && (l.preventedByNestedSwiper = !0),
                  !this.allowSlideNext &&
                    "next" === this.swipeDirection &&
                    i.currentTranslate < i.startTranslate &&
                    (i.currentTranslate = i.startTranslate),
                  !this.allowSlidePrev &&
                    "prev" === this.swipeDirection &&
                    i.currentTranslate > i.startTranslate &&
                    (i.currentTranslate = i.startTranslate),
                  s.threshold > 0)
                ) {
                  if (!(Math.abs(v) > s.threshold || i.allowThresholdMove))
                    return void (i.currentTranslate = i.startTranslate);
                  if (!i.allowThresholdMove)
                    return (
                      (i.allowThresholdMove = !0),
                      (a.startX = a.currentX),
                      (a.startY = a.currentY),
                      (i.currentTranslate = i.startTranslate),
                      void (a.diff = this.isHorizontal()
                        ? a.currentX - a.startX
                        : a.currentY - a.startY)
                    );
                }
                s.followFinger &&
                  !s.cssMode &&
                  ((s.freeMode ||
                    s.watchSlidesProgress ||
                    s.watchSlidesVisibility) &&
                    (this.updateActiveIndex(), this.updateSlidesClasses()),
                  s.freeMode &&
                    (0 === i.velocities.length &&
                      i.velocities.push({
                        position: a[this.isHorizontal() ? "startX" : "startY"],
                        time: i.touchStartTime,
                      }),
                    i.velocities.push({
                      position:
                        a[this.isHorizontal() ? "currentX" : "currentY"],
                      time: r.now(),
                    })),
                  this.updateProgress(i.currentTranslate),
                  this.setTranslate(i.currentTranslate));
              }
          }
        }
      } else i.startMoving && i.isScrolling && this.emit("touchMoveOpposite", l);
    }
    function z(e) {
      var t = this,
        i = t.touchEventsData,
        n = t.params,
        s = t.touches,
        a = t.rtlTranslate,
        o = t.$wrapperEl,
        l = t.slidesGrid,
        c = t.snapGrid,
        u = e;
      if (
        (u.originalEvent && (u = u.originalEvent),
        i.allowTouchCallbacks && t.emit("touchEnd", u),
        (i.allowTouchCallbacks = !1),
        !i.isTouched)
      )
        return (
          i.isMoved && n.grabCursor && t.setGrabCursor(!1),
          (i.isMoved = !1),
          void (i.startMoving = !1)
        );
      n.grabCursor &&
        i.isMoved &&
        i.isTouched &&
        (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
        t.setGrabCursor(!1);
      var d,
        h = r.now(),
        p = h - i.touchStartTime;
      if (
        (t.allowClick &&
          (t.updateClickedSlide(u),
          t.emit("tap click", u),
          p < 300 &&
            h - i.lastClickTime < 300 &&
            t.emit("doubleTap doubleClick", u)),
        (i.lastClickTime = r.now()),
        r.nextTick(function () {
          t.destroyed || (t.allowClick = !0);
        }),
        !i.isTouched ||
          !i.isMoved ||
          !t.swipeDirection ||
          0 === s.diff ||
          i.currentTranslate === i.startTranslate)
      )
        return (i.isTouched = !1), (i.isMoved = !1), void (i.startMoving = !1);
      if (
        ((i.isTouched = !1),
        (i.isMoved = !1),
        (i.startMoving = !1),
        (d = n.followFinger
          ? a
            ? t.translate
            : -t.translate
          : -i.currentTranslate),
        !n.cssMode)
      )
        if (n.freeMode) {
          if (d < -t.minTranslate()) return void t.slideTo(t.activeIndex);
          if (d > -t.maxTranslate())
            return void (t.slides.length < c.length
              ? t.slideTo(c.length - 1)
              : t.slideTo(t.slides.length - 1));
          if (n.freeModeMomentum) {
            if (i.velocities.length > 1) {
              var f = i.velocities.pop(),
                v = i.velocities.pop(),
                m = f.position - v.position,
                g = f.time - v.time;
              (t.velocity = m / g),
                (t.velocity /= 2),
                Math.abs(t.velocity) < n.freeModeMinimumVelocity &&
                  (t.velocity = 0),
                (g > 150 || r.now() - f.time > 300) && (t.velocity = 0);
            } else t.velocity = 0;
            (t.velocity *= n.freeModeMomentumVelocityRatio),
              (i.velocities.length = 0);
            var y = 1e3 * n.freeModeMomentumRatio,
              b = t.velocity * y,
              w = t.translate + b;
            a && (w = -w);
            var S,
              x,
              C = !1,
              k = 20 * Math.abs(t.velocity) * n.freeModeMomentumBounceRatio;
            if (w < t.maxTranslate())
              n.freeModeMomentumBounce
                ? (w + t.maxTranslate() < -k && (w = t.maxTranslate() - k),
                  (S = t.maxTranslate()),
                  (C = !0),
                  (i.allowMomentumBounce = !0))
                : (w = t.maxTranslate()),
                n.loop && n.centeredSlides && (x = !0);
            else if (w > t.minTranslate())
              n.freeModeMomentumBounce
                ? (w - t.minTranslate() > k && (w = t.minTranslate() + k),
                  (S = t.minTranslate()),
                  (C = !0),
                  (i.allowMomentumBounce = !0))
                : (w = t.minTranslate()),
                n.loop && n.centeredSlides && (x = !0);
            else if (n.freeModeSticky) {
              for (var E, T = 0; T < c.length; T += 1)
                if (c[T] > -w) {
                  E = T;
                  break;
                }
              w = -(w =
                Math.abs(c[E] - w) < Math.abs(c[E - 1] - w) ||
                "next" === t.swipeDirection
                  ? c[E]
                  : c[E - 1]);
            }
            if (
              (x &&
                t.once("transitionEnd", function () {
                  t.loopFix();
                }),
              0 !== t.velocity)
            ) {
              if (
                ((y = a
                  ? Math.abs((-w - t.translate) / t.velocity)
                  : Math.abs((w - t.translate) / t.velocity)),
                n.freeModeSticky)
              ) {
                var _ = Math.abs((a ? -w : w) - t.translate),
                  M = t.slidesSizesGrid[t.activeIndex];
                y = _ < M ? n.speed : _ < 2 * M ? 1.5 * n.speed : 2.5 * n.speed;
              }
            } else if (n.freeModeSticky) return void t.slideToClosest();
            n.freeModeMomentumBounce && C
              ? (t.updateProgress(S),
                t.setTransition(y),
                t.setTranslate(w),
                t.transitionStart(!0, t.swipeDirection),
                (t.animating = !0),
                o.transitionEnd(function () {
                  t &&
                    !t.destroyed &&
                    i.allowMomentumBounce &&
                    (t.emit("momentumBounce"),
                    t.setTransition(n.speed),
                    setTimeout(function () {
                      t.setTranslate(S),
                        o.transitionEnd(function () {
                          t && !t.destroyed && t.transitionEnd();
                        });
                    }, 0));
                }))
              : t.velocity
              ? (t.updateProgress(w),
                t.setTransition(y),
                t.setTranslate(w),
                t.transitionStart(!0, t.swipeDirection),
                t.animating ||
                  ((t.animating = !0),
                  o.transitionEnd(function () {
                    t && !t.destroyed && t.transitionEnd();
                  })))
              : t.updateProgress(w),
              t.updateActiveIndex(),
              t.updateSlidesClasses();
          } else if (n.freeModeSticky) return void t.slideToClosest();
          (!n.freeModeMomentum || p >= n.longSwipesMs) &&
            (t.updateProgress(),
            t.updateActiveIndex(),
            t.updateSlidesClasses());
        } else {
          for (
            var L = 0, P = t.slidesSizesGrid[0], I = 0;
            I < l.length;
            I += I < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup
          ) {
            var D = I < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
            void 0 !== l[I + D]
              ? d >= l[I] && d < l[I + D] && ((L = I), (P = l[I + D] - l[I]))
              : d >= l[I] && ((L = I), (P = l[l.length - 1] - l[l.length - 2]));
          }
          var A = (d - l[L]) / P,
            z = L < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
          if (p > n.longSwipesMs) {
            if (!n.longSwipes) return void t.slideTo(t.activeIndex);
            "next" === t.swipeDirection &&
              (A >= n.longSwipesRatio ? t.slideTo(L + z) : t.slideTo(L)),
              "prev" === t.swipeDirection &&
                (A > 1 - n.longSwipesRatio ? t.slideTo(L + z) : t.slideTo(L));
          } else {
            if (!n.shortSwipes) return void t.slideTo(t.activeIndex);
            !t.navigation ||
            (u.target !== t.navigation.nextEl &&
              u.target !== t.navigation.prevEl)
              ? ("next" === t.swipeDirection && t.slideTo(L + z),
                "prev" === t.swipeDirection && t.slideTo(L))
              : u.target === t.navigation.nextEl
              ? t.slideTo(L + z)
              : t.slideTo(L);
          }
        }
    }
    function O() {
      var e = this.params,
        t = this.el;
      if (!t || 0 !== t.offsetWidth) {
        e.breakpoints && this.setBreakpoint();
        var i = this.allowSlideNext,
          n = this.allowSlidePrev,
          s = this.snapGrid;
        (this.allowSlideNext = !0),
          (this.allowSlidePrev = !0),
          this.updateSize(),
          this.updateSlides(),
          this.updateSlidesClasses(),
          ("auto" === e.slidesPerView || e.slidesPerView > 1) &&
          this.isEnd &&
          !this.params.centeredSlides
            ? this.slideTo(this.slides.length - 1, 0, !1, !0)
            : this.slideTo(this.activeIndex, 0, !1, !0),
          this.autoplay &&
            this.autoplay.running &&
            this.autoplay.paused &&
            this.autoplay.run(),
          (this.allowSlidePrev = n),
          (this.allowSlideNext = i),
          this.params.watchOverflow &&
            s !== this.snapGrid &&
            this.checkOverflow();
      }
    }
    function B(e) {
      this.allowClick ||
        (this.params.preventClicks && e.preventDefault(),
        this.params.preventClicksPropagation &&
          this.animating &&
          (e.stopPropagation(), e.stopImmediatePropagation()));
    }
    function N() {
      var e = this.wrapperEl,
        t = this.rtlTranslate;
      (this.previousTranslate = this.translate),
        this.isHorizontal()
          ? (this.translate = t
              ? e.scrollWidth - e.offsetWidth - e.scrollLeft
              : -e.scrollLeft)
          : (this.translate = -e.scrollTop),
        -0 === this.translate && (this.translate = 0),
        this.updateActiveIndex(),
        this.updateSlidesClasses();
      var i = this.maxTranslate() - this.minTranslate();
      (0 === i ? 0 : (this.translate - this.minTranslate()) / i) !==
        this.progress &&
        this.updateProgress(t ? -this.translate : this.translate),
        this.emit("setTranslate", this.translate, !1);
    }
    var q = !1;
    function $() {}
    var H = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        preventInteractionOnTransition: !1,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: 0.02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0,
      },
      F = {
        update: E,
        translate: T,
        transition: {
          setTransition: function (e, t) {
            this.params.cssMode || this.$wrapperEl.transition(e),
              this.emit("setTransition", e, t);
          },
          transitionStart: function (e, t) {
            void 0 === e && (e = !0);
            var i = this.activeIndex,
              n = this.params,
              s = this.previousIndex;
            if (!n.cssMode) {
              n.autoHeight && this.updateAutoHeight();
              var a = t;
              if (
                (a || (a = i > s ? "next" : i < s ? "prev" : "reset"),
                this.emit("transitionStart"),
                e && i !== s)
              ) {
                if ("reset" === a)
                  return void this.emit("slideResetTransitionStart");
                this.emit("slideChangeTransitionStart"),
                  "next" === a
                    ? this.emit("slideNextTransitionStart")
                    : this.emit("slidePrevTransitionStart");
              }
            }
          },
          transitionEnd: function (e, t) {
            void 0 === e && (e = !0);
            var i = this.activeIndex,
              n = this.previousIndex,
              s = this.params;
            if (((this.animating = !1), !s.cssMode)) {
              this.setTransition(0);
              var a = t;
              if (
                (a || (a = i > n ? "next" : i < n ? "prev" : "reset"),
                this.emit("transitionEnd"),
                e && i !== n)
              ) {
                if ("reset" === a)
                  return void this.emit("slideResetTransitionEnd");
                this.emit("slideChangeTransitionEnd"),
                  "next" === a
                    ? this.emit("slideNextTransitionEnd")
                    : this.emit("slidePrevTransitionEnd");
              }
            }
          },
        },
        slide: _,
        loop: M,
        grabCursor: L,
        manipulation: P,
        events: {
          attachEvents: function () {
            var t = this.params,
              i = this.touchEvents,
              n = this.el,
              s = this.wrapperEl;
            (this.onTouchStart = D.bind(this)),
              (this.onTouchMove = A.bind(this)),
              (this.onTouchEnd = z.bind(this)),
              t.cssMode && (this.onScroll = N.bind(this)),
              (this.onClick = B.bind(this));
            var a = !!t.nested;
            if (!o.touch && o.pointerEvents)
              n.addEventListener(i.start, this.onTouchStart, !1),
                e.addEventListener(i.move, this.onTouchMove, a),
                e.addEventListener(i.end, this.onTouchEnd, !1);
            else {
              if (o.touch) {
                var r = !(
                  "touchstart" !== i.start ||
                  !o.passiveListener ||
                  !t.passiveListeners
                ) && { passive: !0, capture: !1 };
                n.addEventListener(i.start, this.onTouchStart, r),
                  n.addEventListener(
                    i.move,
                    this.onTouchMove,
                    o.passiveListener ? { passive: !1, capture: a } : a
                  ),
                  n.addEventListener(i.end, this.onTouchEnd, r),
                  i.cancel && n.addEventListener(i.cancel, this.onTouchEnd, r),
                  q || (e.addEventListener("touchstart", $), (q = !0));
              }
              ((t.simulateTouch && !I.ios && !I.android) ||
                (t.simulateTouch && !o.touch && I.ios)) &&
                (n.addEventListener("mousedown", this.onTouchStart, !1),
                e.addEventListener("mousemove", this.onTouchMove, a),
                e.addEventListener("mouseup", this.onTouchEnd, !1));
            }
            (t.preventClicks || t.preventClicksPropagation) &&
              n.addEventListener("click", this.onClick, !0),
              t.cssMode && s.addEventListener("scroll", this.onScroll),
              t.updateOnWindowResize
                ? this.on(
                    I.ios || I.android
                      ? "resize orientationchange observerUpdate"
                      : "resize observerUpdate",
                    O,
                    !0
                  )
                : this.on("observerUpdate", O, !0);
          },
          detachEvents: function () {
            var t = this.params,
              i = this.touchEvents,
              n = this.el,
              s = this.wrapperEl,
              a = !!t.nested;
            if (!o.touch && o.pointerEvents)
              n.removeEventListener(i.start, this.onTouchStart, !1),
                e.removeEventListener(i.move, this.onTouchMove, a),
                e.removeEventListener(i.end, this.onTouchEnd, !1);
            else {
              if (o.touch) {
                var r = !(
                  "onTouchStart" !== i.start ||
                  !o.passiveListener ||
                  !t.passiveListeners
                ) && { passive: !0, capture: !1 };
                n.removeEventListener(i.start, this.onTouchStart, r),
                  n.removeEventListener(i.move, this.onTouchMove, a),
                  n.removeEventListener(i.end, this.onTouchEnd, r),
                  i.cancel &&
                    n.removeEventListener(i.cancel, this.onTouchEnd, r);
              }
              ((t.simulateTouch && !I.ios && !I.android) ||
                (t.simulateTouch && !o.touch && I.ios)) &&
                (n.removeEventListener("mousedown", this.onTouchStart, !1),
                e.removeEventListener("mousemove", this.onTouchMove, a),
                e.removeEventListener("mouseup", this.onTouchEnd, !1));
            }
            (t.preventClicks || t.preventClicksPropagation) &&
              n.removeEventListener("click", this.onClick, !0),
              t.cssMode && s.removeEventListener("scroll", this.onScroll),
              this.off(
                I.ios || I.android
                  ? "resize orientationchange observerUpdate"
                  : "resize observerUpdate",
                O
              );
          },
        },
        breakpoints: {
          setBreakpoint: function () {
            var e = this.activeIndex,
              t = this.initialized,
              i = this.loopedSlides;
            void 0 === i && (i = 0);
            var n = this.params,
              s = this.$el,
              a = n.breakpoints;
            if (a && (!a || 0 !== Object.keys(a).length)) {
              var o = this.getBreakpoint(a);
              if (o && this.currentBreakpoint !== o) {
                var l = o in a ? a[o] : void 0;
                l &&
                  [
                    "slidesPerView",
                    "spaceBetween",
                    "slidesPerGroup",
                    "slidesPerGroupSkip",
                    "slidesPerColumn",
                  ].forEach(function (e) {
                    var t = l[e];
                    void 0 !== t &&
                      (l[e] =
                        "slidesPerView" !== e || ("AUTO" !== t && "auto" !== t)
                          ? "slidesPerView" === e
                            ? parseFloat(t)
                            : parseInt(t, 10)
                          : "auto");
                  });
                var c = l || this.originalParams,
                  u = n.slidesPerColumn > 1,
                  d = c.slidesPerColumn > 1;
                u && !d
                  ? s.removeClass(
                      n.containerModifierClass +
                        "multirow " +
                        n.containerModifierClass +
                        "multirow-column"
                    )
                  : !u &&
                    d &&
                    (s.addClass(n.containerModifierClass + "multirow"),
                    "column" === c.slidesPerColumnFill &&
                      s.addClass(n.containerModifierClass + "multirow-column"));
                var h = c.direction && c.direction !== n.direction,
                  p = n.loop && (c.slidesPerView !== n.slidesPerView || h);
                h && t && this.changeDirection(),
                  r.extend(this.params, c),
                  r.extend(this, {
                    allowTouchMove: this.params.allowTouchMove,
                    allowSlideNext: this.params.allowSlideNext,
                    allowSlidePrev: this.params.allowSlidePrev,
                  }),
                  (this.currentBreakpoint = o),
                  p &&
                    t &&
                    (this.loopDestroy(),
                    this.loopCreate(),
                    this.updateSlides(),
                    this.slideTo(e - i + this.loopedSlides, 0, !1)),
                  this.emit("breakpoint", c);
              }
            }
          },
          getBreakpoint: function (e) {
            if (e) {
              var i = !1,
                n = Object.keys(e).map(function (e) {
                  if ("string" == typeof e && 0 === e.indexOf("@")) {
                    var i = parseFloat(e.substr(1));
                    return { value: t.innerHeight * i, point: e };
                  }
                  return { value: e, point: e };
                });
              n.sort(function (e, t) {
                return parseInt(e.value, 10) - parseInt(t.value, 10);
              });
              for (var s = 0; s < n.length; s += 1) {
                var a = n[s],
                  r = a.point;
                a.value <= t.innerWidth && (i = r);
              }
              return i || "max";
            }
          },
        },
        checkOverflow: {
          checkOverflow: function () {
            var e = this.params,
              t = this.isLocked,
              i =
                this.slides.length > 0 &&
                e.slidesOffsetBefore +
                  e.spaceBetween * (this.slides.length - 1) +
                  this.slides[0].offsetWidth * this.slides.length;
            e.slidesOffsetBefore && e.slidesOffsetAfter && i
              ? (this.isLocked = i <= this.size)
              : (this.isLocked = 1 === this.snapGrid.length),
              (this.allowSlideNext = !this.isLocked),
              (this.allowSlidePrev = !this.isLocked),
              t !== this.isLocked &&
                this.emit(this.isLocked ? "lock" : "unlock"),
              t &&
                t !== this.isLocked &&
                ((this.isEnd = !1), this.navigation.update());
          },
        },
        classes: {
          addClasses: function () {
            var e = this.classNames,
              t = this.params,
              i = this.rtl,
              n = this.$el,
              s = [];
            s.push("initialized"),
              s.push(t.direction),
              t.freeMode && s.push("free-mode"),
              t.autoHeight && s.push("autoheight"),
              i && s.push("rtl"),
              t.slidesPerColumn > 1 &&
                (s.push("multirow"),
                "column" === t.slidesPerColumnFill &&
                  s.push("multirow-column")),
              I.android && s.push("android"),
              I.ios && s.push("ios"),
              t.cssMode && s.push("css-mode"),
              s.forEach(function (i) {
                e.push(t.containerModifierClass + i);
              }),
              n.addClass(e.join(" "));
          },
          removeClasses: function () {
            var e = this.$el,
              t = this.classNames;
            e.removeClass(t.join(" "));
          },
        },
        images: {
          loadImage: function (e, i, n, s, a, r) {
            var o;
            function l() {
              r && r();
            }
            e.complete && a
              ? l()
              : i
              ? (((o = new t.Image()).onload = l),
                (o.onerror = l),
                s && (o.sizes = s),
                n && (o.srcset = n),
                i && (o.src = i))
              : l();
          },
          preloadImages: function () {
            var e = this;
            function t() {
              null != e &&
                e &&
                !e.destroyed &&
                (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                e.imagesLoaded === e.imagesToLoad.length &&
                  (e.params.updateOnImagesReady && e.update(),
                  e.emit("imagesReady")));
            }
            e.imagesToLoad = e.$el.find("img");
            for (var i = 0; i < e.imagesToLoad.length; i += 1) {
              var n = e.imagesToLoad[i];
              e.loadImage(
                n,
                n.currentSrc || n.getAttribute("src"),
                n.srcset || n.getAttribute("srcset"),
                n.sizes || n.getAttribute("sizes"),
                !0,
                t
              );
            }
          },
        },
      },
      V = {},
      R = (function (e) {
        function t() {
          for (var i, s, a, l = [], c = arguments.length; c--; )
            l[c] = arguments[c];
          1 === l.length && l[0].constructor && l[0].constructor === Object
            ? (a = l[0])
            : ((s = (i = l)[0]), (a = i[1])),
            a || (a = {}),
            (a = r.extend({}, a)),
            s && !a.el && (a.el = s),
            e.call(this, a),
            Object.keys(F).forEach(function (e) {
              Object.keys(F[e]).forEach(function (i) {
                t.prototype[i] || (t.prototype[i] = F[e][i]);
              });
            });
          var u = this;
          void 0 === u.modules && (u.modules = {}),
            Object.keys(u.modules).forEach(function (e) {
              var t = u.modules[e];
              if (t.params) {
                var i = Object.keys(t.params)[0],
                  n = t.params[i];
                if ("object" != typeof n || null === n) return;
                if (!(i in a) || !("enabled" in n)) return;
                !0 === a[i] && (a[i] = { enabled: !0 }),
                  "object" != typeof a[i] ||
                    "enabled" in a[i] ||
                    (a[i].enabled = !0),
                  a[i] || (a[i] = { enabled: !1 });
              }
            });
          var d = r.extend({}, H);
          u.useModulesParams(d),
            (u.params = r.extend({}, d, V, a)),
            (u.originalParams = r.extend({}, u.params)),
            (u.passedParams = r.extend({}, a)),
            (u.$ = n);
          var h = n(u.params.el);
          if ((s = h[0])) {
            if (h.length > 1) {
              var p = [];
              return (
                h.each(function (e, i) {
                  var n = r.extend({}, a, { el: i });
                  p.push(new t(n));
                }),
                p
              );
            }
            var f, v, m;
            return (
              (s.swiper = u),
              h.data("swiper", u),
              s && s.shadowRoot && s.shadowRoot.querySelector
                ? ((f = n(
                    s.shadowRoot.querySelector("." + u.params.wrapperClass)
                  )).children = function (e) {
                    return h.children(e);
                  })
                : (f = h.children("." + u.params.wrapperClass)),
              r.extend(u, {
                $el: h,
                el: s,
                $wrapperEl: f,
                wrapperEl: f[0],
                classNames: [],
                slides: n(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: function () {
                  return "horizontal" === u.params.direction;
                },
                isVertical: function () {
                  return "vertical" === u.params.direction;
                },
                rtl:
                  "rtl" === s.dir.toLowerCase() || "rtl" === h.css("direction"),
                rtlTranslate:
                  "horizontal" === u.params.direction &&
                  ("rtl" === s.dir.toLowerCase() ||
                    "rtl" === h.css("direction")),
                wrongRTL: "-webkit-box" === f.css("display"),
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: u.params.allowSlideNext,
                allowSlidePrev: u.params.allowSlidePrev,
                touchEvents:
                  ((v = ["touchstart", "touchmove", "touchend", "touchcancel"]),
                  (m = ["mousedown", "mousemove", "mouseup"]),
                  o.pointerEvents &&
                    (m = ["pointerdown", "pointermove", "pointerup"]),
                  (u.touchEventsTouch = {
                    start: v[0],
                    move: v[1],
                    end: v[2],
                    cancel: v[3],
                  }),
                  (u.touchEventsDesktop = {
                    start: m[0],
                    move: m[1],
                    end: m[2],
                  }),
                  o.touch || !u.params.simulateTouch
                    ? u.touchEventsTouch
                    : u.touchEventsDesktop),
                touchEventsData: {
                  isTouched: void 0,
                  isMoved: void 0,
                  allowTouchCallbacks: void 0,
                  touchStartTime: void 0,
                  isScrolling: void 0,
                  currentTranslate: void 0,
                  startTranslate: void 0,
                  allowThresholdMove: void 0,
                  formElements:
                    "input, select, option, textarea, button, video, label",
                  lastClickTime: r.now(),
                  clickTimeout: void 0,
                  velocities: [],
                  allowMomentumBounce: void 0,
                  isTouchEvent: void 0,
                  startMoving: void 0,
                },
                allowClick: !0,
                allowTouchMove: u.params.allowTouchMove,
                touches: {
                  startX: 0,
                  startY: 0,
                  currentX: 0,
                  currentY: 0,
                  diff: 0,
                },
                imagesToLoad: [],
                imagesLoaded: 0,
              }),
              u.useModules(),
              u.params.init && u.init(),
              u
            );
          }
        }
        e && (t.__proto__ = e),
          (t.prototype = Object.create(e && e.prototype)),
          (t.prototype.constructor = t);
        var i = {
          extendedDefaults: { configurable: !0 },
          defaults: { configurable: !0 },
          Class: { configurable: !0 },
          $: { configurable: !0 },
        };
        return (
          (t.prototype.slidesPerViewDynamic = function () {
            var e = this.params,
              t = this.slides,
              i = this.slidesGrid,
              n = this.size,
              s = this.activeIndex,
              a = 1;
            if (e.centeredSlides) {
              for (
                var r, o = t[s].swiperSlideSize, l = s + 1;
                l < t.length;
                l += 1
              )
                t[l] &&
                  !r &&
                  ((a += 1), (o += t[l].swiperSlideSize) > n && (r = !0));
              for (var c = s - 1; c >= 0; c -= 1)
                t[c] &&
                  !r &&
                  ((a += 1), (o += t[c].swiperSlideSize) > n && (r = !0));
            } else
              for (var u = s + 1; u < t.length; u += 1)
                i[u] - i[s] < n && (a += 1);
            return a;
          }),
          (t.prototype.update = function () {
            var e = this;
            if (e && !e.destroyed) {
              var t = e.snapGrid,
                i = e.params;
              i.breakpoints && e.setBreakpoint(),
                e.updateSize(),
                e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                e.params.freeMode
                  ? (n(), e.params.autoHeight && e.updateAutoHeight())
                  : (("auto" === e.params.slidesPerView ||
                      e.params.slidesPerView > 1) &&
                    e.isEnd &&
                    !e.params.centeredSlides
                      ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                      : e.slideTo(e.activeIndex, 0, !1, !0)) || n(),
                i.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                e.emit("update");
            }
            function n() {
              var t = e.rtlTranslate ? -1 * e.translate : e.translate,
                i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
              e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses();
            }
          }),
          (t.prototype.changeDirection = function (e, t) {
            void 0 === t && (t = !0);
            var i = this.params.direction;
            return (
              e || (e = "horizontal" === i ? "vertical" : "horizontal"),
              e === i ||
                ("horizontal" !== e && "vertical" !== e) ||
                (this.$el
                  .removeClass("" + this.params.containerModifierClass + i)
                  .addClass("" + this.params.containerModifierClass + e),
                (this.params.direction = e),
                this.slides.each(function (t, i) {
                  "vertical" === e
                    ? (i.style.width = "")
                    : (i.style.height = "");
                }),
                this.emit("changeDirection"),
                t && this.update()),
              this
            );
          }),
          (t.prototype.init = function () {
            this.initialized ||
              (this.emit("beforeInit"),
              this.params.breakpoints && this.setBreakpoint(),
              this.addClasses(),
              this.params.loop && this.loopCreate(),
              this.updateSize(),
              this.updateSlides(),
              this.params.watchOverflow && this.checkOverflow(),
              this.params.grabCursor && this.setGrabCursor(),
              this.params.preloadImages && this.preloadImages(),
              this.params.loop
                ? this.slideTo(
                    this.params.initialSlide + this.loopedSlides,
                    0,
                    this.params.runCallbacksOnInit
                  )
                : this.slideTo(
                    this.params.initialSlide,
                    0,
                    this.params.runCallbacksOnInit
                  ),
              this.attachEvents(),
              (this.initialized = !0),
              this.emit("init"));
          }),
          (t.prototype.destroy = function (e, t) {
            void 0 === e && (e = !0), void 0 === t && (t = !0);
            var i = this,
              n = i.params,
              s = i.$el,
              a = i.$wrapperEl,
              o = i.slides;
            return (
              void 0 === i.params ||
                i.destroyed ||
                (i.emit("beforeDestroy"),
                (i.initialized = !1),
                i.detachEvents(),
                n.loop && i.loopDestroy(),
                t &&
                  (i.removeClasses(),
                  s.removeAttr("style"),
                  a.removeAttr("style"),
                  o &&
                    o.length &&
                    o
                      .removeClass(
                        [
                          n.slideVisibleClass,
                          n.slideActiveClass,
                          n.slideNextClass,
                          n.slidePrevClass,
                        ].join(" ")
                      )
                      .removeAttr("style")
                      .removeAttr("data-swiper-slide-index")),
                i.emit("destroy"),
                Object.keys(i.eventsListeners).forEach(function (e) {
                  i.off(e);
                }),
                !1 !== e &&
                  ((i.$el[0].swiper = null),
                  i.$el.data("swiper", null),
                  r.deleteProps(i)),
                (i.destroyed = !0)),
              null
            );
          }),
          (t.extendDefaults = function (e) {
            r.extend(V, e);
          }),
          (i.extendedDefaults.get = function () {
            return V;
          }),
          (i.defaults.get = function () {
            return H;
          }),
          (i.Class.get = function () {
            return e;
          }),
          (i.$.get = function () {
            return n;
          }),
          Object.defineProperties(t, i),
          t
        );
      })(l),
      j = { name: "device", proto: { device: I }, static: { device: I } },
      X = { name: "support", proto: { support: o }, static: { support: o } },
      G = {
        isEdge: !!t.navigator.userAgent.match(/Edge/g),
        isSafari: (function () {
          var e = t.navigator.userAgent.toLowerCase();
          return (
            e.indexOf("safari") >= 0 &&
            e.indexOf("chrome") < 0 &&
            e.indexOf("android") < 0
          );
        })(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
          t.navigator.userAgent
        ),
      },
      W = { name: "browser", proto: { browser: G }, static: { browser: G } },
      Y = {
        name: "resize",
        create: function () {
          var e = this;
          r.extend(e, {
            resize: {
              resizeHandler: function () {
                e &&
                  !e.destroyed &&
                  e.initialized &&
                  (e.emit("beforeResize"), e.emit("resize"));
              },
              orientationChangeHandler: function () {
                e &&
                  !e.destroyed &&
                  e.initialized &&
                  e.emit("orientationchange");
              },
            },
          });
        },
        on: {
          init: function () {
            t.addEventListener("resize", this.resize.resizeHandler),
              t.addEventListener(
                "orientationchange",
                this.resize.orientationChangeHandler
              );
          },
          destroy: function () {
            t.removeEventListener("resize", this.resize.resizeHandler),
              t.removeEventListener(
                "orientationchange",
                this.resize.orientationChangeHandler
              );
          },
        },
      },
      U = {
        func: t.MutationObserver || t.WebkitMutationObserver,
        attach: function (e, i) {
          void 0 === i && (i = {});
          var n = this,
            s = new (0, U.func)(function (e) {
              if (1 !== e.length) {
                var i = function () {
                  n.emit("observerUpdate", e[0]);
                };
                t.requestAnimationFrame
                  ? t.requestAnimationFrame(i)
                  : t.setTimeout(i, 0);
              } else n.emit("observerUpdate", e[0]);
            });
          s.observe(e, {
            attributes: void 0 === i.attributes || i.attributes,
            childList: void 0 === i.childList || i.childList,
            characterData: void 0 === i.characterData || i.characterData,
          }),
            n.observer.observers.push(s);
        },
        init: function () {
          if (o.observer && this.params.observer) {
            if (this.params.observeParents)
              for (var e = this.$el.parents(), t = 0; t < e.length; t += 1)
                this.observer.attach(e[t]);
            this.observer.attach(this.$el[0], {
              childList: this.params.observeSlideChildren,
            }),
              this.observer.attach(this.$wrapperEl[0], { attributes: !1 });
          }
        },
        destroy: function () {
          this.observer.observers.forEach(function (e) {
            e.disconnect();
          }),
            (this.observer.observers = []);
        },
      },
      K = {
        name: "observer",
        params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
        create: function () {
          r.extend(this, {
            observer: {
              init: U.init.bind(this),
              attach: U.attach.bind(this),
              destroy: U.destroy.bind(this),
              observers: [],
            },
          });
        },
        on: {
          init: function () {
            this.observer.init();
          },
          destroy: function () {
            this.observer.destroy();
          },
        },
      },
      Q = {
        update: function (e) {
          var t = this,
            i = t.params,
            n = i.slidesPerView,
            s = i.slidesPerGroup,
            a = i.centeredSlides,
            o = t.params.virtual,
            l = o.addSlidesBefore,
            c = o.addSlidesAfter,
            u = t.virtual,
            d = u.from,
            h = u.to,
            p = u.slides,
            f = u.slidesGrid,
            v = u.renderSlide,
            m = u.offset;
          t.updateActiveIndex();
          var g,
            y,
            b,
            w = t.activeIndex || 0;
          (g = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top"),
            a
              ? ((y = Math.floor(n / 2) + s + l),
                (b = Math.floor(n / 2) + s + c))
              : ((y = n + (s - 1) + l), (b = s + c));
          var S = Math.max((w || 0) - b, 0),
            x = Math.min((w || 0) + y, p.length - 1),
            C = (t.slidesGrid[S] || 0) - (t.slidesGrid[0] || 0);
          function k() {
            t.updateSlides(),
              t.updateProgress(),
              t.updateSlidesClasses(),
              t.lazy && t.params.lazy.enabled && t.lazy.load();
          }
          if (
            (r.extend(t.virtual, {
              from: S,
              to: x,
              offset: C,
              slidesGrid: t.slidesGrid,
            }),
            d === S && h === x && !e)
          )
            return (
              t.slidesGrid !== f && C !== m && t.slides.css(g, C + "px"),
              void t.updateProgress()
            );
          if (t.params.virtual.renderExternal)
            return (
              t.params.virtual.renderExternal.call(t, {
                offset: C,
                from: S,
                to: x,
                slides: (function () {
                  for (var e = [], t = S; t <= x; t += 1) e.push(p[t]);
                  return e;
                })(),
              }),
              void k()
            );
          var E = [],
            T = [];
          if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();
          else
            for (var _ = d; _ <= h; _ += 1)
              (_ < S || _ > x) &&
                t.$wrapperEl
                  .find(
                    "." +
                      t.params.slideClass +
                      '[data-swiper-slide-index="' +
                      _ +
                      '"]'
                  )
                  .remove();
          for (var M = 0; M < p.length; M += 1)
            M >= S &&
              M <= x &&
              (void 0 === h || e
                ? T.push(M)
                : (M > h && T.push(M), M < d && E.push(M)));
          T.forEach(function (e) {
            t.$wrapperEl.append(v(p[e], e));
          }),
            E.sort(function (e, t) {
              return t - e;
            }).forEach(function (e) {
              t.$wrapperEl.prepend(v(p[e], e));
            }),
            t.$wrapperEl.children(".swiper-slide").css(g, C + "px"),
            k();
        },
        renderSlide: function (e, t) {
          var i = this.params.virtual;
          if (i.cache && this.virtual.cache[t]) return this.virtual.cache[t];
          var s = i.renderSlide
            ? n(i.renderSlide.call(this, e, t))
            : n(
                '<div class="' +
                  this.params.slideClass +
                  '" data-swiper-slide-index="' +
                  t +
                  '">' +
                  e +
                  "</div>"
              );
          return (
            s.attr("data-swiper-slide-index") ||
              s.attr("data-swiper-slide-index", t),
            i.cache && (this.virtual.cache[t] = s),
            s
          );
        },
        appendSlide: function (e) {
          if ("object" == typeof e && "length" in e)
            for (var t = 0; t < e.length; t += 1)
              e[t] && this.virtual.slides.push(e[t]);
          else this.virtual.slides.push(e);
          this.virtual.update(!0);
        },
        prependSlide: function (e) {
          var t = this.activeIndex,
            i = t + 1,
            n = 1;
          if (Array.isArray(e)) {
            for (var s = 0; s < e.length; s += 1)
              e[s] && this.virtual.slides.unshift(e[s]);
            (i = t + e.length), (n = e.length);
          } else this.virtual.slides.unshift(e);
          if (this.params.virtual.cache) {
            var a = this.virtual.cache,
              r = {};
            Object.keys(a).forEach(function (e) {
              var t = a[e],
                i = t.attr("data-swiper-slide-index");
              i && t.attr("data-swiper-slide-index", parseInt(i, 10) + 1),
                (r[parseInt(e, 10) + n] = t);
            }),
              (this.virtual.cache = r);
          }
          this.virtual.update(!0), this.slideTo(i, 0);
        },
        removeSlide: function (e) {
          if (null != e) {
            var t = this.activeIndex;
            if (Array.isArray(e))
              for (var i = e.length - 1; i >= 0; i -= 1)
                this.virtual.slides.splice(e[i], 1),
                  this.params.virtual.cache && delete this.virtual.cache[e[i]],
                  e[i] < t && (t -= 1),
                  (t = Math.max(t, 0));
            else
              this.virtual.slides.splice(e, 1),
                this.params.virtual.cache && delete this.virtual.cache[e],
                e < t && (t -= 1),
                (t = Math.max(t, 0));
            this.virtual.update(!0), this.slideTo(t, 0);
          }
        },
        removeAllSlides: function () {
          (this.virtual.slides = []),
            this.params.virtual.cache && (this.virtual.cache = {}),
            this.virtual.update(!0),
            this.slideTo(0, 0);
        },
      },
      Z = {
        name: "virtual",
        params: {
          virtual: {
            enabled: !1,
            slides: [],
            cache: !0,
            renderSlide: null,
            renderExternal: null,
            addSlidesBefore: 0,
            addSlidesAfter: 0,
          },
        },
        create: function () {
          r.extend(this, {
            virtual: {
              update: Q.update.bind(this),
              appendSlide: Q.appendSlide.bind(this),
              prependSlide: Q.prependSlide.bind(this),
              removeSlide: Q.removeSlide.bind(this),
              removeAllSlides: Q.removeAllSlides.bind(this),
              renderSlide: Q.renderSlide.bind(this),
              slides: this.params.virtual.slides,
              cache: {},
            },
          });
        },
        on: {
          beforeInit: function () {
            if (this.params.virtual.enabled) {
              this.classNames.push(
                this.params.containerModifierClass + "virtual"
              );
              var e = { watchSlidesProgress: !0 };
              r.extend(this.params, e),
                r.extend(this.originalParams, e),
                this.params.initialSlide || this.virtual.update();
            }
          },
          setTranslate: function () {
            this.params.virtual.enabled && this.virtual.update();
          },
        },
      },
      J = {
        handle: function (i) {
          var n = this.rtlTranslate,
            s = i;
          s.originalEvent && (s = s.originalEvent);
          var a = s.keyCode || s.charCode;
          if (
            !this.allowSlideNext &&
            ((this.isHorizontal() && 39 === a) ||
              (this.isVertical() && 40 === a) ||
              34 === a)
          )
            return !1;
          if (
            !this.allowSlidePrev &&
            ((this.isHorizontal() && 37 === a) ||
              (this.isVertical() && 38 === a) ||
              33 === a)
          )
            return !1;
          if (
            !(
              s.shiftKey ||
              s.altKey ||
              s.ctrlKey ||
              s.metaKey ||
              (e.activeElement &&
                e.activeElement.nodeName &&
                ("input" === e.activeElement.nodeName.toLowerCase() ||
                  "textarea" === e.activeElement.nodeName.toLowerCase()))
            )
          ) {
            if (
              this.params.keyboard.onlyInViewport &&
              (33 === a ||
                34 === a ||
                37 === a ||
                39 === a ||
                38 === a ||
                40 === a)
            ) {
              var r = !1;
              if (
                this.$el.parents("." + this.params.slideClass).length > 0 &&
                0 ===
                  this.$el.parents("." + this.params.slideActiveClass).length
              )
                return;
              var o = t.innerWidth,
                l = t.innerHeight,
                c = this.$el.offset();
              n && (c.left -= this.$el[0].scrollLeft);
              for (
                var u = [
                    [c.left, c.top],
                    [c.left + this.width, c.top],
                    [c.left, c.top + this.height],
                    [c.left + this.width, c.top + this.height],
                  ],
                  d = 0;
                d < u.length;
                d += 1
              ) {
                var h = u[d];
                h[0] >= 0 && h[0] <= o && h[1] >= 0 && h[1] <= l && (r = !0);
              }
              if (!r) return;
            }
            this.isHorizontal()
              ? ((33 !== a && 34 !== a && 37 !== a && 39 !== a) ||
                  (s.preventDefault
                    ? s.preventDefault()
                    : (s.returnValue = !1)),
                (((34 !== a && 39 !== a) || n) &&
                  ((33 !== a && 37 !== a) || !n)) ||
                  this.slideNext(),
                (((33 !== a && 37 !== a) || n) &&
                  ((34 !== a && 39 !== a) || !n)) ||
                  this.slidePrev())
              : ((33 !== a && 34 !== a && 38 !== a && 40 !== a) ||
                  (s.preventDefault
                    ? s.preventDefault()
                    : (s.returnValue = !1)),
                (34 !== a && 40 !== a) || this.slideNext(),
                (33 !== a && 38 !== a) || this.slidePrev()),
              this.emit("keyPress", a);
          }
        },
        enable: function () {
          this.keyboard.enabled ||
            (n(e).on("keydown", this.keyboard.handle),
            (this.keyboard.enabled = !0));
        },
        disable: function () {
          this.keyboard.enabled &&
            (n(e).off("keydown", this.keyboard.handle),
            (this.keyboard.enabled = !1));
        },
      },
      ee = {
        name: "keyboard",
        params: { keyboard: { enabled: !1, onlyInViewport: !0 } },
        create: function () {
          r.extend(this, {
            keyboard: {
              enabled: !1,
              enable: J.enable.bind(this),
              disable: J.disable.bind(this),
              handle: J.handle.bind(this),
            },
          });
        },
        on: {
          init: function () {
            this.params.keyboard.enabled && this.keyboard.enable();
          },
          destroy: function () {
            this.keyboard.enabled && this.keyboard.disable();
          },
        },
      },
      te = {
        lastScrollTime: r.now(),
        lastEventBeforeSnap: void 0,
        recentWheelEvents: [],
        event: function () {
          return t.navigator.userAgent.indexOf("firefox") > -1
            ? "DOMMouseScroll"
            : (function () {
                var t = "onwheel" in e;
                if (!t) {
                  var i = e.createElement("div");
                  i.setAttribute("onwheel", "return;"),
                    (t = "function" == typeof i.onwheel);
                }
                return (
                  !t &&
                    e.implementation &&
                    e.implementation.hasFeature &&
                    !0 !== e.implementation.hasFeature("", "") &&
                    (t = e.implementation.hasFeature("Events.wheel", "3.0")),
                  t
                );
              })()
            ? "wheel"
            : "mousewheel";
        },
        normalize: function (e) {
          var t = 0,
            i = 0,
            n = 0,
            s = 0;
          return (
            "detail" in e && (i = e.detail),
            "wheelDelta" in e && (i = -e.wheelDelta / 120),
            "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120),
            "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
            "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = i), (i = 0)),
            (n = 10 * t),
            (s = 10 * i),
            "deltaY" in e && (s = e.deltaY),
            "deltaX" in e && (n = e.deltaX),
            e.shiftKey && !n && ((n = s), (s = 0)),
            (n || s) &&
              e.deltaMode &&
              (1 === e.deltaMode
                ? ((n *= 40), (s *= 40))
                : ((n *= 800), (s *= 800))),
            n && !t && (t = n < 1 ? -1 : 1),
            s && !i && (i = s < 1 ? -1 : 1),
            { spinX: t, spinY: i, pixelX: n, pixelY: s }
          );
        },
        handleMouseEnter: function () {
          this.mouseEntered = !0;
        },
        handleMouseLeave: function () {
          this.mouseEntered = !1;
        },
        handle: function (e) {
          var t = e,
            i = this,
            s = i.params.mousewheel;
          i.params.cssMode && t.preventDefault();
          var a = i.$el;
          if (
            ("container" !== i.params.mousewheel.eventsTarged &&
              (a = n(i.params.mousewheel.eventsTarged)),
            !i.mouseEntered && !a[0].contains(t.target) && !s.releaseOnEdges)
          )
            return !0;
          t.originalEvent && (t = t.originalEvent);
          var o = 0,
            l = i.rtlTranslate ? -1 : 1,
            c = te.normalize(t);
          if (s.forceToAxis)
            if (i.isHorizontal()) {
              if (!(Math.abs(c.pixelX) > Math.abs(c.pixelY))) return !0;
              o = c.pixelX * l;
            } else {
              if (!(Math.abs(c.pixelY) > Math.abs(c.pixelX))) return !0;
              o = c.pixelY;
            }
          else
            o =
              Math.abs(c.pixelX) > Math.abs(c.pixelY)
                ? -c.pixelX * l
                : -c.pixelY;
          if (0 === o) return !0;
          if ((s.invert && (o = -o), i.params.freeMode)) {
            var u = {
                time: r.now(),
                delta: Math.abs(o),
                direction: Math.sign(o),
              },
              d = i.mousewheel.lastEventBeforeSnap,
              h =
                d &&
                u.time < d.time + 500 &&
                u.delta <= d.delta &&
                u.direction === d.direction;
            if (!h) {
              (i.mousewheel.lastEventBeforeSnap = void 0),
                i.params.loop && i.loopFix();
              var p = i.getTranslate() + o * s.sensitivity,
                f = i.isBeginning,
                v = i.isEnd;
              if (
                (p >= i.minTranslate() && (p = i.minTranslate()),
                p <= i.maxTranslate() && (p = i.maxTranslate()),
                i.setTransition(0),
                i.setTranslate(p),
                i.updateProgress(),
                i.updateActiveIndex(),
                i.updateSlidesClasses(),
                ((!f && i.isBeginning) || (!v && i.isEnd)) &&
                  i.updateSlidesClasses(),
                i.params.freeModeSticky)
              ) {
                clearTimeout(i.mousewheel.timeout),
                  (i.mousewheel.timeout = void 0);
                var m = i.mousewheel.recentWheelEvents;
                m.length >= 15 && m.shift();
                var g = m.length ? m[m.length - 1] : void 0,
                  y = m[0];
                if (
                  (m.push(u),
                  g && (u.delta > g.delta || u.direction !== g.direction))
                )
                  m.splice(0);
                else if (
                  m.length >= 15 &&
                  u.time - y.time < 500 &&
                  y.delta - u.delta >= 1 &&
                  u.delta <= 6
                ) {
                  var b = o > 0 ? 0.8 : 0.2;
                  (i.mousewheel.lastEventBeforeSnap = u),
                    m.splice(0),
                    (i.mousewheel.timeout = r.nextTick(function () {
                      i.slideToClosest(i.params.speed, !0, void 0, b);
                    }, 0));
                }
                i.mousewheel.timeout ||
                  (i.mousewheel.timeout = r.nextTick(function () {
                    (i.mousewheel.lastEventBeforeSnap = u),
                      m.splice(0),
                      i.slideToClosest(i.params.speed, !0, void 0, 0.5);
                  }, 500));
              }
              if (
                (h || i.emit("scroll", t),
                i.params.autoplay &&
                  i.params.autoplayDisableOnInteraction &&
                  i.autoplay.stop(),
                p === i.minTranslate() || p === i.maxTranslate())
              )
                return !0;
            }
          } else {
            var w = {
                time: r.now(),
                delta: Math.abs(o),
                direction: Math.sign(o),
                raw: e,
              },
              S = i.mousewheel.recentWheelEvents;
            S.length >= 2 && S.shift();
            var x = S.length ? S[S.length - 1] : void 0;
            if (
              (S.push(w),
              x
                ? (w.direction !== x.direction || w.delta > x.delta) &&
                  i.mousewheel.animateSlider(w)
                : i.mousewheel.animateSlider(w),
              i.mousewheel.releaseScroll(w))
            )
              return !0;
          }
          return (
            t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1
          );
        },
        animateSlider: function (e) {
          return (
            (e.delta >= 6 && r.now() - this.mousewheel.lastScrollTime < 60) ||
            (e.direction < 0
              ? (this.isEnd && !this.params.loop) ||
                this.animating ||
                (this.slideNext(), this.emit("scroll", e.raw))
              : (this.isBeginning && !this.params.loop) ||
                this.animating ||
                (this.slidePrev(), this.emit("scroll", e.raw)),
            (this.mousewheel.lastScrollTime = new t.Date().getTime()),
            !1)
          );
        },
        releaseScroll: function (e) {
          var t = this.params.mousewheel;
          if (e.direction < 0) {
            if (this.isEnd && !this.params.loop && t.releaseOnEdges) return !0;
          } else if (this.isBeginning && !this.params.loop && t.releaseOnEdges)
            return !0;
          return !1;
        },
        enable: function () {
          var e = te.event();
          if (this.params.cssMode)
            return (
              this.wrapperEl.removeEventListener(e, this.mousewheel.handle), !0
            );
          if (!e) return !1;
          if (this.mousewheel.enabled) return !1;
          var t = this.$el;
          return (
            "container" !== this.params.mousewheel.eventsTarged &&
              (t = n(this.params.mousewheel.eventsTarged)),
            t.on("mouseenter", this.mousewheel.handleMouseEnter),
            t.on("mouseleave", this.mousewheel.handleMouseLeave),
            t.on(e, this.mousewheel.handle),
            (this.mousewheel.enabled = !0),
            !0
          );
        },
        disable: function () {
          var e = te.event();
          if (this.params.cssMode)
            return (
              this.wrapperEl.addEventListener(e, this.mousewheel.handle), !0
            );
          if (!e) return !1;
          if (!this.mousewheel.enabled) return !1;
          var t = this.$el;
          return (
            "container" !== this.params.mousewheel.eventsTarged &&
              (t = n(this.params.mousewheel.eventsTarged)),
            t.off(e, this.mousewheel.handle),
            (this.mousewheel.enabled = !1),
            !0
          );
        },
      },
      ie = {
        update: function () {
          var e = this.params.navigation;
          if (!this.params.loop) {
            var t = this.navigation,
              i = t.$nextEl,
              n = t.$prevEl;
            n &&
              n.length > 0 &&
              (this.isBeginning
                ? n.addClass(e.disabledClass)
                : n.removeClass(e.disabledClass),
              n[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](e.lockClass)),
              i &&
                i.length > 0 &&
                (this.isEnd
                  ? i.addClass(e.disabledClass)
                  : i.removeClass(e.disabledClass),
                i[
                  this.params.watchOverflow && this.isLocked
                    ? "addClass"
                    : "removeClass"
                ](e.lockClass));
          }
        },
        onPrevClick: function (e) {
          e.preventDefault(),
            (this.isBeginning && !this.params.loop) || this.slidePrev();
        },
        onNextClick: function (e) {
          e.preventDefault(),
            (this.isEnd && !this.params.loop) || this.slideNext();
        },
        init: function () {
          var e,
            t,
            i = this.params.navigation;
          (i.nextEl || i.prevEl) &&
            (i.nextEl &&
              ((e = n(i.nextEl)),
              this.params.uniqueNavElements &&
                "string" == typeof i.nextEl &&
                e.length > 1 &&
                1 === this.$el.find(i.nextEl).length &&
                (e = this.$el.find(i.nextEl))),
            i.prevEl &&
              ((t = n(i.prevEl)),
              this.params.uniqueNavElements &&
                "string" == typeof i.prevEl &&
                t.length > 1 &&
                1 === this.$el.find(i.prevEl).length &&
                (t = this.$el.find(i.prevEl))),
            e && e.length > 0 && e.on("click", this.navigation.onNextClick),
            t && t.length > 0 && t.on("click", this.navigation.onPrevClick),
            r.extend(this.navigation, {
              $nextEl: e,
              nextEl: e && e[0],
              $prevEl: t,
              prevEl: t && t[0],
            }));
        },
        destroy: function () {
          var e = this.navigation,
            t = e.$nextEl,
            i = e.$prevEl;
          t &&
            t.length &&
            (t.off("click", this.navigation.onNextClick),
            t.removeClass(this.params.navigation.disabledClass)),
            i &&
              i.length &&
              (i.off("click", this.navigation.onPrevClick),
              i.removeClass(this.params.navigation.disabledClass));
        },
      },
      ne = {
        update: function () {
          var e = this.rtl,
            t = this.params.pagination;
          if (
            t.el &&
            this.pagination.el &&
            this.pagination.$el &&
            0 !== this.pagination.$el.length
          ) {
            var i,
              s =
                this.virtual && this.params.virtual.enabled
                  ? this.virtual.slides.length
                  : this.slides.length,
              a = this.pagination.$el,
              r = this.params.loop
                ? Math.ceil(
                    (s - 2 * this.loopedSlides) / this.params.slidesPerGroup
                  )
                : this.snapGrid.length;
            if (
              (this.params.loop
                ? ((i = Math.ceil(
                    (this.activeIndex - this.loopedSlides) /
                      this.params.slidesPerGroup
                  )) >
                    s - 1 - 2 * this.loopedSlides &&
                    (i -= s - 2 * this.loopedSlides),
                  i > r - 1 && (i -= r),
                  i < 0 &&
                    "bullets" !== this.params.paginationType &&
                    (i = r + i))
                : (i =
                    void 0 !== this.snapIndex
                      ? this.snapIndex
                      : this.activeIndex || 0),
              "bullets" === t.type &&
                this.pagination.bullets &&
                this.pagination.bullets.length > 0)
            ) {
              var o,
                l,
                c,
                u = this.pagination.bullets;
              if (
                (t.dynamicBullets &&
                  ((this.pagination.bulletSize = u
                    .eq(0)
                    [this.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                  a.css(
                    this.isHorizontal() ? "width" : "height",
                    this.pagination.bulletSize * (t.dynamicMainBullets + 4) +
                      "px"
                  ),
                  t.dynamicMainBullets > 1 &&
                    void 0 !== this.previousIndex &&
                    ((this.pagination.dynamicBulletIndex +=
                      i - this.previousIndex),
                    this.pagination.dynamicBulletIndex >
                    t.dynamicMainBullets - 1
                      ? (this.pagination.dynamicBulletIndex =
                          t.dynamicMainBullets - 1)
                      : this.pagination.dynamicBulletIndex < 0 &&
                        (this.pagination.dynamicBulletIndex = 0)),
                  (o = i - this.pagination.dynamicBulletIndex),
                  (c =
                    ((l = o + (Math.min(u.length, t.dynamicMainBullets) - 1)) +
                      o) /
                    2)),
                u.removeClass(
                  t.bulletActiveClass +
                    " " +
                    t.bulletActiveClass +
                    "-next " +
                    t.bulletActiveClass +
                    "-next-next " +
                    t.bulletActiveClass +
                    "-prev " +
                    t.bulletActiveClass +
                    "-prev-prev " +
                    t.bulletActiveClass +
                    "-main"
                ),
                a.length > 1)
              )
                u.each(function (e, s) {
                  var a = n(s),
                    r = a.index();
                  r === i && a.addClass(t.bulletActiveClass),
                    t.dynamicBullets &&
                      (r >= o &&
                        r <= l &&
                        a.addClass(t.bulletActiveClass + "-main"),
                      r === o &&
                        a
                          .prev()
                          .addClass(t.bulletActiveClass + "-prev")
                          .prev()
                          .addClass(t.bulletActiveClass + "-prev-prev"),
                      r === l &&
                        a
                          .next()
                          .addClass(t.bulletActiveClass + "-next")
                          .next()
                          .addClass(t.bulletActiveClass + "-next-next"));
                });
              else {
                var d = u.eq(i),
                  h = d.index();
                if ((d.addClass(t.bulletActiveClass), t.dynamicBullets)) {
                  for (var p = u.eq(o), f = u.eq(l), v = o; v <= l; v += 1)
                    u.eq(v).addClass(t.bulletActiveClass + "-main");
                  if (this.params.loop)
                    if (h >= u.length - t.dynamicMainBullets) {
                      for (var m = t.dynamicMainBullets; m >= 0; m -= 1)
                        u.eq(u.length - m).addClass(
                          t.bulletActiveClass + "-main"
                        );
                      u.eq(u.length - t.dynamicMainBullets - 1).addClass(
                        t.bulletActiveClass + "-prev"
                      );
                    } else
                      p
                        .prev()
                        .addClass(t.bulletActiveClass + "-prev")
                        .prev()
                        .addClass(t.bulletActiveClass + "-prev-prev"),
                        f
                          .next()
                          .addClass(t.bulletActiveClass + "-next")
                          .next()
                          .addClass(t.bulletActiveClass + "-next-next");
                  else
                    p
                      .prev()
                      .addClass(t.bulletActiveClass + "-prev")
                      .prev()
                      .addClass(t.bulletActiveClass + "-prev-prev"),
                      f
                        .next()
                        .addClass(t.bulletActiveClass + "-next")
                        .next()
                        .addClass(t.bulletActiveClass + "-next-next");
                }
              }
              if (t.dynamicBullets) {
                var g = Math.min(u.length, t.dynamicMainBullets + 4),
                  y =
                    (this.pagination.bulletSize * g -
                      this.pagination.bulletSize) /
                      2 -
                    c * this.pagination.bulletSize,
                  b = e ? "right" : "left";
                u.css(this.isHorizontal() ? b : "top", y + "px");
              }
            }
            if (
              ("fraction" === t.type &&
                (a
                  .find("." + t.currentClass)
                  .text(t.formatFractionCurrent(i + 1)),
                a.find("." + t.totalClass).text(t.formatFractionTotal(r))),
              "progressbar" === t.type)
            ) {
              var w;
              w = t.progressbarOpposite
                ? this.isHorizontal()
                  ? "vertical"
                  : "horizontal"
                : this.isHorizontal()
                ? "horizontal"
                : "vertical";
              var S = (i + 1) / r,
                x = 1,
                C = 1;
              "horizontal" === w ? (x = S) : (C = S),
                a
                  .find("." + t.progressbarFillClass)
                  .transform(
                    "translate3d(0,0,0) scaleX(" + x + ") scaleY(" + C + ")"
                  )
                  .transition(this.params.speed);
            }
            "custom" === t.type && t.renderCustom
              ? (a.html(t.renderCustom(this, i + 1, r)),
                this.emit("paginationRender", this, a[0]))
              : this.emit("paginationUpdate", this, a[0]),
              a[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](t.lockClass);
          }
        },
        render: function () {
          var e = this.params.pagination;
          if (
            e.el &&
            this.pagination.el &&
            this.pagination.$el &&
            0 !== this.pagination.$el.length
          ) {
            var t =
                this.virtual && this.params.virtual.enabled
                  ? this.virtual.slides.length
                  : this.slides.length,
              i = this.pagination.$el,
              n = "";
            if ("bullets" === e.type) {
              for (
                var s = this.params.loop
                    ? Math.ceil(
                        (t - 2 * this.loopedSlides) / this.params.slidesPerGroup
                      )
                    : this.snapGrid.length,
                  a = 0;
                a < s;
                a += 1
              )
                e.renderBullet
                  ? (n += e.renderBullet.call(this, a, e.bulletClass))
                  : (n +=
                      "<" +
                      e.bulletElement +
                      ' class="' +
                      e.bulletClass +
                      '"></' +
                      e.bulletElement +
                      ">");
              i.html(n),
                (this.pagination.bullets = i.find("." + e.bulletClass));
            }
            "fraction" === e.type &&
              ((n = e.renderFraction
                ? e.renderFraction.call(this, e.currentClass, e.totalClass)
                : '<span class="' +
                  e.currentClass +
                  '"></span> / <span class="' +
                  e.totalClass +
                  '"></span>'),
              i.html(n)),
              "progressbar" === e.type &&
                ((n = e.renderProgressbar
                  ? e.renderProgressbar.call(this, e.progressbarFillClass)
                  : '<span class="' + e.progressbarFillClass + '"></span>'),
                i.html(n)),
              "custom" !== e.type &&
                this.emit("paginationRender", this.pagination.$el[0]);
          }
        },
        init: function () {
          var e = this,
            t = e.params.pagination;
          if (t.el) {
            var i = n(t.el);
            0 !== i.length &&
              (e.params.uniqueNavElements &&
                "string" == typeof t.el &&
                i.length > 1 &&
                1 === e.$el.find(t.el).length &&
                (i = e.$el.find(t.el)),
              "bullets" === t.type &&
                t.clickable &&
                i.addClass(t.clickableClass),
              i.addClass(t.modifierClass + t.type),
              "bullets" === t.type &&
                t.dynamicBullets &&
                (i.addClass("" + t.modifierClass + t.type + "-dynamic"),
                (e.pagination.dynamicBulletIndex = 0),
                t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
              "progressbar" === t.type &&
                t.progressbarOpposite &&
                i.addClass(t.progressbarOppositeClass),
              t.clickable &&
                i.on("click", "." + t.bulletClass, function (t) {
                  t.preventDefault();
                  var i = n(this).index() * e.params.slidesPerGroup;
                  e.params.loop && (i += e.loopedSlides), e.slideTo(i);
                }),
              r.extend(e.pagination, { $el: i, el: i[0] }));
          }
        },
        destroy: function () {
          var e = this.params.pagination;
          if (
            e.el &&
            this.pagination.el &&
            this.pagination.$el &&
            0 !== this.pagination.$el.length
          ) {
            var t = this.pagination.$el;
            t.removeClass(e.hiddenClass),
              t.removeClass(e.modifierClass + e.type),
              this.pagination.bullets &&
                this.pagination.bullets.removeClass(e.bulletActiveClass),
              e.clickable && t.off("click", "." + e.bulletClass);
          }
        },
      },
      se = {
        setTranslate: function () {
          if (this.params.scrollbar.el && this.scrollbar.el) {
            var e = this.scrollbar,
              t = this.rtlTranslate,
              i = this.progress,
              n = e.dragSize,
              s = e.trackSize,
              a = e.$dragEl,
              r = e.$el,
              o = this.params.scrollbar,
              l = n,
              c = (s - n) * i;
            t
              ? (c = -c) > 0
                ? ((l = n - c), (c = 0))
                : -c + n > s && (l = s + c)
              : c < 0
              ? ((l = n + c), (c = 0))
              : c + n > s && (l = s - c),
              this.isHorizontal()
                ? (a.transform("translate3d(" + c + "px, 0, 0)"),
                  (a[0].style.width = l + "px"))
                : (a.transform("translate3d(0px, " + c + "px, 0)"),
                  (a[0].style.height = l + "px")),
              o.hide &&
                (clearTimeout(this.scrollbar.timeout),
                (r[0].style.opacity = 1),
                (this.scrollbar.timeout = setTimeout(function () {
                  (r[0].style.opacity = 0), r.transition(400);
                }, 1e3)));
          }
        },
        setTransition: function (e) {
          this.params.scrollbar.el &&
            this.scrollbar.el &&
            this.scrollbar.$dragEl.transition(e);
        },
        updateSize: function () {
          if (this.params.scrollbar.el && this.scrollbar.el) {
            var e = this.scrollbar,
              t = e.$dragEl,
              i = e.$el;
            (t[0].style.width = ""), (t[0].style.height = "");
            var n,
              s = this.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
              a = this.size / this.virtualSize,
              o = a * (s / this.size);
            (n =
              "auto" === this.params.scrollbar.dragSize
                ? s * a
                : parseInt(this.params.scrollbar.dragSize, 10)),
              this.isHorizontal()
                ? (t[0].style.width = n + "px")
                : (t[0].style.height = n + "px"),
              (i[0].style.display = a >= 1 ? "none" : ""),
              this.params.scrollbar.hide && (i[0].style.opacity = 0),
              r.extend(e, {
                trackSize: s,
                divider: a,
                moveDivider: o,
                dragSize: n,
              }),
              e.$el[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](this.params.scrollbar.lockClass);
          }
        },
        getPointerPosition: function (e) {
          return this.isHorizontal()
            ? "touchstart" === e.type || "touchmove" === e.type
              ? e.targetTouches[0].clientX
              : e.clientX
            : "touchstart" === e.type || "touchmove" === e.type
            ? e.targetTouches[0].clientY
            : e.clientY;
        },
        setDragPosition: function (e) {
          var t,
            i = this.scrollbar,
            n = this.rtlTranslate,
            s = i.$el,
            a = i.dragSize,
            r = i.trackSize,
            o = i.dragStartPos;
          (t =
            (i.getPointerPosition(e) -
              s.offset()[this.isHorizontal() ? "left" : "top"] -
              (null !== o ? o : a / 2)) /
            (r - a)),
            (t = Math.max(Math.min(t, 1), 0)),
            n && (t = 1 - t);
          var l =
            this.minTranslate() +
            (this.maxTranslate() - this.minTranslate()) * t;
          this.updateProgress(l),
            this.setTranslate(l),
            this.updateActiveIndex(),
            this.updateSlidesClasses();
        },
        onDragStart: function (e) {
          var t = this.params.scrollbar,
            i = this.scrollbar,
            n = this.$wrapperEl,
            s = i.$el,
            a = i.$dragEl;
          (this.scrollbar.isTouched = !0),
            (this.scrollbar.dragStartPos =
              e.target === a[0] || e.target === a
                ? i.getPointerPosition(e) -
                  e.target.getBoundingClientRect()[
                    this.isHorizontal() ? "left" : "top"
                  ]
                : null),
            e.preventDefault(),
            e.stopPropagation(),
            n.transition(100),
            a.transition(100),
            i.setDragPosition(e),
            clearTimeout(this.scrollbar.dragTimeout),
            s.transition(0),
            t.hide && s.css("opacity", 1),
            this.params.cssMode &&
              this.$wrapperEl.css("scroll-snap-type", "none"),
            this.emit("scrollbarDragStart", e);
        },
        onDragMove: function (e) {
          var t = this.scrollbar,
            i = this.$wrapperEl,
            n = t.$el,
            s = t.$dragEl;
          this.scrollbar.isTouched &&
            (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
            t.setDragPosition(e),
            i.transition(0),
            n.transition(0),
            s.transition(0),
            this.emit("scrollbarDragMove", e));
        },
        onDragEnd: function (e) {
          var t = this.params.scrollbar,
            i = this.scrollbar,
            n = this.$wrapperEl,
            s = i.$el;
          this.scrollbar.isTouched &&
            ((this.scrollbar.isTouched = !1),
            this.params.cssMode &&
              (this.$wrapperEl.css("scroll-snap-type", ""), n.transition("")),
            t.hide &&
              (clearTimeout(this.scrollbar.dragTimeout),
              (this.scrollbar.dragTimeout = r.nextTick(function () {
                s.css("opacity", 0), s.transition(400);
              }, 1e3))),
            this.emit("scrollbarDragEnd", e),
            t.snapOnRelease && this.slideToClosest());
        },
        enableDraggable: function () {
          if (this.params.scrollbar.el) {
            var t = this.scrollbar,
              i = this.touchEventsTouch,
              n = this.touchEventsDesktop,
              s = this.params,
              a = t.$el[0],
              r = !(!o.passiveListener || !s.passiveListeners) && {
                passive: !1,
                capture: !1,
              },
              l = !(!o.passiveListener || !s.passiveListeners) && {
                passive: !0,
                capture: !1,
              };
            o.touch
              ? (a.addEventListener(i.start, this.scrollbar.onDragStart, r),
                a.addEventListener(i.move, this.scrollbar.onDragMove, r),
                a.addEventListener(i.end, this.scrollbar.onDragEnd, l))
              : (a.addEventListener(n.start, this.scrollbar.onDragStart, r),
                e.addEventListener(n.move, this.scrollbar.onDragMove, r),
                e.addEventListener(n.end, this.scrollbar.onDragEnd, l));
          }
        },
        disableDraggable: function () {
          if (this.params.scrollbar.el) {
            var t = this.scrollbar,
              i = this.touchEventsTouch,
              n = this.touchEventsDesktop,
              s = this.params,
              a = t.$el[0],
              r = !(!o.passiveListener || !s.passiveListeners) && {
                passive: !1,
                capture: !1,
              },
              l = !(!o.passiveListener || !s.passiveListeners) && {
                passive: !0,
                capture: !1,
              };
            o.touch
              ? (a.removeEventListener(i.start, this.scrollbar.onDragStart, r),
                a.removeEventListener(i.move, this.scrollbar.onDragMove, r),
                a.removeEventListener(i.end, this.scrollbar.onDragEnd, l))
              : (a.removeEventListener(n.start, this.scrollbar.onDragStart, r),
                e.removeEventListener(n.move, this.scrollbar.onDragMove, r),
                e.removeEventListener(n.end, this.scrollbar.onDragEnd, l));
          }
        },
        init: function () {
          if (this.params.scrollbar.el) {
            var e = this.scrollbar,
              t = this.$el,
              i = this.params.scrollbar,
              s = n(i.el);
            this.params.uniqueNavElements &&
              "string" == typeof i.el &&
              s.length > 1 &&
              1 === t.find(i.el).length &&
              (s = t.find(i.el));
            var a = s.find("." + this.params.scrollbar.dragClass);
            0 === a.length &&
              ((a = n(
                '<div class="' + this.params.scrollbar.dragClass + '"></div>'
              )),
              s.append(a)),
              r.extend(e, { $el: s, el: s[0], $dragEl: a, dragEl: a[0] }),
              i.draggable && e.enableDraggable();
          }
        },
        destroy: function () {
          this.scrollbar.disableDraggable();
        },
      },
      ae = {
        setTransform: function (e, t) {
          var i = this.rtl,
            s = n(e),
            a = i ? -1 : 1,
            r = s.attr("data-swiper-parallax") || "0",
            o = s.attr("data-swiper-parallax-x"),
            l = s.attr("data-swiper-parallax-y"),
            c = s.attr("data-swiper-parallax-scale"),
            u = s.attr("data-swiper-parallax-opacity");
          if (
            (o || l
              ? ((o = o || "0"), (l = l || "0"))
              : this.isHorizontal()
              ? ((o = r), (l = "0"))
              : ((l = r), (o = "0")),
            (o =
              o.indexOf("%") >= 0
                ? parseInt(o, 10) * t * a + "%"
                : o * t * a + "px"),
            (l =
              l.indexOf("%") >= 0 ? parseInt(l, 10) * t + "%" : l * t + "px"),
            null != u)
          ) {
            var d = u - (u - 1) * (1 - Math.abs(t));
            s[0].style.opacity = d;
          }
          if (null == c) s.transform("translate3d(" + o + ", " + l + ", 0px)");
          else {
            var h = c - (c - 1) * (1 - Math.abs(t));
            s.transform(
              "translate3d(" + o + ", " + l + ", 0px) scale(" + h + ")"
            );
          }
        },
        setTranslate: function () {
          var e = this,
            t = e.$el,
            i = e.slides,
            s = e.progress,
            a = e.snapGrid;
          t
            .children(
              "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
            )
            .each(function (t, i) {
              e.parallax.setTransform(i, s);
            }),
            i.each(function (t, i) {
              var r = i.progress;
              e.params.slidesPerGroup > 1 &&
                "auto" !== e.params.slidesPerView &&
                (r += Math.ceil(t / 2) - s * (a.length - 1)),
                (r = Math.min(Math.max(r, -1), 1)),
                n(i)
                  .find(
                    "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                  )
                  .each(function (t, i) {
                    e.parallax.setTransform(i, r);
                  });
            });
        },
        setTransition: function (e) {
          void 0 === e && (e = this.params.speed),
            this.$el
              .find(
                "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
              )
              .each(function (t, i) {
                var s = n(i),
                  a =
                    parseInt(s.attr("data-swiper-parallax-duration"), 10) || e;
                0 === e && (a = 0), s.transition(a);
              });
        },
      },
      re = {
        getDistanceBetweenTouches: function (e) {
          if (e.targetTouches.length < 2) return 1;
          var t = e.targetTouches[0].pageX,
            i = e.targetTouches[0].pageY,
            n = e.targetTouches[1].pageX,
            s = e.targetTouches[1].pageY;
          return Math.sqrt(Math.pow(n - t, 2) + Math.pow(s - i, 2));
        },
        onGestureStart: function (e) {
          var t = this.params.zoom,
            i = this.zoom,
            s = i.gesture;
          if (
            ((i.fakeGestureTouched = !1),
            (i.fakeGestureMoved = !1),
            !o.gestures)
          ) {
            if (
              "touchstart" !== e.type ||
              ("touchstart" === e.type && e.targetTouches.length < 2)
            )
              return;
            (i.fakeGestureTouched = !0),
              (s.scaleStart = re.getDistanceBetweenTouches(e));
          }
          (s.$slideEl && s.$slideEl.length) ||
          ((s.$slideEl = n(e.target).closest("." + this.params.slideClass)),
          0 === s.$slideEl.length &&
            (s.$slideEl = this.slides.eq(this.activeIndex)),
          (s.$imageEl = s.$slideEl.find(
            "img, svg, canvas, picture, .swiper-zoom-target"
          )),
          (s.$imageWrapEl = s.$imageEl.parent("." + t.containerClass)),
          (s.maxRatio = s.$imageWrapEl.attr("data-swiper-zoom") || t.maxRatio),
          0 !== s.$imageWrapEl.length)
            ? (s.$imageEl && s.$imageEl.transition(0),
              (this.zoom.isScaling = !0))
            : (s.$imageEl = void 0);
        },
        onGestureChange: function (e) {
          var t = this.params.zoom,
            i = this.zoom,
            n = i.gesture;
          if (!o.gestures) {
            if (
              "touchmove" !== e.type ||
              ("touchmove" === e.type && e.targetTouches.length < 2)
            )
              return;
            (i.fakeGestureMoved = !0),
              (n.scaleMove = re.getDistanceBetweenTouches(e));
          }
          n.$imageEl &&
            0 !== n.$imageEl.length &&
            ((i.scale = o.gestures
              ? e.scale * i.currentScale
              : (n.scaleMove / n.scaleStart) * i.currentScale),
            i.scale > n.maxRatio &&
              (i.scale =
                n.maxRatio - 1 + Math.pow(i.scale - n.maxRatio + 1, 0.5)),
            i.scale < t.minRatio &&
              (i.scale =
                t.minRatio + 1 - Math.pow(t.minRatio - i.scale + 1, 0.5)),
            n.$imageEl.transform("translate3d(0,0,0) scale(" + i.scale + ")"));
        },
        onGestureEnd: function (e) {
          var t = this.params.zoom,
            i = this.zoom,
            n = i.gesture;
          if (!o.gestures) {
            if (!i.fakeGestureTouched || !i.fakeGestureMoved) return;
            if (
              "touchend" !== e.type ||
              ("touchend" === e.type &&
                e.changedTouches.length < 2 &&
                !I.android)
            )
              return;
            (i.fakeGestureTouched = !1), (i.fakeGestureMoved = !1);
          }
          n.$imageEl &&
            0 !== n.$imageEl.length &&
            ((i.scale = Math.max(Math.min(i.scale, n.maxRatio), t.minRatio)),
            n.$imageEl
              .transition(this.params.speed)
              .transform("translate3d(0,0,0) scale(" + i.scale + ")"),
            (i.currentScale = i.scale),
            (i.isScaling = !1),
            1 === i.scale && (n.$slideEl = void 0));
        },
        onTouchStart: function (e) {
          var t = this.zoom,
            i = t.gesture,
            n = t.image;
          i.$imageEl &&
            0 !== i.$imageEl.length &&
            (n.isTouched ||
              (I.android && e.preventDefault(),
              (n.isTouched = !0),
              (n.touchesStart.x =
                "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX),
              (n.touchesStart.y =
                "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY)));
        },
        onTouchMove: function (e) {
          var t = this.zoom,
            i = t.gesture,
            n = t.image,
            s = t.velocity;
          if (
            i.$imageEl &&
            0 !== i.$imageEl.length &&
            ((this.allowClick = !1), n.isTouched && i.$slideEl)
          ) {
            n.isMoved ||
              ((n.width = i.$imageEl[0].offsetWidth),
              (n.height = i.$imageEl[0].offsetHeight),
              (n.startX = r.getTranslate(i.$imageWrapEl[0], "x") || 0),
              (n.startY = r.getTranslate(i.$imageWrapEl[0], "y") || 0),
              (i.slideWidth = i.$slideEl[0].offsetWidth),
              (i.slideHeight = i.$slideEl[0].offsetHeight),
              i.$imageWrapEl.transition(0),
              this.rtl && ((n.startX = -n.startX), (n.startY = -n.startY)));
            var a = n.width * t.scale,
              o = n.height * t.scale;
            if (!(a < i.slideWidth && o < i.slideHeight)) {
              if (
                ((n.minX = Math.min(i.slideWidth / 2 - a / 2, 0)),
                (n.maxX = -n.minX),
                (n.minY = Math.min(i.slideHeight / 2 - o / 2, 0)),
                (n.maxY = -n.minY),
                (n.touchesCurrent.x =
                  "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX),
                (n.touchesCurrent.y =
                  "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY),
                !n.isMoved && !t.isScaling)
              ) {
                if (
                  this.isHorizontal() &&
                  ((Math.floor(n.minX) === Math.floor(n.startX) &&
                    n.touchesCurrent.x < n.touchesStart.x) ||
                    (Math.floor(n.maxX) === Math.floor(n.startX) &&
                      n.touchesCurrent.x > n.touchesStart.x))
                )
                  return void (n.isTouched = !1);
                if (
                  !this.isHorizontal() &&
                  ((Math.floor(n.minY) === Math.floor(n.startY) &&
                    n.touchesCurrent.y < n.touchesStart.y) ||
                    (Math.floor(n.maxY) === Math.floor(n.startY) &&
                      n.touchesCurrent.y > n.touchesStart.y))
                )
                  return void (n.isTouched = !1);
              }
              e.preventDefault(),
                e.stopPropagation(),
                (n.isMoved = !0),
                (n.currentX = n.touchesCurrent.x - n.touchesStart.x + n.startX),
                (n.currentY = n.touchesCurrent.y - n.touchesStart.y + n.startY),
                n.currentX < n.minX &&
                  (n.currentX =
                    n.minX + 1 - Math.pow(n.minX - n.currentX + 1, 0.8)),
                n.currentX > n.maxX &&
                  (n.currentX =
                    n.maxX - 1 + Math.pow(n.currentX - n.maxX + 1, 0.8)),
                n.currentY < n.minY &&
                  (n.currentY =
                    n.minY + 1 - Math.pow(n.minY - n.currentY + 1, 0.8)),
                n.currentY > n.maxY &&
                  (n.currentY =
                    n.maxY - 1 + Math.pow(n.currentY - n.maxY + 1, 0.8)),
                s.prevPositionX || (s.prevPositionX = n.touchesCurrent.x),
                s.prevPositionY || (s.prevPositionY = n.touchesCurrent.y),
                s.prevTime || (s.prevTime = Date.now()),
                (s.x =
                  (n.touchesCurrent.x - s.prevPositionX) /
                  (Date.now() - s.prevTime) /
                  2),
                (s.y =
                  (n.touchesCurrent.y - s.prevPositionY) /
                  (Date.now() - s.prevTime) /
                  2),
                Math.abs(n.touchesCurrent.x - s.prevPositionX) < 2 && (s.x = 0),
                Math.abs(n.touchesCurrent.y - s.prevPositionY) < 2 && (s.y = 0),
                (s.prevPositionX = n.touchesCurrent.x),
                (s.prevPositionY = n.touchesCurrent.y),
                (s.prevTime = Date.now()),
                i.$imageWrapEl.transform(
                  "translate3d(" + n.currentX + "px, " + n.currentY + "px,0)"
                );
            }
          }
        },
        onTouchEnd: function () {
          var e = this.zoom,
            t = e.gesture,
            i = e.image,
            n = e.velocity;
          if (t.$imageEl && 0 !== t.$imageEl.length) {
            if (!i.isTouched || !i.isMoved)
              return (i.isTouched = !1), void (i.isMoved = !1);
            (i.isTouched = !1), (i.isMoved = !1);
            var s = 300,
              a = 300,
              r = n.x * s,
              o = i.currentX + r,
              l = n.y * a,
              c = i.currentY + l;
            0 !== n.x && (s = Math.abs((o - i.currentX) / n.x)),
              0 !== n.y && (a = Math.abs((c - i.currentY) / n.y));
            var u = Math.max(s, a);
            (i.currentX = o), (i.currentY = c);
            var d = i.width * e.scale,
              h = i.height * e.scale;
            (i.minX = Math.min(t.slideWidth / 2 - d / 2, 0)),
              (i.maxX = -i.minX),
              (i.minY = Math.min(t.slideHeight / 2 - h / 2, 0)),
              (i.maxY = -i.minY),
              (i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX)),
              (i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY)),
              t.$imageWrapEl
                .transition(u)
                .transform(
                  "translate3d(" + i.currentX + "px, " + i.currentY + "px,0)"
                );
          }
        },
        onTransitionEnd: function () {
          var e = this.zoom,
            t = e.gesture;
          t.$slideEl &&
            this.previousIndex !== this.activeIndex &&
            (t.$imageEl && t.$imageEl.transform("translate3d(0,0,0) scale(1)"),
            t.$imageWrapEl && t.$imageWrapEl.transform("translate3d(0,0,0)"),
            (e.scale = 1),
            (e.currentScale = 1),
            (t.$slideEl = void 0),
            (t.$imageEl = void 0),
            (t.$imageWrapEl = void 0));
        },
        toggle: function (e) {
          var t = this.zoom;
          t.scale && 1 !== t.scale ? t.out() : t.in(e);
        },
        in: function (e) {
          var t,
            i,
            n,
            s,
            a,
            r,
            o,
            l,
            c,
            u,
            d,
            h,
            p,
            f,
            v,
            m,
            g = this.zoom,
            y = this.params.zoom,
            b = g.gesture,
            w = g.image;
          b.$slideEl ||
            (this.params.virtual && this.params.virtual.enabled && this.virtual
              ? (b.$slideEl = this.$wrapperEl.children(
                  "." + this.params.slideActiveClass
                ))
              : (b.$slideEl = this.slides.eq(this.activeIndex)),
            (b.$imageEl = b.$slideEl.find(
              "img, svg, canvas, picture, .swiper-zoom-target"
            )),
            (b.$imageWrapEl = b.$imageEl.parent("." + y.containerClass))),
            b.$imageEl &&
              0 !== b.$imageEl.length &&
              (b.$slideEl.addClass("" + y.zoomedSlideClass),
              void 0 === w.touchesStart.x && e
                ? ((t =
                    "touchend" === e.type
                      ? e.changedTouches[0].pageX
                      : e.pageX),
                  (i =
                    "touchend" === e.type
                      ? e.changedTouches[0].pageY
                      : e.pageY))
                : ((t = w.touchesStart.x), (i = w.touchesStart.y)),
              (g.scale = b.$imageWrapEl.attr("data-swiper-zoom") || y.maxRatio),
              (g.currentScale =
                b.$imageWrapEl.attr("data-swiper-zoom") || y.maxRatio),
              e
                ? ((v = b.$slideEl[0].offsetWidth),
                  (m = b.$slideEl[0].offsetHeight),
                  (n = b.$slideEl.offset().left + v / 2 - t),
                  (s = b.$slideEl.offset().top + m / 2 - i),
                  (o = b.$imageEl[0].offsetWidth),
                  (l = b.$imageEl[0].offsetHeight),
                  (c = o * g.scale),
                  (u = l * g.scale),
                  (p = -(d = Math.min(v / 2 - c / 2, 0))),
                  (f = -(h = Math.min(m / 2 - u / 2, 0))),
                  (a = n * g.scale) < d && (a = d),
                  a > p && (a = p),
                  (r = s * g.scale) < h && (r = h),
                  r > f && (r = f))
                : ((a = 0), (r = 0)),
              b.$imageWrapEl
                .transition(300)
                .transform("translate3d(" + a + "px, " + r + "px,0)"),
              b.$imageEl
                .transition(300)
                .transform("translate3d(0,0,0) scale(" + g.scale + ")"));
        },
        out: function () {
          var e = this.zoom,
            t = this.params.zoom,
            i = e.gesture;
          i.$slideEl ||
            (this.params.virtual && this.params.virtual.enabled && this.virtual
              ? (i.$slideEl = this.$wrapperEl.children(
                  "." + this.params.slideActiveClass
                ))
              : (i.$slideEl = this.slides.eq(this.activeIndex)),
            (i.$imageEl = i.$slideEl.find(
              "img, svg, canvas, picture, .swiper-zoom-target"
            )),
            (i.$imageWrapEl = i.$imageEl.parent("." + t.containerClass))),
            i.$imageEl &&
              0 !== i.$imageEl.length &&
              ((e.scale = 1),
              (e.currentScale = 1),
              i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
              i.$imageEl
                .transition(300)
                .transform("translate3d(0,0,0) scale(1)"),
              i.$slideEl.removeClass("" + t.zoomedSlideClass),
              (i.$slideEl = void 0));
        },
        enable: function () {
          var e = this.zoom;
          if (!e.enabled) {
            e.enabled = !0;
            var t = !(
                "touchstart" !== this.touchEvents.start ||
                !o.passiveListener ||
                !this.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              i = !o.passiveListener || { passive: !1, capture: !0 },
              n = "." + this.params.slideClass;
            o.gestures
              ? (this.$wrapperEl.on("gesturestart", n, e.onGestureStart, t),
                this.$wrapperEl.on("gesturechange", n, e.onGestureChange, t),
                this.$wrapperEl.on("gestureend", n, e.onGestureEnd, t))
              : "touchstart" === this.touchEvents.start &&
                (this.$wrapperEl.on(
                  this.touchEvents.start,
                  n,
                  e.onGestureStart,
                  t
                ),
                this.$wrapperEl.on(
                  this.touchEvents.move,
                  n,
                  e.onGestureChange,
                  i
                ),
                this.$wrapperEl.on(this.touchEvents.end, n, e.onGestureEnd, t),
                this.touchEvents.cancel &&
                  this.$wrapperEl.on(
                    this.touchEvents.cancel,
                    n,
                    e.onGestureEnd,
                    t
                  )),
              this.$wrapperEl.on(
                this.touchEvents.move,
                "." + this.params.zoom.containerClass,
                e.onTouchMove,
                i
              );
          }
        },
        disable: function () {
          var e = this.zoom;
          if (e.enabled) {
            this.zoom.enabled = !1;
            var t = !(
                "touchstart" !== this.touchEvents.start ||
                !o.passiveListener ||
                !this.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              i = !o.passiveListener || { passive: !1, capture: !0 },
              n = "." + this.params.slideClass;
            o.gestures
              ? (this.$wrapperEl.off("gesturestart", n, e.onGestureStart, t),
                this.$wrapperEl.off("gesturechange", n, e.onGestureChange, t),
                this.$wrapperEl.off("gestureend", n, e.onGestureEnd, t))
              : "touchstart" === this.touchEvents.start &&
                (this.$wrapperEl.off(
                  this.touchEvents.start,
                  n,
                  e.onGestureStart,
                  t
                ),
                this.$wrapperEl.off(
                  this.touchEvents.move,
                  n,
                  e.onGestureChange,
                  i
                ),
                this.$wrapperEl.off(this.touchEvents.end, n, e.onGestureEnd, t),
                this.touchEvents.cancel &&
                  this.$wrapperEl.off(
                    this.touchEvents.cancel,
                    n,
                    e.onGestureEnd,
                    t
                  )),
              this.$wrapperEl.off(
                this.touchEvents.move,
                "." + this.params.zoom.containerClass,
                e.onTouchMove,
                i
              );
          }
        },
      },
      oe = {
        loadInSlide: function (e, t) {
          void 0 === t && (t = !0);
          var i = this,
            s = i.params.lazy;
          if (void 0 !== e && 0 !== i.slides.length) {
            var a =
                i.virtual && i.params.virtual.enabled
                  ? i.$wrapperEl.children(
                      "." +
                        i.params.slideClass +
                        '[data-swiper-slide-index="' +
                        e +
                        '"]'
                    )
                  : i.slides.eq(e),
              r = a.find(
                "." +
                  s.elementClass +
                  ":not(." +
                  s.loadedClass +
                  "):not(." +
                  s.loadingClass +
                  ")"
              );
            !a.hasClass(s.elementClass) ||
              a.hasClass(s.loadedClass) ||
              a.hasClass(s.loadingClass) ||
              (r = r.add(a[0])),
              0 !== r.length &&
                r.each(function (e, r) {
                  var o = n(r);
                  o.addClass(s.loadingClass);
                  var l = o.attr("data-background"),
                    c = o.attr("data-src"),
                    u = o.attr("data-srcset"),
                    d = o.attr("data-sizes");
                  i.loadImage(o[0], c || l, u, d, !1, function () {
                    if (null != i && i && (!i || i.params) && !i.destroyed) {
                      if (
                        (l
                          ? (o.css("background-image", 'url("' + l + '")'),
                            o.removeAttr("data-background"))
                          : (u &&
                              (o.attr("srcset", u),
                              o.removeAttr("data-srcset")),
                            d &&
                              (o.attr("sizes", d), o.removeAttr("data-sizes")),
                            c && (o.attr("src", c), o.removeAttr("data-src"))),
                        o.addClass(s.loadedClass).removeClass(s.loadingClass),
                        a.find("." + s.preloaderClass).remove(),
                        i.params.loop && t)
                      ) {
                        var e = a.attr("data-swiper-slide-index");
                        if (a.hasClass(i.params.slideDuplicateClass)) {
                          var n = i.$wrapperEl.children(
                            '[data-swiper-slide-index="' +
                              e +
                              '"]:not(.' +
                              i.params.slideDuplicateClass +
                              ")"
                          );
                          i.lazy.loadInSlide(n.index(), !1);
                        } else {
                          var r = i.$wrapperEl.children(
                            "." +
                              i.params.slideDuplicateClass +
                              '[data-swiper-slide-index="' +
                              e +
                              '"]'
                          );
                          i.lazy.loadInSlide(r.index(), !1);
                        }
                      }
                      i.emit("lazyImageReady", a[0], o[0]),
                        i.params.autoHeight && i.updateAutoHeight();
                    }
                  }),
                    i.emit("lazyImageLoad", a[0], o[0]);
                });
          }
        },
        load: function () {
          var e = this,
            t = e.$wrapperEl,
            i = e.params,
            s = e.slides,
            a = e.activeIndex,
            r = e.virtual && i.virtual.enabled,
            o = i.lazy,
            l = i.slidesPerView;
          function c(e) {
            if (r) {
              if (
                t.children(
                  "." + i.slideClass + '[data-swiper-slide-index="' + e + '"]'
                ).length
              )
                return !0;
            } else if (s[e]) return !0;
            return !1;
          }
          function u(e) {
            return r ? n(e).attr("data-swiper-slide-index") : n(e).index();
          }
          if (
            ("auto" === l && (l = 0),
            e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0),
            e.params.watchSlidesVisibility)
          )
            t.children("." + i.slideVisibleClass).each(function (t, i) {
              var s = r ? n(i).attr("data-swiper-slide-index") : n(i).index();
              e.lazy.loadInSlide(s);
            });
          else if (l > 1)
            for (var d = a; d < a + l; d += 1) c(d) && e.lazy.loadInSlide(d);
          else e.lazy.loadInSlide(a);
          if (o.loadPrevNext)
            if (l > 1 || (o.loadPrevNextAmount && o.loadPrevNextAmount > 1)) {
              for (
                var h = o.loadPrevNextAmount,
                  p = l,
                  f = Math.min(a + p + Math.max(h, p), s.length),
                  v = Math.max(a - Math.max(p, h), 0),
                  m = a + l;
                m < f;
                m += 1
              )
                c(m) && e.lazy.loadInSlide(m);
              for (var g = v; g < a; g += 1) c(g) && e.lazy.loadInSlide(g);
            } else {
              var y = t.children("." + i.slideNextClass);
              y.length > 0 && e.lazy.loadInSlide(u(y));
              var b = t.children("." + i.slidePrevClass);
              b.length > 0 && e.lazy.loadInSlide(u(b));
            }
        },
      },
      le = {
        LinearSpline: function (e, t) {
          var i, n, s, a, r;
          return (
            (this.x = e),
            (this.y = t),
            (this.lastIndex = e.length - 1),
            (this.interpolate = function (e) {
              return e
                ? ((r = (function (e, t) {
                    for (n = -1, i = e.length; i - n > 1; )
                      e[(s = (i + n) >> 1)] <= t ? (n = s) : (i = s);
                    return i;
                  })(this.x, e)),
                  (a = r - 1),
                  ((e - this.x[a]) * (this.y[r] - this.y[a])) /
                    (this.x[r] - this.x[a]) +
                    this.y[a])
                : 0;
            }),
            this
          );
        },
        getInterpolateFunction: function (e) {
          this.controller.spline ||
            (this.controller.spline = this.params.loop
              ? new le.LinearSpline(this.slidesGrid, e.slidesGrid)
              : new le.LinearSpline(this.snapGrid, e.snapGrid));
        },
        setTranslate: function (e, t) {
          var i,
            n,
            s = this,
            a = s.controller.control;
          function r(e) {
            var t = s.rtlTranslate ? -s.translate : s.translate;
            "slide" === s.params.controller.by &&
              (s.controller.getInterpolateFunction(e),
              (n = -s.controller.spline.interpolate(-t))),
              (n && "container" !== s.params.controller.by) ||
                ((i =
                  (e.maxTranslate() - e.minTranslate()) /
                  (s.maxTranslate() - s.minTranslate())),
                (n = (t - s.minTranslate()) * i + e.minTranslate())),
              s.params.controller.inverse && (n = e.maxTranslate() - n),
              e.updateProgress(n),
              e.setTranslate(n, s),
              e.updateActiveIndex(),
              e.updateSlidesClasses();
          }
          if (Array.isArray(a))
            for (var o = 0; o < a.length; o += 1)
              a[o] !== t && a[o] instanceof R && r(a[o]);
          else a instanceof R && t !== a && r(a);
        },
        setTransition: function (e, t) {
          var i,
            n = this,
            s = n.controller.control;
          function a(t) {
            t.setTransition(e, n),
              0 !== e &&
                (t.transitionStart(),
                t.params.autoHeight &&
                  r.nextTick(function () {
                    t.updateAutoHeight();
                  }),
                t.$wrapperEl.transitionEnd(function () {
                  s &&
                    (t.params.loop &&
                      "slide" === n.params.controller.by &&
                      t.loopFix(),
                    t.transitionEnd());
                }));
          }
          if (Array.isArray(s))
            for (i = 0; i < s.length; i += 1)
              s[i] !== t && s[i] instanceof R && a(s[i]);
          else s instanceof R && t !== s && a(s);
        },
      },
      ce = {
        makeElFocusable: function (e) {
          return e.attr("tabIndex", "0"), e;
        },
        addElRole: function (e, t) {
          return e.attr("role", t), e;
        },
        addElLabel: function (e, t) {
          return e.attr("aria-label", t), e;
        },
        disableEl: function (e) {
          return e.attr("aria-disabled", !0), e;
        },
        enableEl: function (e) {
          return e.attr("aria-disabled", !1), e;
        },
        onEnterKey: function (e) {
          var t = this.params.a11y;
          if (13 === e.keyCode) {
            var i = n(e.target);
            this.navigation &&
              this.navigation.$nextEl &&
              i.is(this.navigation.$nextEl) &&
              ((this.isEnd && !this.params.loop) || this.slideNext(),
              this.isEnd
                ? this.a11y.notify(t.lastSlideMessage)
                : this.a11y.notify(t.nextSlideMessage)),
              this.navigation &&
                this.navigation.$prevEl &&
                i.is(this.navigation.$prevEl) &&
                ((this.isBeginning && !this.params.loop) || this.slidePrev(),
                this.isBeginning
                  ? this.a11y.notify(t.firstSlideMessage)
                  : this.a11y.notify(t.prevSlideMessage)),
              this.pagination &&
                i.is("." + this.params.pagination.bulletClass) &&
                i[0].click();
          }
        },
        notify: function (e) {
          var t = this.a11y.liveRegion;
          0 !== t.length && (t.html(""), t.html(e));
        },
        updateNavigation: function () {
          if (!this.params.loop && this.navigation) {
            var e = this.navigation,
              t = e.$nextEl,
              i = e.$prevEl;
            i &&
              i.length > 0 &&
              (this.isBeginning
                ? this.a11y.disableEl(i)
                : this.a11y.enableEl(i)),
              t &&
                t.length > 0 &&
                (this.isEnd ? this.a11y.disableEl(t) : this.a11y.enableEl(t));
          }
        },
        updatePagination: function () {
          var e = this,
            t = e.params.a11y;
          e.pagination &&
            e.params.pagination.clickable &&
            e.pagination.bullets &&
            e.pagination.bullets.length &&
            e.pagination.bullets.each(function (i, s) {
              var a = n(s);
              e.a11y.makeElFocusable(a),
                e.a11y.addElRole(a, "button"),
                e.a11y.addElLabel(
                  a,
                  t.paginationBulletMessage.replace(
                    /\{\{index\}\}/,
                    a.index() + 1
                  )
                );
            });
        },
        init: function () {
          this.$el.append(this.a11y.liveRegion);
          var e,
            t,
            i = this.params.a11y;
          this.navigation &&
            this.navigation.$nextEl &&
            (e = this.navigation.$nextEl),
            this.navigation &&
              this.navigation.$prevEl &&
              (t = this.navigation.$prevEl),
            e &&
              (this.a11y.makeElFocusable(e),
              this.a11y.addElRole(e, "button"),
              this.a11y.addElLabel(e, i.nextSlideMessage),
              e.on("keydown", this.a11y.onEnterKey)),
            t &&
              (this.a11y.makeElFocusable(t),
              this.a11y.addElRole(t, "button"),
              this.a11y.addElLabel(t, i.prevSlideMessage),
              t.on("keydown", this.a11y.onEnterKey)),
            this.pagination &&
              this.params.pagination.clickable &&
              this.pagination.bullets &&
              this.pagination.bullets.length &&
              this.pagination.$el.on(
                "keydown",
                "." + this.params.pagination.bulletClass,
                this.a11y.onEnterKey
              );
        },
        destroy: function () {
          var e, t;
          this.a11y.liveRegion &&
            this.a11y.liveRegion.length > 0 &&
            this.a11y.liveRegion.remove(),
            this.navigation &&
              this.navigation.$nextEl &&
              (e = this.navigation.$nextEl),
            this.navigation &&
              this.navigation.$prevEl &&
              (t = this.navigation.$prevEl),
            e && e.off("keydown", this.a11y.onEnterKey),
            t && t.off("keydown", this.a11y.onEnterKey),
            this.pagination &&
              this.params.pagination.clickable &&
              this.pagination.bullets &&
              this.pagination.bullets.length &&
              this.pagination.$el.off(
                "keydown",
                "." + this.params.pagination.bulletClass,
                this.a11y.onEnterKey
              );
        },
      },
      ue = {
        init: function () {
          if (this.params.history) {
            if (!t.history || !t.history.pushState)
              return (
                (this.params.history.enabled = !1),
                void (this.params.hashNavigation.enabled = !0)
              );
            var e = this.history;
            (e.initialized = !0),
              (e.paths = ue.getPathValues()),
              (e.paths.key || e.paths.value) &&
                (e.scrollToSlide(
                  0,
                  e.paths.value,
                  this.params.runCallbacksOnInit
                ),
                this.params.history.replaceState ||
                  t.addEventListener(
                    "popstate",
                    this.history.setHistoryPopState
                  ));
          }
        },
        destroy: function () {
          this.params.history.replaceState ||
            t.removeEventListener("popstate", this.history.setHistoryPopState);
        },
        setHistoryPopState: function () {
          (this.history.paths = ue.getPathValues()),
            this.history.scrollToSlide(
              this.params.speed,
              this.history.paths.value,
              !1
            );
        },
        getPathValues: function () {
          var e = t.location.pathname
              .slice(1)
              .split("/")
              .filter(function (e) {
                return "" !== e;
              }),
            i = e.length;
          return { key: e[i - 2], value: e[i - 1] };
        },
        setHistory: function (e, i) {
          if (this.history.initialized && this.params.history.enabled) {
            var n = this.slides.eq(i),
              s = ue.slugify(n.attr("data-history"));
            t.location.pathname.includes(e) || (s = e + "/" + s);
            var a = t.history.state;
            (a && a.value === s) ||
              (this.params.history.replaceState
                ? t.history.replaceState({ value: s }, null, s)
                : t.history.pushState({ value: s }, null, s));
          }
        },
        slugify: function (e) {
          return e
            .toString()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]+/g, "")
            .replace(/--+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, "");
        },
        scrollToSlide: function (e, t, i) {
          if (t)
            for (var n = 0, s = this.slides.length; n < s; n += 1) {
              var a = this.slides.eq(n);
              if (
                ue.slugify(a.attr("data-history")) === t &&
                !a.hasClass(this.params.slideDuplicateClass)
              ) {
                var r = a.index();
                this.slideTo(r, e, i);
              }
            }
          else this.slideTo(0, e, i);
        },
      },
      de = {
        onHashCange: function () {
          var t = e.location.hash.replace("#", "");
          if (t !== this.slides.eq(this.activeIndex).attr("data-hash")) {
            var i = this.$wrapperEl
              .children(
                "." + this.params.slideClass + '[data-hash="' + t + '"]'
              )
              .index();
            if (void 0 === i) return;
            this.slideTo(i);
          }
        },
        setHash: function () {
          if (
            this.hashNavigation.initialized &&
            this.params.hashNavigation.enabled
          )
            if (
              this.params.hashNavigation.replaceState &&
              t.history &&
              t.history.replaceState
            )
              t.history.replaceState(
                null,
                null,
                "#" + this.slides.eq(this.activeIndex).attr("data-hash") || ""
              );
            else {
              var i = this.slides.eq(this.activeIndex),
                n = i.attr("data-hash") || i.attr("data-history");
              e.location.hash = n || "";
            }
        },
        init: function () {
          if (
            !(
              !this.params.hashNavigation.enabled ||
              (this.params.history && this.params.history.enabled)
            )
          ) {
            this.hashNavigation.initialized = !0;
            var i = e.location.hash.replace("#", "");
            if (i)
              for (var s = 0, a = this.slides.length; s < a; s += 1) {
                var r = this.slides.eq(s);
                if (
                  (r.attr("data-hash") || r.attr("data-history")) === i &&
                  !r.hasClass(this.params.slideDuplicateClass)
                ) {
                  var o = r.index();
                  this.slideTo(o, 0, this.params.runCallbacksOnInit, !0);
                }
              }
            this.params.hashNavigation.watchState &&
              n(t).on("hashchange", this.hashNavigation.onHashCange);
          }
        },
        destroy: function () {
          this.params.hashNavigation.watchState &&
            n(t).off("hashchange", this.hashNavigation.onHashCange);
        },
      },
      he = {
        run: function () {
          var e = this,
            t = e.slides.eq(e.activeIndex),
            i = e.params.autoplay.delay;
          t.attr("data-swiper-autoplay") &&
            (i = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
            clearTimeout(e.autoplay.timeout),
            (e.autoplay.timeout = r.nextTick(function () {
              e.params.autoplay.reverseDirection
                ? e.params.loop
                  ? (e.loopFix(),
                    e.slidePrev(e.params.speed, !0, !0),
                    e.emit("autoplay"))
                  : e.isBeginning
                  ? e.params.autoplay.stopOnLastSlide
                    ? e.autoplay.stop()
                    : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0),
                      e.emit("autoplay"))
                  : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay"))
                : e.params.loop
                ? (e.loopFix(),
                  e.slideNext(e.params.speed, !0, !0),
                  e.emit("autoplay"))
                : e.isEnd
                ? e.params.autoplay.stopOnLastSlide
                  ? e.autoplay.stop()
                  : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay"))
                : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")),
                e.params.cssMode && e.autoplay.running && e.autoplay.run();
            }, i));
        },
        start: function () {
          return (
            void 0 === this.autoplay.timeout &&
            !this.autoplay.running &&
            ((this.autoplay.running = !0),
            this.emit("autoplayStart"),
            this.autoplay.run(),
            !0)
          );
        },
        stop: function () {
          return (
            !!this.autoplay.running &&
            void 0 !== this.autoplay.timeout &&
            (this.autoplay.timeout &&
              (clearTimeout(this.autoplay.timeout),
              (this.autoplay.timeout = void 0)),
            (this.autoplay.running = !1),
            this.emit("autoplayStop"),
            !0)
          );
        },
        pause: function (e) {
          this.autoplay.running &&
            (this.autoplay.paused ||
              (this.autoplay.timeout && clearTimeout(this.autoplay.timeout),
              (this.autoplay.paused = !0),
              0 !== e && this.params.autoplay.waitForTransition
                ? (this.$wrapperEl[0].addEventListener(
                    "transitionend",
                    this.autoplay.onTransitionEnd
                  ),
                  this.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    this.autoplay.onTransitionEnd
                  ))
                : ((this.autoplay.paused = !1), this.autoplay.run())));
        },
      },
      pe = {
        setTranslate: function () {
          for (var e = this.slides, t = 0; t < e.length; t += 1) {
            var i = this.slides.eq(t),
              n = -i[0].swiperSlideOffset;
            this.params.virtualTranslate || (n -= this.translate);
            var s = 0;
            this.isHorizontal() || ((s = n), (n = 0));
            var a = this.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs(i[0].progress), 0)
              : 1 + Math.min(Math.max(i[0].progress, -1), 0);
            i.css({ opacity: a }).transform(
              "translate3d(" + n + "px, " + s + "px, 0px)"
            );
          }
        },
        setTransition: function (e) {
          var t = this,
            i = t.slides,
            n = t.$wrapperEl;
          if ((i.transition(e), t.params.virtualTranslate && 0 !== e)) {
            var s = !1;
            i.transitionEnd(function () {
              if (!s && t && !t.destroyed) {
                (s = !0), (t.animating = !1);
                for (
                  var e = ["webkitTransitionEnd", "transitionend"], i = 0;
                  i < e.length;
                  i += 1
                )
                  n.trigger(e[i]);
              }
            });
          }
        },
      },
      fe = {
        setTranslate: function () {
          var e,
            t = this.$el,
            i = this.$wrapperEl,
            s = this.slides,
            a = this.width,
            r = this.height,
            o = this.rtlTranslate,
            l = this.size,
            c = this.params.cubeEffect,
            u = this.isHorizontal(),
            d = this.virtual && this.params.virtual.enabled,
            h = 0;
          c.shadow &&
            (u
              ? (0 === (e = i.find(".swiper-cube-shadow")).length &&
                  ((e = n('<div class="swiper-cube-shadow"></div>')),
                  i.append(e)),
                e.css({ height: a + "px" }))
              : 0 === (e = t.find(".swiper-cube-shadow")).length &&
                ((e = n('<div class="swiper-cube-shadow"></div>')),
                t.append(e)));
          for (var p = 0; p < s.length; p += 1) {
            var f = s.eq(p),
              v = p;
            d && (v = parseInt(f.attr("data-swiper-slide-index"), 10));
            var m = 90 * v,
              g = Math.floor(m / 360);
            o && ((m = -m), (g = Math.floor(-m / 360)));
            var y = Math.max(Math.min(f[0].progress, 1), -1),
              b = 0,
              w = 0,
              S = 0;
            v % 4 == 0
              ? ((b = 4 * -g * l), (S = 0))
              : (v - 1) % 4 == 0
              ? ((b = 0), (S = 4 * -g * l))
              : (v - 2) % 4 == 0
              ? ((b = l + 4 * g * l), (S = l))
              : (v - 3) % 4 == 0 && ((b = -l), (S = 3 * l + 4 * l * g)),
              o && (b = -b),
              u || ((w = b), (b = 0));
            var x =
              "rotateX(" +
              (u ? 0 : -m) +
              "deg) rotateY(" +
              (u ? m : 0) +
              "deg) translate3d(" +
              b +
              "px, " +
              w +
              "px, " +
              S +
              "px)";
            if (
              (y <= 1 &&
                y > -1 &&
                ((h = 90 * v + 90 * y), o && (h = 90 * -v - 90 * y)),
              f.transform(x),
              c.slideShadows)
            ) {
              var C = u
                  ? f.find(".swiper-slide-shadow-left")
                  : f.find(".swiper-slide-shadow-top"),
                k = u
                  ? f.find(".swiper-slide-shadow-right")
                  : f.find(".swiper-slide-shadow-bottom");
              0 === C.length &&
                ((C = n(
                  '<div class="swiper-slide-shadow-' +
                    (u ? "left" : "top") +
                    '"></div>'
                )),
                f.append(C)),
                0 === k.length &&
                  ((k = n(
                    '<div class="swiper-slide-shadow-' +
                      (u ? "right" : "bottom") +
                      '"></div>'
                  )),
                  f.append(k)),
                C.length && (C[0].style.opacity = Math.max(-y, 0)),
                k.length && (k[0].style.opacity = Math.max(y, 0));
            }
          }
          if (
            (i.css({
              "-webkit-transform-origin": "50% 50% -" + l / 2 + "px",
              "-moz-transform-origin": "50% 50% -" + l / 2 + "px",
              "-ms-transform-origin": "50% 50% -" + l / 2 + "px",
              "transform-origin": "50% 50% -" + l / 2 + "px",
            }),
            c.shadow)
          )
            if (u)
              e.transform(
                "translate3d(0px, " +
                  (a / 2 + c.shadowOffset) +
                  "px, " +
                  -a / 2 +
                  "px) rotateX(90deg) rotateZ(0deg) scale(" +
                  c.shadowScale +
                  ")"
              );
            else {
              var E = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                T =
                  1.5 -
                  (Math.sin((2 * E * Math.PI) / 360) / 2 +
                    Math.cos((2 * E * Math.PI) / 360) / 2),
                _ = c.shadowScale,
                M = c.shadowScale / T,
                L = c.shadowOffset;
              e.transform(
                "scale3d(" +
                  _ +
                  ", 1, " +
                  M +
                  ") translate3d(0px, " +
                  (r / 2 + L) +
                  "px, " +
                  -r / 2 / M +
                  "px) rotateX(-90deg)"
              );
            }
          var P = G.isSafari || G.isUiWebView ? -l / 2 : 0;
          i.transform(
            "translate3d(0px,0," +
              P +
              "px) rotateX(" +
              (this.isHorizontal() ? 0 : h) +
              "deg) rotateY(" +
              (this.isHorizontal() ? -h : 0) +
              "deg)"
          );
        },
        setTransition: function (e) {
          var t = this.$el;
          this.slides
            .transition(e)
            .find(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            )
            .transition(e),
            this.params.cubeEffect.shadow &&
              !this.isHorizontal() &&
              t.find(".swiper-cube-shadow").transition(e);
        },
      },
      ve = {
        setTranslate: function () {
          for (
            var e = this.slides, t = this.rtlTranslate, i = 0;
            i < e.length;
            i += 1
          ) {
            var s = e.eq(i),
              a = s[0].progress;
            this.params.flipEffect.limitRotation &&
              (a = Math.max(Math.min(s[0].progress, 1), -1));
            var r = -180 * a,
              o = 0,
              l = -s[0].swiperSlideOffset,
              c = 0;
            if (
              (this.isHorizontal()
                ? t && (r = -r)
                : ((c = l), (l = 0), (o = -r), (r = 0)),
              (s[0].style.zIndex = -Math.abs(Math.round(a)) + e.length),
              this.params.flipEffect.slideShadows)
            ) {
              var u = this.isHorizontal()
                  ? s.find(".swiper-slide-shadow-left")
                  : s.find(".swiper-slide-shadow-top"),
                d = this.isHorizontal()
                  ? s.find(".swiper-slide-shadow-right")
                  : s.find(".swiper-slide-shadow-bottom");
              0 === u.length &&
                ((u = n(
                  '<div class="swiper-slide-shadow-' +
                    (this.isHorizontal() ? "left" : "top") +
                    '"></div>'
                )),
                s.append(u)),
                0 === d.length &&
                  ((d = n(
                    '<div class="swiper-slide-shadow-' +
                      (this.isHorizontal() ? "right" : "bottom") +
                      '"></div>'
                  )),
                  s.append(d)),
                u.length && (u[0].style.opacity = Math.max(-a, 0)),
                d.length && (d[0].style.opacity = Math.max(a, 0));
            }
            s.transform(
              "translate3d(" +
                l +
                "px, " +
                c +
                "px, 0px) rotateX(" +
                o +
                "deg) rotateY(" +
                r +
                "deg)"
            );
          }
        },
        setTransition: function (e) {
          var t = this,
            i = t.slides,
            n = t.activeIndex,
            s = t.$wrapperEl;
          if (
            (i
              .transition(e)
              .find(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              )
              .transition(e),
            t.params.virtualTranslate && 0 !== e)
          ) {
            var a = !1;
            i.eq(n).transitionEnd(function () {
              if (!a && t && !t.destroyed) {
                (a = !0), (t.animating = !1);
                for (
                  var e = ["webkitTransitionEnd", "transitionend"], i = 0;
                  i < e.length;
                  i += 1
                )
                  s.trigger(e[i]);
              }
            });
          }
        },
      },
      me = {
        setTranslate: function () {
          for (
            var e = this.width,
              t = this.height,
              i = this.slides,
              s = this.$wrapperEl,
              a = this.slidesSizesGrid,
              r = this.params.coverflowEffect,
              l = this.isHorizontal(),
              c = this.translate,
              u = l ? e / 2 - c : t / 2 - c,
              d = l ? r.rotate : -r.rotate,
              h = r.depth,
              p = 0,
              f = i.length;
            p < f;
            p += 1
          ) {
            var v = i.eq(p),
              m = a[p],
              g = ((u - v[0].swiperSlideOffset - m / 2) / m) * r.modifier,
              y = l ? d * g : 0,
              b = l ? 0 : d * g,
              w = -h * Math.abs(g),
              S = r.stretch;
            "string" == typeof S &&
              -1 !== S.indexOf("%") &&
              (S = (parseFloat(r.stretch) / 100) * m);
            var x = l ? 0 : S * g,
              C = l ? S * g : 0;
            Math.abs(C) < 0.001 && (C = 0),
              Math.abs(x) < 0.001 && (x = 0),
              Math.abs(w) < 0.001 && (w = 0),
              Math.abs(y) < 0.001 && (y = 0),
              Math.abs(b) < 0.001 && (b = 0);
            var k =
              "translate3d(" +
              C +
              "px," +
              x +
              "px," +
              w +
              "px)  rotateX(" +
              b +
              "deg) rotateY(" +
              y +
              "deg)";
            if (
              (v.transform(k),
              (v[0].style.zIndex = 1 - Math.abs(Math.round(g))),
              r.slideShadows)
            ) {
              var E = l
                  ? v.find(".swiper-slide-shadow-left")
                  : v.find(".swiper-slide-shadow-top"),
                T = l
                  ? v.find(".swiper-slide-shadow-right")
                  : v.find(".swiper-slide-shadow-bottom");
              0 === E.length &&
                ((E = n(
                  '<div class="swiper-slide-shadow-' +
                    (l ? "left" : "top") +
                    '"></div>'
                )),
                v.append(E)),
                0 === T.length &&
                  ((T = n(
                    '<div class="swiper-slide-shadow-' +
                      (l ? "right" : "bottom") +
                      '"></div>'
                  )),
                  v.append(T)),
                E.length && (E[0].style.opacity = g > 0 ? g : 0),
                T.length && (T[0].style.opacity = -g > 0 ? -g : 0);
            }
          }
          (o.pointerEvents || o.prefixedPointerEvents) &&
            (s[0].style.perspectiveOrigin = u + "px 50%");
        },
        setTransition: function (e) {
          this.slides
            .transition(e)
            .find(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            )
            .transition(e);
        },
      },
      ge = {
        init: function () {
          var e = this.params.thumbs,
            t = this.constructor;
          e.swiper instanceof t
            ? ((this.thumbs.swiper = e.swiper),
              r.extend(this.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
              r.extend(this.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }))
            : r.isObject(e.swiper) &&
              ((this.thumbs.swiper = new t(
                r.extend({}, e.swiper, {
                  watchSlidesVisibility: !0,
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                })
              )),
              (this.thumbs.swiperCreated = !0)),
            this.thumbs.swiper.$el.addClass(
              this.params.thumbs.thumbsContainerClass
            ),
            this.thumbs.swiper.on("tap", this.thumbs.onThumbClick);
        },
        onThumbClick: function () {
          var e = this.thumbs.swiper;
          if (e) {
            var t = e.clickedIndex,
              i = e.clickedSlide;
            if (
              !(
                (i &&
                  n(i).hasClass(this.params.thumbs.slideThumbActiveClass)) ||
                null == t
              )
            ) {
              var s;
              if (
                ((s = e.params.loop
                  ? parseInt(
                      n(e.clickedSlide).attr("data-swiper-slide-index"),
                      10
                    )
                  : t),
                this.params.loop)
              ) {
                var a = this.activeIndex;
                this.slides.eq(a).hasClass(this.params.slideDuplicateClass) &&
                  (this.loopFix(),
                  (this._clientLeft = this.$wrapperEl[0].clientLeft),
                  (a = this.activeIndex));
                var r = this.slides
                    .eq(a)
                    .prevAll('[data-swiper-slide-index="' + s + '"]')
                    .eq(0)
                    .index(),
                  o = this.slides
                    .eq(a)
                    .nextAll('[data-swiper-slide-index="' + s + '"]')
                    .eq(0)
                    .index();
                s = void 0 === r ? o : void 0 === o ? r : o - a < a - r ? o : r;
              }
              this.slideTo(s);
            }
          }
        },
        update: function (e) {
          var t = this.thumbs.swiper;
          if (t) {
            var i =
                "auto" === t.params.slidesPerView
                  ? t.slidesPerViewDynamic()
                  : t.params.slidesPerView,
              n = this.params.thumbs.autoScrollOffset,
              s = n && !t.params.loop;
            if (this.realIndex !== t.realIndex || s) {
              var a,
                r,
                o = t.activeIndex;
              if (t.params.loop) {
                t.slides.eq(o).hasClass(t.params.slideDuplicateClass) &&
                  (t.loopFix(),
                  (t._clientLeft = t.$wrapperEl[0].clientLeft),
                  (o = t.activeIndex));
                var l = t.slides
                    .eq(o)
                    .prevAll(
                      '[data-swiper-slide-index="' + this.realIndex + '"]'
                    )
                    .eq(0)
                    .index(),
                  c = t.slides
                    .eq(o)
                    .nextAll(
                      '[data-swiper-slide-index="' + this.realIndex + '"]'
                    )
                    .eq(0)
                    .index();
                (a =
                  void 0 === l
                    ? c
                    : void 0 === c
                    ? l
                    : c - o == o - l
                    ? o
                    : c - o < o - l
                    ? c
                    : l),
                  (r = this.activeIndex > this.previousIndex ? "next" : "prev");
              } else
                r = (a = this.realIndex) > this.previousIndex ? "next" : "prev";
              s && (a += "next" === r ? n : -1 * n),
                t.visibleSlidesIndexes &&
                  t.visibleSlidesIndexes.indexOf(a) < 0 &&
                  (t.params.centeredSlides
                    ? (a =
                        a > o
                          ? a - Math.floor(i / 2) + 1
                          : a + Math.floor(i / 2) - 1)
                    : a > o && (a = a - i + 1),
                  t.slideTo(a, e ? 0 : void 0));
            }
            var u = 1,
              d = this.params.thumbs.slideThumbActiveClass;
            if (
              (this.params.slidesPerView > 1 &&
                !this.params.centeredSlides &&
                (u = this.params.slidesPerView),
              this.params.thumbs.multipleActiveThumbs || (u = 1),
              (u = Math.floor(u)),
              t.slides.removeClass(d),
              t.params.loop || (t.params.virtual && t.params.virtual.enabled))
            )
              for (var h = 0; h < u; h += 1)
                t.$wrapperEl
                  .children(
                    '[data-swiper-slide-index="' + (this.realIndex + h) + '"]'
                  )
                  .addClass(d);
            else
              for (var p = 0; p < u; p += 1)
                t.slides.eq(this.realIndex + p).addClass(d);
          }
        },
      },
      ye = [
        j,
        X,
        W,
        Y,
        K,
        Z,
        ee,
        {
          name: "mousewheel",
          params: {
            mousewheel: {
              enabled: !1,
              releaseOnEdges: !1,
              invert: !1,
              forceToAxis: !1,
              sensitivity: 1,
              eventsTarged: "container",
            },
          },
          create: function () {
            r.extend(this, {
              mousewheel: {
                enabled: !1,
                enable: te.enable.bind(this),
                disable: te.disable.bind(this),
                handle: te.handle.bind(this),
                handleMouseEnter: te.handleMouseEnter.bind(this),
                handleMouseLeave: te.handleMouseLeave.bind(this),
                animateSlider: te.animateSlider.bind(this),
                releaseScroll: te.releaseScroll.bind(this),
                lastScrollTime: r.now(),
                lastEventBeforeSnap: void 0,
                recentWheelEvents: [],
              },
            });
          },
          on: {
            init: function () {
              !this.params.mousewheel.enabled &&
                this.params.cssMode &&
                this.mousewheel.disable(),
                this.params.mousewheel.enabled && this.mousewheel.enable();
            },
            destroy: function () {
              this.params.cssMode && this.mousewheel.enable(),
                this.mousewheel.enabled && this.mousewheel.disable();
            },
          },
        },
        {
          name: "navigation",
          params: {
            navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: !1,
              disabledClass: "swiper-button-disabled",
              hiddenClass: "swiper-button-hidden",
              lockClass: "swiper-button-lock",
            },
          },
          create: function () {
            r.extend(this, {
              navigation: {
                init: ie.init.bind(this),
                update: ie.update.bind(this),
                destroy: ie.destroy.bind(this),
                onNextClick: ie.onNextClick.bind(this),
                onPrevClick: ie.onPrevClick.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.navigation.init(), this.navigation.update();
            },
            toEdge: function () {
              this.navigation.update();
            },
            fromEdge: function () {
              this.navigation.update();
            },
            destroy: function () {
              this.navigation.destroy();
            },
            click: function (e) {
              var t,
                i = this.navigation,
                s = i.$nextEl,
                a = i.$prevEl;
              !this.params.navigation.hideOnClick ||
                n(e.target).is(a) ||
                n(e.target).is(s) ||
                (s
                  ? (t = s.hasClass(this.params.navigation.hiddenClass))
                  : a && (t = a.hasClass(this.params.navigation.hiddenClass)),
                !0 === t
                  ? this.emit("navigationShow", this)
                  : this.emit("navigationHide", this),
                s && s.toggleClass(this.params.navigation.hiddenClass),
                a && a.toggleClass(this.params.navigation.hiddenClass));
            },
          },
        },
        {
          name: "pagination",
          params: {
            pagination: {
              el: null,
              bulletElement: "span",
              clickable: !1,
              hideOnClick: !1,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: !1,
              type: "bullets",
              dynamicBullets: !1,
              dynamicMainBullets: 1,
              formatFractionCurrent: function (e) {
                return e;
              },
              formatFractionTotal: function (e) {
                return e;
              },
              bulletClass: "swiper-pagination-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
              modifierClass: "swiper-pagination-",
              currentClass: "swiper-pagination-current",
              totalClass: "swiper-pagination-total",
              hiddenClass: "swiper-pagination-hidden",
              progressbarFillClass: "swiper-pagination-progressbar-fill",
              progressbarOppositeClass:
                "swiper-pagination-progressbar-opposite",
              clickableClass: "swiper-pagination-clickable",
              lockClass: "swiper-pagination-lock",
            },
          },
          create: function () {
            r.extend(this, {
              pagination: {
                init: ne.init.bind(this),
                render: ne.render.bind(this),
                update: ne.update.bind(this),
                destroy: ne.destroy.bind(this),
                dynamicBulletIndex: 0,
              },
            });
          },
          on: {
            init: function () {
              this.pagination.init(),
                this.pagination.render(),
                this.pagination.update();
            },
            activeIndexChange: function () {
              (this.params.loop || void 0 === this.snapIndex) &&
                this.pagination.update();
            },
            snapIndexChange: function () {
              this.params.loop || this.pagination.update();
            },
            slidesLengthChange: function () {
              this.params.loop &&
                (this.pagination.render(), this.pagination.update());
            },
            snapGridLengthChange: function () {
              this.params.loop ||
                (this.pagination.render(), this.pagination.update());
            },
            destroy: function () {
              this.pagination.destroy();
            },
            click: function (e) {
              this.params.pagination.el &&
                this.params.pagination.hideOnClick &&
                this.pagination.$el.length > 0 &&
                !n(e.target).hasClass(this.params.pagination.bulletClass) &&
                (!0 ===
                this.pagination.$el.hasClass(this.params.pagination.hiddenClass)
                  ? this.emit("paginationShow", this)
                  : this.emit("paginationHide", this),
                this.pagination.$el.toggleClass(
                  this.params.pagination.hiddenClass
                ));
            },
          },
        },
        {
          name: "scrollbar",
          params: {
            scrollbar: {
              el: null,
              dragSize: "auto",
              hide: !1,
              draggable: !1,
              snapOnRelease: !0,
              lockClass: "swiper-scrollbar-lock",
              dragClass: "swiper-scrollbar-drag",
            },
          },
          create: function () {
            r.extend(this, {
              scrollbar: {
                init: se.init.bind(this),
                destroy: se.destroy.bind(this),
                updateSize: se.updateSize.bind(this),
                setTranslate: se.setTranslate.bind(this),
                setTransition: se.setTransition.bind(this),
                enableDraggable: se.enableDraggable.bind(this),
                disableDraggable: se.disableDraggable.bind(this),
                setDragPosition: se.setDragPosition.bind(this),
                getPointerPosition: se.getPointerPosition.bind(this),
                onDragStart: se.onDragStart.bind(this),
                onDragMove: se.onDragMove.bind(this),
                onDragEnd: se.onDragEnd.bind(this),
                isTouched: !1,
                timeout: null,
                dragTimeout: null,
              },
            });
          },
          on: {
            init: function () {
              this.scrollbar.init(),
                this.scrollbar.updateSize(),
                this.scrollbar.setTranslate();
            },
            update: function () {
              this.scrollbar.updateSize();
            },
            resize: function () {
              this.scrollbar.updateSize();
            },
            observerUpdate: function () {
              this.scrollbar.updateSize();
            },
            setTranslate: function () {
              this.scrollbar.setTranslate();
            },
            setTransition: function (e) {
              this.scrollbar.setTransition(e);
            },
            destroy: function () {
              this.scrollbar.destroy();
            },
          },
        },
        {
          name: "parallax",
          params: { parallax: { enabled: !1 } },
          create: function () {
            r.extend(this, {
              parallax: {
                setTransform: ae.setTransform.bind(this),
                setTranslate: ae.setTranslate.bind(this),
                setTransition: ae.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              this.params.parallax.enabled &&
                ((this.params.watchSlidesProgress = !0),
                (this.originalParams.watchSlidesProgress = !0));
            },
            init: function () {
              this.params.parallax.enabled && this.parallax.setTranslate();
            },
            setTranslate: function () {
              this.params.parallax.enabled && this.parallax.setTranslate();
            },
            setTransition: function (e) {
              this.params.parallax.enabled && this.parallax.setTransition(e);
            },
          },
        },
        {
          name: "zoom",
          params: {
            zoom: {
              enabled: !1,
              maxRatio: 3,
              minRatio: 1,
              toggle: !0,
              containerClass: "swiper-zoom-container",
              zoomedSlideClass: "swiper-slide-zoomed",
            },
          },
          create: function () {
            var e = this,
              t = {
                enabled: !1,
                scale: 1,
                currentScale: 1,
                isScaling: !1,
                gesture: {
                  $slideEl: void 0,
                  slideWidth: void 0,
                  slideHeight: void 0,
                  $imageEl: void 0,
                  $imageWrapEl: void 0,
                  maxRatio: 3,
                },
                image: {
                  isTouched: void 0,
                  isMoved: void 0,
                  currentX: void 0,
                  currentY: void 0,
                  minX: void 0,
                  minY: void 0,
                  maxX: void 0,
                  maxY: void 0,
                  width: void 0,
                  height: void 0,
                  startX: void 0,
                  startY: void 0,
                  touchesStart: {},
                  touchesCurrent: {},
                },
                velocity: {
                  x: void 0,
                  y: void 0,
                  prevPositionX: void 0,
                  prevPositionY: void 0,
                  prevTime: void 0,
                },
              };
            "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
              .split(" ")
              .forEach(function (i) {
                t[i] = re[i].bind(e);
              }),
              r.extend(e, { zoom: t });
            var i = 1;
            Object.defineProperty(e.zoom, "scale", {
              get: function () {
                return i;
              },
              set: function (t) {
                if (i !== t) {
                  var n = e.zoom.gesture.$imageEl
                      ? e.zoom.gesture.$imageEl[0]
                      : void 0,
                    s = e.zoom.gesture.$slideEl
                      ? e.zoom.gesture.$slideEl[0]
                      : void 0;
                  e.emit("zoomChange", t, n, s);
                }
                i = t;
              },
            });
          },
          on: {
            init: function () {
              this.params.zoom.enabled && this.zoom.enable();
            },
            destroy: function () {
              this.zoom.disable();
            },
            touchStart: function (e) {
              this.zoom.enabled && this.zoom.onTouchStart(e);
            },
            touchEnd: function (e) {
              this.zoom.enabled && this.zoom.onTouchEnd(e);
            },
            doubleTap: function (e) {
              this.params.zoom.enabled &&
                this.zoom.enabled &&
                this.params.zoom.toggle &&
                this.zoom.toggle(e);
            },
            transitionEnd: function () {
              this.zoom.enabled &&
                this.params.zoom.enabled &&
                this.zoom.onTransitionEnd();
            },
            slideChange: function () {
              this.zoom.enabled &&
                this.params.zoom.enabled &&
                this.params.cssMode &&
                this.zoom.onTransitionEnd();
            },
          },
        },
        {
          name: "lazy",
          params: {
            lazy: {
              enabled: !1,
              loadPrevNext: !1,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: !1,
              elementClass: "swiper-lazy",
              loadingClass: "swiper-lazy-loading",
              loadedClass: "swiper-lazy-loaded",
              preloaderClass: "swiper-lazy-preloader",
            },
          },
          create: function () {
            r.extend(this, {
              lazy: {
                initialImageLoaded: !1,
                load: oe.load.bind(this),
                loadInSlide: oe.loadInSlide.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              this.params.lazy.enabled &&
                this.params.preloadImages &&
                (this.params.preloadImages = !1);
            },
            init: function () {
              this.params.lazy.enabled &&
                !this.params.loop &&
                0 === this.params.initialSlide &&
                this.lazy.load();
            },
            scroll: function () {
              this.params.freeMode &&
                !this.params.freeModeSticky &&
                this.lazy.load();
            },
            resize: function () {
              this.params.lazy.enabled && this.lazy.load();
            },
            scrollbarDragMove: function () {
              this.params.lazy.enabled && this.lazy.load();
            },
            transitionStart: function () {
              this.params.lazy.enabled &&
                (this.params.lazy.loadOnTransitionStart ||
                  (!this.params.lazy.loadOnTransitionStart &&
                    !this.lazy.initialImageLoaded)) &&
                this.lazy.load();
            },
            transitionEnd: function () {
              this.params.lazy.enabled &&
                !this.params.lazy.loadOnTransitionStart &&
                this.lazy.load();
            },
            slideChange: function () {
              this.params.lazy.enabled &&
                this.params.cssMode &&
                this.lazy.load();
            },
          },
        },
        {
          name: "controller",
          params: { controller: { control: void 0, inverse: !1, by: "slide" } },
          create: function () {
            r.extend(this, {
              controller: {
                control: this.params.controller.control,
                getInterpolateFunction: le.getInterpolateFunction.bind(this),
                setTranslate: le.setTranslate.bind(this),
                setTransition: le.setTransition.bind(this),
              },
            });
          },
          on: {
            update: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            resize: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            observerUpdate: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            setTranslate: function (e, t) {
              this.controller.control && this.controller.setTranslate(e, t);
            },
            setTransition: function (e, t) {
              this.controller.control && this.controller.setTransition(e, t);
            },
          },
        },
        {
          name: "a11y",
          params: {
            a11y: {
              enabled: !0,
              notificationClass: "swiper-notification",
              prevSlideMessage: "Previous slide",
              nextSlideMessage: "Next slide",
              firstSlideMessage: "This is the first slide",
              lastSlideMessage: "This is the last slide",
              paginationBulletMessage: "Go to slide {{index}}",
            },
          },
          create: function () {
            var e = this;
            r.extend(e, {
              a11y: {
                liveRegion: n(
                  '<span class="' +
                    e.params.a11y.notificationClass +
                    '" aria-live="assertive" aria-atomic="true"></span>'
                ),
              },
            }),
              Object.keys(ce).forEach(function (t) {
                e.a11y[t] = ce[t].bind(e);
              });
          },
          on: {
            init: function () {
              this.params.a11y.enabled &&
                (this.a11y.init(), this.a11y.updateNavigation());
            },
            toEdge: function () {
              this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            fromEdge: function () {
              this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            paginationUpdate: function () {
              this.params.a11y.enabled && this.a11y.updatePagination();
            },
            destroy: function () {
              this.params.a11y.enabled && this.a11y.destroy();
            },
          },
        },
        {
          name: "history",
          params: { history: { enabled: !1, replaceState: !1, key: "slides" } },
          create: function () {
            r.extend(this, {
              history: {
                init: ue.init.bind(this),
                setHistory: ue.setHistory.bind(this),
                setHistoryPopState: ue.setHistoryPopState.bind(this),
                scrollToSlide: ue.scrollToSlide.bind(this),
                destroy: ue.destroy.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.params.history.enabled && this.history.init();
            },
            destroy: function () {
              this.params.history.enabled && this.history.destroy();
            },
            transitionEnd: function () {
              this.history.initialized &&
                this.history.setHistory(
                  this.params.history.key,
                  this.activeIndex
                );
            },
            slideChange: function () {
              this.history.initialized &&
                this.params.cssMode &&
                this.history.setHistory(
                  this.params.history.key,
                  this.activeIndex
                );
            },
          },
        },
        {
          name: "hash-navigation",
          params: {
            hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 },
          },
          create: function () {
            r.extend(this, {
              hashNavigation: {
                initialized: !1,
                init: de.init.bind(this),
                destroy: de.destroy.bind(this),
                setHash: de.setHash.bind(this),
                onHashCange: de.onHashCange.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.params.hashNavigation.enabled && this.hashNavigation.init();
            },
            destroy: function () {
              this.params.hashNavigation.enabled &&
                this.hashNavigation.destroy();
            },
            transitionEnd: function () {
              this.hashNavigation.initialized && this.hashNavigation.setHash();
            },
            slideChange: function () {
              this.hashNavigation.initialized &&
                this.params.cssMode &&
                this.hashNavigation.setHash();
            },
          },
        },
        {
          name: "autoplay",
          params: {
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
            },
          },
          create: function () {
            var e = this;
            r.extend(e, {
              autoplay: {
                running: !1,
                paused: !1,
                run: he.run.bind(e),
                start: he.start.bind(e),
                stop: he.stop.bind(e),
                pause: he.pause.bind(e),
                onVisibilityChange: function () {
                  "hidden" === document.visibilityState &&
                    e.autoplay.running &&
                    e.autoplay.pause(),
                    "visible" === document.visibilityState &&
                      e.autoplay.paused &&
                      (e.autoplay.run(), (e.autoplay.paused = !1));
                },
                onTransitionEnd: function (t) {
                  e &&
                    !e.destroyed &&
                    e.$wrapperEl &&
                    t.target === this &&
                    (e.$wrapperEl[0].removeEventListener(
                      "transitionend",
                      e.autoplay.onTransitionEnd
                    ),
                    e.$wrapperEl[0].removeEventListener(
                      "webkitTransitionEnd",
                      e.autoplay.onTransitionEnd
                    ),
                    (e.autoplay.paused = !1),
                    e.autoplay.running ? e.autoplay.run() : e.autoplay.stop());
                },
              },
            });
          },
          on: {
            init: function () {
              this.params.autoplay.enabled &&
                (this.autoplay.start(),
                document.addEventListener(
                  "visibilitychange",
                  this.autoplay.onVisibilityChange
                ));
            },
            beforeTransitionStart: function (e, t) {
              this.autoplay.running &&
                (t || !this.params.autoplay.disableOnInteraction
                  ? this.autoplay.pause(e)
                  : this.autoplay.stop());
            },
            sliderFirstMove: function () {
              this.autoplay.running &&
                (this.params.autoplay.disableOnInteraction
                  ? this.autoplay.stop()
                  : this.autoplay.pause());
            },
            touchEnd: function () {
              this.params.cssMode &&
                this.autoplay.paused &&
                !this.params.autoplay.disableOnInteraction &&
                this.autoplay.run();
            },
            destroy: function () {
              this.autoplay.running && this.autoplay.stop(),
                document.removeEventListener(
                  "visibilitychange",
                  this.autoplay.onVisibilityChange
                );
            },
          },
        },
        {
          name: "effect-fade",
          params: { fadeEffect: { crossFade: !1 } },
          create: function () {
            r.extend(this, {
              fadeEffect: {
                setTranslate: pe.setTranslate.bind(this),
                setTransition: pe.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if ("fade" === this.params.effect) {
                this.classNames.push(
                  this.params.containerModifierClass + "fade"
                );
                var e = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0,
                };
                r.extend(this.params, e), r.extend(this.originalParams, e);
              }
            },
            setTranslate: function () {
              "fade" === this.params.effect && this.fadeEffect.setTranslate();
            },
            setTransition: function (e) {
              "fade" === this.params.effect && this.fadeEffect.setTransition(e);
            },
          },
        },
        {
          name: "effect-cube",
          params: {
            cubeEffect: {
              slideShadows: !0,
              shadow: !0,
              shadowOffset: 20,
              shadowScale: 0.94,
            },
          },
          create: function () {
            r.extend(this, {
              cubeEffect: {
                setTranslate: fe.setTranslate.bind(this),
                setTransition: fe.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if ("cube" === this.params.effect) {
                this.classNames.push(
                  this.params.containerModifierClass + "cube"
                ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  );
                var e = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  resistanceRatio: 0,
                  spaceBetween: 0,
                  centeredSlides: !1,
                  virtualTranslate: !0,
                };
                r.extend(this.params, e), r.extend(this.originalParams, e);
              }
            },
            setTranslate: function () {
              "cube" === this.params.effect && this.cubeEffect.setTranslate();
            },
            setTransition: function (e) {
              "cube" === this.params.effect && this.cubeEffect.setTransition(e);
            },
          },
        },
        {
          name: "effect-flip",
          params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
          create: function () {
            r.extend(this, {
              flipEffect: {
                setTranslate: ve.setTranslate.bind(this),
                setTransition: ve.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if ("flip" === this.params.effect) {
                this.classNames.push(
                  this.params.containerModifierClass + "flip"
                ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  );
                var e = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0,
                };
                r.extend(this.params, e), r.extend(this.originalParams, e);
              }
            },
            setTranslate: function () {
              "flip" === this.params.effect && this.flipEffect.setTranslate();
            },
            setTransition: function (e) {
              "flip" === this.params.effect && this.flipEffect.setTransition(e);
            },
          },
        },
        {
          name: "effect-coverflow",
          params: {
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: !0,
            },
          },
          create: function () {
            r.extend(this, {
              coverflowEffect: {
                setTranslate: me.setTranslate.bind(this),
                setTransition: me.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              "coverflow" === this.params.effect &&
                (this.classNames.push(
                  this.params.containerModifierClass + "coverflow"
                ),
                this.classNames.push(this.params.containerModifierClass + "3d"),
                (this.params.watchSlidesProgress = !0),
                (this.originalParams.watchSlidesProgress = !0));
            },
            setTranslate: function () {
              "coverflow" === this.params.effect &&
                this.coverflowEffect.setTranslate();
            },
            setTransition: function (e) {
              "coverflow" === this.params.effect &&
                this.coverflowEffect.setTransition(e);
            },
          },
        },
        {
          name: "thumbs",
          params: {
            thumbs: {
              swiper: null,
              multipleActiveThumbs: !0,
              autoScrollOffset: 0,
              slideThumbActiveClass: "swiper-slide-thumb-active",
              thumbsContainerClass: "swiper-container-thumbs",
            },
          },
          create: function () {
            r.extend(this, {
              thumbs: {
                swiper: null,
                init: ge.init.bind(this),
                update: ge.update.bind(this),
                onThumbClick: ge.onThumbClick.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              var e = this.params.thumbs;
              e && e.swiper && (this.thumbs.init(), this.thumbs.update(!0));
            },
            slideChange: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            update: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            resize: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            observerUpdate: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            setTransition: function (e) {
              var t = this.thumbs.swiper;
              t && t.setTransition(e);
            },
            beforeDestroy: function () {
              var e = this.thumbs.swiper;
              e && this.thumbs.swiperCreated && e && e.destroy();
            },
          },
        },
      ];
    return (
      void 0 === R.use &&
        ((R.use = R.Class.use), (R.installModule = R.Class.installModule)),
      R.use(ye),
      R
    );
  }),
  (function (e, t) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define([], t)
      : "object" == typeof exports
      ? (exports.Typed = t())
      : (e.Typed = t());
  })(this, function () {
    return (function (e) {
      function t(n) {
        if (i[n]) return i[n].exports;
        var s = (i[n] = { exports: {}, id: n, loaded: !1 });
        return (
          e[n].call(s.exports, s, s.exports, t), (s.loaded = !0), s.exports
        );
      }
      var i = {};
      return (t.m = e), (t.c = i), (t.p = ""), t(0);
    })([
      function (e, t, i) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var n = (function () {
            function e(e, t) {
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                  "value" in n && (n.writable = !0),
                  Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, i, n) {
              return i && e(t.prototype, i), n && e(t, n), t;
            };
          })(),
          s = i(1),
          a = i(3),
          r = (function () {
            function e(t, i) {
              (function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                s.initializer.load(this, i, t),
                this.begin();
            }
            return (
              n(e, [
                {
                  key: "toggle",
                  value: function () {
                    this.pause.status ? this.start() : this.stop();
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    this.typingComplete ||
                      this.pause.status ||
                      (this.toggleBlinking(!0),
                      (this.pause.status = !0),
                      this.options.onStop(this.arrayPos, this));
                  },
                },
                {
                  key: "start",
                  value: function () {
                    this.typingComplete ||
                      (this.pause.status &&
                        ((this.pause.status = !1),
                        this.pause.typewrite
                          ? this.typewrite(
                              this.pause.curString,
                              this.pause.curStrPos
                            )
                          : this.backspace(
                              this.pause.curString,
                              this.pause.curStrPos
                            ),
                        this.options.onStart(this.arrayPos, this)));
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    this.reset(!1), this.options.onDestroy(this);
                  },
                },
                {
                  key: "reset",
                  value: function () {
                    var e =
                      arguments.length <= 0 ||
                      void 0 === arguments[0] ||
                      arguments[0];
                    clearInterval(this.timeout),
                      this.replaceText(""),
                      this.cursor &&
                        this.cursor.parentNode &&
                        (this.cursor.parentNode.removeChild(this.cursor),
                        (this.cursor = null)),
                      (this.strPos = 0),
                      (this.arrayPos = 0),
                      (this.curLoop = 0),
                      e &&
                        (this.insertCursor(),
                        this.options.onReset(this),
                        this.begin());
                  },
                },
                {
                  key: "begin",
                  value: function () {
                    var e = this;
                    (this.typingComplete = !1),
                      this.shuffleStringsIfNeeded(this),
                      this.insertCursor(),
                      this.bindInputFocusEvents && this.bindFocusEvents(),
                      (this.timeout = setTimeout(function () {
                        e.currentElContent && 0 !== e.currentElContent.length
                          ? e.backspace(
                              e.currentElContent,
                              e.currentElContent.length
                            )
                          : e.typewrite(
                              e.strings[e.sequence[e.arrayPos]],
                              e.strPos
                            );
                      }, this.startDelay));
                  },
                },
                {
                  key: "typewrite",
                  value: function (e, t) {
                    var i = this;
                    this.fadeOut &&
                      this.el.classList.contains(this.fadeOutClass) &&
                      (this.el.classList.remove(this.fadeOutClass),
                      this.cursor &&
                        this.cursor.classList.remove(this.fadeOutClass));
                    var n = this.humanizer(this.typeSpeed),
                      s = 1;
                    return !0 === this.pause.status
                      ? void this.setPauseStatus(e, t, !0)
                      : void (this.timeout = setTimeout(function () {
                          t = a.htmlParser.typeHtmlChars(e, t, i);
                          var n = 0,
                            r = e.substr(t);
                          if ("^" === r.charAt(0) && /^\^\d+/.test(r)) {
                            var o = 1;
                            (o += (r = /\d+/.exec(r)[0]).length),
                              (n = parseInt(r)),
                              (i.temporaryPause = !0),
                              i.options.onTypingPaused(i.arrayPos, i),
                              (e = e.substring(0, t) + e.substring(t + o)),
                              i.toggleBlinking(!0);
                          }
                          if ("`" === r.charAt(0)) {
                            for (
                              ;
                              "`" !== e.substr(t + s).charAt(0) &&
                              (s++, !(t + s > e.length));

                            );
                            var l = e.substring(0, t),
                              c = e.substring(l.length + 1, t + s),
                              u = e.substring(t + s + 1);
                            (e = l + c + u), s--;
                          }
                          i.timeout = setTimeout(function () {
                            i.toggleBlinking(!1),
                              t === e.length
                                ? i.doneTyping(e, t)
                                : i.keepTyping(e, t, s),
                              i.temporaryPause &&
                                ((i.temporaryPause = !1),
                                i.options.onTypingResumed(i.arrayPos, i));
                          }, n);
                        }, n));
                  },
                },
                {
                  key: "keepTyping",
                  value: function (e, t, i) {
                    0 === t &&
                      (this.toggleBlinking(!1),
                      this.options.preStringTyped(this.arrayPos, this)),
                      (t += i);
                    var n = e.substr(0, t);
                    this.replaceText(n), this.typewrite(e, t);
                  },
                },
                {
                  key: "doneTyping",
                  value: function (e, t) {
                    var i = this;
                    this.options.onStringTyped(this.arrayPos, this),
                      this.toggleBlinking(!0),
                      (this.arrayPos === this.strings.length - 1 &&
                        (this.complete(),
                        !1 === this.loop || this.curLoop === this.loopCount)) ||
                        (this.timeout = setTimeout(function () {
                          i.backspace(e, t);
                        }, this.backDelay));
                  },
                },
                {
                  key: "backspace",
                  value: function (e, t) {
                    var i = this;
                    if (!0 !== this.pause.status) {
                      if (this.fadeOut) return this.initFadeOut();
                      this.toggleBlinking(!1);
                      var n = this.humanizer(this.backSpeed);
                      this.timeout = setTimeout(function () {
                        t = a.htmlParser.backSpaceHtmlChars(e, t, i);
                        var n = e.substr(0, t);
                        if ((i.replaceText(n), i.smartBackspace)) {
                          var s = i.strings[i.arrayPos + 1];
                          s && n === s.substr(0, t)
                            ? (i.stopNum = t)
                            : (i.stopNum = 0);
                        }
                        t > i.stopNum
                          ? (t--, i.backspace(e, t))
                          : t <= i.stopNum &&
                            (i.arrayPos++,
                            i.arrayPos === i.strings.length
                              ? ((i.arrayPos = 0),
                                i.options.onLastStringBackspaced(),
                                i.shuffleStringsIfNeeded(),
                                i.begin())
                              : i.typewrite(
                                  i.strings[i.sequence[i.arrayPos]],
                                  t
                                ));
                      }, n);
                    } else this.setPauseStatus(e, t, !0);
                  },
                },
                {
                  key: "complete",
                  value: function () {
                    this.options.onComplete(this),
                      this.loop ? this.curLoop++ : (this.typingComplete = !0);
                  },
                },
                {
                  key: "setPauseStatus",
                  value: function (e, t, i) {
                    (this.pause.typewrite = i),
                      (this.pause.curString = e),
                      (this.pause.curStrPos = t);
                  },
                },
                {
                  key: "toggleBlinking",
                  value: function (e) {
                    if (
                      this.cursor &&
                      !this.pause.status &&
                      this.cursorBlinking !== e
                    ) {
                      this.cursorBlinking = e;
                      var t = e ? "infinite" : 0;
                      this.cursor.style.animationIterationCount = t;
                    }
                  },
                },
                {
                  key: "humanizer",
                  value: function (e) {
                    return Math.round((Math.random() * e) / 2) + e;
                  },
                },
                {
                  key: "shuffleStringsIfNeeded",
                  value: function () {
                    this.shuffle &&
                      (this.sequence = this.sequence.sort(function () {
                        return Math.random() - 0.5;
                      }));
                  },
                },
                {
                  key: "initFadeOut",
                  value: function () {
                    var e = this;
                    return (
                      (this.el.className += " " + this.fadeOutClass),
                      this.cursor &&
                        (this.cursor.className += " " + this.fadeOutClass),
                      setTimeout(function () {
                        e.arrayPos++,
                          e.replaceText(""),
                          e.strings.length > e.arrayPos
                            ? e.typewrite(e.strings[e.sequence[e.arrayPos]], 0)
                            : (e.typewrite(e.strings[0], 0), (e.arrayPos = 0));
                      }, this.fadeOutDelay)
                    );
                  },
                },
                {
                  key: "replaceText",
                  value: function (e) {
                    this.attr
                      ? this.el.setAttribute(this.attr, e)
                      : this.isInput
                      ? (this.el.value = e)
                      : "html" === this.contentType
                      ? (this.el.innerHTML = e)
                      : (this.el.textContent = e);
                  },
                },
                {
                  key: "bindFocusEvents",
                  value: function () {
                    var e = this;
                    this.isInput &&
                      (this.el.addEventListener("focus", function (t) {
                        e.stop();
                      }),
                      this.el.addEventListener("blur", function (t) {
                        (e.el.value && 0 !== e.el.value.length) || e.start();
                      }));
                  },
                },
                {
                  key: "insertCursor",
                  value: function () {
                    this.showCursor &&
                      (this.cursor ||
                        ((this.cursor = document.createElement("span")),
                        (this.cursor.className = "typed-cursor"),
                        (this.cursor.innerHTML = this.cursorChar),
                        this.el.parentNode &&
                          this.el.parentNode.insertBefore(
                            this.cursor,
                            this.el.nextSibling
                          )));
                  },
                },
              ]),
              e
            );
          })();
        (t.default = r), (e.exports = t.default);
      },
      function (e, t, i) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var n =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var i = arguments[t];
                for (var n in i)
                  Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
              }
              return e;
            },
          s = (function () {
            function e(e, t) {
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                  "value" in n && (n.writable = !0),
                  Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, i, n) {
              return i && e(t.prototype, i), n && e(t, n), t;
            };
          })(),
          a = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(i(2)),
          r = (function () {
            function e() {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e);
            }
            return (
              s(e, [
                {
                  key: "load",
                  value: function (e, t, i) {
                    if (
                      ((e.el =
                        "string" == typeof i ? document.querySelector(i) : i),
                      (e.options = n({}, a.default, t)),
                      (e.isInput = "input" === e.el.tagName.toLowerCase()),
                      (e.attr = e.options.attr),
                      (e.bindInputFocusEvents = e.options.bindInputFocusEvents),
                      (e.showCursor = !e.isInput && e.options.showCursor),
                      (e.cursorChar = e.options.cursorChar),
                      (e.cursorBlinking = !0),
                      (e.elContent = e.attr
                        ? e.el.getAttribute(e.attr)
                        : e.el.textContent),
                      (e.contentType = e.options.contentType),
                      (e.typeSpeed = e.options.typeSpeed),
                      (e.startDelay = e.options.startDelay),
                      (e.backSpeed = e.options.backSpeed),
                      (e.smartBackspace = e.options.smartBackspace),
                      (e.backDelay = e.options.backDelay),
                      (e.fadeOut = e.options.fadeOut),
                      (e.fadeOutClass = e.options.fadeOutClass),
                      (e.fadeOutDelay = e.options.fadeOutDelay),
                      (e.isPaused = !1),
                      (e.strings = e.options.strings.map(function (e) {
                        return e.trim();
                      })),
                      "string" == typeof e.options.stringsElement
                        ? (e.stringsElement = document.querySelector(
                            e.options.stringsElement
                          ))
                        : (e.stringsElement = e.options.stringsElement),
                      e.stringsElement)
                    ) {
                      (e.strings = []),
                        (e.stringsElement.style.display = "none");
                      var s = Array.prototype.slice.apply(
                          e.stringsElement.children
                        ),
                        r = s.length;
                      if (r)
                        for (var o = 0; o < r; o += 1) {
                          var l = s[o];
                          e.strings.push(l.innerHTML.trim());
                        }
                    }
                    for (var o in ((e.strPos = 0),
                    (e.arrayPos = 0),
                    (e.stopNum = 0),
                    (e.loop = e.options.loop),
                    (e.loopCount = e.options.loopCount),
                    (e.curLoop = 0),
                    (e.shuffle = e.options.shuffle),
                    (e.sequence = []),
                    (e.pause = {
                      status: !1,
                      typewrite: !0,
                      curString: "",
                      curStrPos: 0,
                    }),
                    (e.typingComplete = !1),
                    e.strings))
                      e.sequence[o] = o;
                    (e.currentElContent = this.getCurrentElContent(e)),
                      (e.autoInsertCss = e.options.autoInsertCss),
                      this.appendAnimationCss(e);
                  },
                },
                {
                  key: "getCurrentElContent",
                  value: function (e) {
                    return e.attr
                      ? e.el.getAttribute(e.attr)
                      : e.isInput
                      ? e.el.value
                      : "html" === e.contentType
                      ? e.el.innerHTML
                      : e.el.textContent;
                  },
                },
                {
                  key: "appendAnimationCss",
                  value: function (e) {
                    if (e.autoInsertCss && e.showCursor && e.fadeOut) {
                      var t = document.createElement("style");
                      t.type = "text/css";
                      var i = "";
                      e.showCursor &&
                        (i +=
                          "\n        .typed-cursor{\n          opacity: 1;\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      "),
                        e.fadeOut &&
                          (i +=
                            "\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n          -webkit-animation: 0;\n                  animation: 0;\n        }\n      "),
                        0 !== t.length &&
                          ((t.innerHTML = i), document.head.appendChild(t));
                    }
                  },
                },
              ]),
              e
            );
          })();
        t.default = r;
        var o = new r();
        t.initializer = o;
      },
      function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        (t.default = {
          strings: [
            "These are the default values...",
            "You know what you should do?",
            "Use your own!",
            "Have a great day!",
          ],
          stringsElement: null,
          typeSpeed: 0,
          startDelay: 0,
          backSpeed: 0,
          smartBackspace: !0,
          shuffle: !1,
          backDelay: 700,
          fadeOut: !1,
          fadeOutClass: "typed-fade-out",
          fadeOutDelay: 500,
          loop: !1,
          loopCount: 1 / 0,
          showCursor: !0,
          cursorChar: "|",
          autoInsertCss: !0,
          attr: null,
          bindInputFocusEvents: !1,
          contentType: "html",
          onComplete: function (e) {},
          preStringTyped: function (e, t) {},
          onStringTyped: function (e, t) {},
          onLastStringBackspaced: function (e) {},
          onTypingPaused: function (e, t) {},
          onTypingResumed: function (e, t) {},
          onReset: function (e) {},
          onStop: function (e, t) {},
          onStart: function (e, t) {},
          onDestroy: function (e) {},
        }),
          (e.exports = t.default);
      },
      function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var i = (function () {
            function e(e, t) {
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                  "value" in n && (n.writable = !0),
                  Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, i, n) {
              return i && e(t.prototype, i), n && e(t, n), t;
            };
          })(),
          n = (function () {
            function e() {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e);
            }
            return (
              i(e, [
                {
                  key: "typeHtmlChars",
                  value: function (e, t, i) {
                    if ("html" !== i.contentType) return t;
                    var n = e.substr(t).charAt(0);
                    if ("<" === n || "&" === n) {
                      var s;
                      for (
                        s = "<" === n ? ">" : ";";
                        e.substr(t + 1).charAt(0) !== s &&
                        !(++t + 1 > e.length);

                      );
                      t++;
                    }
                    return t;
                  },
                },
                {
                  key: "backSpaceHtmlChars",
                  value: function (e, t, i) {
                    if ("html" !== i.contentType) return t;
                    var n = e.substr(t).charAt(0);
                    if (">" === n || ";" === n) {
                      var s;
                      for (
                        s = ">" === n ? "<" : "&";
                        e.substr(t - 1).charAt(0) !== s && !(--t < 0);

                      );
                      t--;
                    }
                    return t;
                  },
                },
              ]),
              e
            );
          })();
        t.default = n;
        var s = new n();
        t.htmlParser = s;
      },
    ]);
  }),
  $(document).ready(function () {
    ysscount = 0;
    $(".ys_custom_gallery_swiper").each(function () {
      ysscount++;
      this_item = $(this);
      this_item.addClass("swiper-container customswiper" + ysscount);
   //   this_item.wrapInner('<div class="swiper-wrapper"></div>');
   //   this_item.find("li").wrap('<div class="swiper-slide"></div>');
      this_item.append('<div class="swiper-pagination"></div>');

      desk_item = this_item.attr("data-desktop_items");
      mob_item = this_item.attr("data-mobile_items");
      ipad_item = this_item.attr("data-ipad_items");
      ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
      ipad_item_vertical = this_item.attr("data-ipad_vertical_items");
      slider_mode = this_item.attr("data-mode");
      swiper_arrows = this_item.attr("data-swiper-style-arrow");
      swiper_style = this_item.attr("data-swiper_style");
      slider_autoplay = this_item.attr("data-slider-autoplay");
      slider_center = this_item.attr("data-slider-center");
      slider_effect = this_item.attr("data-slider-effect");
      slider_desktop_padding = this_item.attr("data-desktop-padding");
      slider_ipad_horizontal_padding = this_item.attr(
        "data-ipad-horizontal-padding"
      );
      slider_ipad_vertical_padding = this_item.attr(
        "data-ipad-vertical-padding"
      );
      slider_mobile_padding = this_item.attr("data-mobile-padding");
      desktop_offset = this_item.attr("data-desktop-offset");
      mobile_offset = this_item.attr("data-mobile-offset");
      ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset");
      ipad_horizontal_offset = this_item.attr("data-ipad-horizontal-offset");
      slider_loop = this_item.attr("data-slider-loop");

      console.log(swiper_style);
      console.log(slider_center);
      console.log(slider_loop);
      swiper_navigation = {};
      swiper_pagination = {};
      slider_autoplay_start = {};
      var is_slider_loop = true;
      var is_slider_center = false;

      if (slider_loop == "false") {
        is_slider_loop = false;
      } else {
        is_slider_loop = true;
      }

      if (slider_center == "false") {
        is_slider_center = false;
      } else {
        is_slider_center = true;
      }

      if (swiper_arrows == "true") {
        this_item.append(
          '<div class="swiper-button-next swiper_arrows  customswiper_next' +
            ysscount +
            '"></div><div class="swiper-button-prev swiper_arrows  customswiper_prev' +
            ysscount +
            '"></div>'
        );
        swiper_navigation = {
          nextEl: ".customswiper_next" + ysscount,
          prevEl: ".customswiper_prev" + ysscount,
        };
      }
      if (swiper_style == "donts") {
        this_item.append('<div class="swiper-pagination"></div>');
        swpier_pagination = {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        };
      } else if (swiper_style == "progress_bar") {
        swpier_pagination = {
          el: ".swiper-pagination",
          type: "progressbar",
          clickable: true,
        };
      } else {
        swpier_pagination = {};
      }

      if (slider_autoplay == "true") {
        slider_autoplay_start = {
          delay: 3500,
          disableOnInteraction: false,
        };
      } else {
        slider_autoplay_start = {
          delay: 250000000000,
          disableOnInteraction: true,
        };
      }

      if (slider_mode == "normal") {
        var partner_swiper = new Swiper(".customswiper" + ysscount, {
          spaceBetween: 0,
          navigation: swiper_navigation,
          effect: slider_effect == "fade" ? "fade" : "",
          pagination: {
            el: ".swiper-pagination",
            type: swiper_style == "progress_bar" ? "progressbar" : "bullets",
            clickable: true,
          },

          loop: is_slider_loop,
          autoplay: slider_autoplay_start,
          centeredSlides: is_slider_center,
          breakpoints: {
            0: {
              slidesPerView: mob_item,
              spaceBetween: slider_mobile_padding,
              slidesOffsetBefore: mobile_offset,
            },
            481: {
              slidesPerView: ipad_item_vertical,
              spaceBetween: slider_ipad_vertical_padding,
              slidesOffsetBefore: ipad_vertical_offset,
            },
            786: {
              slidesPerView: ipad_item_horizontal,
              spaceBetween: slider_ipad_horizontal_padding,
              slidesOffsetBefore: ipad_horizontal_offset,
            },
            1100: {
              slidesPerView: desk_item,
              spaceBetween: slider_desktop_padding,
              slidesOffsetBefore: desktop_offset,
            },
          },
        });
      } else {
        this_item.find(".swiper-wrapper").addClass("swipanim");
        var partner_swiper = new Swiper(".customswiper" + ysscount, {
          spaceBetween: 0,
          navigation: swiper_navigation,
          effect: slider_effect == "fade" ? "fade" : "",
          pagination: swpier_pagination,

          loop: is_slider_loop,
          freeMode: true,
          spaceBetween: 0,
          grabCursor: true,
          slidesPerView: 7,

          autoplay: {
            delay: 1,
            disableOnInteraction: true,
          },
          freeMode: true,
          speed: 5000,
          freeModeMomentum: false,
          breakpoints: {
            0: {
              slidesPerView: mob_item,
              spaceBetween: slider_mobile_padding,
              slidesOffsetBefore: mobile_offset,
            },
            481: {
              slidesPerView: ipad_item_vertical,
              spaceBetween: slider_ipad_vertical_padding,
              slidesOffsetBefore: ipad_vertical_offset,
            },
            786: {
              slidesPerView: ipad_item_horizontal,
              spaceBetween: slider_ipad_horizontal_padding,
              slidesOffsetBefore: ipad_horizontal_offset,
            },
            1100: {
              slidesPerView: desk_item,
              spaceBetween: slider_desktop_padding,
              slidesOffsetBefore: desktop_offset,
            },
          },
        });
      }
    }),
      $(".ys_custom_gallery_swiper_test").each(function () {
        if (
          (ysscount++,
          (this_item = $(this)),
          this_item.addClass("swiper-container customswiper" + ysscount),
          this_item.wrapInner('<div class="swiper-wrapper"></div>'),
          this_item.find("li").wrap('<div class="swiper-slide"></div>'),
          this_item.append(
            '<div class="swiper-button-next swiper_arrows2  customswiper_next' +
              ysscount +
              '"></div><div class="swiper-button-prev swiper_arrows2  customswiper_prev' +
              ysscount +
              '"></div>'
          ),
          (desk_item = this_item.attr("data-desktop_items")),
          (mob_item = this_item.attr("data-mobile_items")),
          (ipad_item = this_item.attr("data-ipad_items")),
          (slider_mode = this_item.attr("data-mode")),
          "normal" == slider_mode)
        )
          new Swiper(".customswiper" + ysscount, {
            spaceBetween: 0,
            navigation: {
              nextEl: ".customswiper_next" + ysscount,
              prevEl: ".customswiper_prev" + ysscount,
            },
            loop: !0,
            autoplay: { delay: 3500, disableOnInteraction: !1 },
            breakpoints: {
              0: { slidesPerView: mob_item, spaceBetween: 20 },
              481: { slidesPerView: ipad_item, spaceBetween: 30 },
              786: { slidesPerView: ipad_item, spaceBetween: 30 },
              1100: { slidesPerView: desk_item, spaceBetween: 30 },
            },
          });
        else {
          this_item.find(".swiper-wrapper").addClass("swipanim");
          new Swiper(".customswiper" + ysscount, {
            spaceBetween: 0,
            navigation: {
              nextEl: ".customswiper_next" + ysscount,
              prevEl: ".customswiper_prev" + ysscount,
            },
            loop: !0,
            freeMode: !0,
            spaceBetween: 0,
            grabCursor: !0,
            slidesPerView: 7,
            loop: !0,
            autoplay: { delay: 1, disableOnInteraction: !0 },
            freeMode: !0,
            speed: 5e3,
            freeModeMomentum: !1,
            breakpoints: {
              0: { slidesPerView: mob_item, spaceBetween: 0 },
              481: { slidesPerView: ipad_item, spaceBetween: 0 },
              786: { slidesPerView: ipad_item, spaceBetween: 0 },
              1100: { slidesPerView: desk_item, spaceBetween: 0 },
            },
          });
        }
      });
  }),
  $(document).ready(function () {
    if ($(".top_slider_texts").length)
      new Typed(".top_slider_texts", {
        strings: ["Where Strength Meets Style", "Where Style Meets Strength"],
        typeSpeed: 90,
        backSpeed: 40,
        backDelay: 1500,
        contentType: "html",
        loop: !0,
      });
    $(document).on("click", ".pdp_offers_wrap ul li .code_wrap", function () {
      (this_id = $(this).find("b").text()),
        console.log(this_id),
        copyText(this_id);
    });
  }),
  document.addEventListener("DOMContentLoaded", (e) => {
    sessionStorage.removeItem("popCartRendered");
  });

/* Countdown Starts */
!(function (a) {
  "use strict";
  "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery);
})(function (a) {
  "use strict";
  function b(a) {
    if (a instanceof Date) return a;
    if (String(a).match(g))
      return (
        String(a).match(/^[0-9]*$/) && (a = Number(a)),
        String(a).match(/\-/) && (a = String(a).replace(/\-/g, "/")),
        new Date(a)
      );
    throw new Error("Couldn't cast `" + a + "` to a date object.");
  }
  function c(a) {
    var b = a.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    return new RegExp(b);
  }
  function d(a) {
    return function (b) {
      var d = b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
      if (d)
        for (var f = 0, g = d.length; g > f; ++f) {
          var h = d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
            j = c(h[0]),
            k = h[1] || "",
            l = h[3] || "",
            m = null;
          (h = h[2]),
            i.hasOwnProperty(h) && ((m = i[h]), (m = Number(a[m]))),
            null !== m &&
              ("!" === k && (m = e(l, m)),
              "" === k && 10 > m && (m = "0" + m.toString()),
              (b = b.replace(j, m.toString())));
        }
      return (b = b.replace(/%%/, "%"));
    };
  }
  function e(a, b) {
    var c = "s",
      d = "";
    return (
      a &&
        ((a = a.replace(/(:|;|\s)/gi, "").split(/\,/)),
        1 === a.length ? (c = a[0]) : ((d = a[0]), (c = a[1]))),
      1 === Math.abs(b) ? d : c
    );
  }
  var f = [],
    g = [],
    h = { precision: 100, elapse: !1 };
  g.push(/^[0-9]*$/.source),
    g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    (g = new RegExp(g.join("|")));
  var i = {
      Y: "years",
      m: "months",
      n: "daysToMonth",
      w: "weeks",
      d: "daysToWeek",
      D: "totalDays",
      H: "hours",
      M: "minutes",
      S: "seconds",
    },
    j = function (b, c, d) {
      (this.el = b),
        (this.$el = a(b)),
        (this.interval = null),
        (this.offset = {}),
        (this.options = a.extend({}, h)),
        (this.instanceNumber = f.length),
        f.push(this),
        this.$el.data("countdown-instance", this.instanceNumber),
        d &&
          ("function" == typeof d
            ? (this.$el.on("update.countdown", d),
              this.$el.on("stoped.countdown", d),
              this.$el.on("finish.countdown", d))
            : (this.options = a.extend({}, h, d))),
        this.setFinalDate(c),
        this.start();
    };
  a.extend(j.prototype, {
    start: function () {
      null !== this.interval && clearInterval(this.interval);
      var a = this;
      this.update(),
        (this.interval = setInterval(function () {
          a.update.call(a);
        }, this.options.precision));
    },
    stop: function () {
      clearInterval(this.interval),
        (this.interval = null),
        this.dispatchEvent("stoped");
    },
    toggle: function () {
      this.interval ? this.stop() : this.start();
    },
    pause: function () {
      this.stop();
    },
    resume: function () {
      this.start();
    },
    remove: function () {
      this.stop.call(this),
        (f[this.instanceNumber] = null),
        delete this.$el.data().countdownInstance;
    },
    setFinalDate: function (a) {
      this.finalDate = b(a);
    },
    update: function () {
      if (0 === this.$el.closest("html").length) return void this.remove();
      var b,
        c = void 0 !== a._data(this.el, "events"),
        d = new Date();
      (b = this.finalDate.getTime() - d.getTime()),
        (b = Math.ceil(b / 1e3)),
        (b = !this.options.elapse && 0 > b ? 0 : Math.abs(b)),
        this.totalSecsLeft !== b &&
          c &&
          ((this.totalSecsLeft = b),
          (this.elapsed = d >= this.finalDate),
          (this.offset = {
            seconds: this.totalSecsLeft % 60,
            minutes: Math.floor(this.totalSecsLeft / 60) % 60,
            hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
            days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
            daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
            daysToMonth: Math.floor(
              (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
            ),
            totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
            weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
            months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
            years: Math.abs(this.finalDate.getFullYear() - d.getFullYear()),
          }),
          this.options.elapse || 0 !== this.totalSecsLeft
            ? this.dispatchEvent("update")
            : (this.stop(), this.dispatchEvent("finish")));
    },
    dispatchEvent: function (b) {
      var c = a.Event(b + ".countdown");
      (c.finalDate = this.finalDate),
        (c.elapsed = this.elapsed),
        (c.offset = a.extend({}, this.offset)),
        (c.strftime = d(this.offset)),
        this.$el.trigger(c);
    },
  }),
    (a.fn.countdown = function () {
      var b = Array.prototype.slice.call(arguments, 0);
      return this.each(function () {
        var c = a(this).data("countdown-instance");
        if (void 0 !== c) {
          var d = f[c],
            e = b[0];
          j.prototype.hasOwnProperty(e)
            ? d[e].apply(d, b.slice(1))
            : null === String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)
            ? (d.setFinalDate.call(d, e), d.start())
            : a.error(
                "Method %s does not exist on jQuery.countdown".replace(
                  /\%s/gi,
                  e
                )
              );
        } else new j(this, b[0], b[1]);
      });
    });
});

$(document).ready(function () {
  ys_timer = 0;

  $(".ys_timer").each(function () {
    ys_timer = ys_timer + 1;
    $(this).attr("id", "ys_timer" + ys_timer);
    timer2 = $(this).attr("data-time");
   

    $("#" + "ys_timer" + ys_timer).countdown(timer2, function (event) {
      $(this).html(
        event.strftime(
          ' <span><span class="digit">%H</span><br>Hours</span> <span><span class="digit">%M</span><br>Mins</span> <span><span class="digit">%S</span><br>Sec</span> '
        )
      );
    });
  });
});
// $(window).load(function(){
//   if($('.template-product').length){
//     $('.template-product variant-picker label').removeClass("selected");
//     $('.product-variant-picker__form input').removeAttr("checked",false);
//     $('.product-form__btn').click(function(evt){
//       $('.alert').remove();
//         id = $('.product-form [name="id"]').val();
//         if(id == ''){
          
//           $('.product-variant-picker__list').append('<div class="full_wrap alert alert-danger" style="background-color:lightcoral;color:#fff">Please select size</div>');
//           evt.preventDefault();
//         }
      
//     });
//   }
// });
$(document).ready(function () {
  
  announcement_bar_ys_timer = 0;
  
  $(".ys_announcement_bar_timer").each(function () {
    announcement_bar_ys_timer = announcement_bar_ys_timer + 1;
    $(this).attr("id", "ys_announcement_bar_timer" + announcement_bar_ys_timer);
    product_timer = $(this).attr("data-time");
   

    $("#" + "ys_announcement_bar_timer" + announcement_bar_ys_timer).countdown(
      product_timer,
      function (event) {
        $(this).html(
          event.strftime(
            '<span><span style="margin-right: 5px">Sale Ends In</span><span><span class="digit"><b>%H</b></span> Hours</span> <span><span class="digit"><b>%M</b></span> Mins</span> <span><span class="digit"><b>%S</b></span> Sec</span> '
          )
        );
      }
    );
  });
});

$(document).ready(function () {
  
  product_ys_timer = 0;
 
  $(".product_ys_timer").each(function () {
    product_ys_timer = product_ys_timer + 1;
    $(this).attr("id", "product_ys_timer" + product_ys_timer);
    product_timer = $(this).attr("data-time");
    

    $("#" + "product_ys_timer" + product_ys_timer).countdown(
      product_timer,
      function (event) {
        $(this).html(
          event.strftime(
            '<span><span style="margin-right: 5px">Sale Ends In</span><span><span class="digit"><b>%H</b></span>hr</span> <span><span class="digit"><b>%M</b></span>m</span> <span><span class="digit"><b>%S</b></span>s</span> '
          )
        );
      }
    );
  });
});

/* Countdown Ends */

 


  $(document).ready(function () {
    if ($(".top_slider_texts").length)
      new Typed(".top_slider_texts", {
        strings: ["Where Strength Meets Style", "Where Style Meets Strength"],
        typeSpeed: 90,
        backSpeed: 40,
        backDelay: 1500,
        contentType: "html",
        loop: !0,
      });
    $(document).on("click", ".pdp_offers_wrap ul li .code_wrap", function () {
      (this_id = $(this).find("b").text()),
        console.log(this_id),
        copyText(this_id);
    });
  });
  document.addEventListener("DOMContentLoaded", (e) => {
    sessionStorage.removeItem("popCartRendered");
  });

function qtyChangeCheck() {
  
}

document.addEventListener("DOMContentLoaded", function() {
  var videos = [].slice.call(document.querySelectorAll(".has_lazy_video .lazyvideo"));

  
imagesload = [].slice.call(document.querySelectorAll(".lazyimages"));
  if(screen.width > 480){
    var videos2 = [].slice.call(document.querySelectorAll(".desktop_ys_banner .lazyvideo"));
    
  }else{
    var videos2 = [].slice.call(document.querySelectorAll(".mobile_ys_banner .lazyvideo"));
    
  }

  

  if ("IntersectionObserver" in window) {
    var count=0;
    var videoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          stype = "image";
          //video.poster = video.dataset.poster;
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
              stype = "video";
            }
          }
          if(stype == "video"){
            video.target.load();
            console.log("video",video);
            video.target.setAttribute("id", "video_lazy_"+count);
            document.getElementById("video_lazy_"+count).play();
            
            video.target.classList.remove("lazyvideo");
          }else{
            console.log(video.target.dataset.src);
            
            video.target.setAttribute("id", "image_lazy_"+count);

            document.getElementById("image_lazy_"+count).setAttribute("src", video.target.dataset.src);
           
            video.target.classList.remove("lazyimages");
          }
          videoObserver.unobserve(video.target);
          count++;
        }
      });
    });

    videos.forEach(function(video) {
      videoObserver.observe(video);
    });

    videos2.forEach(function(video) {
      videoObserver.observe(video);
    });
    
    imagesload.forEach(function(video) {
      videoObserver.observe(video);
    });
  }
});



$(window).load(function(){
  ysscount2=0;
  $('.ys_custom_gallery_swiper_product').each(function(){
    if(!$(this).hasClass("swiper-container-initialized")){
    ysscount2++;
    this_item = $(this);
    this_item.addClass("swiper-container customswiper"+ysscount2);
    this_item.wrapInner('<div class="swiper-wrapper"></div>');
    this_item.find("li").wrap('<div class="swiper-slide"></div>');
  //  this_item.append('<div class="swiper-button-next swiper_arrows  customswiper_next'+ysscount2+'"></div><div class="swiper-button-prev swiper_arrows  customswiper_prev'+ysscount2+'"></div>');
   //   this_item.append('<div class="swiper-pagination"></div>');

    desk_item = this_item.attr("data-desktop_items");
    mob_item = this_item.attr("data-mobile_items");

    var partner_swiper = new Swiper('.customswiper'+ysscount2, {
          spaceBetween: 0,
          // navigation: {
          //     nextEl: ".customswiper_next"+ysscount2,
          //     prevEl: ".customswiper_prev"+ysscount2,
          // },
          pagination: {
        el: ".swiper-pagination",
      },
          loop: true,
          autoplay: {
            delay: 3500,
            disableOnInteraction: false,
          },
          breakpoints: {
              0: {
                  slidesPerView: mob_item,
                  spaceBetween: 0
              },
              481: {
                  slidesPerView: desk_item,
                  spaceBetween: 0
              },
              786: {
                  slidesPerView: desk_item,
                  spaceBetween: 0
              },
              1100: {
                  slidesPerView: desk_item,
                  spaceBetween: 0
              }
          }
      });
    }
  });
});


$(document).ready(function() {
    // Handle tab switching
   

$('.menu-tab-link:first-child').addClass('active');
  
    $(document).on('click', '.menu-tab-link', function() {
        var tabId = $(this).data('tab');
        

        
        $('.menu-tab-link').removeClass('active');
        
        
        $(this).addClass('active');

       
        $('.mobile_menu_tab').hide();

        // Show the related tab content
        $('#' + tabId).show();
      
      $('.mobile_menu_tab.'+tabId).toggleClass('active');
       
      classList.toggleClass('active');
    });

   
    $(document).on('click', '.level1-link', function() {

       var tabId = $(this).data('tab');
      

       
     $('.level1-link.'+tabId).toggleClass('active');

     

        var $subMenu = $(this).next('.sub-menu');

        
        $subMenu.slideToggle(300);
    });

    
    $('.menu-tab-link:first').click();
});

$(document).ready(function(){
  $('.header__cart-icon,.product-form__btn').on("click",function(){
    timing = 10;
    if($(this).hasClass("product-form__btn")){
      timing = 3500;
    }
    setTimeout(function(){
      
    
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const cartItems = data.items;
      if(cartItems.length > 0){
        const productRecommendationsSection = document.querySelector('.product-recommendations');
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+cartItems[0]['product_id']+"&section_id=product-recommendations&limit=10&intent=complementary")
         .then(response => response.text())
         .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
         console.log(recommendations);
            if (recommendations && recommendations.innerHTML.trim().length) {
             	productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
         });
      }
    });
      },timing);
    
  });
   

   var swiper = new Swiper("#ys_menu_gallery_ul", {
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
              0: {
                  slidesPerView: 1,
                  spaceBetween: 0
              },
              481: {
                  slidesPerView: 1,
                  spaceBetween: 0
              },
              786: {
                  slidesPerView: 1,
                  spaceBetween: 0
              },
              1100: {
                  slidesPerView: 1,
                  spaceBetween: 0
              }
          }
    });
});

  
    
   

